export const ProvinceList = {
  "entities": [
    {
      "areaName": "北京",
      "shortName": "北京",
      "code": 110000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "北京市",
          "shortName": "北京",
          "areaCode": "010",
          "code": 110100,
          "parentCode": 110000,
          "level": 3,
          "children": null,
          "id": 3,
        },
        {
          "areaName": "东城区",
          "shortName": "东城",
          "areaCode": "010",
          "code": 110101,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 4,
        },
        {
          "areaName": "西城区",
          "shortName": "西城",
          "areaCode": "010",
          "code": 110102,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 5,
        },
        {
          "areaName": "朝阳区",
          "shortName": "朝阳",
          "areaCode": "010",
          "code": 110105,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 6,
        },
        {
          "areaName": "丰台区",
          "shortName": "丰台",
          "areaCode": "010",
          "code": 110106,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 7,
        },
        {
          "areaName": "石景山区",
          "shortName": "石景山",
          "areaCode": "010",
          "code": 110107,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 8,
        },
        {
          "areaName": "海淀区",
          "shortName": "海淀",
          "areaCode": "010",
          "code": 110108,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 9,
        },
        {
          "areaName": "门头沟区",
          "shortName": "门头沟",
          "areaCode": "010",
          "code": 110109,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 10,
        },
        {
          "areaName": "房山区",
          "shortName": "房山",
          "areaCode": "010",
          "code": 110111,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 11,
        },
        {
          "areaName": "通州区",
          "shortName": "通州",
          "areaCode": "010",
          "code": 110112,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 12,
        },
        {
          "areaName": "顺义区",
          "shortName": "顺义",
          "areaCode": "010",
          "code": 110113,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 13,
        },
        {
          "areaName": "昌平区",
          "shortName": "昌平",
          "areaCode": "010",
          "code": 110114,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 14,
        },
        {
          "areaName": "大兴区",
          "shortName": "大兴",
          "areaCode": "010",
          "code": 110115,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 15,
        },
        {
          "areaName": "怀柔区",
          "shortName": "怀柔",
          "areaCode": "010",
          "code": 110116,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 16,
        },
        {
          "areaName": "平谷区",
          "shortName": "平谷",
          "areaCode": "010",
          "code": 110117,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 17,
        },
        {
          "areaName": "密云县",
          "shortName": "密云",
          "areaCode": "010",
          "code": 110228,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 18,
        },
        {
          "areaName": "延庆县",
          "shortName": "延庆",
          "areaCode": "010",
          "code": 110229,
          "parentCode": 110100,
          "level": 4,
          "children": null,
          "id": 19,
        }
      ],
      "id": 2,
    },
    {
      "areaName": "天津",
      "shortName": "天津",
      "code": 120000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "天津市",
          "shortName": "天津",
          "areaCode": "022",
          "code": 120100,
          "parentCode": 120000,
          "level": 3,
          "children": null,
          "id": 21,
        },
        {
          "areaName": "和平区",
          "shortName": "和平",
          "areaCode": "022",
          "code": 120101,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 22,
        },
        {
          "areaName": "河东区",
          "shortName": "河东",
          "areaCode": "022",
          "code": 120102,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 23,
        },
        {
          "areaName": "河西区",
          "shortName": "河西",
          "areaCode": "022",
          "code": 120103,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 24,
        },
        {
          "areaName": "南开区",
          "shortName": "南开",
          "areaCode": "022",
          "code": 120104,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 25,
        },
        {
          "areaName": "河北区",
          "shortName": "河北",
          "areaCode": "022",
          "code": 120105,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 26,
        },
        {
          "areaName": "红桥区",
          "shortName": "红桥",
          "areaCode": "022",
          "code": 120106,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 27,
        },
        {
          "areaName": "东丽区",
          "shortName": "东丽",
          "areaCode": "022",
          "code": 120110,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 28,
        },
        {
          "areaName": "西青区",
          "shortName": "西青",
          "areaCode": "022",
          "code": 120111,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 29,
        },
        {
          "areaName": "津南区",
          "shortName": "津南",
          "areaCode": "022",
          "code": 120112,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 30,
        },
        {
          "areaName": "北辰区",
          "shortName": "北辰",
          "areaCode": "022",
          "code": 120113,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 31,
        },
        {
          "areaName": "武清区",
          "shortName": "武清",
          "areaCode": "022",
          "code": 120114,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 32,
        },
        {
          "areaName": "宝坻区",
          "shortName": "宝坻",
          "areaCode": "022",
          "code": 120115,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 33,
        },
        {
          "areaName": "滨海新区",
          "shortName": "滨海新区",
          "areaCode": "022",
          "code": 120116,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 34,
        },
        {
          "areaName": "宁河县",
          "shortName": "宁河",
          "areaCode": "022",
          "code": 120221,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 35,
        },
        {
          "areaName": "静海县",
          "shortName": "静海",
          "areaCode": "022",
          "code": 120223,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 36,
        },
        {
          "areaName": "蓟县",
          "shortName": "蓟县",
          "areaCode": "022",
          "code": 120225,
          "parentCode": 120100,
          "level": 4,
          "children": null,
          "id": 37,
        }
      ],
      "id": 20,
    },
    {
      "areaName": "河北省",
      "shortName": "河北",
      "code": 130000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "石家庄市",
          "shortName": "石家庄",
          "areaCode": "0311",
          "code": 130100,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 39,
        },
        {
          "areaName": "长安区",
          "shortName": "长安",
          "areaCode": "0311",
          "code": 130102,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 40,
        },
        {
          "areaName": "桥西区",
          "shortName": "桥西",
          "areaCode": "0311",
          "code": 130104,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 41,
        },
        {
          "areaName": "新华区",
          "shortName": "新华",
          "areaCode": "0311",
          "code": 130105,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 42,
        },
        {
          "areaName": "井陉矿区",
          "shortName": "井陉矿区",
          "areaCode": "0311",
          "code": 130107,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 43,
        },
        {
          "areaName": "裕华区",
          "shortName": "裕华",
          "areaCode": "0311",
          "code": 130108,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 44,
        },
        {
          "areaName": "藁城区",
          "shortName": "藁城",
          "areaCode": "0311",
          "code": 130109,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 45,
        },
        {
          "areaName": "鹿泉区",
          "shortName": "鹿泉",
          "areaCode": "0311",
          "code": 130110,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 46,
        },
        {
          "areaName": "栾城区",
          "shortName": "栾城",
          "areaCode": "0311",
          "code": 130111,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 47,
        },
        {
          "areaName": "井陉县",
          "shortName": "井陉",
          "areaCode": "0311",
          "code": 130121,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 48,
        },
        {
          "areaName": "正定县",
          "shortName": "正定",
          "areaCode": "0311",
          "code": 130123,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 49,
        },
        {
          "areaName": "行唐县",
          "shortName": "行唐",
          "areaCode": "0311",
          "code": 130125,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 50,
        },
        {
          "areaName": "灵寿县",
          "shortName": "灵寿",
          "areaCode": "0311",
          "code": 130126,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 51,
        },
        {
          "areaName": "高邑县",
          "shortName": "高邑",
          "areaCode": "0311",
          "code": 130127,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 52,
        },
        {
          "areaName": "深泽县",
          "shortName": "深泽",
          "areaCode": "0311",
          "code": 130128,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 53,
        },
        {
          "areaName": "赞皇县",
          "shortName": "赞皇",
          "areaCode": "0311",
          "code": 130129,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 54,
        },
        {
          "areaName": "无极县",
          "shortName": "无极",
          "areaCode": "0311",
          "code": 130130,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 55,
        },
        {
          "areaName": "平山县",
          "shortName": "平山",
          "areaCode": "0311",
          "code": 130131,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 56,
        },
        {
          "areaName": "元氏县",
          "shortName": "元氏",
          "areaCode": "0311",
          "code": 130132,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 57,
        },
        {
          "areaName": "赵县",
          "shortName": "赵县",
          "areaCode": "0311",
          "code": 130133,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 58,
        },
        {
          "areaName": "辛集市",
          "shortName": "辛集",
          "areaCode": "0311",
          "code": 130181,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 59,
        },
        {
          "areaName": "晋州市",
          "shortName": "晋州",
          "areaCode": "0311",
          "code": 130183,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 60,
        },
        {
          "areaName": "新乐市",
          "shortName": "新乐",
          "areaCode": "0311",
          "code": 130184,
          "parentCode": 130100,
          "level": 4,
          "children": null,
          "id": 61,
        },
        {
          "areaName": "唐山市",
          "shortName": "唐山",
          "areaCode": "0315",
          "code": 130200,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 62,
        },
        {
          "areaName": "路南区",
          "shortName": "路南",
          "areaCode": "0315",
          "code": 130202,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 63,
        },
        {
          "areaName": "路北区",
          "shortName": "路北",
          "areaCode": "0315",
          "code": 130203,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 64,
        },
        {
          "areaName": "古冶区",
          "shortName": "古冶",
          "areaCode": "0315",
          "code": 130204,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 65,
        },
        {
          "areaName": "开平区",
          "shortName": "开平",
          "areaCode": "0315",
          "code": 130205,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 66,
        },
        {
          "areaName": "丰南区",
          "shortName": "丰南",
          "areaCode": "0315",
          "code": 130207,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 67,
        },
        {
          "areaName": "丰润区",
          "shortName": "丰润",
          "areaCode": "0315",
          "code": 130208,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 68,
        },
        {
          "areaName": "曹妃甸区",
          "shortName": "曹妃甸",
          "areaCode": "0315",
          "code": 130209,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 69,
        },
        {
          "areaName": "滦县",
          "shortName": "滦县",
          "areaCode": "0315",
          "code": 130223,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 70,
        },
        {
          "areaName": "滦南县",
          "shortName": "滦南",
          "areaCode": "0315",
          "code": 130224,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 71,
        },
        {
          "areaName": "乐亭县",
          "shortName": "乐亭",
          "areaCode": "0315",
          "code": 130225,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 72,
        },
        {
          "areaName": "迁西县",
          "shortName": "迁西",
          "areaCode": "0315",
          "code": 130227,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 73,
        },
        {
          "areaName": "玉田县",
          "shortName": "玉田",
          "areaCode": "0315",
          "code": 130229,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 74,
        },
        {
          "areaName": "遵化市",
          "shortName": "遵化",
          "areaCode": "0315",
          "code": 130281,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 75,
        },
        {
          "areaName": "迁安市",
          "shortName": "迁安",
          "areaCode": "0315",
          "code": 130283,
          "parentCode": 130200,
          "level": 4,
          "children": null,
          "id": 76,
        },
        {
          "areaName": "秦皇岛市",
          "shortName": "秦皇岛",
          "areaCode": "0335",
          "code": 130300,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 77,
        },
        {
          "areaName": "海港区",
          "shortName": "海港",
          "areaCode": "0335",
          "code": 130302,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 78,
        },
        {
          "areaName": "山海关区",
          "shortName": "山海关",
          "areaCode": "0335",
          "code": 130303,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 79,
        },
        {
          "areaName": "北戴河区",
          "shortName": "北戴河",
          "areaCode": "0335",
          "code": 130304,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 80,
        },
        {
          "areaName": "青龙满族自治县",
          "shortName": "青龙",
          "areaCode": "0335",
          "code": 130321,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 81,
        },
        {
          "areaName": "昌黎县",
          "shortName": "昌黎",
          "areaCode": "0335",
          "code": 130322,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 82,
        },
        {
          "areaName": "抚宁县",
          "shortName": "抚宁",
          "areaCode": "0335",
          "code": 130323,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 83,
        },
        {
          "areaName": "卢龙县",
          "shortName": "卢龙",
          "areaCode": "0335",
          "code": 130324,
          "parentCode": 130300,
          "level": 4,
          "children": null,
          "id": 84,
        },
        {
          "areaName": "邯郸市",
          "shortName": "邯郸",
          "areaCode": "0310",
          "code": 130400,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 85,
        },
        {
          "areaName": "邯山区",
          "shortName": "邯山",
          "areaCode": "0310",
          "code": 130402,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 86,
        },
        {
          "areaName": "丛台区",
          "shortName": "丛台",
          "areaCode": "0310",
          "code": 130403,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 87,
        },
        {
          "areaName": "复兴区",
          "shortName": "复兴",
          "areaCode": "0310",
          "code": 130404,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 88,
        },
        {
          "areaName": "峰峰矿区",
          "shortName": "峰峰矿区",
          "areaCode": "0310",
          "code": 130406,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 89,
        },
        {
          "areaName": "邯郸县",
          "shortName": "邯郸",
          "areaCode": "0310",
          "code": 130421,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 90,
        },
        {
          "areaName": "临漳县",
          "shortName": "临漳",
          "areaCode": "0310",
          "code": 130423,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 91,
        },
        {
          "areaName": "成安县",
          "shortName": "成安",
          "areaCode": "0310",
          "code": 130424,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 92,
        },
        {
          "areaName": "大名县",
          "shortName": "大名",
          "areaCode": "0310",
          "code": 130425,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 93,
        },
        {
          "areaName": "涉县",
          "shortName": "涉县",
          "areaCode": "0310",
          "code": 130426,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 94,
        },
        {
          "areaName": "磁县",
          "shortName": "磁县",
          "areaCode": "0310",
          "code": 130427,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 95,
        },
        {
          "areaName": "肥乡县",
          "shortName": "肥乡",
          "areaCode": "0310",
          "code": 130428,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 96,
        },
        {
          "areaName": "永年县",
          "shortName": "永年",
          "areaCode": "0310",
          "code": 130429,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 97,
        },
        {
          "areaName": "邱县",
          "shortName": "邱县",
          "areaCode": "0310",
          "code": 130430,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 98,
        },
        {
          "areaName": "鸡泽县",
          "shortName": "鸡泽",
          "areaCode": "0310",
          "code": 130431,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 99,
        },
        {
          "areaName": "广平县",
          "shortName": "广平",
          "areaCode": "0310",
          "code": 130432,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 100,
        },
        {
          "areaName": "馆陶县",
          "shortName": "馆陶",
          "areaCode": "0310",
          "code": 130433,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 101,
        },
        {
          "areaName": "魏县",
          "shortName": "魏县",
          "areaCode": "0310",
          "code": 130434,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 102,
        },
        {
          "areaName": "曲周县",
          "shortName": "曲周",
          "areaCode": "0310",
          "code": 130435,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 103,
        },
        {
          "areaName": "武安市",
          "shortName": "武安",
          "areaCode": "0310",
          "code": 130481,
          "parentCode": 130400,
          "level": 4,
          "children": null,
          "id": 104,
        },
        {
          "areaName": "邢台市",
          "shortName": "邢台",
          "areaCode": "0319",
          "code": 130500,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 105,
        },
        {
          "areaName": "桥东区",
          "shortName": "桥东",
          "areaCode": "0319",
          "code": 130502,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 106,
        },
        {
          "areaName": "桥西区",
          "shortName": "桥西",
          "areaCode": "0319",
          "code": 130503,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 107,
        },
        {
          "areaName": "邢台县",
          "shortName": "邢台",
          "areaCode": "0319",
          "code": 130521,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 108,
        },
        {
          "areaName": "临城县",
          "shortName": "临城",
          "areaCode": "0319",
          "code": 130522,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 109,
        },
        {
          "areaName": "内丘县",
          "shortName": "内丘",
          "areaCode": "0319",
          "code": 130523,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 110,
        },
        {
          "areaName": "柏乡县",
          "shortName": "柏乡",
          "areaCode": "0319",
          "code": 130524,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 111,
        },
        {
          "areaName": "隆尧县",
          "shortName": "隆尧",
          "areaCode": "0319",
          "code": 130525,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 112,
        },
        {
          "areaName": "任县",
          "shortName": "任县",
          "areaCode": "0319",
          "code": 130526,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 113,
        },
        {
          "areaName": "南和县",
          "shortName": "南和",
          "areaCode": "0319",
          "code": 130527,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 114,
        },
        {
          "areaName": "宁晋县",
          "shortName": "宁晋",
          "areaCode": "0319",
          "code": 130528,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 115,
        },
        {
          "areaName": "巨鹿县",
          "shortName": "巨鹿",
          "areaCode": "0319",
          "code": 130529,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 116,
        },
        {
          "areaName": "新河县",
          "shortName": "新河",
          "areaCode": "0319",
          "code": 130530,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 117,
        },
        {
          "areaName": "广宗县",
          "shortName": "广宗",
          "areaCode": "0319",
          "code": 130531,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 118,
        },
        {
          "areaName": "平乡县",
          "shortName": "平乡",
          "areaCode": "0319",
          "code": 130532,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 119,
        },
        {
          "areaName": "威县",
          "shortName": "威县",
          "areaCode": "0319",
          "code": 130533,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 120,
        },
        {
          "areaName": "清河县",
          "shortName": "清河",
          "areaCode": "0319",
          "code": 130534,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 121,
        },
        {
          "areaName": "临西县",
          "shortName": "临西",
          "areaCode": "0319",
          "code": 130535,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 122,
        },
        {
          "areaName": "南宫市",
          "shortName": "南宫",
          "areaCode": "0319",
          "code": 130581,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 123,
        },
        {
          "areaName": "沙河市",
          "shortName": "沙河",
          "areaCode": "0319",
          "code": 130582,
          "parentCode": 130500,
          "level": 4,
          "children": null,
          "id": 124,
        },
        {
          "areaName": "保定市",
          "shortName": "保定",
          "areaCode": "0312",
          "code": 130600,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 125,
        },
        {
          "areaName": "新市区",
          "shortName": "新市",
          "areaCode": "0312",
          "code": 130602,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 126,
        },
        {
          "areaName": "北市区",
          "shortName": "北市",
          "areaCode": "0312",
          "code": 130603,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 127,
        },
        {
          "areaName": "南市区",
          "shortName": "南市",
          "areaCode": "0312",
          "code": 130604,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 128,
        },
        {
          "areaName": "满城县",
          "shortName": "满城",
          "areaCode": "0312",
          "code": 130621,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 129,
        },
        {
          "areaName": "清苑县",
          "shortName": "清苑",
          "areaCode": "0312",
          "code": 130622,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 130,
        },
        {
          "areaName": "涞水县",
          "shortName": "涞水",
          "areaCode": "0312",
          "code": 130623,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 131,
        },
        {
          "areaName": "阜平县",
          "shortName": "阜平",
          "areaCode": "0312",
          "code": 130624,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 132,
        },
        {
          "areaName": "徐水县",
          "shortName": "徐水",
          "areaCode": "0312",
          "code": 130625,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 133,
        },
        {
          "areaName": "定兴县",
          "shortName": "定兴",
          "areaCode": "0312",
          "code": 130626,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 134,
        },
        {
          "areaName": "唐县",
          "shortName": "唐县",
          "areaCode": "0312",
          "code": 130627,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 135,
        },
        {
          "areaName": "高阳县",
          "shortName": "高阳",
          "areaCode": "0312",
          "code": 130628,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 136,
        },
        {
          "areaName": "容城县",
          "shortName": "容城",
          "areaCode": "0312",
          "code": 130629,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 137,
        },
        {
          "areaName": "涞源县",
          "shortName": "涞源",
          "areaCode": "0312",
          "code": 130630,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 138,
        },
        {
          "areaName": "望都县",
          "shortName": "望都",
          "areaCode": "0312",
          "code": 130631,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 139,
        },
        {
          "areaName": "安新县",
          "shortName": "安新",
          "areaCode": "0312",
          "code": 130632,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 140,
        },
        {
          "areaName": "易县",
          "shortName": "易县",
          "areaCode": "0312",
          "code": 130633,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 141,
        },
        {
          "areaName": "曲阳县",
          "shortName": "曲阳",
          "areaCode": "0312",
          "code": 130634,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 142,
        },
        {
          "areaName": "蠡县",
          "shortName": "蠡县",
          "areaCode": "0312",
          "code": 130635,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 143,
        },
        {
          "areaName": "顺平县",
          "shortName": "顺平",
          "areaCode": "0312",
          "code": 130636,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 144,
        },
        {
          "areaName": "博野县",
          "shortName": "博野",
          "areaCode": "0312",
          "code": 130637,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 145,
        },
        {
          "areaName": "雄县",
          "shortName": "雄县",
          "areaCode": "0312",
          "code": 130638,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 146,
        },
        {
          "areaName": "涿州市",
          "shortName": "涿州",
          "areaCode": "0312",
          "code": 130681,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 147,
        },
        {
          "areaName": "定州市",
          "shortName": "定州",
          "areaCode": "0312",
          "code": 130682,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 148,
        },
        {
          "areaName": "安国市",
          "shortName": "安国",
          "areaCode": "0312",
          "code": 130683,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 149,
        },
        {
          "areaName": "高碑店市",
          "shortName": "高碑店",
          "areaCode": "0312",
          "code": 130684,
          "parentCode": 130600,
          "level": 4,
          "children": null,
          "id": 150,
        },
        {
          "areaName": "张家口市",
          "shortName": "张家口",
          "areaCode": "0313",
          "code": 130700,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 151,
        },
        {
          "areaName": "桥东区",
          "shortName": "桥东",
          "areaCode": "0313",
          "code": 130702,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 152,
        },
        {
          "areaName": "桥西区",
          "shortName": "桥西",
          "areaCode": "0313",
          "code": 130703,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 153,
        },
        {
          "areaName": "宣化区",
          "shortName": "宣化",
          "areaCode": "0313",
          "code": 130705,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 154,
        },
        {
          "areaName": "下花园区",
          "shortName": "下花园",
          "areaCode": "0313",
          "code": 130706,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 155,
        },
        {
          "areaName": "宣化县",
          "shortName": "宣化",
          "areaCode": "0313",
          "code": 130721,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 156,
        },
        {
          "areaName": "张北县",
          "shortName": "张北",
          "areaCode": "0313",
          "code": 130722,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 157,
        },
        {
          "areaName": "康保县",
          "shortName": "康保",
          "areaCode": "0313",
          "code": 130723,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 158,
        },
        {
          "areaName": "沽源县",
          "shortName": "沽源",
          "areaCode": "0313",
          "code": 130724,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 159,
        },
        {
          "areaName": "尚义县",
          "shortName": "尚义",
          "areaCode": "0313",
          "code": 130725,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 160,
        },
        {
          "areaName": "蔚县",
          "shortName": "蔚县",
          "areaCode": "0313",
          "code": 130726,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 161,
        },
        {
          "areaName": "阳原县",
          "shortName": "阳原",
          "areaCode": "0313",
          "code": 130727,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 162,
        },
        {
          "areaName": "怀安县",
          "shortName": "怀安",
          "areaCode": "0313",
          "code": 130728,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 163,
        },
        {
          "areaName": "万全县",
          "shortName": "万全",
          "areaCode": "0313",
          "code": 130729,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 164,
        },
        {
          "areaName": "怀来县",
          "shortName": "怀来",
          "areaCode": "0313",
          "code": 130730,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 165,
        },
        {
          "areaName": "涿鹿县",
          "shortName": "涿鹿",
          "areaCode": "0313",
          "code": 130731,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 166,
        },
        {
          "areaName": "赤城县",
          "shortName": "赤城",
          "areaCode": "0313",
          "code": 130732,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 167,
        },
        {
          "areaName": "崇礼县",
          "shortName": "崇礼",
          "areaCode": "0313",
          "code": 130733,
          "parentCode": 130700,
          "level": 4,
          "children": null,
          "id": 168,
        },
        {
          "areaName": "承德市",
          "shortName": "承德",
          "areaCode": "0314",
          "code": 130800,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 169,
        },
        {
          "areaName": "双桥区",
          "shortName": "双桥",
          "areaCode": "0314",
          "code": 130802,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 170,
        },
        {
          "areaName": "双滦区",
          "shortName": "双滦",
          "areaCode": "0314",
          "code": 130803,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 171,
        },
        {
          "areaName": "鹰手营子矿区",
          "shortName": "鹰手营子矿区",
          "areaCode": "0314",
          "code": 130804,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 172,
        },
        {
          "areaName": "承德县",
          "shortName": "承德",
          "areaCode": "0314",
          "code": 130821,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 173,
        },
        {
          "areaName": "兴隆县",
          "shortName": "兴隆",
          "areaCode": "0314",
          "code": 130822,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 174,
        },
        {
          "areaName": "平泉县",
          "shortName": "平泉",
          "areaCode": "0314",
          "code": 130823,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 175,
        },
        {
          "areaName": "滦平县",
          "shortName": "滦平",
          "areaCode": "0314",
          "code": 130824,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 176,
        },
        {
          "areaName": "隆化县",
          "shortName": "隆化",
          "areaCode": "0314",
          "code": 130825,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 177,
        },
        {
          "areaName": "丰宁满族自治县",
          "shortName": "丰宁",
          "areaCode": "0314",
          "code": 130826,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 178,
        },
        {
          "areaName": "宽城满族自治县",
          "shortName": "宽城",
          "areaCode": "0314",
          "code": 130827,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 179,
        },
        {
          "areaName": "围场满族蒙古族自治县",
          "shortName": "围场",
          "areaCode": "0314",
          "code": 130828,
          "parentCode": 130800,
          "level": 4,
          "children": null,
          "id": 180,
        },
        {
          "areaName": "沧州市",
          "shortName": "沧州",
          "areaCode": "0317",
          "code": 130900,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 181,
        },
        {
          "areaName": "新华区",
          "shortName": "新华",
          "areaCode": "0317",
          "code": 130902,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 182,
        },
        {
          "areaName": "运河区",
          "shortName": "运河",
          "areaCode": "0317",
          "code": 130903,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 183,
        },
        {
          "areaName": "沧县",
          "shortName": "沧县",
          "areaCode": "0317",
          "code": 130921,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 184,
        },
        {
          "areaName": "青县",
          "shortName": "青县",
          "areaCode": "0317",
          "code": 130922,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 185,
        },
        {
          "areaName": "东光县",
          "shortName": "东光",
          "areaCode": "0317",
          "code": 130923,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 186,
        },
        {
          "areaName": "海兴县",
          "shortName": "海兴",
          "areaCode": "0317",
          "code": 130924,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 187,
        },
        {
          "areaName": "盐山县",
          "shortName": "盐山",
          "areaCode": "0317",
          "code": 130925,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 188,
        },
        {
          "areaName": "肃宁县",
          "shortName": "肃宁",
          "areaCode": "0317",
          "code": 130926,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 189,
        },
        {
          "areaName": "南皮县",
          "shortName": "南皮",
          "areaCode": "0317",
          "code": 130927,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 190,
        },
        {
          "areaName": "吴桥县",
          "shortName": "吴桥",
          "areaCode": "0317",
          "code": 130928,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 191,
        },
        {
          "areaName": "献县",
          "shortName": "献县",
          "areaCode": "0317",
          "code": 130929,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 192,
        },
        {
          "areaName": "孟村回族自治县",
          "shortName": "孟村",
          "areaCode": "0317",
          "code": 130930,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 193,
        },
        {
          "areaName": "泊头市",
          "shortName": "泊头",
          "areaCode": "0317",
          "code": 130981,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 194,
        },
        {
          "areaName": "任丘市",
          "shortName": "任丘",
          "areaCode": "0317",
          "code": 130982,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 195,
        },
        {
          "areaName": "黄骅市",
          "shortName": "黄骅",
          "areaCode": "0317",
          "code": 130983,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 196,
        },
        {
          "areaName": "河间市",
          "shortName": "河间",
          "areaCode": "0317",
          "code": 130984,
          "parentCode": 130900,
          "level": 4,
          "children": null,
          "id": 197,
        },
        {
          "areaName": "廊坊市",
          "shortName": "廊坊",
          "areaCode": "0316",
          "code": 131000,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 198,
        },
        {
          "areaName": "安次区",
          "shortName": "安次",
          "areaCode": "0316",
          "code": 131002,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 199,
        },
        {
          "areaName": "广阳区",
          "shortName": "广阳",
          "areaCode": "0316",
          "code": 131003,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 200,
        },
        {
          "areaName": "固安县",
          "shortName": "固安",
          "areaCode": "0316",
          "code": 131022,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 201,
        },
        {
          "areaName": "永清县",
          "shortName": "永清",
          "areaCode": "0316",
          "code": 131023,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 202,
        },
        {
          "areaName": "香河县",
          "shortName": "香河",
          "areaCode": "0316",
          "code": 131024,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 203,
        },
        {
          "areaName": "大城县",
          "shortName": "大城",
          "areaCode": "0316",
          "code": 131025,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 204,
        },
        {
          "areaName": "文安县",
          "shortName": "文安",
          "areaCode": "0316",
          "code": 131026,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 205,
        },
        {
          "areaName": "大厂回族自治县",
          "shortName": "大厂",
          "areaCode": "0316",
          "code": 131028,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 206,
        },
        {
          "areaName": "霸州市",
          "shortName": "霸州",
          "areaCode": "0316",
          "code": 131081,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 207,
        },
        {
          "areaName": "三河市",
          "shortName": "三河",
          "areaCode": "0316",
          "code": 131082,
          "parentCode": 131000,
          "level": 4,
          "children": null,
          "id": 208,
        },
        {
          "areaName": "衡水市",
          "shortName": "衡水",
          "areaCode": "0318",
          "code": 131100,
          "parentCode": 130000,
          "level": 3,
          "children": null,
          "id": 209,
        },
        {
          "areaName": "桃城区",
          "shortName": "桃城",
          "areaCode": "0318",
          "code": 131102,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 210,
        },
        {
          "areaName": "枣强县",
          "shortName": "枣强",
          "areaCode": "0318",
          "code": 131121,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 211,
        },
        {
          "areaName": "武邑县",
          "shortName": "武邑",
          "areaCode": "0318",
          "code": 131122,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 212,
        },
        {
          "areaName": "武强县",
          "shortName": "武强",
          "areaCode": "0318",
          "code": 131123,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 213,
        },
        {
          "areaName": "饶阳县",
          "shortName": "饶阳",
          "areaCode": "0318",
          "code": 131124,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 214,
        },
        {
          "areaName": "安平县",
          "shortName": "安平",
          "areaCode": "0318",
          "code": 131125,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 215,
        },
        {
          "areaName": "故城县",
          "shortName": "故城",
          "areaCode": "0318",
          "code": 131126,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 216,
        },
        {
          "areaName": "景县",
          "shortName": "景县",
          "areaCode": "0318",
          "code": 131127,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 217,
        },
        {
          "areaName": "阜城县",
          "shortName": "阜城",
          "areaCode": "0318",
          "code": 131128,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 218,
        },
        {
          "areaName": "冀州市",
          "shortName": "冀州",
          "areaCode": "0318",
          "code": 131181,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 219,
        },
        {
          "areaName": "深州市",
          "shortName": "深州",
          "areaCode": "0318",
          "code": 131182,
          "parentCode": 131100,
          "level": 4,
          "children": null,
          "id": 220,
        }
      ],
      "id": 38,
    },
    {
      "areaName": "山西省",
      "shortName": "山西",
      "code": 140000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "太原市",
          "shortName": "太原",
          "areaCode": "0351",
          "code": 140100,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 222,
        },
        {
          "areaName": "小店区",
          "shortName": "小店",
          "areaCode": "0351",
          "code": 140105,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 223,
        },
        {
          "areaName": "迎泽区",
          "shortName": "迎泽",
          "areaCode": "0351",
          "code": 140106,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 224,
        },
        {
          "areaName": "杏花岭区",
          "shortName": "杏花岭",
          "areaCode": "0351",
          "code": 140107,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 225,
        },
        {
          "areaName": "尖草坪区",
          "shortName": "尖草坪",
          "areaCode": "0351",
          "code": 140108,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 226,
        },
        {
          "areaName": "万柏林区",
          "shortName": "万柏林",
          "areaCode": "0351",
          "code": 140109,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 227,
        },
        {
          "areaName": "晋源区",
          "shortName": "晋源",
          "areaCode": "0351",
          "code": 140110,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 228,
        },
        {
          "areaName": "清徐县",
          "shortName": "清徐",
          "areaCode": "0351",
          "code": 140121,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 229,
        },
        {
          "areaName": "阳曲县",
          "shortName": "阳曲",
          "areaCode": "0351",
          "code": 140122,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 230,
        },
        {
          "areaName": "娄烦县",
          "shortName": "娄烦",
          "areaCode": "0351",
          "code": 140123,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 231,
        },
        {
          "areaName": "古交市",
          "shortName": "古交",
          "areaCode": "0351",
          "code": 140181,
          "parentCode": 140100,
          "level": 4,
          "children": null,
          "id": 232,
        },
        {
          "areaName": "大同市",
          "shortName": "大同",
          "areaCode": "0352",
          "code": 140200,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 233,
        },
        {
          "areaName": "城区",
          "shortName": "城区",
          "areaCode": "0352",
          "code": 140202,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 234,
        },
        {
          "areaName": "矿区",
          "shortName": "矿区",
          "areaCode": "0352",
          "code": 140203,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 235,
        },
        {
          "areaName": "南郊区",
          "shortName": "南郊",
          "areaCode": "0352",
          "code": 140211,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 236,
        },
        {
          "areaName": "新荣区",
          "shortName": "新荣",
          "areaCode": "0352",
          "code": 140212,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 237,
        },
        {
          "areaName": "阳高县",
          "shortName": "阳高",
          "areaCode": "0352",
          "code": 140221,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 238,
        },
        {
          "areaName": "天镇县",
          "shortName": "天镇",
          "areaCode": "0352",
          "code": 140222,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 239,
        },
        {
          "areaName": "广灵县",
          "shortName": "广灵",
          "areaCode": "0352",
          "code": 140223,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 240,
        },
        {
          "areaName": "灵丘县",
          "shortName": "灵丘",
          "areaCode": "0352",
          "code": 140224,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 241,
        },
        {
          "areaName": "浑源县",
          "shortName": "浑源",
          "areaCode": "0352",
          "code": 140225,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 242,
        },
        {
          "areaName": "左云县",
          "shortName": "左云",
          "areaCode": "0352",
          "code": 140226,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 243,
        },
        {
          "areaName": "大同县",
          "shortName": "大同",
          "areaCode": "0352",
          "code": 140227,
          "parentCode": 140200,
          "level": 4,
          "children": null,
          "id": 244,
        },
        {
          "areaName": "阳泉市",
          "shortName": "阳泉",
          "areaCode": "0353",
          "code": 140300,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 245,
        },
        {
          "areaName": "城区",
          "shortName": "城区",
          "areaCode": "0353",
          "code": 140302,
          "parentCode": 140300,
          "level": 4,
          "children": null,
          "id": 246,
        },
        {
          "areaName": "矿区",
          "shortName": "矿区",
          "areaCode": "0353",
          "code": 140303,
          "parentCode": 140300,
          "level": 4,
          "children": null,
          "id": 247,
        },
        {
          "areaName": "郊区",
          "shortName": "郊区",
          "areaCode": "0353",
          "code": 140311,
          "parentCode": 140300,
          "level": 4,
          "children": null,
          "id": 248,
        },
        {
          "areaName": "平定县",
          "shortName": "平定",
          "areaCode": "0353",
          "code": 140321,
          "parentCode": 140300,
          "level": 4,
          "children": null,
          "id": 249,
        },
        {
          "areaName": "盂县",
          "shortName": "盂县",
          "areaCode": "0353",
          "code": 140322,
          "parentCode": 140300,
          "level": 4,
          "children": null,
          "id": 250,
        },
        {
          "areaName": "长治市",
          "shortName": "长治",
          "areaCode": "0355",
          "code": 140400,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 251,
        },
        {
          "areaName": "城区",
          "shortName": "城区",
          "areaCode": "0355",
          "code": 140402,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 252,
        },
        {
          "areaName": "郊区",
          "shortName": "郊区",
          "areaCode": "0355",
          "code": 140411,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 253,
        },
        {
          "areaName": "长治县",
          "shortName": "长治",
          "areaCode": "0355",
          "code": 140421,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 254,
        },
        {
          "areaName": "襄垣县",
          "shortName": "襄垣",
          "areaCode": "0355",
          "code": 140423,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 255,
        },
        {
          "areaName": "屯留县",
          "shortName": "屯留",
          "areaCode": "0355",
          "code": 140424,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 256,
        },
        {
          "areaName": "平顺县",
          "shortName": "平顺",
          "areaCode": "0355",
          "code": 140425,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 257,
        },
        {
          "areaName": "黎城县",
          "shortName": "黎城",
          "areaCode": "0355",
          "code": 140426,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 258,
        },
        {
          "areaName": "壶关县",
          "shortName": "壶关",
          "areaCode": "0355",
          "code": 140427,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 259,
        },
        {
          "areaName": "长子县",
          "shortName": "长子",
          "areaCode": "0355",
          "code": 140428,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 260,
        },
        {
          "areaName": "武乡县",
          "shortName": "武乡",
          "areaCode": "0355",
          "code": 140429,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 261,
        },
        {
          "areaName": "沁县",
          "shortName": "沁县",
          "areaCode": "0355",
          "code": 140430,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 262,
        },
        {
          "areaName": "沁源县",
          "shortName": "沁源",
          "areaCode": "0355",
          "code": 140431,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 263,
        },
        {
          "areaName": "潞城市",
          "shortName": "潞城",
          "areaCode": "0355",
          "code": 140481,
          "parentCode": 140400,
          "level": 4,
          "children": null,
          "id": 264,
        },
        {
          "areaName": "晋城市",
          "shortName": "晋城",
          "areaCode": "0356",
          "code": 140500,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 265,
        },
        {
          "areaName": "城区",
          "shortName": "城区",
          "areaCode": "0356",
          "code": 140502,
          "parentCode": 140500,
          "level": 4,
          "children": null,
          "id": 266,
        },
        {
          "areaName": "沁水县",
          "shortName": "沁水",
          "areaCode": "0356",
          "code": 140521,
          "parentCode": 140500,
          "level": 4,
          "children": null,
          "id": 267,
        },
        {
          "areaName": "阳城县",
          "shortName": "阳城",
          "areaCode": "0356",
          "code": 140522,
          "parentCode": 140500,
          "level": 4,
          "children": null,
          "id": 268,
        },
        {
          "areaName": "陵川县",
          "shortName": "陵川",
          "areaCode": "0356",
          "code": 140524,
          "parentCode": 140500,
          "level": 4,
          "children": null,
          "id": 269,
        },
        {
          "areaName": "泽州县",
          "shortName": "泽州",
          "areaCode": "0356",
          "code": 140525,
          "parentCode": 140500,
          "level": 4,
          "children": null,
          "id": 270,
        },
        {
          "areaName": "高平市",
          "shortName": "高平",
          "areaCode": "0356",
          "code": 140581,
          "parentCode": 140500,
          "level": 4,
          "children": null,
          "id": 271,
        },
        {
          "areaName": "朔州市",
          "shortName": "朔州",
          "areaCode": "0349",
          "code": 140600,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 272,
        },
        {
          "areaName": "朔城区",
          "shortName": "朔城",
          "areaCode": "0349",
          "code": 140602,
          "parentCode": 140600,
          "level": 4,
          "children": null,
          "id": 273,
        },
        {
          "areaName": "平鲁区",
          "shortName": "平鲁",
          "areaCode": "0349",
          "code": 140603,
          "parentCode": 140600,
          "level": 4,
          "children": null,
          "id": 274,
        },
        {
          "areaName": "山阴县",
          "shortName": "山阴",
          "areaCode": "0349",
          "code": 140621,
          "parentCode": 140600,
          "level": 4,
          "children": null,
          "id": 275,
        },
        {
          "areaName": "应县",
          "shortName": "应县",
          "areaCode": "0349",
          "code": 140622,
          "parentCode": 140600,
          "level": 4,
          "children": null,
          "id": 276,
        },
        {
          "areaName": "右玉县",
          "shortName": "右玉",
          "areaCode": "0349",
          "code": 140623,
          "parentCode": 140600,
          "level": 4,
          "children": null,
          "id": 277,
        },
        {
          "areaName": "怀仁县",
          "shortName": "怀仁",
          "areaCode": "0349",
          "code": 140624,
          "parentCode": 140600,
          "level": 4,
          "children": null,
          "id": 278,
        },
        {
          "areaName": "晋中市",
          "shortName": "晋中",
          "areaCode": "0354",
          "code": 140700,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 279,
        },
        {
          "areaName": "榆次区",
          "shortName": "榆次",
          "areaCode": "0354",
          "code": 140702,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 280,
        },
        {
          "areaName": "榆社县",
          "shortName": "榆社",
          "areaCode": "0354",
          "code": 140721,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 281,
        },
        {
          "areaName": "左权县",
          "shortName": "左权",
          "areaCode": "0354",
          "code": 140722,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 282,
        },
        {
          "areaName": "和顺县",
          "shortName": "和顺",
          "areaCode": "0354",
          "code": 140723,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 283,
        },
        {
          "areaName": "昔阳县",
          "shortName": "昔阳",
          "areaCode": "0354",
          "code": 140724,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 284,
        },
        {
          "areaName": "寿阳县",
          "shortName": "寿阳",
          "areaCode": "0354",
          "code": 140725,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 285,
        },
        {
          "areaName": "太谷县",
          "shortName": "太谷",
          "areaCode": "0354",
          "code": 140726,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 286,
        },
        {
          "areaName": "祁县",
          "shortName": "祁县",
          "areaCode": "0354",
          "code": 140727,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 287,
        },
        {
          "areaName": "平遥县",
          "shortName": "平遥",
          "areaCode": "0354",
          "code": 140728,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 288,
        },
        {
          "areaName": "灵石县",
          "shortName": "灵石",
          "areaCode": "0354",
          "code": 140729,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 289,
        },
        {
          "areaName": "介休市",
          "shortName": "介休",
          "areaCode": "0354",
          "code": 140781,
          "parentCode": 140700,
          "level": 4,
          "children": null,
          "id": 290,
        },
        {
          "areaName": "运城市",
          "shortName": "运城",
          "areaCode": "0359",
          "code": 140800,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 291,
        },
        {
          "areaName": "盐湖区",
          "shortName": "盐湖",
          "areaCode": "0359",
          "code": 140802,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 292,
        },
        {
          "areaName": "临猗县",
          "shortName": "临猗",
          "areaCode": "0359",
          "code": 140821,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 293,
        },
        {
          "areaName": "万荣县",
          "shortName": "万荣",
          "areaCode": "0359",
          "code": 140822,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 294,
        },
        {
          "areaName": "闻喜县",
          "shortName": "闻喜",
          "areaCode": "0359",
          "code": 140823,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 295,
        },
        {
          "areaName": "稷山县",
          "shortName": "稷山",
          "areaCode": "0359",
          "code": 140824,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 296,
        },
        {
          "areaName": "新绛县",
          "shortName": "新绛",
          "areaCode": "0359",
          "code": 140825,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 297,
        },
        {
          "areaName": "绛县",
          "shortName": "绛县",
          "areaCode": "0359",
          "code": 140826,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 298,
        },
        {
          "areaName": "垣曲县",
          "shortName": "垣曲",
          "areaCode": "0359",
          "code": 140827,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 299,
        },
        {
          "areaName": "夏县",
          "shortName": "夏县",
          "areaCode": "0359",
          "code": 140828,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 300,
        },
        {
          "areaName": "平陆县",
          "shortName": "平陆",
          "areaCode": "0359",
          "code": 140829,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 301,
        },
        {
          "areaName": "芮城县",
          "shortName": "芮城",
          "areaCode": "0359",
          "code": 140830,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 302,
        },
        {
          "areaName": "永济市",
          "shortName": "永济",
          "areaCode": "0359",
          "code": 140881,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 303,
        },
        {
          "areaName": "河津市",
          "shortName": "河津",
          "areaCode": "0359",
          "code": 140882,
          "parentCode": 140800,
          "level": 4,
          "children": null,
          "id": 304,
        },
        {
          "areaName": "忻州市",
          "shortName": "忻州",
          "areaCode": "0350",
          "code": 140900,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 305,
        },
        {
          "areaName": "忻府区",
          "shortName": "忻府",
          "areaCode": "0350",
          "code": 140902,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 306,
        },
        {
          "areaName": "定襄县",
          "shortName": "定襄",
          "areaCode": "0350",
          "code": 140921,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 307,
        },
        {
          "areaName": "五台县",
          "shortName": "五台",
          "areaCode": "0350",
          "code": 140922,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 308,
        },
        {
          "areaName": "代县",
          "shortName": "代县",
          "areaCode": "0350",
          "code": 140923,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 309,
        },
        {
          "areaName": "繁峙县",
          "shortName": "繁峙",
          "areaCode": "0350",
          "code": 140924,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 310,
        },
        {
          "areaName": "宁武县",
          "shortName": "宁武",
          "areaCode": "0350",
          "code": 140925,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 311,
        },
        {
          "areaName": "静乐县",
          "shortName": "静乐",
          "areaCode": "0350",
          "code": 140926,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 312,
        },
        {
          "areaName": "神池县",
          "shortName": "神池",
          "areaCode": "0350",
          "code": 140927,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 313,
        },
        {
          "areaName": "五寨县",
          "shortName": "五寨",
          "areaCode": "0350",
          "code": 140928,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 314,
        },
        {
          "areaName": "岢岚县",
          "shortName": "岢岚",
          "areaCode": "0350",
          "code": 140929,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 315,
        },
        {
          "areaName": "河曲县",
          "shortName": "河曲",
          "areaCode": "0350",
          "code": 140930,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 316,
        },
        {
          "areaName": "保德县",
          "shortName": "保德",
          "areaCode": "0350",
          "code": 140931,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 317,
        },
        {
          "areaName": "偏关县",
          "shortName": "偏关",
          "areaCode": "0350",
          "code": 140932,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 318,
        },
        {
          "areaName": "原平市",
          "shortName": "原平",
          "areaCode": "0350",
          "code": 140981,
          "parentCode": 140900,
          "level": 4,
          "children": null,
          "id": 319,
        },
        {
          "areaName": "临汾市",
          "shortName": "临汾",
          "areaCode": "0357",
          "code": 141000,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 320,
        },
        {
          "areaName": "尧都区",
          "shortName": "尧都",
          "areaCode": "0357",
          "code": 141002,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 321,
        },
        {
          "areaName": "曲沃县",
          "shortName": "曲沃",
          "areaCode": "0357",
          "code": 141021,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 322,
        },
        {
          "areaName": "翼城县",
          "shortName": "翼城",
          "areaCode": "0357",
          "code": 141022,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 323,
        },
        {
          "areaName": "襄汾县",
          "shortName": "襄汾",
          "areaCode": "0357",
          "code": 141023,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 324,
        },
        {
          "areaName": "洪洞县",
          "shortName": "洪洞",
          "areaCode": "0357",
          "code": 141024,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 325,
        },
        {
          "areaName": "古县",
          "shortName": "古县",
          "areaCode": "0357",
          "code": 141025,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 326,
        },
        {
          "areaName": "安泽县",
          "shortName": "安泽",
          "areaCode": "0357",
          "code": 141026,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 327,
        },
        {
          "areaName": "浮山县",
          "shortName": "浮山",
          "areaCode": "0357",
          "code": 141027,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 328,
        },
        {
          "areaName": "吉县",
          "shortName": "吉县",
          "areaCode": "0357",
          "code": 141028,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 329,
        },
        {
          "areaName": "乡宁县",
          "shortName": "乡宁",
          "areaCode": "0357",
          "code": 141029,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 330,
        },
        {
          "areaName": "大宁县",
          "shortName": "大宁",
          "areaCode": "0357",
          "code": 141030,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 331,
        },
        {
          "areaName": "隰县",
          "shortName": "隰县",
          "areaCode": "0357",
          "code": 141031,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 332,
        },
        {
          "areaName": "永和县",
          "shortName": "永和",
          "areaCode": "0357",
          "code": 141032,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 333,
        },
        {
          "areaName": "蒲县",
          "shortName": "蒲县",
          "areaCode": "0357",
          "code": 141033,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 334,
        },
        {
          "areaName": "汾西县",
          "shortName": "汾西",
          "areaCode": "0357",
          "code": 141034,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 335,
        },
        {
          "areaName": "侯马市",
          "shortName": "侯马",
          "areaCode": "0357",
          "code": 141081,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 336,
        },
        {
          "areaName": "霍州市",
          "shortName": "霍州",
          "areaCode": "0357",
          "code": 141082,
          "parentCode": 141000,
          "level": 4,
          "children": null,
          "id": 337,
        },
        {
          "areaName": "吕梁市",
          "shortName": "吕梁",
          "areaCode": "0358",
          "code": 141100,
          "parentCode": 140000,
          "level": 3,
          "children": null,
          "id": 338,
        },
        {
          "areaName": "离石区",
          "shortName": "离石",
          "areaCode": "0358",
          "code": 141102,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 339,
        },
        {
          "areaName": "文水县",
          "shortName": "文水",
          "areaCode": "0358",
          "code": 141121,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 340,
        },
        {
          "areaName": "交城县",
          "shortName": "交城",
          "areaCode": "0358",
          "code": 141122,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 341,
        },
        {
          "areaName": "兴县",
          "shortName": "兴县",
          "areaCode": "0358",
          "code": 141123,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 342,
        },
        {
          "areaName": "临县",
          "shortName": "临县",
          "areaCode": "0358",
          "code": 141124,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 343,
        },
        {
          "areaName": "柳林县",
          "shortName": "柳林",
          "areaCode": "0358",
          "code": 141125,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 344,
        },
        {
          "areaName": "石楼县",
          "shortName": "石楼",
          "areaCode": "0358",
          "code": 141126,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 345,
        },
        {
          "areaName": "岚县",
          "shortName": "岚县",
          "areaCode": "0358",
          "code": 141127,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 346,
        },
        {
          "areaName": "方山县",
          "shortName": "方山",
          "areaCode": "0358",
          "code": 141128,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 347,
        },
        {
          "areaName": "中阳县",
          "shortName": "中阳",
          "areaCode": "0358",
          "code": 141129,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 348,
        },
        {
          "areaName": "交口县",
          "shortName": "交口",
          "areaCode": "0358",
          "code": 141130,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 349,
        },
        {
          "areaName": "孝义市",
          "shortName": "孝义",
          "areaCode": "0358",
          "code": 141181,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 350,
        },
        {
          "areaName": "汾阳市",
          "shortName": "汾阳",
          "areaCode": "0358",
          "code": 141182,
          "parentCode": 141100,
          "level": 4,
          "children": null,
          "id": 351,
        }
      ],
      "id": 221,
    },
    {
      "areaName": "内蒙古自治区",
      "shortName": "内蒙古",
      "code": 150000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "呼和浩特市",
          "shortName": "呼和浩特",
          "areaCode": "0471",
          "code": 150100,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 353,
        },
        {
          "areaName": "新城区",
          "shortName": "新城",
          "areaCode": "0471",
          "code": 150102,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 354,
        },
        {
          "areaName": "回民区",
          "shortName": "回民",
          "areaCode": "0471",
          "code": 150103,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 355,
        },
        {
          "areaName": "玉泉区",
          "shortName": "玉泉",
          "areaCode": "0471",
          "code": 150104,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 356,
        },
        {
          "areaName": "赛罕区",
          "shortName": "赛罕",
          "areaCode": "0471",
          "code": 150105,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 357,
        },
        {
          "areaName": "土默特左旗",
          "shortName": "土默特左旗",
          "areaCode": "0471",
          "code": 150121,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 358,
        },
        {
          "areaName": "托克托县",
          "shortName": "托克托",
          "areaCode": "0471",
          "code": 150122,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 359,
        },
        {
          "areaName": "和林格尔县",
          "shortName": "和林格尔",
          "areaCode": "0471",
          "code": 150123,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 360,
        },
        {
          "areaName": "清水河县",
          "shortName": "清水河",
          "areaCode": "0471",
          "code": 150124,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 361,
        },
        {
          "areaName": "武川县",
          "shortName": "武川",
          "areaCode": "0471",
          "code": 150125,
          "parentCode": 150100,
          "level": 4,
          "children": null,
          "id": 362,
        },
        {
          "areaName": "包头市",
          "shortName": "包头",
          "areaCode": "0472",
          "code": 150200,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 363,
        },
        {
          "areaName": "东河区",
          "shortName": "东河",
          "areaCode": "0472",
          "code": 150202,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 364,
        },
        {
          "areaName": "昆都仑区",
          "shortName": "昆都仑",
          "areaCode": "0472",
          "code": 150203,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 365,
        },
        {
          "areaName": "青山区",
          "shortName": "青山",
          "areaCode": "0472",
          "code": 150204,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 366,
        },
        {
          "areaName": "石拐区",
          "shortName": "石拐",
          "areaCode": "0472",
          "code": 150205,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 367,
        },
        {
          "areaName": "白云鄂博矿区",
          "shortName": "白云鄂博矿区",
          "areaCode": "0472",
          "code": 150206,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 368,
        },
        {
          "areaName": "九原区",
          "shortName": "九原",
          "areaCode": "0472",
          "code": 150207,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 369,
        },
        {
          "areaName": "土默特右旗",
          "shortName": "土默特右旗",
          "areaCode": "0472",
          "code": 150221,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 370,
        },
        {
          "areaName": "固阳县",
          "shortName": "固阳",
          "areaCode": "0472",
          "code": 150222,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 371,
        },
        {
          "areaName": "达尔罕茂明安联合旗",
          "shortName": "达茂旗",
          "areaCode": "0472",
          "code": 150223,
          "parentCode": 150200,
          "level": 4,
          "children": null,
          "id": 372,
        },
        {
          "areaName": "乌海市",
          "shortName": "乌海",
          "areaCode": "0473",
          "code": 150300,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 373,
        },
        {
          "areaName": "海勃湾区",
          "shortName": "海勃湾",
          "areaCode": "0473",
          "code": 150302,
          "parentCode": 150300,
          "level": 4,
          "children": null,
          "id": 374,
        },
        {
          "areaName": "海南区",
          "shortName": "海南",
          "areaCode": "0473",
          "code": 150303,
          "parentCode": 150300,
          "level": 4,
          "children": null,
          "id": 375,
        },
        {
          "areaName": "乌达区",
          "shortName": "乌达",
          "areaCode": "0473",
          "code": 150304,
          "parentCode": 150300,
          "level": 4,
          "children": null,
          "id": 376,
        },
        {
          "areaName": "赤峰市",
          "shortName": "赤峰",
          "areaCode": "0476",
          "code": 150400,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 377,
        },
        {
          "areaName": "红山区",
          "shortName": "红山",
          "areaCode": "0476",
          "code": 150402,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 378,
        },
        {
          "areaName": "元宝山区",
          "shortName": "元宝山",
          "areaCode": "0476",
          "code": 150403,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 379,
        },
        {
          "areaName": "松山区",
          "shortName": "松山",
          "areaCode": "0476",
          "code": 150404,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 380,
        },
        {
          "areaName": "阿鲁科尔沁旗",
          "shortName": "阿鲁科尔沁旗",
          "areaCode": "0476",
          "code": 150421,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 381,
        },
        {
          "areaName": "巴林左旗",
          "shortName": "巴林左旗",
          "areaCode": "0476",
          "code": 150422,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 382,
        },
        {
          "areaName": "巴林右旗",
          "shortName": "巴林右旗",
          "areaCode": "0476",
          "code": 150423,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 383,
        },
        {
          "areaName": "林西县",
          "shortName": "林西",
          "areaCode": "0476",
          "code": 150424,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 384,
        },
        {
          "areaName": "克什克腾旗",
          "shortName": "克什克腾旗",
          "areaCode": "0476",
          "code": 150425,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 385,
        },
        {
          "areaName": "翁牛特旗",
          "shortName": "翁牛特旗",
          "areaCode": "0476",
          "code": 150426,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 386,
        },
        {
          "areaName": "喀喇沁旗",
          "shortName": "喀喇沁旗",
          "areaCode": "0476",
          "code": 150428,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 387,
        },
        {
          "areaName": "宁城县",
          "shortName": "宁城",
          "areaCode": "0476",
          "code": 150429,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 388,
        },
        {
          "areaName": "敖汉旗",
          "shortName": "敖汉旗",
          "areaCode": "0476",
          "code": 150430,
          "parentCode": 150400,
          "level": 4,
          "children": null,
          "id": 389,
        },
        {
          "areaName": "通辽市",
          "shortName": "通辽",
          "areaCode": "0475",
          "code": 150500,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 390,
        },
        {
          "areaName": "科尔沁区",
          "shortName": "科尔沁",
          "areaCode": "0475",
          "code": 150502,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 391,
        },
        {
          "areaName": "科尔沁左翼中旗",
          "shortName": "科尔沁左翼中旗",
          "areaCode": "0475",
          "code": 150521,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 392,
        },
        {
          "areaName": "科尔沁左翼后旗",
          "shortName": "科尔沁左翼后旗",
          "areaCode": "0475",
          "code": 150522,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 393,
        },
        {
          "areaName": "开鲁县",
          "shortName": "开鲁",
          "areaCode": "0475",
          "code": 150523,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 394,
        },
        {
          "areaName": "库伦旗",
          "shortName": "库伦旗",
          "areaCode": "0475",
          "code": 150524,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 395,
        },
        {
          "areaName": "奈曼旗",
          "shortName": "奈曼旗",
          "areaCode": "0475",
          "code": 150525,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 396,
        },
        {
          "areaName": "扎鲁特旗",
          "shortName": "扎鲁特旗",
          "areaCode": "0475",
          "code": 150526,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 397,
        },
        {
          "areaName": "霍林郭勒市",
          "shortName": "霍林郭勒",
          "areaCode": "0475",
          "code": 150581,
          "parentCode": 150500,
          "level": 4,
          "children": null,
          "id": 398,
        },
        {
          "areaName": "鄂尔多斯市",
          "shortName": "鄂尔多斯",
          "areaCode": "0477",
          "code": 150600,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 399,
        },
        {
          "areaName": "东胜区",
          "shortName": "东胜",
          "areaCode": "0477",
          "code": 150602,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 400,
        },
        {
          "areaName": "达拉特旗",
          "shortName": "达拉特旗",
          "areaCode": "0477",
          "code": 150621,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 401,
        },
        {
          "areaName": "准格尔旗",
          "shortName": "准格尔旗",
          "areaCode": "0477",
          "code": 150622,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 402,
        },
        {
          "areaName": "鄂托克前旗",
          "shortName": "鄂托克前旗",
          "areaCode": "0477",
          "code": 150623,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 403,
        },
        {
          "areaName": "鄂托克旗",
          "shortName": "鄂托克旗",
          "areaCode": "0477",
          "code": 150624,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 404,
        },
        {
          "areaName": "杭锦旗",
          "shortName": "杭锦旗",
          "areaCode": "0477",
          "code": 150625,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 405,
        },
        {
          "areaName": "乌审旗",
          "shortName": "乌审旗",
          "areaCode": "0477",
          "code": 150626,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 406,
        },
        {
          "areaName": "伊金霍洛旗",
          "shortName": "伊金霍洛旗",
          "areaCode": "0477",
          "code": 150627,
          "parentCode": 150600,
          "level": 4,
          "children": null,
          "id": 407,
        },
        {
          "areaName": "呼伦贝尔市",
          "shortName": "呼伦贝尔",
          "areaCode": "0470",
          "code": 150700,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 408,
        },
        {
          "areaName": "海拉尔区",
          "shortName": "海拉尔",
          "areaCode": "0470",
          "code": 150702,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 409,
        },
        {
          "areaName": "扎赉诺尔区",
          "shortName": "扎赉诺尔",
          "areaCode": "0470",
          "code": 150703,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 410,
        },
        {
          "areaName": "阿荣旗",
          "shortName": "阿荣旗",
          "areaCode": "0470",
          "code": 150721,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 411,
        },
        {
          "areaName": "莫力达瓦达斡尔族自治旗",
          "shortName": "莫旗",
          "areaCode": "0470",
          "code": 150722,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 412,
        },
        {
          "areaName": "鄂伦春自治旗",
          "shortName": "鄂伦春",
          "areaCode": "0470",
          "code": 150723,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 413,
        },
        {
          "areaName": "鄂温克族自治旗",
          "shortName": "鄂温",
          "areaCode": "0470",
          "code": 150724,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 414,
        },
        {
          "areaName": "陈巴尔虎旗",
          "shortName": "陈巴尔虎旗",
          "areaCode": "0470",
          "code": 150725,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 415,
        },
        {
          "areaName": "新巴尔虎左旗",
          "shortName": "新巴尔虎左旗",
          "areaCode": "0470",
          "code": 150726,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 416,
        },
        {
          "areaName": "新巴尔虎右旗",
          "shortName": "新巴尔虎右旗",
          "areaCode": "0470",
          "code": 150727,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 417,
        },
        {
          "areaName": "满洲里市",
          "shortName": "满洲里",
          "areaCode": "0470",
          "code": 150781,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 418,
        },
        {
          "areaName": "牙克石市",
          "shortName": "牙克石",
          "areaCode": "0470",
          "code": 150782,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 419,
        },
        {
          "areaName": "扎兰屯市",
          "shortName": "扎兰屯",
          "areaCode": "0470",
          "code": 150783,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 420,
        },
        {
          "areaName": "额尔古纳市",
          "shortName": "额尔古纳",
          "areaCode": "0470",
          "code": 150784,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 421,
        },
        {
          "areaName": "根河市",
          "shortName": "根河",
          "areaCode": "0470",
          "code": 150785,
          "parentCode": 150700,
          "level": 4,
          "children": null,
          "id": 422,
        },
        {
          "areaName": "巴彦淖尔市",
          "shortName": "巴彦淖尔",
          "areaCode": "0478",
          "code": 150800,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 423,
        },
        {
          "areaName": "临河区",
          "shortName": "临河",
          "areaCode": "0478",
          "code": 150802,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 424,
        },
        {
          "areaName": "五原县",
          "shortName": "五原",
          "areaCode": "0478",
          "code": 150821,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 425,
        },
        {
          "areaName": "磴口县",
          "shortName": "磴口",
          "areaCode": "0478",
          "code": 150822,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 426,
        },
        {
          "areaName": "乌拉特前旗",
          "shortName": "乌拉特前旗",
          "areaCode": "0478",
          "code": 150823,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 427,
        },
        {
          "areaName": "乌拉特中旗",
          "shortName": "乌拉特中旗",
          "areaCode": "0478",
          "code": 150824,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 428,
        },
        {
          "areaName": "乌拉特后旗",
          "shortName": "乌拉特后旗",
          "areaCode": "0478",
          "code": 150825,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 429,
        },
        {
          "areaName": "杭锦后旗",
          "shortName": "杭锦后旗",
          "areaCode": "0478",
          "code": 150826,
          "parentCode": 150800,
          "level": 4,
          "children": null,
          "id": 430,
        },
        {
          "areaName": "乌兰察布市",
          "shortName": "乌兰察布",
          "areaCode": "0474",
          "code": 150900,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 431,
        },
        {
          "areaName": "集宁区",
          "shortName": "集宁",
          "areaCode": "0474",
          "code": 150902,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 432,
        },
        {
          "areaName": "卓资县",
          "shortName": "卓资",
          "areaCode": "0474",
          "code": 150921,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 433,
        },
        {
          "areaName": "化德县",
          "shortName": "化德",
          "areaCode": "0474",
          "code": 150922,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 434,
        },
        {
          "areaName": "商都县",
          "shortName": "商都",
          "areaCode": "0474",
          "code": 150923,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 435,
        },
        {
          "areaName": "兴和县",
          "shortName": "兴和",
          "areaCode": "0474",
          "code": 150924,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 436,
        },
        {
          "areaName": "凉城县",
          "shortName": "凉城",
          "areaCode": "0474",
          "code": 150925,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 437,
        },
        {
          "areaName": "察哈尔右翼前旗",
          "shortName": "察右前旗",
          "areaCode": "0474",
          "code": 150926,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 438,
        },
        {
          "areaName": "察哈尔右翼中旗",
          "shortName": "察右中旗",
          "areaCode": "0474",
          "code": 150927,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 439,
        },
        {
          "areaName": "察哈尔右翼后旗",
          "shortName": "察右后旗",
          "areaCode": "0474",
          "code": 150928,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 440,
        },
        {
          "areaName": "四子王旗",
          "shortName": "四子王旗",
          "areaCode": "0474",
          "code": 150929,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 441,
        },
        {
          "areaName": "丰镇市",
          "shortName": "丰镇",
          "areaCode": "0474",
          "code": 150981,
          "parentCode": 150900,
          "level": 4,
          "children": null,
          "id": 442,
        },
        {
          "areaName": "兴安盟",
          "shortName": "兴安盟",
          "areaCode": "0482",
          "code": 152200,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 443,
        },
        {
          "areaName": "乌兰浩特市",
          "shortName": "乌兰浩特",
          "areaCode": "0482",
          "code": 152201,
          "parentCode": 152200,
          "level": 4,
          "children": null,
          "id": 444,
        },
        {
          "areaName": "阿尔山市",
          "shortName": "阿尔山",
          "areaCode": "0482",
          "code": 152202,
          "parentCode": 152200,
          "level": 4,
          "children": null,
          "id": 445,
        },
        {
          "areaName": "科尔沁右翼前旗",
          "shortName": "科右前旗",
          "areaCode": "0482",
          "code": 152221,
          "parentCode": 152200,
          "level": 4,
          "children": null,
          "id": 446,
        },
        {
          "areaName": "科尔沁右翼中旗",
          "shortName": "科右中旗",
          "areaCode": "0482",
          "code": 152222,
          "parentCode": 152200,
          "level": 4,
          "children": null,
          "id": 447,
        },
        {
          "areaName": "扎赉特旗",
          "shortName": "扎赉特旗",
          "areaCode": "0482",
          "code": 152223,
          "parentCode": 152200,
          "level": 4,
          "children": null,
          "id": 448,
        },
        {
          "areaName": "突泉县",
          "shortName": "突泉",
          "areaCode": "0482",
          "code": 152224,
          "parentCode": 152200,
          "level": 4,
          "children": null,
          "id": 449,
        },
        {
          "areaName": "锡林郭勒盟",
          "shortName": "锡林郭勒盟",
          "areaCode": "0479",
          "code": 152500,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 450,
        },
        {
          "areaName": "二连浩特市",
          "shortName": "二连浩特",
          "areaCode": "0479",
          "code": 152501,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 451,
        },
        {
          "areaName": "锡林浩特市",
          "shortName": "锡林浩特",
          "areaCode": "0479",
          "code": 152502,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 452,
        },
        {
          "areaName": "阿巴嘎旗",
          "shortName": "阿巴嘎旗",
          "areaCode": "0479",
          "code": 152522,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 453,
        },
        {
          "areaName": "苏尼特左旗",
          "shortName": "苏尼特左旗",
          "areaCode": "0479",
          "code": 152523,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 454,
        },
        {
          "areaName": "苏尼特右旗",
          "shortName": "苏尼特右旗",
          "areaCode": "0479",
          "code": 152524,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 455,
        },
        {
          "areaName": "东乌珠穆沁旗",
          "shortName": "东乌旗",
          "areaCode": "0479",
          "code": 152525,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 456,
        },
        {
          "areaName": "西乌珠穆沁旗",
          "shortName": "西乌旗",
          "areaCode": "0479",
          "code": 152526,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 457,
        },
        {
          "areaName": "太仆寺旗",
          "shortName": "太仆寺旗",
          "areaCode": "0479",
          "code": 152527,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 458,
        },
        {
          "areaName": "镶黄旗",
          "shortName": "镶黄旗",
          "areaCode": "0479",
          "code": 152528,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 459,
        },
        {
          "areaName": "正镶白旗",
          "shortName": "正镶白旗",
          "areaCode": "0479",
          "code": 152529,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 460,
        },
        {
          "areaName": "正蓝旗",
          "shortName": "正蓝旗",
          "areaCode": "0479",
          "code": 152530,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 461,
        },
        {
          "areaName": "多伦县",
          "shortName": "多伦",
          "areaCode": "0479",
          "code": 152531,
          "parentCode": 152500,
          "level": 4,
          "children": null,
          "id": 462,
        },
        {
          "areaName": "阿拉善盟",
          "shortName": "阿拉善盟",
          "areaCode": "0483",
          "code": 152900,
          "parentCode": 150000,
          "level": 3,
          "children": null,
          "id": 463,
        },
        {
          "areaName": "阿拉善左旗",
          "shortName": "阿拉善左旗",
          "areaCode": "0483",
          "code": 152921,
          "parentCode": 152900,
          "level": 4,
          "children": null,
          "id": 464,
        },
        {
          "areaName": "阿拉善右旗",
          "shortName": "阿拉善右旗",
          "areaCode": "0483",
          "code": 152922,
          "parentCode": 152900,
          "level": 4,
          "children": null,
          "id": 465,
        },
        {
          "areaName": "额济纳旗",
          "shortName": "额济纳旗",
          "areaCode": "0483",
          "code": 152923,
          "parentCode": 152900,
          "level": 4,
          "children": null,
          "id": 466,
        }
      ],
      "id": 352,
    },
    {
      "areaName": "辽宁省",
      "shortName": "辽宁",
      "code": 210000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "沈阳市",
          "shortName": "沈阳",
          "areaCode": "024",
          "code": 210100,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 468,
        },
        {
          "areaName": "和平区",
          "shortName": "和平",
          "areaCode": "024",
          "code": 210102,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 469,
        },
        {
          "areaName": "沈河区",
          "shortName": "沈河",
          "areaCode": "024",
          "code": 210103,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 470,
        },
        {
          "areaName": "大东区",
          "shortName": "大东",
          "areaCode": "024",
          "code": 210104,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 471,
        },
        {
          "areaName": "皇姑区",
          "shortName": "皇姑",
          "areaCode": "024",
          "code": 210105,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 472,
        },
        {
          "areaName": "铁西区",
          "shortName": "铁西",
          "areaCode": "024",
          "code": 210106,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 473,
        },
        {
          "areaName": "苏家屯区",
          "shortName": "苏家屯",
          "areaCode": "024",
          "code": 210111,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 474,
        },
        {
          "areaName": "浑南区",
          "shortName": "浑南",
          "areaCode": "024",
          "code": 210112,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 475,
        },
        {
          "areaName": "沈北新区",
          "shortName": "沈北新区",
          "areaCode": "024",
          "code": 210113,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 476,
        },
        {
          "areaName": "于洪区",
          "shortName": "于洪",
          "areaCode": "024",
          "code": 210114,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 477,
        },
        {
          "areaName": "辽中县",
          "shortName": "辽中",
          "areaCode": "024",
          "code": 210122,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 478,
        },
        {
          "areaName": "康平县",
          "shortName": "康平",
          "areaCode": "024",
          "code": 210123,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 479,
        },
        {
          "areaName": "法库县",
          "shortName": "法库",
          "areaCode": "024",
          "code": 210124,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 480,
        },
        {
          "areaName": "新民市",
          "shortName": "新民",
          "areaCode": "024",
          "code": 210181,
          "parentCode": 210100,
          "level": 4,
          "children": null,
          "id": 481,
        },
        {
          "areaName": "大连市",
          "shortName": "大连",
          "areaCode": "0411",
          "code": 210200,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 482,
        },
        {
          "areaName": "中山区",
          "shortName": "中山",
          "areaCode": "0411",
          "code": 210202,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 483,
        },
        {
          "areaName": "西岗区",
          "shortName": "西岗",
          "areaCode": "0411",
          "code": 210203,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 484,
        },
        {
          "areaName": "沙河口区",
          "shortName": "沙河口",
          "areaCode": "0411",
          "code": 210204,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 485,
        },
        {
          "areaName": "甘井子区",
          "shortName": "甘井子",
          "areaCode": "0411",
          "code": 210211,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 486,
        },
        {
          "areaName": "旅顺口区",
          "shortName": "旅顺口",
          "areaCode": "0411",
          "code": 210212,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 487,
        },
        {
          "areaName": "金州区",
          "shortName": "金州",
          "areaCode": "0411",
          "code": 210213,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 488,
        },
        {
          "areaName": "长海县",
          "shortName": "长海",
          "areaCode": "0411",
          "code": 210224,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 489,
        },
        {
          "areaName": "瓦房店市",
          "shortName": "瓦房店",
          "areaCode": "0411",
          "code": 210281,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 490,
        },
        {
          "areaName": "普兰店市",
          "shortName": "普兰店",
          "areaCode": "0411",
          "code": 210282,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 491,
        },
        {
          "areaName": "庄河市",
          "shortName": "庄河",
          "areaCode": "0411",
          "code": 210283,
          "parentCode": 210200,
          "level": 4,
          "children": null,
          "id": 492,
        },
        {
          "areaName": "鞍山市",
          "shortName": "鞍山",
          "areaCode": "0412",
          "code": 210300,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 493,
        },
        {
          "areaName": "铁东区",
          "shortName": "铁东",
          "areaCode": "0412",
          "code": 210302,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 494,
        },
        {
          "areaName": "铁西区",
          "shortName": "铁西",
          "areaCode": "0413",
          "code": 210303,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 495,
        },
        {
          "areaName": "立山区",
          "shortName": "立山",
          "areaCode": "0414",
          "code": 210304,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 496,
        },
        {
          "areaName": "千山区",
          "shortName": "千山",
          "areaCode": "0415",
          "code": 210311,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 497,
        },
        {
          "areaName": "台安县",
          "shortName": "台安",
          "areaCode": "0417",
          "code": 210321,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 498,
        },
        {
          "areaName": "岫岩满族自治县",
          "shortName": "岫岩",
          "areaCode": "0418",
          "code": 210323,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 499,
        },
        {
          "areaName": "海城市",
          "shortName": "海城",
          "areaCode": "0416",
          "code": 210381,
          "parentCode": 210300,
          "level": 4,
          "children": null,
          "id": 500,
        },
        {
          "areaName": "抚顺市",
          "shortName": "抚顺",
          "areaCode": "024",
          "code": 210400,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 501,
        },
        {
          "areaName": "新抚区",
          "shortName": "新抚",
          "areaCode": "024",
          "code": 210402,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 502,
        },
        {
          "areaName": "东洲区",
          "shortName": "东洲",
          "areaCode": "024",
          "code": 210403,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 503,
        },
        {
          "areaName": "望花区",
          "shortName": "望花",
          "areaCode": "024",
          "code": 210404,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 504,
        },
        {
          "areaName": "顺城区",
          "shortName": "顺城",
          "areaCode": "024",
          "code": 210411,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 505,
        },
        {
          "areaName": "抚顺县",
          "shortName": "抚顺",
          "areaCode": "024",
          "code": 210421,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 506,
        },
        {
          "areaName": "新宾满族自治县",
          "shortName": "新宾",
          "areaCode": "024",
          "code": 210422,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 507,
        },
        {
          "areaName": "清原满族自治县",
          "shortName": "清原",
          "areaCode": "024",
          "code": 210423,
          "parentCode": 210400,
          "level": 4,
          "children": null,
          "id": 508,
        },
        {
          "areaName": "本溪市",
          "shortName": "本溪",
          "areaCode": "0414",
          "code": 210500,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 509,
        },
        {
          "areaName": "平山区",
          "shortName": "平山",
          "areaCode": "0414",
          "code": 210502,
          "parentCode": 210500,
          "level": 4,
          "children": null,
          "id": 510,
        },
        {
          "areaName": "溪湖区",
          "shortName": "溪湖",
          "areaCode": "0414",
          "code": 210503,
          "parentCode": 210500,
          "level": 4,
          "children": null,
          "id": 511,
        },
        {
          "areaName": "明山区",
          "shortName": "明山",
          "areaCode": "0414",
          "code": 210504,
          "parentCode": 210500,
          "level": 4,
          "children": null,
          "id": 512,
        },
        {
          "areaName": "南芬区",
          "shortName": "南芬",
          "areaCode": "0414",
          "code": 210505,
          "parentCode": 210500,
          "level": 4,
          "children": null,
          "id": 513,
        },
        {
          "areaName": "本溪满族自治县",
          "shortName": "本溪",
          "areaCode": "0414",
          "code": 210521,
          "parentCode": 210500,
          "level": 4,
          "children": null,
          "id": 514,
        },
        {
          "areaName": "桓仁满族自治县",
          "shortName": "桓仁",
          "areaCode": "0414",
          "code": 210522,
          "parentCode": 210500,
          "level": 4,
          "children": null,
          "id": 515,
        },
        {
          "areaName": "丹东市",
          "shortName": "丹东",
          "areaCode": "0415",
          "code": 210600,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 516,
        },
        {
          "areaName": "元宝区",
          "shortName": "元宝",
          "areaCode": "0415",
          "code": 210602,
          "parentCode": 210600,
          "level": 4,
          "children": null,
          "id": 517,
        },
        {
          "areaName": "振兴区",
          "shortName": "振兴",
          "areaCode": "0415",
          "code": 210603,
          "parentCode": 210600,
          "level": 4,
          "children": null,
          "id": 518,
        },
        {
          "areaName": "振安区",
          "shortName": "振安",
          "areaCode": "0415",
          "code": 210604,
          "parentCode": 210600,
          "level": 4,
          "children": null,
          "id": 519,
        },
        {
          "areaName": "宽甸满族自治县",
          "shortName": "宽甸",
          "areaCode": "0415",
          "code": 210624,
          "parentCode": 210600,
          "level": 4,
          "children": null,
          "id": 520,
        },
        {
          "areaName": "东港市",
          "shortName": "东港",
          "areaCode": "0415",
          "code": 210681,
          "parentCode": 210600,
          "level": 4,
          "children": null,
          "id": 521,
        },
        {
          "areaName": "凤城市",
          "shortName": "凤城",
          "areaCode": "0415",
          "code": 210682,
          "parentCode": 210600,
          "level": 4,
          "children": null,
          "id": 522,
        },
        {
          "areaName": "锦州市",
          "shortName": "锦州",
          "areaCode": "0416",
          "code": 210700,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 523,
        },
        {
          "areaName": "古塔区",
          "shortName": "古塔",
          "areaCode": "0416",
          "code": 210702,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 524,
        },
        {
          "areaName": "凌河区",
          "shortName": "凌河",
          "areaCode": "0416",
          "code": 210703,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 525,
        },
        {
          "areaName": "太和区",
          "shortName": "太和",
          "areaCode": "0416",
          "code": 210711,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 526,
        },
        {
          "areaName": "黑山县",
          "shortName": "黑山",
          "areaCode": "0416",
          "code": 210726,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 527,
        },
        {
          "areaName": "义县",
          "shortName": "义县",
          "areaCode": "0416",
          "code": 210727,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 528,
        },
        {
          "areaName": "凌海市",
          "shortName": "凌海",
          "areaCode": "0416",
          "code": 210781,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 529,
        },
        {
          "areaName": "北镇市",
          "shortName": "北镇",
          "areaCode": "0416",
          "code": 210782,
          "parentCode": 210700,
          "level": 4,
          "children": null,
          "id": 530,
        },
        {
          "areaName": "营口市",
          "shortName": "营口",
          "areaCode": "0417",
          "code": 210800,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 531,
        },
        {
          "areaName": "站前区",
          "shortName": "站前",
          "areaCode": "0417",
          "code": 210802,
          "parentCode": 210800,
          "level": 4,
          "children": null,
          "id": 532,
        },
        {
          "areaName": "西市区",
          "shortName": "西市",
          "areaCode": "0417",
          "code": 210803,
          "parentCode": 210800,
          "level": 4,
          "children": null,
          "id": 533,
        },
        {
          "areaName": "鲅鱼圈区",
          "shortName": "鲅鱼圈",
          "areaCode": "0417",
          "code": 210804,
          "parentCode": 210800,
          "level": 4,
          "children": null,
          "id": 534,
        },
        {
          "areaName": "老边区",
          "shortName": "老边",
          "areaCode": "0417",
          "code": 210811,
          "parentCode": 210800,
          "level": 4,
          "children": null,
          "id": 535,
        },
        {
          "areaName": "盖州市",
          "shortName": "盖州",
          "areaCode": "0417",
          "code": 210881,
          "parentCode": 210800,
          "level": 4,
          "children": null,
          "id": 536,
        },
        {
          "areaName": "大石桥市",
          "shortName": "大石桥",
          "areaCode": "0417",
          "code": 210882,
          "parentCode": 210800,
          "level": 4,
          "children": null,
          "id": 537,
        },
        {
          "areaName": "阜新市",
          "shortName": "阜新",
          "areaCode": "0418",
          "code": 210900,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 538,
        },
        {
          "areaName": "海州区",
          "shortName": "海州",
          "areaCode": "0418",
          "code": 210902,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 539,
        },
        {
          "areaName": "新邱区",
          "shortName": "新邱",
          "areaCode": "0418",
          "code": 210903,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 540,
        },
        {
          "areaName": "太平区",
          "shortName": "太平",
          "areaCode": "0418",
          "code": 210904,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 541,
        },
        {
          "areaName": "清河门区",
          "shortName": "清河门",
          "areaCode": "0418",
          "code": 210905,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 542,
        },
        {
          "areaName": "细河区",
          "shortName": "细河",
          "areaCode": "0418",
          "code": 210911,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 543,
        },
        {
          "areaName": "阜新蒙古族自治县",
          "shortName": "阜新",
          "areaCode": "0418",
          "code": 210921,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 544,
        },
        {
          "areaName": "彰武县",
          "shortName": "彰武",
          "areaCode": "0418",
          "code": 210922,
          "parentCode": 210900,
          "level": 4,
          "children": null,
          "id": 545,
        },
        {
          "areaName": "辽阳市",
          "shortName": "辽阳",
          "areaCode": "0419",
          "code": 211000,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 546,
        },
        {
          "areaName": "白塔区",
          "shortName": "白塔",
          "areaCode": "0419",
          "code": 211002,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 547,
        },
        {
          "areaName": "文圣区",
          "shortName": "文圣",
          "areaCode": "0419",
          "code": 211003,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 548,
        },
        {
          "areaName": "宏伟区",
          "shortName": "宏伟",
          "areaCode": "0419",
          "code": 211004,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 549,
        },
        {
          "areaName": "弓长岭区",
          "shortName": "弓长岭",
          "areaCode": "0419",
          "code": 211005,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 550,
        },
        {
          "areaName": "太子河区",
          "shortName": "太子河",
          "areaCode": "0419",
          "code": 211011,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 551,
        },
        {
          "areaName": "辽阳县",
          "shortName": "辽阳",
          "areaCode": "0419",
          "code": 211021,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 552,
        },
        {
          "areaName": "灯塔市",
          "shortName": "灯塔",
          "areaCode": "0419",
          "code": 211081,
          "parentCode": 211000,
          "level": 4,
          "children": null,
          "id": 553,
        },
        {
          "areaName": "盘锦市",
          "shortName": "盘锦",
          "areaCode": "0427",
          "code": 211100,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 554,
        },
        {
          "areaName": "双台子区",
          "shortName": "双台子",
          "areaCode": "0427",
          "code": 211102,
          "parentCode": 211100,
          "level": 4,
          "children": null,
          "id": 555,
        },
        {
          "areaName": "兴隆台区",
          "shortName": "兴隆台",
          "areaCode": "0427",
          "code": 211103,
          "parentCode": 211100,
          "level": 4,
          "children": null,
          "id": 556,
        },
        {
          "areaName": "大洼县",
          "shortName": "大洼",
          "areaCode": "0427",
          "code": 211121,
          "parentCode": 211100,
          "level": 4,
          "children": null,
          "id": 557,
        },
        {
          "areaName": "盘山县",
          "shortName": "盘山",
          "areaCode": "0427",
          "code": 211122,
          "parentCode": 211100,
          "level": 4,
          "children": null,
          "id": 558,
        },
        {
          "areaName": "铁岭市",
          "shortName": "铁岭",
          "areaCode": "024",
          "code": 211200,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 559,
        },
        {
          "areaName": "银州区",
          "shortName": "银州",
          "areaCode": "024",
          "code": 211202,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 560,
        },
        {
          "areaName": "清河区",
          "shortName": "清河",
          "areaCode": "024",
          "code": 211204,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 561,
        },
        {
          "areaName": "铁岭县",
          "shortName": "铁岭",
          "areaCode": "024",
          "code": 211221,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 562,
        },
        {
          "areaName": "西丰县",
          "shortName": "西丰",
          "areaCode": "024",
          "code": 211223,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 563,
        },
        {
          "areaName": "昌图县",
          "shortName": "昌图",
          "areaCode": "024",
          "code": 211224,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 564,
        },
        {
          "areaName": "调兵山市",
          "shortName": "调兵山",
          "areaCode": "024",
          "code": 211281,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 565,
        },
        {
          "areaName": "开原市",
          "shortName": "开原",
          "areaCode": "024",
          "code": 211282,
          "parentCode": 211200,
          "level": 4,
          "children": null,
          "id": 566,
        },
        {
          "areaName": "朝阳市",
          "shortName": "朝阳",
          "areaCode": "0421",
          "code": 211300,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 567,
        },
        {
          "areaName": "双塔区",
          "shortName": "双塔",
          "areaCode": "0421",
          "code": 211302,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 568,
        },
        {
          "areaName": "龙城区",
          "shortName": "龙城",
          "areaCode": "0421",
          "code": 211303,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 569,
        },
        {
          "areaName": "朝阳县",
          "shortName": "朝阳",
          "areaCode": "0421",
          "code": 211321,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 570,
        },
        {
          "areaName": "建平县",
          "shortName": "建平",
          "areaCode": "0421",
          "code": 211322,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 571,
        },
        {
          "areaName": "喀喇沁左翼蒙古族自治县",
          "shortName": "喀喇沁左翼",
          "areaCode": "0421",
          "code": 211324,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 572,
        },
        {
          "areaName": "北票市",
          "shortName": "北票",
          "areaCode": "0421",
          "code": 211381,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 573,
        },
        {
          "areaName": "凌源市",
          "shortName": "凌源",
          "areaCode": "0421",
          "code": 211382,
          "parentCode": 211300,
          "level": 4,
          "children": null,
          "id": 574,
        },
        {
          "areaName": "葫芦岛市",
          "shortName": "葫芦岛",
          "areaCode": "0429",
          "code": 211400,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 575,
        },
        {
          "areaName": "连山区",
          "shortName": "连山",
          "areaCode": "0429",
          "code": 211402,
          "parentCode": 211400,
          "level": 4,
          "children": null,
          "id": 576,
        },
        {
          "areaName": "龙港区",
          "shortName": "龙港",
          "areaCode": "0429",
          "code": 211403,
          "parentCode": 211400,
          "level": 4,
          "children": null,
          "id": 577,
        },
        {
          "areaName": "南票区",
          "shortName": "南票",
          "areaCode": "0429",
          "code": 211404,
          "parentCode": 211400,
          "level": 4,
          "children": null,
          "id": 578,
        },
        {
          "areaName": "绥中县",
          "shortName": "绥中",
          "areaCode": "0429",
          "code": 211421,
          "parentCode": 211400,
          "level": 4,
          "children": null,
          "id": 579,
        },
        {
          "areaName": "建昌县",
          "shortName": "建昌",
          "areaCode": "0429",
          "code": 211422,
          "parentCode": 211400,
          "level": 4,
          "children": null,
          "id": 580,
        },
        {
          "areaName": "兴城市",
          "shortName": "兴城",
          "areaCode": "0429",
          "code": 211481,
          "parentCode": 211400,
          "level": 4,
          "children": null,
          "id": 581,
        },
        {
          "areaName": "金普新区",
          "shortName": "金普新区",
          "areaCode": "0411",
          "code": 211500,
          "parentCode": 210000,
          "level": 3,
          "children": null,
          "id": 582,
        },
        {
          "areaName": "金州新区",
          "shortName": "金州新区",
          "areaCode": "0411",
          "code": 211501,
          "parentCode": 211500,
          "level": 4,
          "children": null,
          "id": 583,
        },
        {
          "areaName": "普湾新区",
          "shortName": "普湾新区",
          "areaCode": "0411",
          "code": 211502,
          "parentCode": 211500,
          "level": 4,
          "children": null,
          "id": 584,
        },
        {
          "areaName": "保税区",
          "shortName": "保税区",
          "areaCode": "0411",
          "code": 211503,
          "parentCode": 211500,
          "level": 4,
          "children": null,
          "id": 585,
        }
      ],
      "id": 467,
    },
    {
      "areaName": "吉林省",
      "shortName": "吉林",
      "code": 220000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "长春市",
          "shortName": "长春",
          "areaCode": "0431",
          "code": 220100,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 587,
        },
        {
          "areaName": "南关区",
          "shortName": "南关",
          "areaCode": "0431",
          "code": 220102,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 588,
        },
        {
          "areaName": "宽城区",
          "shortName": "宽城",
          "areaCode": "0431",
          "code": 220103,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 589,
        },
        {
          "areaName": "朝阳区",
          "shortName": "朝阳",
          "areaCode": "0431",
          "code": 220104,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 590,
        },
        {
          "areaName": "二道区",
          "shortName": "二道",
          "areaCode": "0431",
          "code": 220105,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 591,
        },
        {
          "areaName": "绿园区",
          "shortName": "绿园",
          "areaCode": "0431",
          "code": 220106,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 592,
        },
        {
          "areaName": "双阳区",
          "shortName": "双阳",
          "areaCode": "0431",
          "code": 220112,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 593,
        },
        {
          "areaName": "九台区",
          "shortName": "九台",
          "areaCode": "0431",
          "code": 220113,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 594,
        },
        {
          "areaName": "农安县",
          "shortName": "农安",
          "areaCode": "0431",
          "code": 220122,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 595,
        },
        {
          "areaName": "榆树市",
          "shortName": "榆树",
          "areaCode": "0431",
          "code": 220182,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 596,
        },
        {
          "areaName": "德惠市",
          "shortName": "德惠",
          "areaCode": "0431",
          "code": 220183,
          "parentCode": 220100,
          "level": 4,
          "children": null,
          "id": 597,
        },
        {
          "areaName": "吉林市",
          "shortName": "吉林",
          "areaCode": "0432",
          "code": 220200,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 598,
        },
        {
          "areaName": "昌邑区",
          "shortName": "昌邑",
          "areaCode": "0432",
          "code": 220202,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 599,
        },
        {
          "areaName": "龙潭区",
          "shortName": "龙潭",
          "areaCode": "0432",
          "code": 220203,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 600,
        },
        {
          "areaName": "船营区",
          "shortName": "船营",
          "areaCode": "0432",
          "code": 220204,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 601,
        },
        {
          "areaName": "丰满区",
          "shortName": "丰满",
          "areaCode": "0432",
          "code": 220211,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 602,
        },
        {
          "areaName": "永吉县",
          "shortName": "永吉",
          "areaCode": "0432",
          "code": 220221,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 603,
        },
        {
          "areaName": "蛟河市",
          "shortName": "蛟河",
          "areaCode": "0432",
          "code": 220281,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 604,
        },
        {
          "areaName": "桦甸市",
          "shortName": "桦甸",
          "areaCode": "0432",
          "code": 220282,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 605,
        },
        {
          "areaName": "舒兰市",
          "shortName": "舒兰",
          "areaCode": "0432",
          "code": 220283,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 606,
        },
        {
          "areaName": "磐石市",
          "shortName": "磐石",
          "areaCode": "0432",
          "code": 220284,
          "parentCode": 220200,
          "level": 4,
          "children": null,
          "id": 607,
        },
        {
          "areaName": "四平市",
          "shortName": "四平",
          "areaCode": "0434",
          "code": 220300,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 608,
        },
        {
          "areaName": "铁西区",
          "shortName": "铁西",
          "areaCode": "0434",
          "code": 220302,
          "parentCode": 220300,
          "level": 4,
          "children": null,
          "id": 609,
        },
        {
          "areaName": "铁东区",
          "shortName": "铁东",
          "areaCode": "0434",
          "code": 220303,
          "parentCode": 220300,
          "level": 4,
          "children": null,
          "id": 610,
        },
        {
          "areaName": "梨树县",
          "shortName": "梨树",
          "areaCode": "0434",
          "code": 220322,
          "parentCode": 220300,
          "level": 4,
          "children": null,
          "id": 611,
        },
        {
          "areaName": "伊通满族自治县",
          "shortName": "伊通",
          "areaCode": "0434",
          "code": 220323,
          "parentCode": 220300,
          "level": 4,
          "children": null,
          "id": 612,
        },
        {
          "areaName": "公主岭市",
          "shortName": "公主岭",
          "areaCode": "0434",
          "code": 220381,
          "parentCode": 220300,
          "level": 4,
          "children": null,
          "id": 613,
        },
        {
          "areaName": "双辽市",
          "shortName": "双辽",
          "areaCode": "0434",
          "code": 220382,
          "parentCode": 220300,
          "level": 4,
          "children": null,
          "id": 614,
        },
        {
          "areaName": "辽源市",
          "shortName": "辽源",
          "areaCode": "0437",
          "code": 220400,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 615,
        },
        {
          "areaName": "龙山区",
          "shortName": "龙山",
          "areaCode": "0437",
          "code": 220402,
          "parentCode": 220400,
          "level": 4,
          "children": null,
          "id": 616,
        },
        {
          "areaName": "西安区",
          "shortName": "西安",
          "areaCode": "0437",
          "code": 220403,
          "parentCode": 220400,
          "level": 4,
          "children": null,
          "id": 617,
        },
        {
          "areaName": "东丰县",
          "shortName": "东丰",
          "areaCode": "0437",
          "code": 220421,
          "parentCode": 220400,
          "level": 4,
          "children": null,
          "id": 618,
        },
        {
          "areaName": "东辽县",
          "shortName": "东辽",
          "areaCode": "0437",
          "code": 220422,
          "parentCode": 220400,
          "level": 4,
          "children": null,
          "id": 619,
        },
        {
          "areaName": "通化市",
          "shortName": "通化",
          "areaCode": "0435",
          "code": 220500,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 620,
        },
        {
          "areaName": "东昌区",
          "shortName": "东昌",
          "areaCode": "0435",
          "code": 220502,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 621,
        },
        {
          "areaName": "二道江区",
          "shortName": "二道江",
          "areaCode": "0435",
          "code": 220503,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 622,
        },
        {
          "areaName": "通化县",
          "shortName": "通化",
          "areaCode": "0435",
          "code": 220521,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 623,
        },
        {
          "areaName": "辉南县",
          "shortName": "辉南",
          "areaCode": "0435",
          "code": 220523,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 624,
        },
        {
          "areaName": "柳河县",
          "shortName": "柳河",
          "areaCode": "0435",
          "code": 220524,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 625,
        },
        {
          "areaName": "梅河口市",
          "shortName": "梅河口",
          "areaCode": "0435",
          "code": 220581,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 626,
        },
        {
          "areaName": "集安市",
          "shortName": "集安",
          "areaCode": "0435",
          "code": 220582,
          "parentCode": 220500,
          "level": 4,
          "children": null,
          "id": 627,
        },
        {
          "areaName": "白山市",
          "shortName": "白山",
          "areaCode": "0439",
          "code": 220600,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 628,
        },
        {
          "areaName": "浑江区",
          "shortName": "浑江",
          "areaCode": "0439",
          "code": 220602,
          "parentCode": 220600,
          "level": 4,
          "children": null,
          "id": 629,
        },
        {
          "areaName": "江源区",
          "shortName": "江源",
          "areaCode": "0439",
          "code": 220605,
          "parentCode": 220600,
          "level": 4,
          "children": null,
          "id": 630,
        },
        {
          "areaName": "抚松县",
          "shortName": "抚松",
          "areaCode": "0439",
          "code": 220621,
          "parentCode": 220600,
          "level": 4,
          "children": null,
          "id": 631,
        },
        {
          "areaName": "靖宇县",
          "shortName": "靖宇",
          "areaCode": "0439",
          "code": 220622,
          "parentCode": 220600,
          "level": 4,
          "children": null,
          "id": 632,
        },
        {
          "areaName": "长白朝鲜族自治县",
          "shortName": "长白",
          "areaCode": "0439",
          "code": 220623,
          "parentCode": 220600,
          "level": 4,
          "children": null,
          "id": 633,
        },
        {
          "areaName": "临江市",
          "shortName": "临江",
          "areaCode": "0439",
          "code": 220681,
          "parentCode": 220600,
          "level": 4,
          "children": null,
          "id": 634,
        },
        {
          "areaName": "松原市",
          "shortName": "松原",
          "areaCode": "0438",
          "code": 220700,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 635,
        },
        {
          "areaName": "宁江区",
          "shortName": "宁江",
          "areaCode": "0438",
          "code": 220702,
          "parentCode": 220700,
          "level": 4,
          "children": null,
          "id": 636,
        },
        {
          "areaName": "前郭尔罗斯蒙古族自治县",
          "shortName": "前郭尔罗斯",
          "areaCode": "0438",
          "code": 220721,
          "parentCode": 220700,
          "level": 4,
          "children": null,
          "id": 637,
        },
        {
          "areaName": "长岭县",
          "shortName": "长岭",
          "areaCode": "0438",
          "code": 220722,
          "parentCode": 220700,
          "level": 4,
          "children": null,
          "id": 638,
        },
        {
          "areaName": "乾安县",
          "shortName": "乾安",
          "areaCode": "0438",
          "code": 220723,
          "parentCode": 220700,
          "level": 4,
          "children": null,
          "id": 639,
        },
        {
          "areaName": "扶余市",
          "shortName": "扶余",
          "areaCode": "0438",
          "code": 220781,
          "parentCode": 220700,
          "level": 4,
          "children": null,
          "id": 640,
        },
        {
          "areaName": "白城市",
          "shortName": "白城",
          "areaCode": "0436",
          "code": 220800,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 641,
        },
        {
          "areaName": "洮北区",
          "shortName": "洮北",
          "areaCode": "0436",
          "code": 220802,
          "parentCode": 220800,
          "level": 4,
          "children": null,
          "id": 642,
        },
        {
          "areaName": "镇赉县",
          "shortName": "镇赉",
          "areaCode": "0436",
          "code": 220821,
          "parentCode": 220800,
          "level": 4,
          "children": null,
          "id": 643,
        },
        {
          "areaName": "通榆县",
          "shortName": "通榆",
          "areaCode": "0436",
          "code": 220822,
          "parentCode": 220800,
          "level": 4,
          "children": null,
          "id": 644,
        },
        {
          "areaName": "洮南市",
          "shortName": "洮南",
          "areaCode": "0436",
          "code": 220881,
          "parentCode": 220800,
          "level": 4,
          "children": null,
          "id": 645,
        },
        {
          "areaName": "大安市",
          "shortName": "大安",
          "areaCode": "0436",
          "code": 220882,
          "parentCode": 220800,
          "level": 4,
          "children": null,
          "id": 646,
        },
        {
          "areaName": "延边朝鲜族自治州",
          "shortName": "延边",
          "areaCode": "0433",
          "code": 222400,
          "parentCode": 220000,
          "level": 3,
          "children": null,
          "id": 647,
        },
        {
          "areaName": "延吉市",
          "shortName": "延吉",
          "areaCode": "0433",
          "code": 222401,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 648,
        },
        {
          "areaName": "图们市",
          "shortName": "图们",
          "areaCode": "0433",
          "code": 222402,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 649,
        },
        {
          "areaName": "敦化市",
          "shortName": "敦化",
          "areaCode": "0433",
          "code": 222403,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 650,
        },
        {
          "areaName": "珲春市",
          "shortName": "珲春",
          "areaCode": "0433",
          "code": 222404,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 651,
        },
        {
          "areaName": "龙井市",
          "shortName": "龙井",
          "areaCode": "0433",
          "code": 222405,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 652,
        },
        {
          "areaName": "和龙市",
          "shortName": "和龙",
          "areaCode": "0433",
          "code": 222406,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 653,
        },
        {
          "areaName": "汪清县",
          "shortName": "汪清",
          "areaCode": "0433",
          "code": 222424,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 654,
        },
        {
          "areaName": "安图县",
          "shortName": "安图",
          "areaCode": "0433",
          "code": 222426,
          "parentCode": 222400,
          "level": 4,
          "children": null,
          "id": 655,
        }
      ],
      "id": 586,
    },
    {
      "areaName": "黑龙江省",
      "shortName": "黑龙江",
      "code": 230000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "哈尔滨市",
          "shortName": "哈尔滨",
          "areaCode": "0451",
          "code": 230100,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 657,
        },
        {
          "areaName": "道里区",
          "shortName": "道里",
          "areaCode": "0451",
          "code": 230102,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 658,
        },
        {
          "areaName": "南岗区",
          "shortName": "南岗",
          "areaCode": "0451",
          "code": 230103,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 659,
        },
        {
          "areaName": "道外区",
          "shortName": "道外",
          "areaCode": "0451",
          "code": 230104,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 660,
        },
        {
          "areaName": "平房区",
          "shortName": "平房",
          "areaCode": "0451",
          "code": 230108,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 661,
        },
        {
          "areaName": "松北区",
          "shortName": "松北",
          "areaCode": "0451",
          "code": 230109,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 662,
        },
        {
          "areaName": "香坊区",
          "shortName": "香坊",
          "areaCode": "0451",
          "code": 230110,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 663,
        },
        {
          "areaName": "呼兰区",
          "shortName": "呼兰",
          "areaCode": "0451",
          "code": 230111,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 664,
        },
        {
          "areaName": "阿城区",
          "shortName": "阿城",
          "areaCode": "0451",
          "code": 230112,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 665,
        },
        {
          "areaName": "双城区",
          "shortName": "双城",
          "areaCode": "0451",
          "code": 230113,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 666,
        },
        {
          "areaName": "依兰县",
          "shortName": "依兰",
          "areaCode": "0451",
          "code": 230123,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 667,
        },
        {
          "areaName": "方正县",
          "shortName": "方正",
          "areaCode": "0451",
          "code": 230124,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 668,
        },
        {
          "areaName": "宾县",
          "shortName": "宾县",
          "areaCode": "0451",
          "code": 230125,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 669,
        },
        {
          "areaName": "巴彦县",
          "shortName": "巴彦",
          "areaCode": "0451",
          "code": 230126,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 670,
        },
        {
          "areaName": "木兰县",
          "shortName": "木兰",
          "areaCode": "0451",
          "code": 230127,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 671,
        },
        {
          "areaName": "通河县",
          "shortName": "通河",
          "areaCode": "0451",
          "code": 230128,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 672,
        },
        {
          "areaName": "延寿县",
          "shortName": "延寿",
          "areaCode": "0451",
          "code": 230129,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 673,
        },
        {
          "areaName": "尚志市",
          "shortName": "尚志",
          "areaCode": "0451",
          "code": 230183,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 674,
        },
        {
          "areaName": "五常市",
          "shortName": "五常",
          "areaCode": "0451",
          "code": 230184,
          "parentCode": 230100,
          "level": 4,
          "children": null,
          "id": 675,
        },
        {
          "areaName": "齐齐哈尔市",
          "shortName": "齐齐哈尔",
          "areaCode": "0452",
          "code": 230200,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 676,
        },
        {
          "areaName": "龙沙区",
          "shortName": "龙沙",
          "areaCode": "0452",
          "code": 230202,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 677,
        },
        {
          "areaName": "建华区",
          "shortName": "建华",
          "areaCode": "0452",
          "code": 230203,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 678,
        },
        {
          "areaName": "铁锋区",
          "shortName": "铁锋",
          "areaCode": "0452",
          "code": 230204,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 679,
        },
        {
          "areaName": "昂昂溪区",
          "shortName": "昂昂溪",
          "areaCode": "0452",
          "code": 230205,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 680,
        },
        {
          "areaName": "富拉尔基区",
          "shortName": "富拉尔基",
          "areaCode": "0452",
          "code": 230206,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 681,
        },
        {
          "areaName": "碾子山区",
          "shortName": "碾子山",
          "areaCode": "0452",
          "code": 230207,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 682,
        },
        {
          "areaName": "梅里斯达斡尔族区",
          "shortName": "梅里斯",
          "areaCode": "0452",
          "code": 230208,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 683,
        },
        {
          "areaName": "龙江县",
          "shortName": "龙江",
          "areaCode": "0452",
          "code": 230221,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 684,
        },
        {
          "areaName": "依安县",
          "shortName": "依安",
          "areaCode": "0452",
          "code": 230223,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 685,
        },
        {
          "areaName": "泰来县",
          "shortName": "泰来",
          "areaCode": "0452",
          "code": 230224,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 686,
        },
        {
          "areaName": "甘南县",
          "shortName": "甘南",
          "areaCode": "0452",
          "code": 230225,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 687,
        },
        {
          "areaName": "富裕县",
          "shortName": "富裕",
          "areaCode": "0452",
          "code": 230227,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 688,
        },
        {
          "areaName": "克山县",
          "shortName": "克山",
          "areaCode": "0452",
          "code": 230229,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 689,
        },
        {
          "areaName": "克东县",
          "shortName": "克东",
          "areaCode": "0452",
          "code": 230230,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 690,
        },
        {
          "areaName": "拜泉县",
          "shortName": "拜泉",
          "areaCode": "0452",
          "code": 230231,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 691,
        },
        {
          "areaName": "讷河市",
          "shortName": "讷河",
          "areaCode": "0452",
          "code": 230281,
          "parentCode": 230200,
          "level": 4,
          "children": null,
          "id": 692,
        },
        {
          "areaName": "鸡西市",
          "shortName": "鸡西",
          "areaCode": "0467",
          "code": 230300,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 693,
        },
        {
          "areaName": "鸡冠区",
          "shortName": "鸡冠",
          "areaCode": "0467",
          "code": 230302,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 694,
        },
        {
          "areaName": "恒山区",
          "shortName": "恒山",
          "areaCode": "0467",
          "code": 230303,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 695,
        },
        {
          "areaName": "滴道区",
          "shortName": "滴道",
          "areaCode": "0467",
          "code": 230304,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 696,
        },
        {
          "areaName": "梨树区",
          "shortName": "梨树",
          "areaCode": "0467",
          "code": 230305,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 697,
        },
        {
          "areaName": "城子河区",
          "shortName": "城子河",
          "areaCode": "0467",
          "code": 230306,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 698,
        },
        {
          "areaName": "麻山区",
          "shortName": "麻山",
          "areaCode": "0467",
          "code": 230307,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 699,
        },
        {
          "areaName": "鸡东县",
          "shortName": "鸡东",
          "areaCode": "0467",
          "code": 230321,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 700,
        },
        {
          "areaName": "虎林市",
          "shortName": "虎林",
          "areaCode": "0467",
          "code": 230381,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 701,
        },
        {
          "areaName": "密山市",
          "shortName": "密山",
          "areaCode": "0467",
          "code": 230382,
          "parentCode": 230300,
          "level": 4,
          "children": null,
          "id": 702,
        },
        {
          "areaName": "鹤岗市",
          "shortName": "鹤岗",
          "areaCode": "0468",
          "code": 230400,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 703,
        },
        {
          "areaName": "向阳区",
          "shortName": "向阳",
          "areaCode": "0468",
          "code": 230402,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 704,
        },
        {
          "areaName": "工农区",
          "shortName": "工农",
          "areaCode": "0468",
          "code": 230403,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 705,
        },
        {
          "areaName": "南山区",
          "shortName": "南山",
          "areaCode": "0468",
          "code": 230404,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 706,
        },
        {
          "areaName": "兴安区",
          "shortName": "兴安",
          "areaCode": "0468",
          "code": 230405,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 707,
        },
        {
          "areaName": "东山区",
          "shortName": "东山",
          "areaCode": "0468",
          "code": 230406,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 708,
        },
        {
          "areaName": "兴山区",
          "shortName": "兴山",
          "areaCode": "0468",
          "code": 230407,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 709,
        },
        {
          "areaName": "萝北县",
          "shortName": "萝北",
          "areaCode": "0468",
          "code": 230421,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 710,
        },
        {
          "areaName": "绥滨县",
          "shortName": "绥滨",
          "areaCode": "0468",
          "code": 230422,
          "parentCode": 230400,
          "level": 4,
          "children": null,
          "id": 711,
        },
        {
          "areaName": "双鸭山市",
          "shortName": "双鸭山",
          "areaCode": "0469",
          "code": 230500,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 712,
        },
        {
          "areaName": "尖山区",
          "shortName": "尖山",
          "areaCode": "0469",
          "code": 230502,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 713,
        },
        {
          "areaName": "岭东区",
          "shortName": "岭东",
          "areaCode": "0469",
          "code": 230503,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 714,
        },
        {
          "areaName": "四方台区",
          "shortName": "四方台",
          "areaCode": "0469",
          "code": 230505,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 715,
        },
        {
          "areaName": "宝山区",
          "shortName": "宝山",
          "areaCode": "0469",
          "code": 230506,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 716,
        },
        {
          "areaName": "集贤县",
          "shortName": "集贤",
          "areaCode": "0469",
          "code": 230521,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 717,
        },
        {
          "areaName": "友谊县",
          "shortName": "友谊",
          "areaCode": "0469",
          "code": 230522,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 718,
        },
        {
          "areaName": "宝清县",
          "shortName": "宝清",
          "areaCode": "0469",
          "code": 230523,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 719,
        },
        {
          "areaName": "饶河县",
          "shortName": "饶河",
          "areaCode": "0469",
          "code": 230524,
          "parentCode": 230500,
          "level": 4,
          "children": null,
          "id": 720,
        },
        {
          "areaName": "大庆市",
          "shortName": "大庆",
          "areaCode": "0459",
          "code": 230600,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 721,
        },
        {
          "areaName": "萨尔图区",
          "shortName": "萨尔图",
          "areaCode": "0459",
          "code": 230602,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 722,
        },
        {
          "areaName": "龙凤区",
          "shortName": "龙凤",
          "areaCode": "0459",
          "code": 230603,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 723,
        },
        {
          "areaName": "让胡路区",
          "shortName": "让胡路",
          "areaCode": "0459",
          "code": 230604,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 724,
        },
        {
          "areaName": "红岗区",
          "shortName": "红岗",
          "areaCode": "0459",
          "code": 230605,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 725,
        },
        {
          "areaName": "大同区",
          "shortName": "大同",
          "areaCode": "0459",
          "code": 230606,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 726,
        },
        {
          "areaName": "肇州县",
          "shortName": "肇州",
          "areaCode": "0459",
          "code": 230621,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 727,
        },
        {
          "areaName": "肇源县",
          "shortName": "肇源",
          "areaCode": "0459",
          "code": 230622,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 728,
        },
        {
          "areaName": "林甸县",
          "shortName": "林甸",
          "areaCode": "0459",
          "code": 230623,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 729,
        },
        {
          "areaName": "杜尔伯特蒙古族自治县",
          "shortName": "杜尔伯特",
          "areaCode": "0459",
          "code": 230624,
          "parentCode": 230600,
          "level": 4,
          "children": null,
          "id": 730,
        },
        {
          "areaName": "伊春市",
          "shortName": "伊春",
          "areaCode": "0458",
          "code": 230700,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 731,
        },
        {
          "areaName": "伊春区",
          "shortName": "伊春",
          "areaCode": "0458",
          "code": 230702,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 732,
        },
        {
          "areaName": "南岔区",
          "shortName": "南岔",
          "areaCode": "0458",
          "code": 230703,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 733,
        },
        {
          "areaName": "友好区",
          "shortName": "友好",
          "areaCode": "0458",
          "code": 230704,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 734,
        },
        {
          "areaName": "西林区",
          "shortName": "西林",
          "areaCode": "0458",
          "code": 230705,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 735,
        },
        {
          "areaName": "翠峦区",
          "shortName": "翠峦",
          "areaCode": "0458",
          "code": 230706,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 736,
        },
        {
          "areaName": "新青区",
          "shortName": "新青",
          "areaCode": "0458",
          "code": 230707,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 737,
        },
        {
          "areaName": "美溪区",
          "shortName": "美溪",
          "areaCode": "0458",
          "code": 230708,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 738,
        },
        {
          "areaName": "金山屯区",
          "shortName": "金山屯",
          "areaCode": "0458",
          "code": 230709,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 739,
        },
        {
          "areaName": "五营区",
          "shortName": "五营",
          "areaCode": "0458",
          "code": 230710,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 740,
        },
        {
          "areaName": "乌马河区",
          "shortName": "乌马河",
          "areaCode": "0458",
          "code": 230711,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 741,
        },
        {
          "areaName": "汤旺河区",
          "shortName": "汤旺河",
          "areaCode": "0458",
          "code": 230712,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 742,
        },
        {
          "areaName": "带岭区",
          "shortName": "带岭",
          "areaCode": "0458",
          "code": 230713,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 743,
        },
        {
          "areaName": "乌伊岭区",
          "shortName": "乌伊岭",
          "areaCode": "0458",
          "code": 230714,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 744,
        },
        {
          "areaName": "红星区",
          "shortName": "红星",
          "areaCode": "0458",
          "code": 230715,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 745,
        },
        {
          "areaName": "上甘岭区",
          "shortName": "上甘岭",
          "areaCode": "0458",
          "code": 230716,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 746,
        },
        {
          "areaName": "嘉荫县",
          "shortName": "嘉荫",
          "areaCode": "0458",
          "code": 230722,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 747,
        },
        {
          "areaName": "铁力市",
          "shortName": "铁力",
          "areaCode": "0458",
          "code": 230781,
          "parentCode": 230700,
          "level": 4,
          "children": null,
          "id": 748,
        },
        {
          "areaName": "佳木斯市",
          "shortName": "佳木斯",
          "areaCode": "0454",
          "code": 230800,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 749,
        },
        {
          "areaName": "向阳区",
          "shortName": "向阳",
          "areaCode": "0454",
          "code": 230803,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 750,
        },
        {
          "areaName": "前进区",
          "shortName": "前进",
          "areaCode": "0454",
          "code": 230804,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 751,
        },
        {
          "areaName": "东风区",
          "shortName": "东风",
          "areaCode": "0454",
          "code": 230805,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 752,
        },
        {
          "areaName": "郊区",
          "shortName": "郊区",
          "areaCode": "0454",
          "code": 230811,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 753,
        },
        {
          "areaName": "桦南县",
          "shortName": "桦南",
          "areaCode": "0454",
          "code": 230822,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 754,
        },
        {
          "areaName": "桦川县",
          "shortName": "桦川",
          "areaCode": "0454",
          "code": 230826,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 755,
        },
        {
          "areaName": "汤原县",
          "shortName": "汤原",
          "areaCode": "0454",
          "code": 230828,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 756,
        },
        {
          "areaName": "抚远县",
          "shortName": "抚远",
          "areaCode": "0454",
          "code": 230833,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 757,
        },
        {
          "areaName": "同江市",
          "shortName": "同江",
          "areaCode": "0454",
          "code": 230881,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 758,
        },
        {
          "areaName": "富锦市",
          "shortName": "富锦",
          "areaCode": "0454",
          "code": 230882,
          "parentCode": 230800,
          "level": 4,
          "children": null,
          "id": 759,
        },
        {
          "areaName": "七台河市",
          "shortName": "七台河",
          "areaCode": "0464",
          "code": 230900,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 760,
        },
        {
          "areaName": "新兴区",
          "shortName": "新兴",
          "areaCode": "0464",
          "code": 230902,
          "parentCode": 230900,
          "level": 4,
          "children": null,
          "id": 761,
        },
        {
          "areaName": "桃山区",
          "shortName": "桃山",
          "areaCode": "0464",
          "code": 230903,
          "parentCode": 230900,
          "level": 4,
          "children": null,
          "id": 762,
        },
        {
          "areaName": "茄子河区",
          "shortName": "茄子河",
          "areaCode": "0464",
          "code": 230904,
          "parentCode": 230900,
          "level": 4,
          "children": null,
          "id": 763,
        },
        {
          "areaName": "勃利县",
          "shortName": "勃利",
          "areaCode": "0464",
          "code": 230921,
          "parentCode": 230900,
          "level": 4,
          "children": null,
          "id": 764,
        },
        {
          "areaName": "牡丹江市",
          "shortName": "牡丹江",
          "areaCode": "0453",
          "code": 231000,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 765,
        },
        {
          "areaName": "东安区",
          "shortName": "东安",
          "areaCode": "0453",
          "code": 231002,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 766,
        },
        {
          "areaName": "阳明区",
          "shortName": "阳明",
          "areaCode": "0453",
          "code": 231003,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 767,
        },
        {
          "areaName": "爱民区",
          "shortName": "爱民",
          "areaCode": "0453",
          "code": 231004,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 768,
        },
        {
          "areaName": "西安区",
          "shortName": "西安",
          "areaCode": "0453",
          "code": 231005,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 769,
        },
        {
          "areaName": "东宁县",
          "shortName": "东宁",
          "areaCode": "0453",
          "code": 231024,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 770,
        },
        {
          "areaName": "林口县",
          "shortName": "林口",
          "areaCode": "0453",
          "code": 231025,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 771,
        },
        {
          "areaName": "绥芬河市",
          "shortName": "绥芬河",
          "areaCode": "0453",
          "code": 231081,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 772,
        },
        {
          "areaName": "海林市",
          "shortName": "海林",
          "areaCode": "0453",
          "code": 231083,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 773,
        },
        {
          "areaName": "宁安市",
          "shortName": "宁安",
          "areaCode": "0453",
          "code": 231084,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 774,
        },
        {
          "areaName": "穆棱市",
          "shortName": "穆棱",
          "areaCode": "0453",
          "code": 231085,
          "parentCode": 231000,
          "level": 4,
          "children": null,
          "id": 775,
        },
        {
          "areaName": "黑河市",
          "shortName": "黑河",
          "areaCode": "0456",
          "code": 231100,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 776,
        },
        {
          "areaName": "爱辉区",
          "shortName": "爱辉",
          "areaCode": "0456",
          "code": 231102,
          "parentCode": 231100,
          "level": 4,
          "children": null,
          "id": 777,
        },
        {
          "areaName": "嫩江县",
          "shortName": "嫩江",
          "areaCode": "0456",
          "code": 231121,
          "parentCode": 231100,
          "level": 4,
          "children": null,
          "id": 778,
        },
        {
          "areaName": "逊克县",
          "shortName": "逊克",
          "areaCode": "0456",
          "code": 231123,
          "parentCode": 231100,
          "level": 4,
          "children": null,
          "id": 779,
        },
        {
          "areaName": "孙吴县",
          "shortName": "孙吴",
          "areaCode": "0456",
          "code": 231124,
          "parentCode": 231100,
          "level": 4,
          "children": null,
          "id": 780,
        },
        {
          "areaName": "北安市",
          "shortName": "北安",
          "areaCode": "0456",
          "code": 231181,
          "parentCode": 231100,
          "level": 4,
          "children": null,
          "id": 781,
        },
        {
          "areaName": "五大连池市",
          "shortName": "五大连池",
          "areaCode": "0456",
          "code": 231182,
          "parentCode": 231100,
          "level": 4,
          "children": null,
          "id": 782,
        },
        {
          "areaName": "绥化市",
          "shortName": "绥化",
          "areaCode": "0455",
          "code": 231200,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 783,
        },
        {
          "areaName": "北林区",
          "shortName": "北林",
          "areaCode": "0455",
          "code": 231202,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 784,
        },
        {
          "areaName": "望奎县",
          "shortName": "望奎",
          "areaCode": "0455",
          "code": 231221,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 785,
        },
        {
          "areaName": "兰西县",
          "shortName": "兰西",
          "areaCode": "0455",
          "code": 231222,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 786,
        },
        {
          "areaName": "青冈县",
          "shortName": "青冈",
          "areaCode": "0455",
          "code": 231223,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 787,
        },
        {
          "areaName": "庆安县",
          "shortName": "庆安",
          "areaCode": "0455",
          "code": 231224,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 788,
        },
        {
          "areaName": "明水县",
          "shortName": "明水",
          "areaCode": "0455",
          "code": 231225,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 789,
        },
        {
          "areaName": "绥棱县",
          "shortName": "绥棱",
          "areaCode": "0455",
          "code": 231226,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 790,
        },
        {
          "areaName": "安达市",
          "shortName": "安达",
          "areaCode": "0455",
          "code": 231281,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 791,
        },
        {
          "areaName": "肇东市",
          "shortName": "肇东",
          "areaCode": "0455",
          "code": 231282,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 792,
        },
        {
          "areaName": "海伦市",
          "shortName": "海伦",
          "areaCode": "0455",
          "code": 231283,
          "parentCode": 231200,
          "level": 4,
          "children": null,
          "id": 793,
        },
        {
          "areaName": "大兴安岭地区",
          "shortName": "大兴安岭",
          "areaCode": "0457",
          "code": 232700,
          "parentCode": 230000,
          "level": 3,
          "children": null,
          "id": 794,
        },
        {
          "areaName": "加格达奇区",
          "shortName": "加格达奇",
          "areaCode": "0457",
          "code": 232701,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 795,
        },
        {
          "areaName": "新林区",
          "shortName": "新林",
          "areaCode": "0457",
          "code": 232702,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 796,
        },
        {
          "areaName": "松岭区",
          "shortName": "松岭",
          "areaCode": "0457",
          "code": 232703,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 797,
        },
        {
          "areaName": "呼中区",
          "shortName": "呼中",
          "areaCode": "0457",
          "code": 232704,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 798,
        },
        {
          "areaName": "呼玛县",
          "shortName": "呼玛",
          "areaCode": "0457",
          "code": 232721,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 799,
        },
        {
          "areaName": "塔河县",
          "shortName": "塔河",
          "areaCode": "0457",
          "code": 232722,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 800,
        },
        {
          "areaName": "漠河县",
          "shortName": "漠河",
          "areaCode": "0457",
          "code": 232723,
          "parentCode": 232700,
          "level": 4,
          "children": null,
          "id": 801,
        }
      ],
      "id": 656,
    },
    {
      "areaName": "上海",
      "shortName": "上海",
      "code": 310000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "上海市",
          "shortName": "上海",
          "areaCode": "021",
          "code": 310100,
          "parentCode": 310000,
          "level": 3,
          "children": null,
          "id": 803,
        },
        {
          "areaName": "黄浦区",
          "shortName": "黄浦",
          "areaCode": "021",
          "code": 310101,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 804,
        },
        {
          "areaName": "徐汇区",
          "shortName": "徐汇",
          "areaCode": "021",
          "code": 310104,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 805,
        },
        {
          "areaName": "长宁区",
          "shortName": "长宁",
          "areaCode": "021",
          "code": 310105,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 806,
        },
        {
          "areaName": "静安区",
          "shortName": "静安",
          "areaCode": "021",
          "code": 310106,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 807,
        },
        {
          "areaName": "普陀区",
          "shortName": "普陀",
          "areaCode": "021",
          "code": 310107,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 808,
        },
        {
          "areaName": "闸北区",
          "shortName": "闸北",
          "areaCode": "021",
          "code": 310108,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 809,
        },
        {
          "areaName": "虹口区",
          "shortName": "虹口",
          "areaCode": "021",
          "code": 310109,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 810,
        },
        {
          "areaName": "杨浦区",
          "shortName": "杨浦",
          "areaCode": "021",
          "code": 310110,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 811,
        },
        {
          "areaName": "闵行区",
          "shortName": "闵行",
          "areaCode": "021",
          "code": 310112,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 812,
        },
        {
          "areaName": "宝山区",
          "shortName": "宝山",
          "areaCode": "021",
          "code": 310113,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 813,
        },
        {
          "areaName": "嘉定区",
          "shortName": "嘉定",
          "areaCode": "021",
          "code": 310114,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 814,
        },
        {
          "areaName": "浦东新区",
          "shortName": "浦东",
          "areaCode": "021",
          "code": 310115,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 815,
        },
        {
          "areaName": "金山区",
          "shortName": "金山",
          "areaCode": "021",
          "code": 310116,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 816,
        },
        {
          "areaName": "松江区",
          "shortName": "松江",
          "areaCode": "021",
          "code": 310117,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 817,
        },
        {
          "areaName": "青浦区",
          "shortName": "青浦",
          "areaCode": "021",
          "code": 310118,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 818,
        },
        {
          "areaName": "奉贤区",
          "shortName": "奉贤",
          "areaCode": "021",
          "code": 310120,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 819,
        },
        {
          "areaName": "崇明县",
          "shortName": "崇明",
          "areaCode": "021",
          "code": 310230,
          "parentCode": 310100,
          "level": 4,
          "children": null,
          "id": 820,
        }
      ],
      "id": 802,
    },
    {
      "areaName": "江苏省",
      "shortName": "江苏",
      "code": 320000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "南京市",
          "shortName": "南京",
          "areaCode": "025",
          "code": 320100,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 822,
        },
        {
          "areaName": "玄武区",
          "shortName": "玄武",
          "areaCode": "025",
          "code": 320102,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 823,
        },
        {
          "areaName": "秦淮区",
          "shortName": "秦淮",
          "areaCode": "025",
          "code": 320104,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 824,
        },
        {
          "areaName": "建邺区",
          "shortName": "建邺",
          "areaCode": "025",
          "code": 320105,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 825,
        },
        {
          "areaName": "鼓楼区",
          "shortName": "鼓楼",
          "areaCode": "025",
          "code": 320106,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 826,
        },
        {
          "areaName": "浦口区",
          "shortName": "浦口",
          "areaCode": "025",
          "code": 320111,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 827,
        },
        {
          "areaName": "栖霞区",
          "shortName": "栖霞",
          "areaCode": "025",
          "code": 320113,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 828,
        },
        {
          "areaName": "雨花台区",
          "shortName": "雨花台",
          "areaCode": "025",
          "code": 320114,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 829,
        },
        {
          "areaName": "江宁区",
          "shortName": "江宁",
          "areaCode": "025",
          "code": 320115,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 830,
        },
        {
          "areaName": "六合区",
          "shortName": "六合",
          "areaCode": "025",
          "code": 320116,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 831,
        },
        {
          "areaName": "溧水区",
          "shortName": "溧水",
          "areaCode": "025",
          "code": 320117,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 832,
        },
        {
          "areaName": "高淳区",
          "shortName": "高淳",
          "areaCode": "025",
          "code": 320118,
          "parentCode": 320100,
          "level": 4,
          "children": null,
          "id": 833,
        },
        {
          "areaName": "无锡市",
          "shortName": "无锡",
          "areaCode": "0510",
          "code": 320200,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 834,
        },
        {
          "areaName": "崇安区",
          "shortName": "崇安",
          "areaCode": "0510",
          "code": 320202,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 835,
        },
        {
          "areaName": "南长区",
          "shortName": "南长",
          "areaCode": "0510",
          "code": 320203,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 836,
        },
        {
          "areaName": "北塘区",
          "shortName": "北塘",
          "areaCode": "0510",
          "code": 320204,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 837,
        },
        {
          "areaName": "锡山区",
          "shortName": "锡山",
          "areaCode": "0510",
          "code": 320205,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 838,
        },
        {
          "areaName": "惠山区",
          "shortName": "惠山",
          "areaCode": "0510",
          "code": 320206,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 839,
        },
        {
          "areaName": "滨湖区",
          "shortName": "滨湖",
          "areaCode": "0510",
          "code": 320211,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 840,
        },
        {
          "areaName": "江阴市",
          "shortName": "江阴",
          "areaCode": "0510",
          "code": 320281,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 841,
        },
        {
          "areaName": "宜兴市",
          "shortName": "宜兴",
          "areaCode": "0510",
          "code": 320282,
          "parentCode": 320200,
          "level": 4,
          "children": null,
          "id": 842,
        },
        {
          "areaName": "徐州市",
          "shortName": "徐州",
          "areaCode": "0516",
          "code": 320300,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 843,
        },
        {
          "areaName": "鼓楼区",
          "shortName": "鼓楼",
          "areaCode": "0516",
          "code": 320302,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 844,
        },
        {
          "areaName": "云龙区",
          "shortName": "云龙",
          "areaCode": "0516",
          "code": 320303,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 845,
        },
        {
          "areaName": "贾汪区",
          "shortName": "贾汪",
          "areaCode": "0516",
          "code": 320305,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 846,
        },
        {
          "areaName": "泉山区",
          "shortName": "泉山",
          "areaCode": "0516",
          "code": 320311,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 847,
        },
        {
          "areaName": "铜山区",
          "shortName": "铜山",
          "areaCode": "0516",
          "code": 320312,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 848,
        },
        {
          "areaName": "丰县",
          "shortName": "丰县",
          "areaCode": "0516",
          "code": 320321,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 849,
        },
        {
          "areaName": "沛县",
          "shortName": "沛县",
          "areaCode": "0516",
          "code": 320322,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 850,
        },
        {
          "areaName": "睢宁县",
          "shortName": "睢宁",
          "areaCode": "0516",
          "code": 320324,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 851,
        },
        {
          "areaName": "新沂市",
          "shortName": "新沂",
          "areaCode": "0516",
          "code": 320381,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 852,
        },
        {
          "areaName": "邳州市",
          "shortName": "邳州",
          "areaCode": "0516",
          "code": 320382,
          "parentCode": 320300,
          "level": 4,
          "children": null,
          "id": 853,
        },
        {
          "areaName": "常州市",
          "shortName": "常州",
          "areaCode": "0519",
          "code": 320400,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 854,
        },
        {
          "areaName": "天宁区",
          "shortName": "天宁",
          "areaCode": "0519",
          "code": 320402,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 855,
        },
        {
          "areaName": "钟楼区",
          "shortName": "钟楼",
          "areaCode": "0519",
          "code": 320404,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 856,
        },
        {
          "areaName": "戚墅堰区",
          "shortName": "戚墅堰",
          "areaCode": "0519",
          "code": 320405,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 857,
        },
        {
          "areaName": "新北区",
          "shortName": "新北",
          "areaCode": "0519",
          "code": 320411,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 858,
        },
        {
          "areaName": "武进区",
          "shortName": "武进",
          "areaCode": "0519",
          "code": 320412,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 859,
        },
        {
          "areaName": "溧阳市",
          "shortName": "溧阳",
          "areaCode": "0519",
          "code": 320481,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 860,
        },
        {
          "areaName": "金坛市",
          "shortName": "金坛",
          "areaCode": "0519",
          "code": 320482,
          "parentCode": 320400,
          "level": 4,
          "children": null,
          "id": 861,
        },
        {
          "areaName": "苏州市",
          "shortName": "苏州",
          "areaCode": "0512",
          "code": 320500,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 862,
        },
        {
          "areaName": "虎丘区",
          "shortName": "虎丘",
          "areaCode": "0512",
          "code": 320505,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 863,
        },
        {
          "areaName": "吴中区",
          "shortName": "吴中",
          "areaCode": "0512",
          "code": 320506,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 864,
        },
        {
          "areaName": "相城区",
          "shortName": "相城",
          "areaCode": "0512",
          "code": 320507,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 865,
        },
        {
          "areaName": "姑苏区",
          "shortName": "姑苏",
          "areaCode": "0512",
          "code": 320508,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 866,
        },
        {
          "areaName": "吴江区",
          "shortName": "吴江",
          "areaCode": "0512",
          "code": 320509,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 867,
        },
        {
          "areaName": "常熟市",
          "shortName": "常熟",
          "areaCode": "0512",
          "code": 320581,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 868,
        },
        {
          "areaName": "张家港市",
          "shortName": "张家港",
          "areaCode": "0512",
          "code": 320582,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 869,
        },
        {
          "areaName": "昆山市",
          "shortName": "昆山",
          "areaCode": "0512",
          "code": 320583,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 870,
        },
        {
          "areaName": "太仓市",
          "shortName": "太仓",
          "areaCode": "0512",
          "code": 320585,
          "parentCode": 320500,
          "level": 4,
          "children": null,
          "id": 871,
        },
        {
          "areaName": "南通市",
          "shortName": "南通",
          "areaCode": "0513",
          "code": 320600,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 872,
        },
        {
          "areaName": "崇川区",
          "shortName": "崇川",
          "areaCode": "0513",
          "code": 320602,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 873,
        },
        {
          "areaName": "港闸区",
          "shortName": "港闸",
          "areaCode": "0513",
          "code": 320611,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 874,
        },
        {
          "areaName": "通州区",
          "shortName": "通州",
          "areaCode": "0513",
          "code": 320612,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 875,
        },
        {
          "areaName": "海安县",
          "shortName": "海安",
          "areaCode": "0513",
          "code": 320621,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 876,
        },
        {
          "areaName": "如东县",
          "shortName": "如东",
          "areaCode": "0513",
          "code": 320623,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 877,
        },
        {
          "areaName": "启东市",
          "shortName": "启东",
          "areaCode": "0513",
          "code": 320681,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 878,
        },
        {
          "areaName": "如皋市",
          "shortName": "如皋",
          "areaCode": "0513",
          "code": 320682,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 879,
        },
        {
          "areaName": "海门市",
          "shortName": "海门",
          "areaCode": "0513",
          "code": 320684,
          "parentCode": 320600,
          "level": 4,
          "children": null,
          "id": 880,
        },
        {
          "areaName": "连云港市",
          "shortName": "连云港",
          "areaCode": "0518",
          "code": 320700,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 881,
        },
        {
          "areaName": "连云区",
          "shortName": "连云",
          "areaCode": "0518",
          "code": 320703,
          "parentCode": 320700,
          "level": 4,
          "children": null,
          "id": 882,
        },
        {
          "areaName": "海州区",
          "shortName": "海州",
          "areaCode": "0518",
          "code": 320706,
          "parentCode": 320700,
          "level": 4,
          "children": null,
          "id": 883,
        },
        {
          "areaName": "赣榆区",
          "shortName": "赣榆",
          "areaCode": "0518",
          "code": 320707,
          "parentCode": 320700,
          "level": 4,
          "children": null,
          "id": 884,
        },
        {
          "areaName": "东海县",
          "shortName": "东海",
          "areaCode": "0518",
          "code": 320722,
          "parentCode": 320700,
          "level": 4,
          "children": null,
          "id": 885,
        },
        {
          "areaName": "灌云县",
          "shortName": "灌云",
          "areaCode": "0518",
          "code": 320723,
          "parentCode": 320700,
          "level": 4,
          "children": null,
          "id": 886,
        },
        {
          "areaName": "灌南县",
          "shortName": "灌南",
          "areaCode": "0518",
          "code": 320724,
          "parentCode": 320700,
          "level": 4,
          "children": null,
          "id": 887,
        },
        {
          "areaName": "淮安市",
          "shortName": "淮安",
          "areaCode": "0517",
          "code": 320800,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 888,
        },
        {
          "areaName": "清河区",
          "shortName": "清河",
          "areaCode": "0517",
          "code": 320802,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 889,
        },
        {
          "areaName": "淮安区",
          "shortName": "淮安",
          "areaCode": "0517",
          "code": 320803,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 890,
        },
        {
          "areaName": "淮阴区",
          "shortName": "淮阴",
          "areaCode": "0517",
          "code": 320804,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 891,
        },
        {
          "areaName": "清浦区",
          "shortName": "清浦",
          "areaCode": "0517",
          "code": 320811,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 892,
        },
        {
          "areaName": "涟水县",
          "shortName": "涟水",
          "areaCode": "0517",
          "code": 320826,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 893,
        },
        {
          "areaName": "洪泽县",
          "shortName": "洪泽",
          "areaCode": "0517",
          "code": 320829,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 894,
        },
        {
          "areaName": "盱眙县",
          "shortName": "盱眙",
          "areaCode": "0517",
          "code": 320830,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 895,
        },
        {
          "areaName": "金湖县",
          "shortName": "金湖",
          "areaCode": "0517",
          "code": 320831,
          "parentCode": 320800,
          "level": 4,
          "children": null,
          "id": 896,
        },
        {
          "areaName": "盐城市",
          "shortName": "盐城",
          "areaCode": "0515",
          "code": 320900,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 897,
        },
        {
          "areaName": "亭湖区",
          "shortName": "亭湖",
          "areaCode": "0515",
          "code": 320902,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 898,
        },
        {
          "areaName": "盐都区",
          "shortName": "盐都",
          "areaCode": "0515",
          "code": 320903,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 899,
        },
        {
          "areaName": "响水县",
          "shortName": "响水",
          "areaCode": "0515",
          "code": 320921,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 900,
        },
        {
          "areaName": "滨海县",
          "shortName": "滨海",
          "areaCode": "0515",
          "code": 320922,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 901,
        },
        {
          "areaName": "阜宁县",
          "shortName": "阜宁",
          "areaCode": "0515",
          "code": 320923,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 902,
        },
        {
          "areaName": "射阳县",
          "shortName": "射阳",
          "areaCode": "0515",
          "code": 320924,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 903,
        },
        {
          "areaName": "建湖县",
          "shortName": "建湖",
          "areaCode": "0515",
          "code": 320925,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 904,
        },
        {
          "areaName": "东台市",
          "shortName": "东台",
          "areaCode": "0515",
          "code": 320981,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 905,
        },
        {
          "areaName": "大丰市",
          "shortName": "大丰",
          "areaCode": "0515",
          "code": 320982,
          "parentCode": 320900,
          "level": 4,
          "children": null,
          "id": 906,
        },
        {
          "areaName": "扬州市",
          "shortName": "扬州",
          "areaCode": "0514",
          "code": 321000,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 907,
        },
        {
          "areaName": "广陵区",
          "shortName": "广陵",
          "areaCode": "0514",
          "code": 321002,
          "parentCode": 321000,
          "level": 4,
          "children": null,
          "id": 908,
        },
        {
          "areaName": "邗江区",
          "shortName": "邗江",
          "areaCode": "0514",
          "code": 321003,
          "parentCode": 321000,
          "level": 4,
          "children": null,
          "id": 909,
        },
        {
          "areaName": "江都区",
          "shortName": "江都",
          "areaCode": "0514",
          "code": 321012,
          "parentCode": 321000,
          "level": 4,
          "children": null,
          "id": 910,
        },
        {
          "areaName": "宝应县",
          "shortName": "宝应",
          "areaCode": "0514",
          "code": 321023,
          "parentCode": 321000,
          "level": 4,
          "children": null,
          "id": 911,
        },
        {
          "areaName": "仪征市",
          "shortName": "仪征",
          "areaCode": "0514",
          "code": 321081,
          "parentCode": 321000,
          "level": 4,
          "children": null,
          "id": 912,
        },
        {
          "areaName": "高邮市",
          "shortName": "高邮",
          "areaCode": "0514",
          "code": 321084,
          "parentCode": 321000,
          "level": 4,
          "children": null,
          "id": 913,
        },
        {
          "areaName": "镇江市",
          "shortName": "镇江",
          "areaCode": "0511",
          "code": 321100,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 914,
        },
        {
          "areaName": "京口区",
          "shortName": "京口",
          "areaCode": "0511",
          "code": 321102,
          "parentCode": 321100,
          "level": 4,
          "children": null,
          "id": 915,
        },
        {
          "areaName": "润州区",
          "shortName": "润州",
          "areaCode": "0511",
          "code": 321111,
          "parentCode": 321100,
          "level": 4,
          "children": null,
          "id": 916,
        },
        {
          "areaName": "丹徒区",
          "shortName": "丹徒",
          "areaCode": "0511",
          "code": 321112,
          "parentCode": 321100,
          "level": 4,
          "children": null,
          "id": 917,
        },
        {
          "areaName": "丹阳市",
          "shortName": "丹阳",
          "areaCode": "0511",
          "code": 321181,
          "parentCode": 321100,
          "level": 4,
          "children": null,
          "id": 918,
        },
        {
          "areaName": "扬中市",
          "shortName": "扬中",
          "areaCode": "0511",
          "code": 321182,
          "parentCode": 321100,
          "level": 4,
          "children": null,
          "id": 919,
        },
        {
          "areaName": "句容市",
          "shortName": "句容",
          "areaCode": "0511",
          "code": 321183,
          "parentCode": 321100,
          "level": 4,
          "children": null,
          "id": 920,
        },
        {
          "areaName": "泰州市",
          "shortName": "泰州",
          "areaCode": "0523",
          "code": 321200,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 921,
        },
        {
          "areaName": "海陵区",
          "shortName": "海陵",
          "areaCode": "0523",
          "code": 321202,
          "parentCode": 321200,
          "level": 4,
          "children": null,
          "id": 922,
        },
        {
          "areaName": "高港区",
          "shortName": "高港",
          "areaCode": "0523",
          "code": 321203,
          "parentCode": 321200,
          "level": 4,
          "children": null,
          "id": 923,
        },
        {
          "areaName": "姜堰区",
          "shortName": "姜堰",
          "areaCode": "0523",
          "code": 321204,
          "parentCode": 321200,
          "level": 4,
          "children": null,
          "id": 924,
        },
        {
          "areaName": "兴化市",
          "shortName": "兴化",
          "areaCode": "0523",
          "code": 321281,
          "parentCode": 321200,
          "level": 4,
          "children": null,
          "id": 925,
        },
        {
          "areaName": "靖江市",
          "shortName": "靖江",
          "areaCode": "0523",
          "code": 321282,
          "parentCode": 321200,
          "level": 4,
          "children": null,
          "id": 926,
        },
        {
          "areaName": "泰兴市",
          "shortName": "泰兴",
          "areaCode": "0523",
          "code": 321283,
          "parentCode": 321200,
          "level": 4,
          "children": null,
          "id": 927,
        },
        {
          "areaName": "宿迁市",
          "shortName": "宿迁",
          "areaCode": "0527",
          "code": 321300,
          "parentCode": 320000,
          "level": 3,
          "children": null,
          "id": 928,
        },
        {
          "areaName": "宿城区",
          "shortName": "宿城",
          "areaCode": "0527",
          "code": 321302,
          "parentCode": 321300,
          "level": 4,
          "children": null,
          "id": 929,
        },
        {
          "areaName": "宿豫区",
          "shortName": "宿豫",
          "areaCode": "0527",
          "code": 321311,
          "parentCode": 321300,
          "level": 4,
          "children": null,
          "id": 930,
        },
        {
          "areaName": "沭阳县",
          "shortName": "沭阳",
          "areaCode": "0527",
          "code": 321322,
          "parentCode": 321300,
          "level": 4,
          "children": null,
          "id": 931,
        },
        {
          "areaName": "泗阳县",
          "shortName": "泗阳",
          "areaCode": "0527",
          "code": 321323,
          "parentCode": 321300,
          "level": 4,
          "children": null,
          "id": 932,
        },
        {
          "areaName": "泗洪县",
          "shortName": "泗洪",
          "areaCode": "0527",
          "code": 321324,
          "parentCode": 321300,
          "level": 4,
          "children": null,
          "id": 933,
        }
      ],
      "id": 821,
    },
    {
      "areaName": "浙江省",
      "shortName": "浙江",
      "code": 330000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "杭州市",
          "shortName": "杭州",
          "areaCode": "0571",
          "code": 330100,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 935,
        },
        {
          "areaName": "上城区",
          "shortName": "上城",
          "areaCode": "0571",
          "code": 330102,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 936,
        },
        {
          "areaName": "下城区",
          "shortName": "下城",
          "areaCode": "0571",
          "code": 330103,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 937,
        },
        {
          "areaName": "江干区",
          "shortName": "江干",
          "areaCode": "0571",
          "code": 330104,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 938,
        },
        {
          "areaName": "拱墅区",
          "shortName": "拱墅",
          "areaCode": "0571",
          "code": 330105,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 939,
        },
        {
          "areaName": "西湖区",
          "shortName": "西湖",
          "areaCode": "0571",
          "code": 330106,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 940,
        },
        {
          "areaName": "滨江区",
          "shortName": "滨江",
          "areaCode": "0571",
          "code": 330108,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 941,
        },
        {
          "areaName": "萧山区",
          "shortName": "萧山",
          "areaCode": "0571",
          "code": 330109,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 942,
        },
        {
          "areaName": "余杭区",
          "shortName": "余杭",
          "areaCode": "0571",
          "code": 330110,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 943,
        },
        {
          "areaName": "桐庐县",
          "shortName": "桐庐",
          "areaCode": "0571",
          "code": 330122,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 944,
        },
        {
          "areaName": "淳安县",
          "shortName": "淳安",
          "areaCode": "0571",
          "code": 330127,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 945,
        },
        {
          "areaName": "建德市",
          "shortName": "建德",
          "areaCode": "0571",
          "code": 330182,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 946,
        },
        {
          "areaName": "富阳区",
          "shortName": "富阳",
          "areaCode": "0571",
          "code": 330183,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 947,
        },
        {
          "areaName": "临安市",
          "shortName": "临安",
          "areaCode": "0571",
          "code": 330185,
          "parentCode": 330100,
          "level": 4,
          "children": null,
          "id": 948,
        },
        {
          "areaName": "宁波市",
          "shortName": "宁波",
          "areaCode": "0574",
          "code": 330200,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 949,
        },
        {
          "areaName": "海曙区",
          "shortName": "海曙",
          "areaCode": "0574",
          "code": 330203,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 950,
        },
        {
          "areaName": "江东区",
          "shortName": "江东",
          "areaCode": "0574",
          "code": 330204,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 951,
        },
        {
          "areaName": "江北区",
          "shortName": "江北",
          "areaCode": "0574",
          "code": 330205,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 952,
        },
        {
          "areaName": "北仑区",
          "shortName": "北仑",
          "areaCode": "0574",
          "code": 330206,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 953,
        },
        {
          "areaName": "镇海区",
          "shortName": "镇海",
          "areaCode": "0574",
          "code": 330211,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 954,
        },
        {
          "areaName": "鄞州区",
          "shortName": "鄞州",
          "areaCode": "0574",
          "code": 330212,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 955,
        },
        {
          "areaName": "象山县",
          "shortName": "象山",
          "areaCode": "0574",
          "code": 330225,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 956,
        },
        {
          "areaName": "宁海县",
          "shortName": "宁海",
          "areaCode": "0574",
          "code": 330226,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 957,
        },
        {
          "areaName": "余姚市",
          "shortName": "余姚",
          "areaCode": "0574",
          "code": 330281,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 958,
        },
        {
          "areaName": "慈溪市",
          "shortName": "慈溪",
          "areaCode": "0574",
          "code": 330282,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 959,
        },
        {
          "areaName": "奉化市",
          "shortName": "奉化",
          "areaCode": "0574",
          "code": 330283,
          "parentCode": 330200,
          "level": 4,
          "children": null,
          "id": 960,
        },
        {
          "areaName": "温州市",
          "shortName": "温州",
          "areaCode": "0577",
          "code": 330300,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 961,
        },
        {
          "areaName": "鹿城区",
          "shortName": "鹿城",
          "areaCode": "0577",
          "code": 330302,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 962,
        },
        {
          "areaName": "龙湾区",
          "shortName": "龙湾",
          "areaCode": "0577",
          "code": 330303,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 963,
        },
        {
          "areaName": "瓯海区",
          "shortName": "瓯海",
          "areaCode": "0577",
          "code": 330304,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 964,
        },
        {
          "areaName": "洞头县",
          "shortName": "洞头",
          "areaCode": "0577",
          "code": 330322,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 965,
        },
        {
          "areaName": "永嘉县",
          "shortName": "永嘉",
          "areaCode": "0577",
          "code": 330324,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 966,
        },
        {
          "areaName": "平阳县",
          "shortName": "平阳",
          "areaCode": "0577",
          "code": 330326,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 967,
        },
        {
          "areaName": "苍南县",
          "shortName": "苍南",
          "areaCode": "0577",
          "code": 330327,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 968,
        },
        {
          "areaName": "文成县",
          "shortName": "文成",
          "areaCode": "0577",
          "code": 330328,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 969,
        },
        {
          "areaName": "泰顺县",
          "shortName": "泰顺",
          "areaCode": "0577",
          "code": 330329,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 970,
        },
        {
          "areaName": "瑞安市",
          "shortName": "瑞安",
          "areaCode": "0577",
          "code": 330381,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 971,
        },
        {
          "areaName": "乐清市",
          "shortName": "乐清",
          "areaCode": "0577",
          "code": 330382,
          "parentCode": 330300,
          "level": 4,
          "children": null,
          "id": 972,
        },
        {
          "areaName": "嘉兴市",
          "shortName": "嘉兴",
          "areaCode": "0573",
          "code": 330400,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 973,
        },
        {
          "areaName": "南湖区",
          "shortName": "南湖",
          "areaCode": "0573",
          "code": 330402,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 974,
        },
        {
          "areaName": "秀洲区",
          "shortName": "秀洲",
          "areaCode": "0573",
          "code": 330411,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 975,
        },
        {
          "areaName": "嘉善县",
          "shortName": "嘉善",
          "areaCode": "0573",
          "code": 330421,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 976,
        },
        {
          "areaName": "海盐县",
          "shortName": "海盐",
          "areaCode": "0573",
          "code": 330424,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 977,
        },
        {
          "areaName": "海宁市",
          "shortName": "海宁",
          "areaCode": "0573",
          "code": 330481,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 978,
        },
        {
          "areaName": "平湖市",
          "shortName": "平湖",
          "areaCode": "0573",
          "code": 330482,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 979,
        },
        {
          "areaName": "桐乡市",
          "shortName": "桐乡",
          "areaCode": "0573",
          "code": 330483,
          "parentCode": 330400,
          "level": 4,
          "children": null,
          "id": 980,
        },
        {
          "areaName": "湖州市",
          "shortName": "湖州",
          "areaCode": "0572",
          "code": 330500,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 981,
        },
        {
          "areaName": "吴兴区",
          "shortName": "吴兴",
          "areaCode": "0572",
          "code": 330502,
          "parentCode": 330500,
          "level": 4,
          "children": null,
          "id": 982,
        },
        {
          "areaName": "南浔区",
          "shortName": "南浔",
          "areaCode": "0572",
          "code": 330503,
          "parentCode": 330500,
          "level": 4,
          "children": null,
          "id": 983,
        },
        {
          "areaName": "德清县",
          "shortName": "德清",
          "areaCode": "0572",
          "code": 330521,
          "parentCode": 330500,
          "level": 4,
          "children": null,
          "id": 984,
        },
        {
          "areaName": "长兴县",
          "shortName": "长兴",
          "areaCode": "0572",
          "code": 330522,
          "parentCode": 330500,
          "level": 4,
          "children": null,
          "id": 985,
        },
        {
          "areaName": "安吉县",
          "shortName": "安吉",
          "areaCode": "0572",
          "code": 330523,
          "parentCode": 330500,
          "level": 4,
          "children": null,
          "id": 986,
        },
        {
          "areaName": "绍兴市",
          "shortName": "绍兴",
          "areaCode": "0575",
          "code": 330600,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 987,
        },
        {
          "areaName": "越城区",
          "shortName": "越城",
          "areaCode": "0575",
          "code": 330602,
          "parentCode": 330600,
          "level": 4,
          "children": null,
          "id": 988,
        },
        {
          "areaName": "柯桥区",
          "shortName": "柯桥",
          "areaCode": "0575",
          "code": 330603,
          "parentCode": 330600,
          "level": 4,
          "children": null,
          "id": 989,
        },
        {
          "areaName": "上虞区",
          "shortName": "上虞",
          "areaCode": "0575",
          "code": 330604,
          "parentCode": 330600,
          "level": 4,
          "children": null,
          "id": 990,
        },
        {
          "areaName": "新昌县",
          "shortName": "新昌",
          "areaCode": "0575",
          "code": 330624,
          "parentCode": 330600,
          "level": 4,
          "children": null,
          "id": 991,
        },
        {
          "areaName": "诸暨市",
          "shortName": "诸暨",
          "areaCode": "0575",
          "code": 330681,
          "parentCode": 330600,
          "level": 4,
          "children": null,
          "id": 992,
        },
        {
          "areaName": "嵊州市",
          "shortName": "嵊州",
          "areaCode": "0575",
          "code": 330683,
          "parentCode": 330600,
          "level": 4,
          "children": null,
          "id": 993,
        },
        {
          "areaName": "金华市",
          "shortName": "金华",
          "areaCode": "0579",
          "code": 330700,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 994,
        },
        {
          "areaName": "婺城区",
          "shortName": "婺城",
          "areaCode": "0579",
          "code": 330702,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 995,
        },
        {
          "areaName": "金东区",
          "shortName": "金东",
          "areaCode": "0579",
          "code": 330703,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 996,
        },
        {
          "areaName": "武义县",
          "shortName": "武义",
          "areaCode": "0579",
          "code": 330723,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 997,
        },
        {
          "areaName": "浦江县",
          "shortName": "浦江",
          "areaCode": "0579",
          "code": 330726,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 998,
        },
        {
          "areaName": "磐安县",
          "shortName": "磐安",
          "areaCode": "0579",
          "code": 330727,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 999,
        },
        {
          "areaName": "兰溪市",
          "shortName": "兰溪",
          "areaCode": "0579",
          "code": 330781,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 1000,
        },
        {
          "areaName": "义乌市",
          "shortName": "义乌",
          "areaCode": "0579",
          "code": 330782,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 1001,
        },
        {
          "areaName": "东阳市",
          "shortName": "东阳",
          "areaCode": "0579",
          "code": 330783,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 1002,
        },
        {
          "areaName": "永康市",
          "shortName": "永康",
          "areaCode": "0579",
          "code": 330784,
          "parentCode": 330700,
          "level": 4,
          "children": null,
          "id": 1003,
        },
        {
          "areaName": "衢州市",
          "shortName": "衢州",
          "areaCode": "0570",
          "code": 330800,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 1004,
        },
        {
          "areaName": "柯城区",
          "shortName": "柯城",
          "areaCode": "0570",
          "code": 330802,
          "parentCode": 330800,
          "level": 4,
          "children": null,
          "id": 1005,
        },
        {
          "areaName": "衢江区",
          "shortName": "衢江",
          "areaCode": "0570",
          "code": 330803,
          "parentCode": 330800,
          "level": 4,
          "children": null,
          "id": 1006,
        },
        {
          "areaName": "常山县",
          "shortName": "常山",
          "areaCode": "0570",
          "code": 330822,
          "parentCode": 330800,
          "level": 4,
          "children": null,
          "id": 1007,
        },
        {
          "areaName": "开化县",
          "shortName": "开化",
          "areaCode": "0570",
          "code": 330824,
          "parentCode": 330800,
          "level": 4,
          "children": null,
          "id": 1008,
        },
        {
          "areaName": "龙游县",
          "shortName": "龙游",
          "areaCode": "0570",
          "code": 330825,
          "parentCode": 330800,
          "level": 4,
          "children": null,
          "id": 1009,
        },
        {
          "areaName": "江山市",
          "shortName": "江山",
          "areaCode": "0570",
          "code": 330881,
          "parentCode": 330800,
          "level": 4,
          "children": null,
          "id": 1010,
        },
        {
          "areaName": "舟山市",
          "shortName": "舟山",
          "areaCode": "0580",
          "code": 330900,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 1011,
        },
        {
          "areaName": "定海区",
          "shortName": "定海",
          "areaCode": "0580",
          "code": 330902,
          "parentCode": 330900,
          "level": 4,
          "children": null,
          "id": 1012,
        },
        {
          "areaName": "普陀区",
          "shortName": "普陀",
          "areaCode": "0580",
          "code": 330903,
          "parentCode": 330900,
          "level": 4,
          "children": null,
          "id": 1013,
        },
        {
          "areaName": "岱山县",
          "shortName": "岱山",
          "areaCode": "0580",
          "code": 330921,
          "parentCode": 330900,
          "level": 4,
          "children": null,
          "id": 1014,
        },
        {
          "areaName": "嵊泗县",
          "shortName": "嵊泗",
          "areaCode": "0580",
          "code": 330922,
          "parentCode": 330900,
          "level": 4,
          "children": null,
          "id": 1015,
        },
        {
          "areaName": "台州市",
          "shortName": "台州",
          "areaCode": "0576",
          "code": 331000,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 1016,
        },
        {
          "areaName": "椒江区",
          "shortName": "椒江",
          "areaCode": "0576",
          "code": 331002,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1017,
        },
        {
          "areaName": "黄岩区",
          "shortName": "黄岩",
          "areaCode": "0576",
          "code": 331003,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1018,
        },
        {
          "areaName": "路桥区",
          "shortName": "路桥",
          "areaCode": "0576",
          "code": 331004,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1019,
        },
        {
          "areaName": "玉环县",
          "shortName": "玉环",
          "areaCode": "0576",
          "code": 331021,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1020,
        },
        {
          "areaName": "三门县",
          "shortName": "三门",
          "areaCode": "0576",
          "code": 331022,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1021,
        },
        {
          "areaName": "天台县",
          "shortName": "天台",
          "areaCode": "0576",
          "code": 331023,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1022,
        },
        {
          "areaName": "仙居县",
          "shortName": "仙居",
          "areaCode": "0576",
          "code": 331024,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1023,
        },
        {
          "areaName": "温岭市",
          "shortName": "温岭",
          "areaCode": "0576",
          "code": 331081,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1024,
        },
        {
          "areaName": "临海市",
          "shortName": "临海",
          "areaCode": "0576",
          "code": 331082,
          "parentCode": 331000,
          "level": 4,
          "children": null,
          "id": 1025,
        },
        {
          "areaName": "丽水市",
          "shortName": "丽水",
          "areaCode": "0578",
          "code": 331100,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 1026,
        },
        {
          "areaName": "莲都区",
          "shortName": "莲都",
          "areaCode": "0578",
          "code": 331102,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1027,
        },
        {
          "areaName": "青田县",
          "shortName": "青田",
          "areaCode": "0578",
          "code": 331121,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1028,
        },
        {
          "areaName": "缙云县",
          "shortName": "缙云",
          "areaCode": "0578",
          "code": 331122,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1029,
        },
        {
          "areaName": "遂昌县",
          "shortName": "遂昌",
          "areaCode": "0578",
          "code": 331123,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1030,
        },
        {
          "areaName": "松阳县",
          "shortName": "松阳",
          "areaCode": "0578",
          "code": 331124,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1031,
        },
        {
          "areaName": "云和县",
          "shortName": "云和",
          "areaCode": "0578",
          "code": 331125,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1032,
        },
        {
          "areaName": "庆元县",
          "shortName": "庆元",
          "areaCode": "0578",
          "code": 331126,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1033,
        },
        {
          "areaName": "景宁畲族自治县",
          "shortName": "景宁",
          "areaCode": "0578",
          "code": 331127,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1034,
        },
        {
          "areaName": "龙泉市",
          "shortName": "龙泉",
          "areaCode": "0578",
          "code": 331181,
          "parentCode": 331100,
          "level": 4,
          "children": null,
          "id": 1035,
        },
        {
          "areaName": "舟山群岛新区",
          "shortName": "舟山新区",
          "areaCode": "0580",
          "code": 331200,
          "parentCode": 330000,
          "level": 3,
          "children": null,
          "id": 1036,
        },
        {
          "areaName": "金塘岛",
          "shortName": "金塘",
          "areaCode": "0580",
          "code": 331201,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1037,
        },
        {
          "areaName": "六横岛",
          "shortName": "六横",
          "areaCode": "0580",
          "code": 331202,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1038,
        },
        {
          "areaName": "衢山岛",
          "shortName": "衢山",
          "areaCode": "0580",
          "code": 331203,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1039,
        },
        {
          "areaName": "舟山本岛西北部",
          "shortName": "舟山",
          "areaCode": "0580",
          "code": 331204,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1040,
        },
        {
          "areaName": "岱山岛西南部",
          "shortName": "岱山",
          "areaCode": "0580",
          "code": 331205,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1041,
        },
        {
          "areaName": "泗礁岛",
          "shortName": "泗礁",
          "areaCode": "0580",
          "code": 331206,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1042,
        },
        {
          "areaName": "朱家尖岛",
          "shortName": "朱家尖",
          "areaCode": "0580",
          "code": 331207,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1043,
        },
        {
          "areaName": "洋山岛",
          "shortName": "洋山",
          "areaCode": "0580",
          "code": 331208,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1044,
        },
        {
          "areaName": "长涂岛",
          "shortName": "长涂",
          "areaCode": "0580",
          "code": 331209,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1045,
        },
        {
          "areaName": "虾峙岛",
          "shortName": "虾峙",
          "areaCode": "0580",
          "code": 331210,
          "parentCode": 331200,
          "level": 4,
          "children": null,
          "id": 1046,
        }
      ],
      "id": 934,
    },
    {
      "areaName": "安徽省",
      "shortName": "安徽",
      "code": 340000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "合肥市",
          "shortName": "合肥",
          "areaCode": "0551",
          "code": 340100,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1048,
        },
        {
          "areaName": "瑶海区",
          "shortName": "瑶海",
          "areaCode": "0551",
          "code": 340102,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1049,
        },
        {
          "areaName": "庐阳区",
          "shortName": "庐阳",
          "areaCode": "0551",
          "code": 340103,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1050,
        },
        {
          "areaName": "蜀山区",
          "shortName": "蜀山",
          "areaCode": "0551",
          "code": 340104,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1051,
        },
        {
          "areaName": "包河区",
          "shortName": "包河",
          "areaCode": "0551",
          "code": 340111,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1052,
        },
        {
          "areaName": "长丰县",
          "shortName": "长丰",
          "areaCode": "0551",
          "code": 340121,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1053,
        },
        {
          "areaName": "肥东县",
          "shortName": "肥东",
          "areaCode": "0551",
          "code": 340122,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1054,
        },
        {
          "areaName": "肥西县",
          "shortName": "肥西",
          "areaCode": "0551",
          "code": 340123,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1055,
        },
        {
          "areaName": "庐江县",
          "shortName": "庐江",
          "areaCode": "0565",
          "code": 340124,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1056,
        },
        {
          "areaName": "巢湖市",
          "shortName": "巢湖",
          "areaCode": "0565",
          "code": 340181,
          "parentCode": 340100,
          "level": 4,
          "children": null,
          "id": 1057,
        },
        {
          "areaName": "芜湖市",
          "shortName": "芜湖",
          "areaCode": "0551",
          "code": 340200,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1058,
        },
        {
          "areaName": "镜湖区",
          "shortName": "镜湖",
          "areaCode": "0553",
          "code": 340202,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1059,
        },
        {
          "areaName": "弋江区",
          "shortName": "弋江",
          "areaCode": "0553",
          "code": 340203,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1060,
        },
        {
          "areaName": "鸠江区",
          "shortName": "鸠江",
          "areaCode": "0553",
          "code": 340207,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1061,
        },
        {
          "areaName": "三山区",
          "shortName": "三山",
          "areaCode": "0553",
          "code": 340208,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1062,
        },
        {
          "areaName": "芜湖县",
          "shortName": "芜湖",
          "areaCode": "0553",
          "code": 340221,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1063,
        },
        {
          "areaName": "繁昌县",
          "shortName": "繁昌",
          "areaCode": "0553",
          "code": 340222,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1064,
        },
        {
          "areaName": "南陵县",
          "shortName": "南陵",
          "areaCode": "0553",
          "code": 340223,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1065,
        },
        {
          "areaName": "无为县",
          "shortName": "无为",
          "areaCode": "0565",
          "code": 340225,
          "parentCode": 340200,
          "level": 4,
          "children": null,
          "id": 1066,
        },
        {
          "areaName": "蚌埠市",
          "shortName": "蚌埠",
          "areaCode": "0552",
          "code": 340300,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1067,
        },
        {
          "areaName": "龙子湖区",
          "shortName": "龙子湖",
          "areaCode": "0552",
          "code": 340302,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1068,
        },
        {
          "areaName": "蚌山区",
          "shortName": "蚌山",
          "areaCode": "0552",
          "code": 340303,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1069,
        },
        {
          "areaName": "禹会区",
          "shortName": "禹会",
          "areaCode": "0552",
          "code": 340304,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1070,
        },
        {
          "areaName": "淮上区",
          "shortName": "淮上",
          "areaCode": "0552",
          "code": 340311,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1071,
        },
        {
          "areaName": "怀远县",
          "shortName": "怀远",
          "areaCode": "0552",
          "code": 340321,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1072,
        },
        {
          "areaName": "五河县",
          "shortName": "五河",
          "areaCode": "0552",
          "code": 340322,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1073,
        },
        {
          "areaName": "固镇县",
          "shortName": "固镇",
          "areaCode": "0552",
          "code": 340323,
          "parentCode": 340300,
          "level": 4,
          "children": null,
          "id": 1074,
        },
        {
          "areaName": "淮南市",
          "shortName": "淮南",
          "areaCode": "0554",
          "code": 340400,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1075,
        },
        {
          "areaName": "大通区",
          "shortName": "大通",
          "areaCode": "0554",
          "code": 340402,
          "parentCode": 340400,
          "level": 4,
          "children": null,
          "id": 1076,
        },
        {
          "areaName": "田家庵区",
          "shortName": "田家庵",
          "areaCode": "0554",
          "code": 340403,
          "parentCode": 340400,
          "level": 4,
          "children": null,
          "id": 1077,
        },
        {
          "areaName": "谢家集区",
          "shortName": "谢家集",
          "areaCode": "0554",
          "code": 340404,
          "parentCode": 340400,
          "level": 4,
          "children": null,
          "id": 1078,
        },
        {
          "areaName": "八公山区",
          "shortName": "八公山",
          "areaCode": "0554",
          "code": 340405,
          "parentCode": 340400,
          "level": 4,
          "children": null,
          "id": 1079,
        },
        {
          "areaName": "潘集区",
          "shortName": "潘集",
          "areaCode": "0554",
          "code": 340406,
          "parentCode": 340400,
          "level": 4,
          "children": null,
          "id": 1080,
        },
        {
          "areaName": "凤台县",
          "shortName": "凤台",
          "areaCode": "0554",
          "code": 340421,
          "parentCode": 340400,
          "level": 4,
          "children": null,
          "id": 1081,
        },
        {
          "areaName": "马鞍山市",
          "shortName": "马鞍山",
          "areaCode": "0555",
          "code": 340500,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1082,
        },
        {
          "areaName": "花山区",
          "shortName": "花山",
          "areaCode": "0555",
          "code": 340503,
          "parentCode": 340500,
          "level": 4,
          "children": null,
          "id": 1083,
        },
        {
          "areaName": "雨山区",
          "shortName": "雨山",
          "areaCode": "0555",
          "code": 340504,
          "parentCode": 340500,
          "level": 4,
          "children": null,
          "id": 1084,
        },
        {
          "areaName": "博望区",
          "shortName": "博望",
          "areaCode": "0555",
          "code": 340506,
          "parentCode": 340500,
          "level": 4,
          "children": null,
          "id": 1085,
        },
        {
          "areaName": "当涂县",
          "shortName": "当涂",
          "areaCode": "0555",
          "code": 340521,
          "parentCode": 340500,
          "level": 4,
          "children": null,
          "id": 1086,
        },
        {
          "areaName": "含山县",
          "shortName": "含山",
          "areaCode": "0555",
          "code": 340522,
          "parentCode": 340500,
          "level": 4,
          "children": null,
          "id": 1087,
        },
        {
          "areaName": "和县",
          "shortName": "和县",
          "areaCode": "0555",
          "code": 340523,
          "parentCode": 340500,
          "level": 4,
          "children": null,
          "id": 1088,
        },
        {
          "areaName": "淮北市",
          "shortName": "淮北",
          "areaCode": "0561",
          "code": 340600,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1089,
        },
        {
          "areaName": "杜集区",
          "shortName": "杜集",
          "areaCode": "0561",
          "code": 340602,
          "parentCode": 340600,
          "level": 4,
          "children": null,
          "id": 1090,
        },
        {
          "areaName": "相山区",
          "shortName": "相山",
          "areaCode": "0561",
          "code": 340603,
          "parentCode": 340600,
          "level": 4,
          "children": null,
          "id": 1091,
        },
        {
          "areaName": "烈山区",
          "shortName": "烈山",
          "areaCode": "0561",
          "code": 340604,
          "parentCode": 340600,
          "level": 4,
          "children": null,
          "id": 1092,
        },
        {
          "areaName": "濉溪县",
          "shortName": "濉溪",
          "areaCode": "0561",
          "code": 340621,
          "parentCode": 340600,
          "level": 4,
          "children": null,
          "id": 1093,
        },
        {
          "areaName": "铜陵市",
          "shortName": "铜陵",
          "areaCode": "0562",
          "code": 340700,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1094,
        },
        {
          "areaName": "铜官山区",
          "shortName": "铜官山",
          "areaCode": "0562",
          "code": 340702,
          "parentCode": 340700,
          "level": 4,
          "children": null,
          "id": 1095,
        },
        {
          "areaName": "狮子山区",
          "shortName": "狮子山",
          "areaCode": "0562",
          "code": 340703,
          "parentCode": 340700,
          "level": 4,
          "children": null,
          "id": 1096,
        },
        {
          "areaName": "郊区",
          "shortName": "郊区",
          "areaCode": "0562",
          "code": 340711,
          "parentCode": 340700,
          "level": 4,
          "children": null,
          "id": 1097,
        },
        {
          "areaName": "铜陵县",
          "shortName": "铜陵",
          "areaCode": "0562",
          "code": 340721,
          "parentCode": 340700,
          "level": 4,
          "children": null,
          "id": 1098,
        },
        {
          "areaName": "安庆市",
          "shortName": "安庆",
          "areaCode": "0556",
          "code": 340800,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1099,
        },
        {
          "areaName": "迎江区",
          "shortName": "迎江",
          "areaCode": "0556",
          "code": 340802,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1100,
        },
        {
          "areaName": "大观区",
          "shortName": "大观",
          "areaCode": "0556",
          "code": 340803,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1101,
        },
        {
          "areaName": "宜秀区",
          "shortName": "宜秀",
          "areaCode": "0556",
          "code": 340811,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1102,
        },
        {
          "areaName": "怀宁县",
          "shortName": "怀宁",
          "areaCode": "0556",
          "code": 340822,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1103,
        },
        {
          "areaName": "枞阳县",
          "shortName": "枞阳",
          "areaCode": "0556",
          "code": 340823,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1104,
        },
        {
          "areaName": "潜山县",
          "shortName": "潜山",
          "areaCode": "0556",
          "code": 340824,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1105,
        },
        {
          "areaName": "太湖县",
          "shortName": "太湖",
          "areaCode": "0556",
          "code": 340825,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1106,
        },
        {
          "areaName": "宿松县",
          "shortName": "宿松",
          "areaCode": "0556",
          "code": 340826,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1107,
        },
        {
          "areaName": "望江县",
          "shortName": "望江",
          "areaCode": "0556",
          "code": 340827,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1108,
        },
        {
          "areaName": "岳西县",
          "shortName": "岳西",
          "areaCode": "0556",
          "code": 340828,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1109,
        },
        {
          "areaName": "桐城市",
          "shortName": "桐城",
          "areaCode": "0556",
          "code": 340881,
          "parentCode": 340800,
          "level": 4,
          "children": null,
          "id": 1110,
        },
        {
          "areaName": "黄山市",
          "shortName": "黄山",
          "areaCode": "0559",
          "code": 341000,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1111,
        },
        {
          "areaName": "屯溪区",
          "shortName": "屯溪",
          "areaCode": "0559",
          "code": 341002,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1112,
        },
        {
          "areaName": "黄山区",
          "shortName": "黄山",
          "areaCode": "0559",
          "code": 341003,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1113,
        },
        {
          "areaName": "徽州区",
          "shortName": "徽州",
          "areaCode": "0559",
          "code": 341004,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1114,
        },
        {
          "areaName": "歙县",
          "shortName": "歙县",
          "areaCode": "0559",
          "code": 341021,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1115,
        },
        {
          "areaName": "休宁县",
          "shortName": "休宁",
          "areaCode": "0559",
          "code": 341022,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1116,
        },
        {
          "areaName": "黟县",
          "shortName": "黟县",
          "areaCode": "0559",
          "code": 341023,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1117,
        },
        {
          "areaName": "祁门县",
          "shortName": "祁门",
          "areaCode": "0559",
          "code": 341024,
          "parentCode": 341000,
          "level": 4,
          "children": null,
          "id": 1118,
        },
        {
          "areaName": "滁州市",
          "shortName": "滁州",
          "areaCode": "0550",
          "code": 341100,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1119,
        },
        {
          "areaName": "琅琊区",
          "shortName": "琅琊",
          "areaCode": "0550",
          "code": 341102,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1120,
        },
        {
          "areaName": "南谯区",
          "shortName": "南谯",
          "areaCode": "0550",
          "code": 341103,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1121,
        },
        {
          "areaName": "来安县",
          "shortName": "来安",
          "areaCode": "0550",
          "code": 341122,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1122,
        },
        {
          "areaName": "全椒县",
          "shortName": "全椒",
          "areaCode": "0550",
          "code": 341124,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1123,
        },
        {
          "areaName": "定远县",
          "shortName": "定远",
          "areaCode": "0550",
          "code": 341125,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1124,
        },
        {
          "areaName": "凤阳县",
          "shortName": "凤阳",
          "areaCode": "0550",
          "code": 341126,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1125,
        },
        {
          "areaName": "天长市",
          "shortName": "天长",
          "areaCode": "0550",
          "code": 341181,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1126,
        },
        {
          "areaName": "明光市",
          "shortName": "明光",
          "areaCode": "0550",
          "code": 341182,
          "parentCode": 341100,
          "level": 4,
          "children": null,
          "id": 1127,
        },
        {
          "areaName": "阜阳市",
          "shortName": "阜阳",
          "areaCode": "0558",
          "code": 341200,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1128,
        },
        {
          "areaName": "颍州区",
          "shortName": "颍州",
          "areaCode": "0558",
          "code": 341202,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1129,
        },
        {
          "areaName": "颍东区",
          "shortName": "颍东",
          "areaCode": "0558",
          "code": 341203,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1130,
        },
        {
          "areaName": "颍泉区",
          "shortName": "颍泉",
          "areaCode": "0558",
          "code": 341204,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1131,
        },
        {
          "areaName": "临泉县",
          "shortName": "临泉",
          "areaCode": "0558",
          "code": 341221,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1132,
        },
        {
          "areaName": "太和县",
          "shortName": "太和",
          "areaCode": "0558",
          "code": 341222,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1133,
        },
        {
          "areaName": "阜南县",
          "shortName": "阜南",
          "areaCode": "0558",
          "code": 341225,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1134,
        },
        {
          "areaName": "颍上县",
          "shortName": "颍上",
          "areaCode": "0558",
          "code": 341226,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1135,
        },
        {
          "areaName": "界首市",
          "shortName": "界首",
          "areaCode": "0558",
          "code": 341282,
          "parentCode": 341200,
          "level": 4,
          "children": null,
          "id": 1136,
        },
        {
          "areaName": "宿州市",
          "shortName": "宿州",
          "areaCode": "0557",
          "code": 341300,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1137,
        },
        {
          "areaName": "埇桥区",
          "shortName": "埇桥",
          "areaCode": "0557",
          "code": 341302,
          "parentCode": 341300,
          "level": 4,
          "children": null,
          "id": 1138,
        },
        {
          "areaName": "砀山县",
          "shortName": "砀山",
          "areaCode": "0557",
          "code": 341321,
          "parentCode": 341300,
          "level": 4,
          "children": null,
          "id": 1139,
        },
        {
          "areaName": "萧县",
          "shortName": "萧县",
          "areaCode": "0557",
          "code": 341322,
          "parentCode": 341300,
          "level": 4,
          "children": null,
          "id": 1140,
        },
        {
          "areaName": "灵璧县",
          "shortName": "灵璧",
          "areaCode": "0557",
          "code": 341323,
          "parentCode": 341300,
          "level": 4,
          "children": null,
          "id": 1141,
        },
        {
          "areaName": "泗县",
          "shortName": "泗县",
          "areaCode": "0557",
          "code": 341324,
          "parentCode": 341300,
          "level": 4,
          "children": null,
          "id": 1142,
        },
        {
          "areaName": "六安市",
          "shortName": "六安",
          "areaCode": "0564",
          "code": 341500,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1143,
        },
        {
          "areaName": "金安区",
          "shortName": "金安",
          "areaCode": "0564",
          "code": 341502,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1144,
        },
        {
          "areaName": "裕安区",
          "shortName": "裕安",
          "areaCode": "0564",
          "code": 341503,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1145,
        },
        {
          "areaName": "寿县",
          "shortName": "寿县",
          "areaCode": "0564",
          "code": 341521,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1146,
        },
        {
          "areaName": "霍邱县",
          "shortName": "霍邱",
          "areaCode": "0564",
          "code": 341522,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1147,
        },
        {
          "areaName": "舒城县",
          "shortName": "舒城",
          "areaCode": "0564",
          "code": 341523,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1148,
        },
        {
          "areaName": "金寨县",
          "shortName": "金寨",
          "areaCode": "0564",
          "code": 341524,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1149,
        },
        {
          "areaName": "霍山县",
          "shortName": "霍山",
          "areaCode": "0564",
          "code": 341525,
          "parentCode": 341500,
          "level": 4,
          "children": null,
          "id": 1150,
        },
        {
          "areaName": "亳州市",
          "shortName": "亳州",
          "areaCode": "0558",
          "code": 341600,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1151,
        },
        {
          "areaName": "谯城区",
          "shortName": "谯城",
          "areaCode": "0558",
          "code": 341602,
          "parentCode": 341600,
          "level": 4,
          "children": null,
          "id": 1152,
        },
        {
          "areaName": "涡阳县",
          "shortName": "涡阳",
          "areaCode": "0558",
          "code": 341621,
          "parentCode": 341600,
          "level": 4,
          "children": null,
          "id": 1153,
        },
        {
          "areaName": "蒙城县",
          "shortName": "蒙城",
          "areaCode": "0558",
          "code": 341622,
          "parentCode": 341600,
          "level": 4,
          "children": null,
          "id": 1154,
        },
        {
          "areaName": "利辛县",
          "shortName": "利辛",
          "areaCode": "0558",
          "code": 341623,
          "parentCode": 341600,
          "level": 4,
          "children": null,
          "id": 1155,
        },
        {
          "areaName": "池州市",
          "shortName": "池州",
          "areaCode": "0566",
          "code": 341700,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1156,
        },
        {
          "areaName": "贵池区",
          "shortName": "贵池",
          "areaCode": "0566",
          "code": 341702,
          "parentCode": 341700,
          "level": 4,
          "children": null,
          "id": 1157,
        },
        {
          "areaName": "东至县",
          "shortName": "东至",
          "areaCode": "0566",
          "code": 341721,
          "parentCode": 341700,
          "level": 4,
          "children": null,
          "id": 1158,
        },
        {
          "areaName": "石台县",
          "shortName": "石台",
          "areaCode": "0566",
          "code": 341722,
          "parentCode": 341700,
          "level": 4,
          "children": null,
          "id": 1159,
        },
        {
          "areaName": "青阳县",
          "shortName": "青阳",
          "areaCode": "0566",
          "code": 341723,
          "parentCode": 341700,
          "level": 4,
          "children": null,
          "id": 1160,
        },
        {
          "areaName": "宣城市",
          "shortName": "宣城",
          "areaCode": "0563",
          "code": 341800,
          "parentCode": 340000,
          "level": 3,
          "children": null,
          "id": 1161,
        },
        {
          "areaName": "宣州区",
          "shortName": "宣州",
          "areaCode": "0563",
          "code": 341802,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1162,
        },
        {
          "areaName": "郎溪县",
          "shortName": "郎溪",
          "areaCode": "0563",
          "code": 341821,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1163,
        },
        {
          "areaName": "广德县",
          "shortName": "广德",
          "areaCode": "0563",
          "code": 341822,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1164,
        },
        {
          "areaName": "泾县",
          "shortName": "泾县",
          "areaCode": "0563",
          "code": 341823,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1165,
        },
        {
          "areaName": "绩溪县",
          "shortName": "绩溪",
          "areaCode": "0563",
          "code": 341824,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1166,
        },
        {
          "areaName": "旌德县",
          "shortName": "旌德",
          "areaCode": "0563",
          "code": 341825,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1167,
        },
        {
          "areaName": "宁国市",
          "shortName": "宁国",
          "areaCode": "0563",
          "code": 341881,
          "parentCode": 341800,
          "level": 4,
          "children": null,
          "id": 1168,
        }
      ],
      "id": 1047,
    },
    {
      "areaName": "福建省",
      "shortName": "福建",
      "code": 350000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "福州市",
          "shortName": "福州",
          "areaCode": "0591",
          "code": 350100,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1170,
        },
        {
          "areaName": "鼓楼区",
          "shortName": "鼓楼",
          "areaCode": "0591",
          "code": 350102,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1171,
        },
        {
          "areaName": "台江区",
          "shortName": "台江",
          "areaCode": "0591",
          "code": 350103,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1172,
        },
        {
          "areaName": "仓山区",
          "shortName": "仓山",
          "areaCode": "0591",
          "code": 350104,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1173,
        },
        {
          "areaName": "马尾区",
          "shortName": "马尾",
          "areaCode": "0591",
          "code": 350105,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1174,
        },
        {
          "areaName": "晋安区",
          "shortName": "晋安",
          "areaCode": "0591",
          "code": 350111,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1175,
        },
        {
          "areaName": "闽侯县",
          "shortName": "闽侯",
          "areaCode": "0591",
          "code": 350121,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1176,
        },
        {
          "areaName": "连江县",
          "shortName": "连江",
          "areaCode": "0591",
          "code": 350122,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1177,
        },
        {
          "areaName": "罗源县",
          "shortName": "罗源",
          "areaCode": "0591",
          "code": 350123,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1178,
        },
        {
          "areaName": "闽清县",
          "shortName": "闽清",
          "areaCode": "0591",
          "code": 350124,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1179,
        },
        {
          "areaName": "永泰县",
          "shortName": "永泰",
          "areaCode": "0591",
          "code": 350125,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1180,
        },
        {
          "areaName": "平潭县",
          "shortName": "平潭",
          "areaCode": "0591",
          "code": 350128,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1181,
        },
        {
          "areaName": "福清市",
          "shortName": "福清",
          "areaCode": "0591",
          "code": 350181,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1182,
        },
        {
          "areaName": "长乐市",
          "shortName": "长乐",
          "areaCode": "0591",
          "code": 350182,
          "parentCode": 350100,
          "level": 4,
          "children": null,
          "id": 1183,
        },
        {
          "areaName": "厦门市",
          "shortName": "厦门",
          "areaCode": "0592",
          "code": 350200,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1184,
        },
        {
          "areaName": "思明区",
          "shortName": "思明",
          "areaCode": "0592",
          "code": 350203,
          "parentCode": 350200,
          "level": 4,
          "children": null,
          "id": 1185,
        },
        {
          "areaName": "海沧区",
          "shortName": "海沧",
          "areaCode": "0592",
          "code": 350205,
          "parentCode": 350200,
          "level": 4,
          "children": null,
          "id": 1186,
        },
        {
          "areaName": "湖里区",
          "shortName": "湖里",
          "areaCode": "0592",
          "code": 350206,
          "parentCode": 350200,
          "level": 4,
          "children": null,
          "id": 1187,
        },
        {
          "areaName": "集美区",
          "shortName": "集美",
          "areaCode": "0592",
          "code": 350211,
          "parentCode": 350200,
          "level": 4,
          "children": null,
          "id": 1188,
        },
        {
          "areaName": "同安区",
          "shortName": "同安",
          "areaCode": "0592",
          "code": 350212,
          "parentCode": 350200,
          "level": 4,
          "children": null,
          "id": 1189,
        },
        {
          "areaName": "翔安区",
          "shortName": "翔安",
          "areaCode": "0592",
          "code": 350213,
          "parentCode": 350200,
          "level": 4,
          "children": null,
          "id": 1190,
        },
        {
          "areaName": "莆田市",
          "shortName": "莆田",
          "areaCode": "0594",
          "code": 350300,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1191,
        },
        {
          "areaName": "城厢区",
          "shortName": "城厢",
          "areaCode": "0594",
          "code": 350302,
          "parentCode": 350300,
          "level": 4,
          "children": null,
          "id": 1192,
        },
        {
          "areaName": "涵江区",
          "shortName": "涵江",
          "areaCode": "0594",
          "code": 350303,
          "parentCode": 350300,
          "level": 4,
          "children": null,
          "id": 1193,
        },
        {
          "areaName": "荔城区",
          "shortName": "荔城",
          "areaCode": "0594",
          "code": 350304,
          "parentCode": 350300,
          "level": 4,
          "children": null,
          "id": 1194,
        },
        {
          "areaName": "秀屿区",
          "shortName": "秀屿",
          "areaCode": "0594",
          "code": 350305,
          "parentCode": 350300,
          "level": 4,
          "children": null,
          "id": 1195,
        },
        {
          "areaName": "仙游县",
          "shortName": "仙游",
          "areaCode": "0594",
          "code": 350322,
          "parentCode": 350300,
          "level": 4,
          "children": null,
          "id": 1196,
        },
        {
          "areaName": "三明市",
          "shortName": "三明",
          "areaCode": "0598",
          "code": 350400,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1197,
        },
        {
          "areaName": "梅列区",
          "shortName": "梅列",
          "areaCode": "0598",
          "code": 350402,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1198,
        },
        {
          "areaName": "三元区",
          "shortName": "三元",
          "areaCode": "0598",
          "code": 350403,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1199,
        },
        {
          "areaName": "明溪县",
          "shortName": "明溪",
          "areaCode": "0598",
          "code": 350421,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1200,
        },
        {
          "areaName": "清流县",
          "shortName": "清流",
          "areaCode": "0598",
          "code": 350423,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1201,
        },
        {
          "areaName": "宁化县",
          "shortName": "宁化",
          "areaCode": "0598",
          "code": 350424,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1202,
        },
        {
          "areaName": "大田县",
          "shortName": "大田",
          "areaCode": "0598",
          "code": 350425,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1203,
        },
        {
          "areaName": "尤溪县",
          "shortName": "尤溪",
          "areaCode": "0598",
          "code": 350426,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1204,
        },
        {
          "areaName": "沙县",
          "shortName": "沙县",
          "areaCode": "0598",
          "code": 350427,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1205,
        },
        {
          "areaName": "将乐县",
          "shortName": "将乐",
          "areaCode": "0598",
          "code": 350428,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1206,
        },
        {
          "areaName": "泰宁县",
          "shortName": "泰宁",
          "areaCode": "0598",
          "code": 350429,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1207,
        },
        {
          "areaName": "建宁县",
          "shortName": "建宁",
          "areaCode": "0598",
          "code": 350430,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1208,
        },
        {
          "areaName": "永安市",
          "shortName": "永安",
          "areaCode": "0598",
          "code": 350481,
          "parentCode": 350400,
          "level": 4,
          "children": null,
          "id": 1209,
        },
        {
          "areaName": "泉州市",
          "shortName": "泉州",
          "areaCode": "0595",
          "code": 350500,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1210,
        },
        {
          "areaName": "鲤城区",
          "shortName": "鲤城",
          "areaCode": "0595",
          "code": 350502,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1211,
        },
        {
          "areaName": "丰泽区",
          "shortName": "丰泽",
          "areaCode": "0595",
          "code": 350503,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1212,
        },
        {
          "areaName": "洛江区",
          "shortName": "洛江",
          "areaCode": "0595",
          "code": 350504,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1213,
        },
        {
          "areaName": "泉港区",
          "shortName": "泉港",
          "areaCode": "0595",
          "code": 350505,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1214,
        },
        {
          "areaName": "惠安县",
          "shortName": "惠安",
          "areaCode": "0595",
          "code": 350521,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1215,
        },
        {
          "areaName": "安溪县",
          "shortName": "安溪",
          "areaCode": "0595",
          "code": 350524,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1216,
        },
        {
          "areaName": "永春县",
          "shortName": "永春",
          "areaCode": "0595",
          "code": 350525,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1217,
        },
        {
          "areaName": "德化县",
          "shortName": "德化",
          "areaCode": "0595",
          "code": 350526,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1218,
        },
        {
          "areaName": "金门县",
          "shortName": "金门",
          "code": 350527,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1219,
        },
        {
          "areaName": "石狮市",
          "shortName": "石狮",
          "areaCode": "0595",
          "code": 350581,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1220,
        },
        {
          "areaName": "晋江市",
          "shortName": "晋江",
          "areaCode": "0595",
          "code": 350582,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1221,
        },
        {
          "areaName": "南安市",
          "shortName": "南安",
          "areaCode": "0595",
          "code": 350583,
          "parentCode": 350500,
          "level": 4,
          "children": null,
          "id": 1222,
        },
        {
          "areaName": "漳州市",
          "shortName": "漳州",
          "areaCode": "0596",
          "code": 350600,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1223,
        },
        {
          "areaName": "芗城区",
          "shortName": "芗城",
          "areaCode": "0596",
          "code": 350602,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1224,
        },
        {
          "areaName": "龙文区",
          "shortName": "龙文",
          "areaCode": "0596",
          "code": 350603,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1225,
        },
        {
          "areaName": "云霄县",
          "shortName": "云霄",
          "areaCode": "0596",
          "code": 350622,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1226,
        },
        {
          "areaName": "漳浦县",
          "shortName": "漳浦",
          "areaCode": "0596",
          "code": 350623,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1227,
        },
        {
          "areaName": "诏安县",
          "shortName": "诏安",
          "areaCode": "0596",
          "code": 350624,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1228,
        },
        {
          "areaName": "长泰县",
          "shortName": "长泰",
          "areaCode": "0596",
          "code": 350625,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1229,
        },
        {
          "areaName": "东山县",
          "shortName": "东山",
          "areaCode": "0596",
          "code": 350626,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1230,
        },
        {
          "areaName": "南靖县",
          "shortName": "南靖",
          "areaCode": "0596",
          "code": 350627,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1231,
        },
        {
          "areaName": "平和县",
          "shortName": "平和",
          "areaCode": "0596",
          "code": 350628,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1232,
        },
        {
          "areaName": "华安县",
          "shortName": "华安",
          "areaCode": "0596",
          "code": 350629,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1233,
        },
        {
          "areaName": "龙海市",
          "shortName": "龙海",
          "areaCode": "0596",
          "code": 350681,
          "parentCode": 350600,
          "level": 4,
          "children": null,
          "id": 1234,
        },
        {
          "areaName": "南平市",
          "shortName": "南平",
          "areaCode": "0599",
          "code": 350700,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1235,
        },
        {
          "areaName": "延平区",
          "shortName": "延平",
          "areaCode": "0600",
          "code": 350702,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1236,
        },
        {
          "areaName": "建阳区",
          "shortName": "建阳",
          "areaCode": "0599",
          "code": 350703,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1237,
        },
        {
          "areaName": "顺昌县",
          "shortName": "顺昌",
          "areaCode": "0605",
          "code": 350721,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1238,
        },
        {
          "areaName": "浦城县",
          "shortName": "浦城",
          "areaCode": "0606",
          "code": 350722,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1239,
        },
        {
          "areaName": "光泽县",
          "shortName": "光泽",
          "areaCode": "0607",
          "code": 350723,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1240,
        },
        {
          "areaName": "松溪县",
          "shortName": "松溪",
          "areaCode": "0608",
          "code": 350724,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1241,
        },
        {
          "areaName": "政和县",
          "shortName": "政和",
          "areaCode": "0609",
          "code": 350725,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1242,
        },
        {
          "areaName": "邵武市",
          "shortName": "邵武",
          "areaCode": "0601",
          "code": 350781,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1243,
        },
        {
          "areaName": "武夷山市",
          "shortName": "武夷山",
          "areaCode": "0602",
          "code": 350782,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1244,
        },
        {
          "areaName": "建瓯市",
          "shortName": "建瓯",
          "areaCode": "0603",
          "code": 350783,
          "parentCode": 350700,
          "level": 4,
          "children": null,
          "id": 1245,
        },
        {
          "areaName": "龙岩市",
          "shortName": "龙岩",
          "areaCode": "0597",
          "code": 350800,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1246,
        },
        {
          "areaName": "新罗区",
          "shortName": "新罗",
          "areaCode": "0597",
          "code": 350802,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1247,
        },
        {
          "areaName": "长汀县",
          "shortName": "长汀",
          "areaCode": "0597",
          "code": 350821,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1248,
        },
        {
          "areaName": "永定区",
          "shortName": "永定",
          "areaCode": "0597",
          "code": 350822,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1249,
        },
        {
          "areaName": "上杭县",
          "shortName": "上杭",
          "areaCode": "0597",
          "code": 350823,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1250,
        },
        {
          "areaName": "武平县",
          "shortName": "武平",
          "areaCode": "0597",
          "code": 350824,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1251,
        },
        {
          "areaName": "连城县",
          "shortName": "连城",
          "areaCode": "0597",
          "code": 350825,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1252,
        },
        {
          "areaName": "漳平市",
          "shortName": "漳平",
          "areaCode": "0597",
          "code": 350881,
          "parentCode": 350800,
          "level": 4,
          "children": null,
          "id": 1253,
        },
        {
          "areaName": "宁德市",
          "shortName": "宁德",
          "areaCode": "0593",
          "code": 350900,
          "parentCode": 350000,
          "level": 3,
          "children": null,
          "id": 1254,
        },
        {
          "areaName": "蕉城区",
          "shortName": "蕉城",
          "areaCode": "0593",
          "code": 350902,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1255,
        },
        {
          "areaName": "霞浦县",
          "shortName": "霞浦",
          "areaCode": "0593",
          "code": 350921,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1256,
        },
        {
          "areaName": "古田县",
          "shortName": "古田",
          "areaCode": "0593",
          "code": 350922,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1257,
        },
        {
          "areaName": "屏南县",
          "shortName": "屏南",
          "areaCode": "0593",
          "code": 350923,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1258,
        },
        {
          "areaName": "寿宁县",
          "shortName": "寿宁",
          "areaCode": "0593",
          "code": 350924,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1259,
        },
        {
          "areaName": "周宁县",
          "shortName": "周宁",
          "areaCode": "0593",
          "code": 350925,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1260,
        },
        {
          "areaName": "柘荣县",
          "shortName": "柘荣",
          "areaCode": "0593",
          "code": 350926,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1261,
        },
        {
          "areaName": "福安市",
          "shortName": "福安",
          "areaCode": "0593",
          "code": 350981,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1262,
        },
        {
          "areaName": "福鼎市",
          "shortName": "福鼎",
          "areaCode": "0593",
          "code": 350982,
          "parentCode": 350900,
          "level": 4,
          "children": null,
          "id": 1263,
        }
      ],
      "id": 1169,
    },
    {
      "areaName": "江西省",
      "shortName": "江西",
      "code": 360000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "南昌市",
          "shortName": "南昌",
          "areaCode": "0791",
          "code": 360100,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1265,
        },
        {
          "areaName": "东湖区",
          "shortName": "东湖",
          "areaCode": "0791",
          "code": 360102,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1266,
        },
        {
          "areaName": "西湖区",
          "shortName": "西湖",
          "areaCode": "0791",
          "code": 360103,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1267,
        },
        {
          "areaName": "青云谱区",
          "shortName": "青云谱",
          "areaCode": "0791",
          "code": 360104,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1268,
        },
        {
          "areaName": "湾里区",
          "shortName": "湾里",
          "areaCode": "0791",
          "code": 360105,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1269,
        },
        {
          "areaName": "青山湖区",
          "shortName": "青山湖",
          "areaCode": "0791",
          "code": 360111,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1270,
        },
        {
          "areaName": "南昌县",
          "shortName": "南昌",
          "areaCode": "0791",
          "code": 360121,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1271,
        },
        {
          "areaName": "新建县",
          "shortName": "新建",
          "areaCode": "0791",
          "code": 360122,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1272,
        },
        {
          "areaName": "安义县",
          "shortName": "安义",
          "areaCode": "0791",
          "code": 360123,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1273,
        },
        {
          "areaName": "进贤县",
          "shortName": "进贤",
          "areaCode": "0791",
          "code": 360124,
          "parentCode": 360100,
          "level": 4,
          "children": null,
          "id": 1274,
        },
        {
          "areaName": "景德镇市",
          "shortName": "景德镇",
          "areaCode": "0798",
          "code": 360200,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1275,
        },
        {
          "areaName": "昌江区",
          "shortName": "昌江",
          "areaCode": "0799",
          "code": 360202,
          "parentCode": 360200,
          "level": 4,
          "children": null,
          "id": 1276,
        },
        {
          "areaName": "珠山区",
          "shortName": "珠山",
          "areaCode": "0800",
          "code": 360203,
          "parentCode": 360200,
          "level": 4,
          "children": null,
          "id": 1277,
        },
        {
          "areaName": "浮梁县",
          "shortName": "浮梁",
          "areaCode": "0802",
          "code": 360222,
          "parentCode": 360200,
          "level": 4,
          "children": null,
          "id": 1278,
        },
        {
          "areaName": "乐平市",
          "shortName": "乐平",
          "areaCode": "0801",
          "code": 360281,
          "parentCode": 360200,
          "level": 4,
          "children": null,
          "id": 1279,
        },
        {
          "areaName": "萍乡市",
          "shortName": "萍乡",
          "areaCode": "0799",
          "code": 360300,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1280,
        },
        {
          "areaName": "安源区",
          "shortName": "安源",
          "areaCode": "0800",
          "code": 360302,
          "parentCode": 360300,
          "level": 4,
          "children": null,
          "id": 1281,
        },
        {
          "areaName": "湘东区",
          "shortName": "湘东",
          "areaCode": "0801",
          "code": 360313,
          "parentCode": 360300,
          "level": 4,
          "children": null,
          "id": 1282,
        },
        {
          "areaName": "莲花县",
          "shortName": "莲花",
          "areaCode": "0802",
          "code": 360321,
          "parentCode": 360300,
          "level": 4,
          "children": null,
          "id": 1283,
        },
        {
          "areaName": "上栗县",
          "shortName": "上栗",
          "areaCode": "0803",
          "code": 360322,
          "parentCode": 360300,
          "level": 4,
          "children": null,
          "id": 1284,
        },
        {
          "areaName": "芦溪县",
          "shortName": "芦溪",
          "areaCode": "0804",
          "code": 360323,
          "parentCode": 360300,
          "level": 4,
          "children": null,
          "id": 1285,
        },
        {
          "areaName": "九江市",
          "shortName": "九江",
          "areaCode": "0792",
          "code": 360400,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1286,
        },
        {
          "areaName": "庐山区",
          "shortName": "庐山",
          "areaCode": "0792",
          "code": 360402,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1287,
        },
        {
          "areaName": "浔阳区",
          "shortName": "浔阳",
          "areaCode": "0792",
          "code": 360403,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1288,
        },
        {
          "areaName": "九江县",
          "shortName": "九江",
          "areaCode": "0792",
          "code": 360421,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1289,
        },
        {
          "areaName": "武宁县",
          "shortName": "武宁",
          "areaCode": "0792",
          "code": 360423,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1290,
        },
        {
          "areaName": "修水县",
          "shortName": "修水",
          "areaCode": "0792",
          "code": 360424,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1291,
        },
        {
          "areaName": "永修县",
          "shortName": "永修",
          "areaCode": "0792",
          "code": 360425,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1292,
        },
        {
          "areaName": "德安县",
          "shortName": "德安",
          "areaCode": "0792",
          "code": 360426,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1293,
        },
        {
          "areaName": "星子县",
          "shortName": "星子",
          "areaCode": "0792",
          "code": 360427,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1294,
        },
        {
          "areaName": "都昌县",
          "shortName": "都昌",
          "areaCode": "0792",
          "code": 360428,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1295,
        },
        {
          "areaName": "湖口县",
          "shortName": "湖口",
          "areaCode": "0792",
          "code": 360429,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1296,
        },
        {
          "areaName": "彭泽县",
          "shortName": "彭泽",
          "areaCode": "0792",
          "code": 360430,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1297,
        },
        {
          "areaName": "瑞昌市",
          "shortName": "瑞昌",
          "areaCode": "0792",
          "code": 360481,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1298,
        },
        {
          "areaName": "共青城市",
          "shortName": "共青城",
          "areaCode": "0792",
          "code": 360482,
          "parentCode": 360400,
          "level": 4,
          "children": null,
          "id": 1299,
        },
        {
          "areaName": "新余市",
          "shortName": "新余",
          "areaCode": "0790",
          "code": 360500,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1300,
        },
        {
          "areaName": "渝水区",
          "shortName": "渝水",
          "areaCode": "0790",
          "code": 360502,
          "parentCode": 360500,
          "level": 4,
          "children": null,
          "id": 1301,
        },
        {
          "areaName": "分宜县",
          "shortName": "分宜",
          "areaCode": "0790",
          "code": 360521,
          "parentCode": 360500,
          "level": 4,
          "children": null,
          "id": 1302,
        },
        {
          "areaName": "鹰潭市",
          "shortName": "鹰潭",
          "areaCode": "0701",
          "code": 360600,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1303,
        },
        {
          "areaName": "月湖区",
          "shortName": "月湖",
          "areaCode": "0701",
          "code": 360602,
          "parentCode": 360600,
          "level": 4,
          "children": null,
          "id": 1304,
        },
        {
          "areaName": "余江县",
          "shortName": "余江",
          "areaCode": "0701",
          "code": 360622,
          "parentCode": 360600,
          "level": 4,
          "children": null,
          "id": 1305,
        },
        {
          "areaName": "贵溪市",
          "shortName": "贵溪",
          "areaCode": "0701",
          "code": 360681,
          "parentCode": 360600,
          "level": 4,
          "children": null,
          "id": 1306,
        },
        {
          "areaName": "赣州市",
          "shortName": "赣州",
          "areaCode": "0797",
          "code": 360700,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1307,
        },
        {
          "areaName": "章贡区",
          "shortName": "章贡",
          "areaCode": "0797",
          "code": 360702,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1308,
        },
        {
          "areaName": "南康区",
          "shortName": "南康",
          "areaCode": "0797",
          "code": 360703,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1309,
        },
        {
          "areaName": "赣县",
          "shortName": "赣县",
          "areaCode": "0797",
          "code": 360721,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1310,
        },
        {
          "areaName": "信丰县",
          "shortName": "信丰",
          "areaCode": "0797",
          "code": 360722,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1311,
        },
        {
          "areaName": "大余县",
          "shortName": "大余",
          "areaCode": "0797",
          "code": 360723,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1312,
        },
        {
          "areaName": "上犹县",
          "shortName": "上犹",
          "areaCode": "0797",
          "code": 360724,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1313,
        },
        {
          "areaName": "崇义县",
          "shortName": "崇义",
          "areaCode": "0797",
          "code": 360725,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1314,
        },
        {
          "areaName": "安远县",
          "shortName": "安远",
          "areaCode": "0797",
          "code": 360726,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1315,
        },
        {
          "areaName": "龙南县",
          "shortName": "龙南",
          "areaCode": "0797",
          "code": 360727,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1316,
        },
        {
          "areaName": "定南县",
          "shortName": "定南",
          "areaCode": "0797",
          "code": 360728,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1317,
        },
        {
          "areaName": "全南县",
          "shortName": "全南",
          "areaCode": "0797",
          "code": 360729,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1318,
        },
        {
          "areaName": "宁都县",
          "shortName": "宁都",
          "areaCode": "0797",
          "code": 360730,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1319,
        },
        {
          "areaName": "于都县",
          "shortName": "于都",
          "areaCode": "0797",
          "code": 360731,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1320,
        },
        {
          "areaName": "兴国县",
          "shortName": "兴国",
          "areaCode": "0797",
          "code": 360732,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1321,
        },
        {
          "areaName": "会昌县",
          "shortName": "会昌",
          "areaCode": "0797",
          "code": 360733,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1322,
        },
        {
          "areaName": "寻乌县",
          "shortName": "寻乌",
          "areaCode": "0797",
          "code": 360734,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1323,
        },
        {
          "areaName": "石城县",
          "shortName": "石城",
          "areaCode": "0797",
          "code": 360735,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1324,
        },
        {
          "areaName": "瑞金市",
          "shortName": "瑞金",
          "areaCode": "0797",
          "code": 360781,
          "parentCode": 360700,
          "level": 4,
          "children": null,
          "id": 1325,
        },
        {
          "areaName": "吉安市",
          "shortName": "吉安",
          "areaCode": "0796",
          "code": 360800,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1326,
        },
        {
          "areaName": "吉州区",
          "shortName": "吉州",
          "areaCode": "0796",
          "code": 360802,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1327,
        },
        {
          "areaName": "青原区",
          "shortName": "青原",
          "areaCode": "0796",
          "code": 360803,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1328,
        },
        {
          "areaName": "吉安县",
          "shortName": "吉安",
          "areaCode": "0796",
          "code": 360821,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1329,
        },
        {
          "areaName": "吉水县",
          "shortName": "吉水",
          "areaCode": "0796",
          "code": 360822,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1330,
        },
        {
          "areaName": "峡江县",
          "shortName": "峡江",
          "areaCode": "0796",
          "code": 360823,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1331,
        },
        {
          "areaName": "新干县",
          "shortName": "新干",
          "areaCode": "0796",
          "code": 360824,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1332,
        },
        {
          "areaName": "永丰县",
          "shortName": "永丰",
          "areaCode": "0796",
          "code": 360825,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1333,
        },
        {
          "areaName": "泰和县",
          "shortName": "泰和",
          "areaCode": "0796",
          "code": 360826,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1334,
        },
        {
          "areaName": "遂川县",
          "shortName": "遂川",
          "areaCode": "0796",
          "code": 360827,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1335,
        },
        {
          "areaName": "万安县",
          "shortName": "万安",
          "areaCode": "0796",
          "code": 360828,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1336,
        },
        {
          "areaName": "安福县",
          "shortName": "安福",
          "areaCode": "0796",
          "code": 360829,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1337,
        },
        {
          "areaName": "永新县",
          "shortName": "永新",
          "areaCode": "0796",
          "code": 360830,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1338,
        },
        {
          "areaName": "井冈山市",
          "shortName": "井冈山",
          "areaCode": "0796",
          "code": 360881,
          "parentCode": 360800,
          "level": 4,
          "children": null,
          "id": 1339,
        },
        {
          "areaName": "宜春市",
          "shortName": "宜春",
          "areaCode": "0795",
          "code": 360900,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1340,
        },
        {
          "areaName": "袁州区",
          "shortName": "袁州",
          "areaCode": "0795",
          "code": 360902,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1341,
        },
        {
          "areaName": "奉新县",
          "shortName": "奉新",
          "areaCode": "0795",
          "code": 360921,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1342,
        },
        {
          "areaName": "万载县",
          "shortName": "万载",
          "areaCode": "0795",
          "code": 360922,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1343,
        },
        {
          "areaName": "上高县",
          "shortName": "上高",
          "areaCode": "0795",
          "code": 360923,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1344,
        },
        {
          "areaName": "宜丰县",
          "shortName": "宜丰",
          "areaCode": "0795",
          "code": 360924,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1345,
        },
        {
          "areaName": "靖安县",
          "shortName": "靖安",
          "areaCode": "0795",
          "code": 360925,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1346,
        },
        {
          "areaName": "铜鼓县",
          "shortName": "铜鼓",
          "areaCode": "0795",
          "code": 360926,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1347,
        },
        {
          "areaName": "丰城市",
          "shortName": "丰城",
          "areaCode": "0795",
          "code": 360981,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1348,
        },
        {
          "areaName": "樟树市",
          "shortName": "樟树",
          "areaCode": "0795",
          "code": 360982,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1349,
        },
        {
          "areaName": "高安市",
          "shortName": "高安",
          "areaCode": "0795",
          "code": 360983,
          "parentCode": 360900,
          "level": 4,
          "children": null,
          "id": 1350,
        },
        {
          "areaName": "抚州市",
          "shortName": "抚州",
          "areaCode": "0794",
          "code": 361000,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1351,
        },
        {
          "areaName": "临川区",
          "shortName": "临川",
          "areaCode": "0794",
          "code": 361002,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1352,
        },
        {
          "areaName": "南城县",
          "shortName": "南城",
          "areaCode": "0794",
          "code": 361021,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1353,
        },
        {
          "areaName": "黎川县",
          "shortName": "黎川",
          "areaCode": "0794",
          "code": 361022,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1354,
        },
        {
          "areaName": "南丰县",
          "shortName": "南丰",
          "areaCode": "0794",
          "code": 361023,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1355,
        },
        {
          "areaName": "崇仁县",
          "shortName": "崇仁",
          "areaCode": "0794",
          "code": 361024,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1356,
        },
        {
          "areaName": "乐安县",
          "shortName": "乐安",
          "areaCode": "0794",
          "code": 361025,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1357,
        },
        {
          "areaName": "宜黄县",
          "shortName": "宜黄",
          "areaCode": "0794",
          "code": 361026,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1358,
        },
        {
          "areaName": "金溪县",
          "shortName": "金溪",
          "areaCode": "0794",
          "code": 361027,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1359,
        },
        {
          "areaName": "资溪县",
          "shortName": "资溪",
          "areaCode": "0794",
          "code": 361028,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1360,
        },
        {
          "areaName": "东乡县",
          "shortName": "东乡",
          "areaCode": "0794",
          "code": 361029,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1361,
        },
        {
          "areaName": "广昌县",
          "shortName": "广昌",
          "areaCode": "0794",
          "code": 361030,
          "parentCode": 361000,
          "level": 4,
          "children": null,
          "id": 1362,
        },
        {
          "areaName": "上饶市",
          "shortName": "上饶",
          "areaCode": "0793",
          "code": 361100,
          "parentCode": 360000,
          "level": 3,
          "children": null,
          "id": 1363,
        },
        {
          "areaName": "信州区",
          "shortName": "信州",
          "areaCode": "0793",
          "code": 361102,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1364,
        },
        {
          "areaName": "上饶县",
          "shortName": "上饶",
          "areaCode": "0793",
          "code": 361121,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1365,
        },
        {
          "areaName": "广丰县",
          "shortName": "广丰",
          "areaCode": "0793",
          "code": 361122,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1366,
        },
        {
          "areaName": "玉山县",
          "shortName": "玉山",
          "areaCode": "0793",
          "code": 361123,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1367,
        },
        {
          "areaName": "铅山县",
          "shortName": "铅山",
          "areaCode": "0793",
          "code": 361124,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1368,
        },
        {
          "areaName": "横峰县",
          "shortName": "横峰",
          "areaCode": "0793",
          "code": 361125,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1369,
        },
        {
          "areaName": "弋阳县",
          "shortName": "弋阳",
          "areaCode": "0793",
          "code": 361126,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1370,
        },
        {
          "areaName": "余干县",
          "shortName": "余干",
          "areaCode": "0793",
          "code": 361127,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1371,
        },
        {
          "areaName": "鄱阳县",
          "shortName": "鄱阳",
          "areaCode": "0793",
          "code": 361128,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1372,
        },
        {
          "areaName": "万年县",
          "shortName": "万年",
          "areaCode": "0793",
          "code": 361129,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1373,
        },
        {
          "areaName": "婺源县",
          "shortName": "婺源",
          "areaCode": "0793",
          "code": 361130,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1374,
        },
        {
          "areaName": "德兴市",
          "shortName": "德兴",
          "areaCode": "0793",
          "code": 361181,
          "parentCode": 361100,
          "level": 4,
          "children": null,
          "id": 1375,
        }
      ],
      "id": 1264,
    },
    {
      "areaName": "山东省",
      "shortName": "山东",
      "code": 370000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "济南市",
          "shortName": "济南",
          "areaCode": "0531",
          "code": 370100,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1377,
        },
        {
          "areaName": "历下区",
          "shortName": "历下",
          "areaCode": "0531",
          "code": 370102,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1378,
        },
        {
          "areaName": "市中区",
          "shortName": "市中区",
          "areaCode": "0531",
          "code": 370103,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1379,
        },
        {
          "areaName": "槐荫区",
          "shortName": "槐荫",
          "areaCode": "0531",
          "code": 370104,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1380,
        },
        {
          "areaName": "天桥区",
          "shortName": "天桥",
          "areaCode": "0531",
          "code": 370105,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1381,
        },
        {
          "areaName": "历城区",
          "shortName": "历城",
          "areaCode": "0531",
          "code": 370112,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1382,
        },
        {
          "areaName": "长清区",
          "shortName": "长清",
          "areaCode": "0531",
          "code": 370113,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1383,
        },
        {
          "areaName": "平阴县",
          "shortName": "平阴",
          "areaCode": "0531",
          "code": 370124,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1384,
        },
        {
          "areaName": "济阳县",
          "shortName": "济阳",
          "areaCode": "0531",
          "code": 370125,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1385,
        },
        {
          "areaName": "商河县",
          "shortName": "商河",
          "areaCode": "0531",
          "code": 370126,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1386,
        },
        {
          "areaName": "章丘市",
          "shortName": "章丘",
          "areaCode": "0531",
          "code": 370181,
          "parentCode": 370100,
          "level": 4,
          "children": null,
          "id": 1387,
        },
        {
          "areaName": "青岛市",
          "shortName": "青岛",
          "areaCode": "0532",
          "code": 370200,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1388,
        },
        {
          "areaName": "市南区",
          "shortName": "市南",
          "areaCode": "0532",
          "code": 370202,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1389,
        },
        {
          "areaName": "市北区",
          "shortName": "市北",
          "areaCode": "0532",
          "code": 370203,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1390,
        },
        {
          "areaName": "黄岛区",
          "shortName": "黄岛",
          "areaCode": "0532",
          "code": 370211,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1391,
        },
        {
          "areaName": "崂山区",
          "shortName": "崂山",
          "areaCode": "0532",
          "code": 370212,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1392,
        },
        {
          "areaName": "李沧区",
          "shortName": "李沧",
          "areaCode": "0532",
          "code": 370213,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1393,
        },
        {
          "areaName": "城阳区",
          "shortName": "城阳",
          "areaCode": "0532",
          "code": 370214,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1394,
        },
        {
          "areaName": "胶州市",
          "shortName": "胶州",
          "areaCode": "0532",
          "code": 370281,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1395,
        },
        {
          "areaName": "即墨市",
          "shortName": "即墨",
          "areaCode": "0532",
          "code": 370282,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1396,
        },
        {
          "areaName": "平度市",
          "shortName": "平度",
          "areaCode": "0532",
          "code": 370283,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1397,
        },
        {
          "areaName": "莱西市",
          "shortName": "莱西",
          "areaCode": "0532",
          "code": 370285,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1398,
        },
        {
          "areaName": "西海岸新区",
          "shortName": "西海岸",
          "areaCode": "0532",
          "code": 370286,
          "parentCode": 370200,
          "level": 4,
          "children": null,
          "id": 1399,
        },
        {
          "areaName": "淄博市",
          "shortName": "淄博",
          "areaCode": "0533",
          "code": 370300,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1400,
        },
        {
          "areaName": "淄川区",
          "shortName": "淄川",
          "areaCode": "0533",
          "code": 370302,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1401,
        },
        {
          "areaName": "张店区",
          "shortName": "张店",
          "areaCode": "0533",
          "code": 370303,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1402,
        },
        {
          "areaName": "博山区",
          "shortName": "博山",
          "areaCode": "0533",
          "code": 370304,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1403,
        },
        {
          "areaName": "临淄区",
          "shortName": "临淄",
          "areaCode": "0533",
          "code": 370305,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1404,
        },
        {
          "areaName": "周村区",
          "shortName": "周村",
          "areaCode": "0533",
          "code": 370306,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1405,
        },
        {
          "areaName": "桓台县",
          "shortName": "桓台",
          "areaCode": "0533",
          "code": 370321,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1406,
        },
        {
          "areaName": "高青县",
          "shortName": "高青",
          "areaCode": "0533",
          "code": 370322,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1407,
        },
        {
          "areaName": "沂源县",
          "shortName": "沂源",
          "areaCode": "0533",
          "code": 370323,
          "parentCode": 370300,
          "level": 4,
          "children": null,
          "id": 1408,
        },
        {
          "areaName": "枣庄市",
          "shortName": "枣庄",
          "areaCode": "0632",
          "code": 370400,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1409,
        },
        {
          "areaName": "市中区",
          "shortName": "市中区",
          "areaCode": "0632",
          "code": 370402,
          "parentCode": 370400,
          "level": 4,
          "children": null,
          "id": 1410,
        },
        {
          "areaName": "薛城区",
          "shortName": "薛城",
          "areaCode": "0632",
          "code": 370403,
          "parentCode": 370400,
          "level": 4,
          "children": null,
          "id": 1411,
        },
        {
          "areaName": "峄城区",
          "shortName": "峄城",
          "areaCode": "0632",
          "code": 370404,
          "parentCode": 370400,
          "level": 4,
          "children": null,
          "id": 1412,
        },
        {
          "areaName": "台儿庄区",
          "shortName": "台儿庄",
          "areaCode": "0632",
          "code": 370405,
          "parentCode": 370400,
          "level": 4,
          "children": null,
          "id": 1413,
        },
        {
          "areaName": "山亭区",
          "shortName": "山亭",
          "areaCode": "0632",
          "code": 370406,
          "parentCode": 370400,
          "level": 4,
          "children": null,
          "id": 1414,
        },
        {
          "areaName": "滕州市",
          "shortName": "滕州",
          "areaCode": "0632",
          "code": 370481,
          "parentCode": 370400,
          "level": 4,
          "children": null,
          "id": 1415,
        },
        {
          "areaName": "东营市",
          "shortName": "东营",
          "areaCode": "0546",
          "code": 370500,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1416,
        },
        {
          "areaName": "东营区",
          "shortName": "东营",
          "areaCode": "0546",
          "code": 370502,
          "parentCode": 370500,
          "level": 4,
          "children": null,
          "id": 1417,
        },
        {
          "areaName": "河口区",
          "shortName": "河口",
          "areaCode": "0546",
          "code": 370503,
          "parentCode": 370500,
          "level": 4,
          "children": null,
          "id": 1418,
        },
        {
          "areaName": "垦利县",
          "shortName": "垦利",
          "areaCode": "0546",
          "code": 370521,
          "parentCode": 370500,
          "level": 4,
          "children": null,
          "id": 1419,
        },
        {
          "areaName": "利津县",
          "shortName": "利津",
          "areaCode": "0546",
          "code": 370522,
          "parentCode": 370500,
          "level": 4,
          "children": null,
          "id": 1420,
        },
        {
          "areaName": "广饶县",
          "shortName": "广饶",
          "areaCode": "0546",
          "code": 370523,
          "parentCode": 370500,
          "level": 4,
          "children": null,
          "id": 1421,
        },
        {
          "areaName": "烟台市",
          "shortName": "烟台",
          "areaCode": "0635",
          "code": 370600,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1422,
        },
        {
          "areaName": "芝罘区",
          "shortName": "芝罘",
          "areaCode": "0635",
          "code": 370602,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1423,
        },
        {
          "areaName": "福山区",
          "shortName": "福山",
          "areaCode": "0635",
          "code": 370611,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1424,
        },
        {
          "areaName": "牟平区",
          "shortName": "牟平",
          "areaCode": "0635",
          "code": 370612,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1425,
        },
        {
          "areaName": "莱山区",
          "shortName": "莱山",
          "areaCode": "0635",
          "code": 370613,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1426,
        },
        {
          "areaName": "长岛县",
          "shortName": "长岛",
          "areaCode": "0635",
          "code": 370634,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1427,
        },
        {
          "areaName": "龙口市",
          "shortName": "龙口",
          "areaCode": "0635",
          "code": 370681,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1428,
        },
        {
          "areaName": "莱阳市",
          "shortName": "莱阳",
          "areaCode": "0635",
          "code": 370682,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1429,
        },
        {
          "areaName": "莱州市",
          "shortName": "莱州",
          "areaCode": "0635",
          "code": 370683,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1430,
        },
        {
          "areaName": "蓬莱市",
          "shortName": "蓬莱",
          "areaCode": "0635",
          "code": 370684,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1431,
        },
        {
          "areaName": "招远市",
          "shortName": "招远",
          "areaCode": "0635",
          "code": 370685,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1432,
        },
        {
          "areaName": "栖霞市",
          "shortName": "栖霞",
          "areaCode": "0635",
          "code": 370686,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1433,
        },
        {
          "areaName": "海阳市",
          "shortName": "海阳",
          "areaCode": "0635",
          "code": 370687,
          "parentCode": 370600,
          "level": 4,
          "children": null,
          "id": 1434,
        },
        {
          "areaName": "潍坊市",
          "shortName": "潍坊",
          "areaCode": "0536",
          "code": 370700,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1435,
        },
        {
          "areaName": "潍城区",
          "shortName": "潍城",
          "areaCode": "0536",
          "code": 370702,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1436,
        },
        {
          "areaName": "寒亭区",
          "shortName": "寒亭",
          "areaCode": "0536",
          "code": 370703,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1437,
        },
        {
          "areaName": "坊子区",
          "shortName": "坊子",
          "areaCode": "0536",
          "code": 370704,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1438,
        },
        {
          "areaName": "奎文区",
          "shortName": "奎文",
          "areaCode": "0536",
          "code": 370705,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1439,
        },
        {
          "areaName": "临朐县",
          "shortName": "临朐",
          "areaCode": "0536",
          "code": 370724,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1440,
        },
        {
          "areaName": "昌乐县",
          "shortName": "昌乐",
          "areaCode": "0536",
          "code": 370725,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1441,
        },
        {
          "areaName": "青州市",
          "shortName": "青州",
          "areaCode": "0536",
          "code": 370781,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1442,
        },
        {
          "areaName": "诸城市",
          "shortName": "诸城",
          "areaCode": "0536",
          "code": 370782,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1443,
        },
        {
          "areaName": "寿光市",
          "shortName": "寿光",
          "areaCode": "0536",
          "code": 370783,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1444,
        },
        {
          "areaName": "安丘市",
          "shortName": "安丘",
          "areaCode": "0536",
          "code": 370784,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1445,
        },
        {
          "areaName": "高密市",
          "shortName": "高密",
          "areaCode": "0536",
          "code": 370785,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1446,
        },
        {
          "areaName": "昌邑市",
          "shortName": "昌邑",
          "areaCode": "0536",
          "code": 370786,
          "parentCode": 370700,
          "level": 4,
          "children": null,
          "id": 1447,
        },
        {
          "areaName": "济宁市",
          "shortName": "济宁",
          "areaCode": "0537",
          "code": 370800,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1448,
        },
        {
          "areaName": "任城区",
          "shortName": "任城",
          "areaCode": "0537",
          "code": 370811,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1449,
        },
        {
          "areaName": "兖州区",
          "shortName": "兖州",
          "areaCode": "0537",
          "code": 370812,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1450,
        },
        {
          "areaName": "微山县",
          "shortName": "微山",
          "areaCode": "0537",
          "code": 370826,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1451,
        },
        {
          "areaName": "鱼台县",
          "shortName": "鱼台",
          "areaCode": "0537",
          "code": 370827,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1452,
        },
        {
          "areaName": "金乡县",
          "shortName": "金乡",
          "areaCode": "0537",
          "code": 370828,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1453,
        },
        {
          "areaName": "嘉祥县",
          "shortName": "嘉祥",
          "areaCode": "0537",
          "code": 370829,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1454,
        },
        {
          "areaName": "汶上县",
          "shortName": "汶上",
          "areaCode": "0537",
          "code": 370830,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1455,
        },
        {
          "areaName": "泗水县",
          "shortName": "泗水",
          "areaCode": "0537",
          "code": 370831,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1456,
        },
        {
          "areaName": "梁山县",
          "shortName": "梁山",
          "areaCode": "0537",
          "code": 370832,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1457,
        },
        {
          "areaName": "曲阜市",
          "shortName": "曲阜",
          "areaCode": "0537",
          "code": 370881,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1458,
        },
        {
          "areaName": "邹城市",
          "shortName": "邹城",
          "areaCode": "0537",
          "code": 370883,
          "parentCode": 370800,
          "level": 4,
          "children": null,
          "id": 1459,
        },
        {
          "areaName": "泰安市",
          "shortName": "泰安",
          "areaCode": "0538",
          "code": 370900,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1460,
        },
        {
          "areaName": "泰山区",
          "shortName": "泰山",
          "areaCode": "0538",
          "code": 370902,
          "parentCode": 370900,
          "level": 4,
          "children": null,
          "id": 1461,
        },
        {
          "areaName": "岱岳区",
          "shortName": "岱岳",
          "areaCode": "0538",
          "code": 370911,
          "parentCode": 370900,
          "level": 4,
          "children": null,
          "id": 1462,
        },
        {
          "areaName": "宁阳县",
          "shortName": "宁阳",
          "areaCode": "0538",
          "code": 370921,
          "parentCode": 370900,
          "level": 4,
          "children": null,
          "id": 1463,
        },
        {
          "areaName": "东平县",
          "shortName": "东平",
          "areaCode": "0538",
          "code": 370923,
          "parentCode": 370900,
          "level": 4,
          "children": null,
          "id": 1464,
        },
        {
          "areaName": "新泰市",
          "shortName": "新泰",
          "areaCode": "0538",
          "code": 370982,
          "parentCode": 370900,
          "level": 4,
          "children": null,
          "id": 1465,
        },
        {
          "areaName": "肥城市",
          "shortName": "肥城",
          "areaCode": "0538",
          "code": 370983,
          "parentCode": 370900,
          "level": 4,
          "children": null,
          "id": 1466,
        },
        {
          "areaName": "威海市",
          "shortName": "威海",
          "areaCode": "0631",
          "code": 371000,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1467,
        },
        {
          "areaName": "环翠区",
          "shortName": "环翠",
          "areaCode": "0631",
          "code": 371002,
          "parentCode": 371000,
          "level": 4,
          "children": null,
          "id": 1468,
        },
        {
          "areaName": "文登区",
          "shortName": "文登",
          "areaCode": "0631",
          "code": 371003,
          "parentCode": 371000,
          "level": 4,
          "children": null,
          "id": 1469,
        },
        {
          "areaName": "荣成市",
          "shortName": "荣成",
          "areaCode": "0631",
          "code": 371082,
          "parentCode": 371000,
          "level": 4,
          "children": null,
          "id": 1470,
        },
        {
          "areaName": "乳山市",
          "shortName": "乳山",
          "areaCode": "0631",
          "code": 371083,
          "parentCode": 371000,
          "level": 4,
          "children": null,
          "id": 1471,
        },
        {
          "areaName": "日照市",
          "shortName": "日照",
          "areaCode": "0633",
          "code": 371100,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1472,
        },
        {
          "areaName": "东港区",
          "shortName": "东港",
          "areaCode": "0633",
          "code": 371102,
          "parentCode": 371100,
          "level": 4,
          "children": null,
          "id": 1473,
        },
        {
          "areaName": "岚山区",
          "shortName": "岚山",
          "areaCode": "0633",
          "code": 371103,
          "parentCode": 371100,
          "level": 4,
          "children": null,
          "id": 1474,
        },
        {
          "areaName": "五莲县",
          "shortName": "五莲",
          "areaCode": "0633",
          "code": 371121,
          "parentCode": 371100,
          "level": 4,
          "children": null,
          "id": 1475,
        },
        {
          "areaName": "莒县",
          "shortName": "莒县",
          "areaCode": "0633",
          "code": 371122,
          "parentCode": 371100,
          "level": 4,
          "children": null,
          "id": 1476,
        },
        {
          "areaName": "莱芜市",
          "shortName": "莱芜",
          "areaCode": "0634",
          "code": 371200,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1477,
        },
        {
          "areaName": "莱城区",
          "shortName": "莱城",
          "areaCode": "0634",
          "code": 371202,
          "parentCode": 371200,
          "level": 4,
          "children": null,
          "id": 1478,
        },
        {
          "areaName": "钢城区",
          "shortName": "钢城",
          "areaCode": "0634",
          "code": 371203,
          "parentCode": 371200,
          "level": 4,
          "children": null,
          "id": 1479,
        },
        {
          "areaName": "临沂市",
          "shortName": "临沂",
          "areaCode": "0539",
          "code": 371300,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1480,
        },
        {
          "areaName": "兰山区",
          "shortName": "兰山",
          "areaCode": "0539",
          "code": 371302,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1481,
        },
        {
          "areaName": "罗庄区",
          "shortName": "罗庄",
          "areaCode": "0539",
          "code": 371311,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1482,
        },
        {
          "areaName": "河东区",
          "shortName": "河东",
          "areaCode": "0539",
          "code": 371312,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1483,
        },
        {
          "areaName": "沂南县",
          "shortName": "沂南",
          "areaCode": "0539",
          "code": 371321,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1484,
        },
        {
          "areaName": "郯城县",
          "shortName": "郯城",
          "areaCode": "0539",
          "code": 371322,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1485,
        },
        {
          "areaName": "沂水县",
          "shortName": "沂水",
          "areaCode": "0539",
          "code": 371323,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1486,
        },
        {
          "areaName": "兰陵县",
          "shortName": "兰陵",
          "areaCode": "0539",
          "code": 371324,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1487,
        },
        {
          "areaName": "费县",
          "shortName": "费县",
          "areaCode": "0539",
          "code": 371325,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1488,
        },
        {
          "areaName": "平邑县",
          "shortName": "平邑",
          "areaCode": "0539",
          "code": 371326,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1489,
        },
        {
          "areaName": "莒南县",
          "shortName": "莒南",
          "areaCode": "0539",
          "code": 371327,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1490,
        },
        {
          "areaName": "蒙阴县",
          "shortName": "蒙阴",
          "areaCode": "0539",
          "code": 371328,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1491,
        },
        {
          "areaName": "临沭县",
          "shortName": "临沭",
          "areaCode": "0539",
          "code": 371329,
          "parentCode": 371300,
          "level": 4,
          "children": null,
          "id": 1492,
        },
        {
          "areaName": "德州市",
          "shortName": "德州",
          "areaCode": "0534",
          "code": 371400,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1493,
        },
        {
          "areaName": "德城区",
          "shortName": "德城",
          "areaCode": "0534",
          "code": 371402,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1494,
        },
        {
          "areaName": "陵城区",
          "shortName": "陵城",
          "areaCode": "0534",
          "code": 371403,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1495,
        },
        {
          "areaName": "宁津县",
          "shortName": "宁津",
          "areaCode": "0534",
          "code": 371422,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1496,
        },
        {
          "areaName": "庆云县",
          "shortName": "庆云",
          "areaCode": "0534",
          "code": 371423,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1497,
        },
        {
          "areaName": "临邑县",
          "shortName": "临邑",
          "areaCode": "0534",
          "code": 371424,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1498,
        },
        {
          "areaName": "齐河县",
          "shortName": "齐河",
          "areaCode": "0534",
          "code": 371425,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1499,
        },
        {
          "areaName": "平原县",
          "shortName": "平原",
          "areaCode": "0534",
          "code": 371426,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1500,
        },
        {
          "areaName": "夏津县",
          "shortName": "夏津",
          "areaCode": "0534",
          "code": 371427,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1501,
        },
        {
          "areaName": "武城县",
          "shortName": "武城",
          "areaCode": "0534",
          "code": 371428,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1502,
        },
        {
          "areaName": "乐陵市",
          "shortName": "乐陵",
          "areaCode": "0534",
          "code": 371481,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1503,
        },
        {
          "areaName": "禹城市",
          "shortName": "禹城",
          "areaCode": "0534",
          "code": 371482,
          "parentCode": 371400,
          "level": 4,
          "children": null,
          "id": 1504,
        },
        {
          "areaName": "聊城市",
          "shortName": "聊城",
          "areaCode": "0635",
          "code": 371500,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1505,
        },
        {
          "areaName": "东昌府区",
          "shortName": "东昌府",
          "areaCode": "0635",
          "code": 371502,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1506,
        },
        {
          "areaName": "阳谷县",
          "shortName": "阳谷",
          "areaCode": "0635",
          "code": 371521,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1507,
        },
        {
          "areaName": "莘县",
          "shortName": "莘县",
          "areaCode": "0635",
          "code": 371522,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1508,
        },
        {
          "areaName": "茌平县",
          "shortName": "茌平",
          "areaCode": "0635",
          "code": 371523,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1509,
        },
        {
          "areaName": "东阿县",
          "shortName": "东阿",
          "areaCode": "0635",
          "code": 371524,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1510,
        },
        {
          "areaName": "冠县",
          "shortName": "冠县",
          "areaCode": "0635",
          "code": 371525,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1511,
        },
        {
          "areaName": "高唐县",
          "shortName": "高唐",
          "areaCode": "0635",
          "code": 371526,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1512,
        },
        {
          "areaName": "临清市",
          "shortName": "临清",
          "areaCode": "0635",
          "code": 371581,
          "parentCode": 371500,
          "level": 4,
          "children": null,
          "id": 1513,
        },
        {
          "areaName": "滨州市",
          "shortName": "滨州",
          "areaCode": "0543",
          "code": 371600,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1514,
        },
        {
          "areaName": "滨城区",
          "shortName": "滨城",
          "areaCode": "0543",
          "code": 371602,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1515,
        },
        {
          "areaName": "沾化区",
          "shortName": "沾化",
          "areaCode": "0543",
          "code": 371603,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1516,
        },
        {
          "areaName": "惠民县",
          "shortName": "惠民",
          "areaCode": "0543",
          "code": 371621,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1517,
        },
        {
          "areaName": "阳信县",
          "shortName": "阳信",
          "areaCode": "0543",
          "code": 371622,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1518,
        },
        {
          "areaName": "无棣县",
          "shortName": "无棣",
          "areaCode": "0543",
          "code": 371623,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1519,
        },
        {
          "areaName": "博兴县",
          "shortName": "博兴",
          "areaCode": "0543",
          "code": 371625,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1520,
        },
        {
          "areaName": "邹平县",
          "shortName": "邹平",
          "areaCode": "0543",
          "code": 371626,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1521,
        },
        {
          "areaName": "北海新区",
          "shortName": "北海新区",
          "areaCode": "0543",
          "code": 371627,
          "parentCode": 371600,
          "level": 4,
          "children": null,
          "id": 1522,
        },
        {
          "areaName": "菏泽市",
          "shortName": "菏泽",
          "areaCode": "0530",
          "code": 371700,
          "parentCode": 370000,
          "level": 3,
          "children": null,
          "id": 1523,
        },
        {
          "areaName": "牡丹区",
          "shortName": "牡丹",
          "areaCode": "0530",
          "code": 371702,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1524,
        },
        {
          "areaName": "曹县",
          "shortName": "曹县",
          "areaCode": "0530",
          "code": 371721,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1525,
        },
        {
          "areaName": "单县",
          "shortName": "单县",
          "areaCode": "0530",
          "code": 371722,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1526,
        },
        {
          "areaName": "成武县",
          "shortName": "成武",
          "areaCode": "0530",
          "code": 371723,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1527,
        },
        {
          "areaName": "巨野县",
          "shortName": "巨野",
          "areaCode": "0530",
          "code": 371724,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1528,
        },
        {
          "areaName": "郓城县",
          "shortName": "郓城",
          "areaCode": "0530",
          "code": 371725,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1529,
        },
        {
          "areaName": "鄄城县",
          "shortName": "鄄城",
          "areaCode": "0530",
          "code": 371726,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1530,
        },
        {
          "areaName": "定陶县",
          "shortName": "定陶",
          "areaCode": "0530",
          "code": 371727,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1531,
        },
        {
          "areaName": "东明县",
          "shortName": "东明",
          "areaCode": "0530",
          "code": 371728,
          "parentCode": 371700,
          "level": 4,
          "children": null,
          "id": 1532,
        }
      ],
      "id": 1376,
    },
    {
      "areaName": "河南省",
      "shortName": "河南",
      "code": 410000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "郑州市",
          "shortName": "郑州",
          "areaCode": "0371",
          "code": 410100,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1534,
        },
        {
          "areaName": "中原区",
          "shortName": "中原",
          "areaCode": "0371",
          "code": 410102,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1535,
        },
        {
          "areaName": "二七区",
          "shortName": "二七",
          "areaCode": "0371",
          "code": 410103,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1536,
        },
        {
          "areaName": "管城回族区",
          "shortName": "管城",
          "areaCode": "0371",
          "code": 410104,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1537,
        },
        {
          "areaName": "金水区",
          "shortName": "金水",
          "areaCode": "0371",
          "code": 410105,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1538,
        },
        {
          "areaName": "上街区",
          "shortName": "上街",
          "areaCode": "0371",
          "code": 410106,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1539,
        },
        {
          "areaName": "惠济区",
          "shortName": "惠济",
          "areaCode": "0371",
          "code": 410108,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1540,
        },
        {
          "areaName": "中牟县",
          "shortName": "中牟",
          "areaCode": "0371",
          "code": 410122,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1541,
        },
        {
          "areaName": "巩义市",
          "shortName": "巩义",
          "areaCode": "0371",
          "code": 410181,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1542,
        },
        {
          "areaName": "荥阳市",
          "shortName": "荥阳",
          "areaCode": "0371",
          "code": 410182,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1543,
        },
        {
          "areaName": "新密市",
          "shortName": "新密",
          "areaCode": "0371",
          "code": 410183,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1544,
        },
        {
          "areaName": "新郑市",
          "shortName": "新郑",
          "areaCode": "0371",
          "code": 410184,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1545,
        },
        {
          "areaName": "登封市",
          "shortName": "登封",
          "areaCode": "0371",
          "code": 410185,
          "parentCode": 410100,
          "level": 4,
          "children": null,
          "id": 1546,
        },
        {
          "areaName": "开封市",
          "shortName": "开封",
          "areaCode": "0378",
          "code": 410200,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1547,
        },
        {
          "areaName": "龙亭区",
          "shortName": "龙亭",
          "areaCode": "0378",
          "code": 410202,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1548,
        },
        {
          "areaName": "顺河回族区",
          "shortName": "顺河",
          "areaCode": "0378",
          "code": 410203,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1549,
        },
        {
          "areaName": "鼓楼区",
          "shortName": "鼓楼",
          "areaCode": "0378",
          "code": 410204,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1550,
        },
        {
          "areaName": "禹王台区",
          "shortName": "禹王台",
          "areaCode": "0378",
          "code": 410205,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1551,
        },
        {
          "areaName": "祥符区",
          "shortName": "祥符",
          "areaCode": "0378",
          "code": 410212,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1552,
        },
        {
          "areaName": "杞县",
          "shortName": "杞县",
          "areaCode": "0378",
          "code": 410221,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1553,
        },
        {
          "areaName": "通许县",
          "shortName": "通许",
          "areaCode": "0378",
          "code": 410222,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1554,
        },
        {
          "areaName": "尉氏县",
          "shortName": "尉氏",
          "areaCode": "0378",
          "code": 410223,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1555,
        },
        {
          "areaName": "兰考县",
          "shortName": "兰考",
          "areaCode": "0378",
          "code": 410225,
          "parentCode": 410200,
          "level": 4,
          "children": null,
          "id": 1556,
        },
        {
          "areaName": "洛阳市",
          "shortName": "洛阳",
          "areaCode": "0379",
          "code": 410300,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1557,
        },
        {
          "areaName": "老城区",
          "shortName": "老城",
          "areaCode": "0379",
          "code": 410302,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1558,
        },
        {
          "areaName": "西工区",
          "shortName": "西工",
          "areaCode": "0379",
          "code": 410303,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1559,
        },
        {
          "areaName": "瀍河回族区",
          "shortName": "瀍河",
          "areaCode": "0379",
          "code": 410304,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1560,
        },
        {
          "areaName": "涧西区",
          "shortName": "涧西",
          "areaCode": "0379",
          "code": 410305,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1561,
        },
        {
          "areaName": "吉利区",
          "shortName": "吉利",
          "areaCode": "0379",
          "code": 410306,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1562,
        },
        {
          "areaName": "洛龙区",
          "shortName": "洛龙",
          "areaCode": "0379",
          "code": 410311,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1563,
        },
        {
          "areaName": "孟津县",
          "shortName": "孟津",
          "areaCode": "0379",
          "code": 410322,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1564,
        },
        {
          "areaName": "新安县",
          "shortName": "新安",
          "areaCode": "0379",
          "code": 410323,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1565,
        },
        {
          "areaName": "栾川县",
          "shortName": "栾川",
          "areaCode": "0379",
          "code": 410324,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1566,
        },
        {
          "areaName": "嵩县",
          "shortName": "嵩县",
          "areaCode": "0379",
          "code": 410325,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1567,
        },
        {
          "areaName": "汝阳县",
          "shortName": "汝阳",
          "areaCode": "0379",
          "code": 410326,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1568,
        },
        {
          "areaName": "宜阳县",
          "shortName": "宜阳",
          "areaCode": "0379",
          "code": 410327,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1569,
        },
        {
          "areaName": "洛宁县",
          "shortName": "洛宁",
          "areaCode": "0379",
          "code": 410328,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1570,
        },
        {
          "areaName": "伊川县",
          "shortName": "伊川",
          "areaCode": "0379",
          "code": 410329,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1571,
        },
        {
          "areaName": "偃师市",
          "shortName": "偃师",
          "areaCode": "0379",
          "code": 410381,
          "parentCode": 410300,
          "level": 4,
          "children": null,
          "id": 1572,
        },
        {
          "areaName": "平顶山市",
          "shortName": "平顶山",
          "areaCode": "0375",
          "code": 410400,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1573,
        },
        {
          "areaName": "新华区",
          "shortName": "新华",
          "areaCode": "0375",
          "code": 410402,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1574,
        },
        {
          "areaName": "卫东区",
          "shortName": "卫东",
          "areaCode": "0375",
          "code": 410403,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1575,
        },
        {
          "areaName": "石龙区",
          "shortName": "石龙",
          "areaCode": "0375",
          "code": 410404,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1576,
        },
        {
          "areaName": "湛河区",
          "shortName": "湛河",
          "areaCode": "0375",
          "code": 410411,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1577,
        },
        {
          "areaName": "宝丰县",
          "shortName": "宝丰",
          "areaCode": "0375",
          "code": 410421,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1578,
        },
        {
          "areaName": "叶县",
          "shortName": "叶县",
          "areaCode": "0375",
          "code": 410422,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1579,
        },
        {
          "areaName": "鲁山县",
          "shortName": "鲁山",
          "areaCode": "0375",
          "code": 410423,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1580,
        },
        {
          "areaName": "郏县",
          "shortName": "郏县",
          "areaCode": "0375",
          "code": 410425,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1581,
        },
        {
          "areaName": "舞钢市",
          "shortName": "舞钢",
          "areaCode": "0375",
          "code": 410481,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1582,
        },
        {
          "areaName": "汝州市",
          "shortName": "汝州",
          "areaCode": "0375",
          "code": 410482,
          "parentCode": 410400,
          "level": 4,
          "children": null,
          "id": 1583,
        },
        {
          "areaName": "安阳市",
          "shortName": "安阳",
          "areaCode": "0372",
          "code": 410500,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1584,
        },
        {
          "areaName": "文峰区",
          "shortName": "文峰",
          "areaCode": "0372",
          "code": 410502,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1585,
        },
        {
          "areaName": "北关区",
          "shortName": "北关",
          "areaCode": "0372",
          "code": 410503,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1586,
        },
        {
          "areaName": "殷都区",
          "shortName": "殷都",
          "areaCode": "0372",
          "code": 410505,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1587,
        },
        {
          "areaName": "龙安区",
          "shortName": "龙安",
          "areaCode": "0372",
          "code": 410506,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1588,
        },
        {
          "areaName": "安阳县",
          "shortName": "安阳",
          "areaCode": "0372",
          "code": 410522,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1589,
        },
        {
          "areaName": "汤阴县",
          "shortName": "汤阴",
          "areaCode": "0372",
          "code": 410523,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1590,
        },
        {
          "areaName": "滑县",
          "shortName": "滑县",
          "areaCode": "0372",
          "code": 410526,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1591,
        },
        {
          "areaName": "内黄县",
          "shortName": "内黄",
          "areaCode": "0372",
          "code": 410527,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1592,
        },
        {
          "areaName": "林州市",
          "shortName": "林州",
          "areaCode": "0372",
          "code": 410581,
          "parentCode": 410500,
          "level": 4,
          "children": null,
          "id": 1593,
        },
        {
          "areaName": "鹤壁市",
          "shortName": "鹤壁",
          "areaCode": "0392",
          "code": 410600,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1594,
        },
        {
          "areaName": "鹤山区",
          "shortName": "鹤山",
          "areaCode": "0392",
          "code": 410602,
          "parentCode": 410600,
          "level": 4,
          "children": null,
          "id": 1595,
        },
        {
          "areaName": "山城区",
          "shortName": "山城",
          "areaCode": "0392",
          "code": 410603,
          "parentCode": 410600,
          "level": 4,
          "children": null,
          "id": 1596,
        },
        {
          "areaName": "淇滨区",
          "shortName": "淇滨",
          "areaCode": "0392",
          "code": 410611,
          "parentCode": 410600,
          "level": 4,
          "children": null,
          "id": 1597,
        },
        {
          "areaName": "浚县",
          "shortName": "浚县",
          "areaCode": "0392",
          "code": 410621,
          "parentCode": 410600,
          "level": 4,
          "children": null,
          "id": 1598,
        },
        {
          "areaName": "淇县",
          "shortName": "淇县",
          "areaCode": "0392",
          "code": 410622,
          "parentCode": 410600,
          "level": 4,
          "children": null,
          "id": 1599,
        },
        {
          "areaName": "新乡市",
          "shortName": "新乡",
          "areaCode": "0373",
          "code": 410700,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1600,
        },
        {
          "areaName": "红旗区",
          "shortName": "红旗",
          "areaCode": "0373",
          "code": 410702,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1601,
        },
        {
          "areaName": "卫滨区",
          "shortName": "卫滨",
          "areaCode": "0373",
          "code": 410703,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1602,
        },
        {
          "areaName": "凤泉区",
          "shortName": "凤泉",
          "areaCode": "0373",
          "code": 410704,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1603,
        },
        {
          "areaName": "牧野区",
          "shortName": "牧野",
          "areaCode": "0373",
          "code": 410711,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1604,
        },
        {
          "areaName": "新乡县",
          "shortName": "新乡",
          "areaCode": "0373",
          "code": 410721,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1605,
        },
        {
          "areaName": "获嘉县",
          "shortName": "获嘉",
          "areaCode": "0373",
          "code": 410724,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1606,
        },
        {
          "areaName": "原阳县",
          "shortName": "原阳",
          "areaCode": "0373",
          "code": 410725,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1607,
        },
        {
          "areaName": "延津县",
          "shortName": "延津",
          "areaCode": "0373",
          "code": 410726,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1608,
        },
        {
          "areaName": "封丘县",
          "shortName": "封丘",
          "areaCode": "0373",
          "code": 410727,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1609,
        },
        {
          "areaName": "长垣县",
          "shortName": "长垣",
          "areaCode": "0373",
          "code": 410728,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1610,
        },
        {
          "areaName": "卫辉市",
          "shortName": "卫辉",
          "areaCode": "0373",
          "code": 410781,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1611,
        },
        {
          "areaName": "辉县市",
          "shortName": "辉县",
          "areaCode": "0373",
          "code": 410782,
          "parentCode": 410700,
          "level": 4,
          "children": null,
          "id": 1612,
        },
        {
          "areaName": "焦作市",
          "shortName": "焦作",
          "areaCode": "0391",
          "code": 410800,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1613,
        },
        {
          "areaName": "解放区",
          "shortName": "解放",
          "areaCode": "0391",
          "code": 410802,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1614,
        },
        {
          "areaName": "中站区",
          "shortName": "中站",
          "areaCode": "0391",
          "code": 410803,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1615,
        },
        {
          "areaName": "马村区",
          "shortName": "马村",
          "areaCode": "0391",
          "code": 410804,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1616,
        },
        {
          "areaName": "山阳区",
          "shortName": "山阳",
          "areaCode": "0391",
          "code": 410811,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1617,
        },
        {
          "areaName": "修武县",
          "shortName": "修武",
          "areaCode": "0391",
          "code": 410821,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1618,
        },
        {
          "areaName": "博爱县",
          "shortName": "博爱",
          "areaCode": "0391",
          "code": 410822,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1619,
        },
        {
          "areaName": "武陟县",
          "shortName": "武陟",
          "areaCode": "0391",
          "code": 410823,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1620,
        },
        {
          "areaName": "温县",
          "shortName": "温县",
          "areaCode": "0391",
          "code": 410825,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1621,
        },
        {
          "areaName": "沁阳市",
          "shortName": "沁阳",
          "areaCode": "0391",
          "code": 410882,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1622,
        },
        {
          "areaName": "孟州市",
          "shortName": "孟州",
          "areaCode": "0391",
          "code": 410883,
          "parentCode": 410800,
          "level": 4,
          "children": null,
          "id": 1623,
        },
        {
          "areaName": "濮阳市",
          "shortName": "濮阳",
          "areaCode": "0393",
          "code": 410900,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1624,
        },
        {
          "areaName": "华龙区",
          "shortName": "华龙",
          "areaCode": "0393",
          "code": 410902,
          "parentCode": 410900,
          "level": 4,
          "children": null,
          "id": 1625,
        },
        {
          "areaName": "清丰县",
          "shortName": "清丰",
          "areaCode": "0393",
          "code": 410922,
          "parentCode": 410900,
          "level": 4,
          "children": null,
          "id": 1626,
        },
        {
          "areaName": "南乐县",
          "shortName": "南乐",
          "areaCode": "0393",
          "code": 410923,
          "parentCode": 410900,
          "level": 4,
          "children": null,
          "id": 1627,
        },
        {
          "areaName": "范县",
          "shortName": "范县",
          "areaCode": "0393",
          "code": 410926,
          "parentCode": 410900,
          "level": 4,
          "children": null,
          "id": 1628,
        },
        {
          "areaName": "台前县",
          "shortName": "台前",
          "areaCode": "0393",
          "code": 410927,
          "parentCode": 410900,
          "level": 4,
          "children": null,
          "id": 1629,
        },
        {
          "areaName": "濮阳县",
          "shortName": "濮阳",
          "areaCode": "0393",
          "code": 410928,
          "parentCode": 410900,
          "level": 4,
          "children": null,
          "id": 1630,
        },
        {
          "areaName": "许昌市",
          "shortName": "许昌",
          "areaCode": "0374",
          "code": 411000,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1631,
        },
        {
          "areaName": "魏都区",
          "shortName": "魏都",
          "areaCode": "0374",
          "code": 411002,
          "parentCode": 411000,
          "level": 4,
          "children": null,
          "id": 1632,
        },
        {
          "areaName": "许昌县",
          "shortName": "许昌",
          "areaCode": "0374",
          "code": 411023,
          "parentCode": 411000,
          "level": 4,
          "children": null,
          "id": 1633,
        },
        {
          "areaName": "鄢陵县",
          "shortName": "鄢陵",
          "areaCode": "0374",
          "code": 411024,
          "parentCode": 411000,
          "level": 4,
          "children": null,
          "id": 1634,
        },
        {
          "areaName": "襄城县",
          "shortName": "襄城",
          "areaCode": "0374",
          "code": 411025,
          "parentCode": 411000,
          "level": 4,
          "children": null,
          "id": 1635,
        },
        {
          "areaName": "禹州市",
          "shortName": "禹州",
          "areaCode": "0374",
          "code": 411081,
          "parentCode": 411000,
          "level": 4,
          "children": null,
          "id": 1636,
        },
        {
          "areaName": "长葛市",
          "shortName": "长葛",
          "areaCode": "0374",
          "code": 411082,
          "parentCode": 411000,
          "level": 4,
          "children": null,
          "id": 1637,
        },
        {
          "areaName": "漯河市",
          "shortName": "漯河",
          "areaCode": "0395",
          "code": 411100,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1638,
        },
        {
          "areaName": "源汇区",
          "shortName": "源汇",
          "areaCode": "0395",
          "code": 411102,
          "parentCode": 411100,
          "level": 4,
          "children": null,
          "id": 1639,
        },
        {
          "areaName": "郾城区",
          "shortName": "郾城",
          "areaCode": "0395",
          "code": 411103,
          "parentCode": 411100,
          "level": 4,
          "children": null,
          "id": 1640,
        },
        {
          "areaName": "召陵区",
          "shortName": "召陵",
          "areaCode": "0395",
          "code": 411104,
          "parentCode": 411100,
          "level": 4,
          "children": null,
          "id": 1641,
        },
        {
          "areaName": "舞阳县",
          "shortName": "舞阳",
          "areaCode": "0395",
          "code": 411121,
          "parentCode": 411100,
          "level": 4,
          "children": null,
          "id": 1642,
        },
        {
          "areaName": "临颍县",
          "shortName": "临颍",
          "areaCode": "0395",
          "code": 411122,
          "parentCode": 411100,
          "level": 4,
          "children": null,
          "id": 1643,
        },
        {
          "areaName": "三门峡市",
          "shortName": "三门峡",
          "areaCode": "0398",
          "code": 411200,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1644,
        },
        {
          "areaName": "湖滨区",
          "shortName": "湖滨",
          "areaCode": "0398",
          "code": 411202,
          "parentCode": 411200,
          "level": 4,
          "children": null,
          "id": 1645,
        },
        {
          "areaName": "渑池县",
          "shortName": "渑池",
          "areaCode": "0398",
          "code": 411221,
          "parentCode": 411200,
          "level": 4,
          "children": null,
          "id": 1646,
        },
        {
          "areaName": "陕县",
          "shortName": "陕县",
          "areaCode": "0398",
          "code": 411222,
          "parentCode": 411200,
          "level": 4,
          "children": null,
          "id": 1647,
        },
        {
          "areaName": "卢氏县",
          "shortName": "卢氏",
          "areaCode": "0398",
          "code": 411224,
          "parentCode": 411200,
          "level": 4,
          "children": null,
          "id": 1648,
        },
        {
          "areaName": "义马市",
          "shortName": "义马",
          "areaCode": "0398",
          "code": 411281,
          "parentCode": 411200,
          "level": 4,
          "children": null,
          "id": 1649,
        },
        {
          "areaName": "灵宝市",
          "shortName": "灵宝",
          "areaCode": "0398",
          "code": 411282,
          "parentCode": 411200,
          "level": 4,
          "children": null,
          "id": 1650,
        },
        {
          "areaName": "南阳市",
          "shortName": "南阳",
          "areaCode": "0377",
          "code": 411300,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1651,
        },
        {
          "areaName": "宛城区",
          "shortName": "宛城",
          "areaCode": "0377",
          "code": 411302,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1652,
        },
        {
          "areaName": "卧龙区",
          "shortName": "卧龙",
          "areaCode": "0377",
          "code": 411303,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1653,
        },
        {
          "areaName": "南召县",
          "shortName": "南召",
          "areaCode": "0377",
          "code": 411321,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1654,
        },
        {
          "areaName": "方城县",
          "shortName": "方城",
          "areaCode": "0377",
          "code": 411322,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1655,
        },
        {
          "areaName": "西峡县",
          "shortName": "西峡",
          "areaCode": "0377",
          "code": 411323,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1656,
        },
        {
          "areaName": "镇平县",
          "shortName": "镇平",
          "areaCode": "0377",
          "code": 411324,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1657,
        },
        {
          "areaName": "内乡县",
          "shortName": "内乡",
          "areaCode": "0377",
          "code": 411325,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1658,
        },
        {
          "areaName": "淅川县",
          "shortName": "淅川",
          "areaCode": "0377",
          "code": 411326,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1659,
        },
        {
          "areaName": "社旗县",
          "shortName": "社旗",
          "areaCode": "0377",
          "code": 411327,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1660,
        },
        {
          "areaName": "唐河县",
          "shortName": "唐河",
          "areaCode": "0377",
          "code": 411328,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1661,
        },
        {
          "areaName": "新野县",
          "shortName": "新野",
          "areaCode": "0377",
          "code": 411329,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1662,
        },
        {
          "areaName": "桐柏县",
          "shortName": "桐柏",
          "areaCode": "0377",
          "code": 411330,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1663,
        },
        {
          "areaName": "邓州市",
          "shortName": "邓州",
          "areaCode": "0377",
          "code": 411381,
          "parentCode": 411300,
          "level": 4,
          "children": null,
          "id": 1664,
        },
        {
          "areaName": "商丘市",
          "shortName": "商丘",
          "areaCode": "0370",
          "code": 411400,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1665,
        },
        {
          "areaName": "梁园区",
          "shortName": "梁园",
          "areaCode": "0370",
          "code": 411402,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1666,
        },
        {
          "areaName": "睢阳区",
          "shortName": "睢阳",
          "areaCode": "0370",
          "code": 411403,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1667,
        },
        {
          "areaName": "民权县",
          "shortName": "民权",
          "areaCode": "0370",
          "code": 411421,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1668,
        },
        {
          "areaName": "睢县",
          "shortName": "睢县",
          "areaCode": "0370",
          "code": 411422,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1669,
        },
        {
          "areaName": "宁陵县",
          "shortName": "宁陵",
          "areaCode": "0370",
          "code": 411423,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1670,
        },
        {
          "areaName": "柘城县",
          "shortName": "柘城",
          "areaCode": "0370",
          "code": 411424,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1671,
        },
        {
          "areaName": "虞城县",
          "shortName": "虞城",
          "areaCode": "0370",
          "code": 411425,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1672,
        },
        {
          "areaName": "夏邑县",
          "shortName": "夏邑",
          "areaCode": "0370",
          "code": 411426,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1673,
        },
        {
          "areaName": "永城市",
          "shortName": "永城",
          "areaCode": "0370",
          "code": 411481,
          "parentCode": 411400,
          "level": 4,
          "children": null,
          "id": 1674,
        },
        {
          "areaName": "信阳市",
          "shortName": "信阳",
          "areaCode": "0376",
          "code": 411500,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1675,
        },
        {
          "areaName": "浉河区",
          "shortName": "浉河",
          "areaCode": "0376",
          "code": 411502,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1676,
        },
        {
          "areaName": "平桥区",
          "shortName": "平桥",
          "areaCode": "0376",
          "code": 411503,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1677,
        },
        {
          "areaName": "罗山县",
          "shortName": "罗山",
          "areaCode": "0376",
          "code": 411521,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1678,
        },
        {
          "areaName": "光山县",
          "shortName": "光山",
          "areaCode": "0376",
          "code": 411522,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1679,
        },
        {
          "areaName": "新县",
          "shortName": "新县",
          "areaCode": "0376",
          "code": 411523,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1680,
        },
        {
          "areaName": "商城县",
          "shortName": "商城",
          "areaCode": "0376",
          "code": 411524,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1681,
        },
        {
          "areaName": "固始县",
          "shortName": "固始",
          "areaCode": "0376",
          "code": 411525,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1682,
        },
        {
          "areaName": "潢川县",
          "shortName": "潢川",
          "areaCode": "0376",
          "code": 411526,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1683,
        },
        {
          "areaName": "淮滨县",
          "shortName": "淮滨",
          "areaCode": "0376",
          "code": 411527,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1684,
        },
        {
          "areaName": "息县",
          "shortName": "息县",
          "areaCode": "0376",
          "code": 411528,
          "parentCode": 411500,
          "level": 4,
          "children": null,
          "id": 1685,
        },
        {
          "areaName": "周口市",
          "shortName": "周口",
          "areaCode": "0394",
          "code": 411600,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1686,
        },
        {
          "areaName": "川汇区",
          "shortName": "川汇",
          "areaCode": "0394",
          "code": 411602,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1687,
        },
        {
          "areaName": "扶沟县",
          "shortName": "扶沟",
          "areaCode": "0394",
          "code": 411621,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1688,
        },
        {
          "areaName": "西华县",
          "shortName": "西华",
          "areaCode": "0394",
          "code": 411622,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1689,
        },
        {
          "areaName": "商水县",
          "shortName": "商水",
          "areaCode": "0394",
          "code": 411623,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1690,
        },
        {
          "areaName": "沈丘县",
          "shortName": "沈丘",
          "areaCode": "0394",
          "code": 411624,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1691,
        },
        {
          "areaName": "郸城县",
          "shortName": "郸城",
          "areaCode": "0394",
          "code": 411625,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1692,
        },
        {
          "areaName": "淮阳县",
          "shortName": "淮阳",
          "areaCode": "0394",
          "code": 411626,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1693,
        },
        {
          "areaName": "太康县",
          "shortName": "太康",
          "areaCode": "0394",
          "code": 411627,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1694,
        },
        {
          "areaName": "鹿邑县",
          "shortName": "鹿邑",
          "areaCode": "0394",
          "code": 411628,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1695,
        },
        {
          "areaName": "项城市",
          "shortName": "项城",
          "areaCode": "0394",
          "code": 411681,
          "parentCode": 411600,
          "level": 4,
          "children": null,
          "id": 1696,
        },
        {
          "areaName": "驻马店市",
          "shortName": "驻马店",
          "areaCode": "0396",
          "code": 411700,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1697,
        },
        {
          "areaName": "驿城区",
          "shortName": "驿城",
          "areaCode": "0396",
          "code": 411702,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1698,
        },
        {
          "areaName": "西平县",
          "shortName": "西平",
          "areaCode": "0396",
          "code": 411721,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1699,
        },
        {
          "areaName": "上蔡县",
          "shortName": "上蔡",
          "areaCode": "0396",
          "code": 411722,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1700,
        },
        {
          "areaName": "平舆县",
          "shortName": "平舆",
          "areaCode": "0396",
          "code": 411723,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1701,
        },
        {
          "areaName": "正阳县",
          "shortName": "正阳",
          "areaCode": "0396",
          "code": 411724,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1702,
        },
        {
          "areaName": "确山县",
          "shortName": "确山",
          "areaCode": "0396",
          "code": 411725,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1703,
        },
        {
          "areaName": "泌阳县",
          "shortName": "泌阳",
          "areaCode": "0396",
          "code": 411726,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1704,
        },
        {
          "areaName": "汝南县",
          "shortName": "汝南",
          "areaCode": "0396",
          "code": 411727,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1705,
        },
        {
          "areaName": "遂平县",
          "shortName": "遂平",
          "areaCode": "0396",
          "code": 411728,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1706,
        },
        {
          "areaName": "新蔡县",
          "shortName": "新蔡",
          "areaCode": "0396",
          "code": 411729,
          "parentCode": 411700,
          "level": 4,
          "children": null,
          "id": 1707,
        },
        {
          "areaName": "直辖县级",
          "shortName": "",
          "code": 419000,
          "parentCode": 410000,
          "level": 3,
          "children": null,
          "id": 1708,
        },
        {
          "areaName": "济源市",
          "shortName": "济源",
          "areaCode": "0391",
          "code": 419001,
          "parentCode": 419000,
          "level": 4,
          "children": null,
          "id": 1709,
        }
      ],
      "id": 1533,
    },
    {
      "areaName": "湖北省",
      "shortName": "湖北",
      "code": 420000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "武汉市",
          "shortName": "武汉",
          "code": 420100,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1711,
        },
        {
          "areaName": "江岸区",
          "shortName": "江岸",
          "areaCode": "027",
          "code": 420102,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1712,
        },
        {
          "areaName": "江汉区",
          "shortName": "江汉",
          "areaCode": "027",
          "code": 420103,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1713,
        },
        {
          "areaName": "硚口区",
          "shortName": "硚口",
          "areaCode": "027",
          "code": 420104,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1714,
        },
        {
          "areaName": "汉阳区",
          "shortName": "汉阳",
          "areaCode": "027",
          "code": 420105,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1715,
        },
        {
          "areaName": "武昌区",
          "shortName": "武昌",
          "areaCode": "027",
          "code": 420106,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1716,
        },
        {
          "areaName": "青山区",
          "shortName": "青山",
          "areaCode": "027",
          "code": 420107,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1717,
        },
        {
          "areaName": "洪山区",
          "shortName": "洪山",
          "areaCode": "027",
          "code": 420111,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1718,
        },
        {
          "areaName": "东西湖区",
          "shortName": "东西湖",
          "areaCode": "027",
          "code": 420112,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1719,
        },
        {
          "areaName": "汉南区",
          "shortName": "汉南",
          "areaCode": "027",
          "code": 420113,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1720,
        },
        {
          "areaName": "蔡甸区",
          "shortName": "蔡甸",
          "areaCode": "027",
          "code": 420114,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1721,
        },
        {
          "areaName": "江夏区",
          "shortName": "江夏",
          "areaCode": "027",
          "code": 420115,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1722,
        },
        {
          "areaName": "黄陂区",
          "shortName": "黄陂",
          "areaCode": "027",
          "code": 420116,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1723,
        },
        {
          "areaName": "新洲区",
          "shortName": "新洲",
          "areaCode": "027",
          "code": 420117,
          "parentCode": 420100,
          "level": 4,
          "children": null,
          "id": 1724,
        },
        {
          "areaName": "黄石市",
          "shortName": "黄石",
          "areaCode": "0714",
          "code": 420200,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1725,
        },
        {
          "areaName": "黄石港区",
          "shortName": "黄石港",
          "areaCode": "0714",
          "code": 420202,
          "parentCode": 420200,
          "level": 4,
          "children": null,
          "id": 1726,
        },
        {
          "areaName": "西塞山区",
          "shortName": "西塞山",
          "areaCode": "0714",
          "code": 420203,
          "parentCode": 420200,
          "level": 4,
          "children": null,
          "id": 1727,
        },
        {
          "areaName": "下陆区",
          "shortName": "下陆",
          "areaCode": "0714",
          "code": 420204,
          "parentCode": 420200,
          "level": 4,
          "children": null,
          "id": 1728,
        },
        {
          "areaName": "铁山区",
          "shortName": "铁山",
          "areaCode": "0714",
          "code": 420205,
          "parentCode": 420200,
          "level": 4,
          "children": null,
          "id": 1729,
        },
        {
          "areaName": "阳新县",
          "shortName": "阳新",
          "areaCode": "0714",
          "code": 420222,
          "parentCode": 420200,
          "level": 4,
          "children": null,
          "id": 1730,
        },
        {
          "areaName": "大冶市",
          "shortName": "大冶",
          "areaCode": "0714",
          "code": 420281,
          "parentCode": 420200,
          "level": 4,
          "children": null,
          "id": 1731,
        },
        {
          "areaName": "十堰市",
          "shortName": "十堰",
          "areaCode": "0719",
          "code": 420300,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1732,
        },
        {
          "areaName": "茅箭区",
          "shortName": "茅箭",
          "areaCode": "0719",
          "code": 420302,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1733,
        },
        {
          "areaName": "张湾区",
          "shortName": "张湾",
          "areaCode": "0719",
          "code": 420303,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1734,
        },
        {
          "areaName": "郧阳区",
          "shortName": "郧阳",
          "areaCode": "0719",
          "code": 420304,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1735,
        },
        {
          "areaName": "郧西县",
          "shortName": "郧西",
          "areaCode": "0719",
          "code": 420322,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1736,
        },
        {
          "areaName": "竹山县",
          "shortName": "竹山",
          "areaCode": "0719",
          "code": 420323,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1737,
        },
        {
          "areaName": "竹溪县",
          "shortName": "竹溪",
          "areaCode": "0719",
          "code": 420324,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1738,
        },
        {
          "areaName": "房县",
          "shortName": "房县",
          "areaCode": "0719",
          "code": 420325,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1739,
        },
        {
          "areaName": "丹江口市",
          "shortName": "丹江口",
          "areaCode": "0719",
          "code": 420381,
          "parentCode": 420300,
          "level": 4,
          "children": null,
          "id": 1740,
        },
        {
          "areaName": "宜昌市",
          "shortName": "宜昌",
          "areaCode": "0717",
          "code": 420500,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1741,
        },
        {
          "areaName": "西陵区",
          "shortName": "西陵",
          "areaCode": "0717",
          "code": 420502,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1742,
        },
        {
          "areaName": "伍家岗区",
          "shortName": "伍家岗",
          "areaCode": "0717",
          "code": 420503,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1743,
        },
        {
          "areaName": "点军区",
          "shortName": "点军",
          "areaCode": "0717",
          "code": 420504,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1744,
        },
        {
          "areaName": "猇亭区",
          "shortName": "猇亭",
          "areaCode": "0717",
          "code": 420505,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1745,
        },
        {
          "areaName": "夷陵区",
          "shortName": "夷陵",
          "areaCode": "0717",
          "code": 420506,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1746,
        },
        {
          "areaName": "远安县",
          "shortName": "远安",
          "areaCode": "0717",
          "code": 420525,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1747,
        },
        {
          "areaName": "兴山县",
          "shortName": "兴山",
          "areaCode": "0717",
          "code": 420526,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1748,
        },
        {
          "areaName": "秭归县",
          "shortName": "秭归",
          "areaCode": "0717",
          "code": 420527,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1749,
        },
        {
          "areaName": "长阳土家族自治县",
          "shortName": "长阳",
          "areaCode": "0717",
          "code": 420528,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1750,
        },
        {
          "areaName": "五峰土家族自治县",
          "shortName": "五峰",
          "areaCode": "0717",
          "code": 420529,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1751,
        },
        {
          "areaName": "宜都市",
          "shortName": "宜都",
          "areaCode": "0717",
          "code": 420581,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1752,
        },
        {
          "areaName": "当阳市",
          "shortName": "当阳",
          "areaCode": "0717",
          "code": 420582,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1753,
        },
        {
          "areaName": "枝江市",
          "shortName": "枝江",
          "areaCode": "0717",
          "code": 420583,
          "parentCode": 420500,
          "level": 4,
          "children": null,
          "id": 1754,
        },
        {
          "areaName": "襄阳市",
          "shortName": "襄阳",
          "areaCode": "0710",
          "code": 420600,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1755,
        },
        {
          "areaName": "襄城区",
          "shortName": "襄城",
          "areaCode": "0710",
          "code": 420602,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1756,
        },
        {
          "areaName": "樊城区",
          "shortName": "樊城",
          "areaCode": "0710",
          "code": 420606,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1757,
        },
        {
          "areaName": "襄州区",
          "shortName": "襄州",
          "areaCode": "0710",
          "code": 420607,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1758,
        },
        {
          "areaName": "南漳县",
          "shortName": "南漳",
          "areaCode": "0710",
          "code": 420624,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1759,
        },
        {
          "areaName": "谷城县",
          "shortName": "谷城",
          "areaCode": "0710",
          "code": 420625,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1760,
        },
        {
          "areaName": "保康县",
          "shortName": "保康",
          "areaCode": "0710",
          "code": 420626,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1761,
        },
        {
          "areaName": "老河口市",
          "shortName": "老河口",
          "areaCode": "0710",
          "code": 420682,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1762,
        },
        {
          "areaName": "枣阳市",
          "shortName": "枣阳",
          "areaCode": "0710",
          "code": 420683,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1763,
        },
        {
          "areaName": "宜城市",
          "shortName": "宜城",
          "areaCode": "0710",
          "code": 420684,
          "parentCode": 420600,
          "level": 4,
          "children": null,
          "id": 1764,
        },
        {
          "areaName": "鄂州市",
          "shortName": "鄂州",
          "areaCode": "0711",
          "code": 420700,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1765,
        },
        {
          "areaName": "梁子湖区",
          "shortName": "梁子湖",
          "areaCode": "0711",
          "code": 420702,
          "parentCode": 420700,
          "level": 4,
          "children": null,
          "id": 1766,
        },
        {
          "areaName": "华容区",
          "shortName": "华容",
          "areaCode": "0711",
          "code": 420703,
          "parentCode": 420700,
          "level": 4,
          "children": null,
          "id": 1767,
        },
        {
          "areaName": "鄂城区",
          "shortName": "鄂城",
          "areaCode": "0711",
          "code": 420704,
          "parentCode": 420700,
          "level": 4,
          "children": null,
          "id": 1768,
        },
        {
          "areaName": "荆门市",
          "shortName": "荆门",
          "areaCode": "0724",
          "code": 420800,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1769,
        },
        {
          "areaName": "东宝区",
          "shortName": "东宝",
          "areaCode": "0724",
          "code": 420802,
          "parentCode": 420800,
          "level": 4,
          "children": null,
          "id": 1770,
        },
        {
          "areaName": "掇刀区",
          "shortName": "掇刀",
          "areaCode": "0724",
          "code": 420804,
          "parentCode": 420800,
          "level": 4,
          "children": null,
          "id": 1771,
        },
        {
          "areaName": "京山县",
          "shortName": "京山",
          "areaCode": "0724",
          "code": 420821,
          "parentCode": 420800,
          "level": 4,
          "children": null,
          "id": 1772,
        },
        {
          "areaName": "沙洋县",
          "shortName": "沙洋",
          "areaCode": "0724",
          "code": 420822,
          "parentCode": 420800,
          "level": 4,
          "children": null,
          "id": 1773,
        },
        {
          "areaName": "钟祥市",
          "shortName": "钟祥",
          "areaCode": "0724",
          "code": 420881,
          "parentCode": 420800,
          "level": 4,
          "children": null,
          "id": 1774,
        },
        {
          "areaName": "孝感市",
          "shortName": "孝感",
          "areaCode": "0712",
          "code": 420900,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1775,
        },
        {
          "areaName": "孝南区",
          "shortName": "孝南",
          "areaCode": "0712",
          "code": 420902,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1776,
        },
        {
          "areaName": "孝昌县",
          "shortName": "孝昌",
          "areaCode": "0712",
          "code": 420921,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1777,
        },
        {
          "areaName": "大悟县",
          "shortName": "大悟",
          "areaCode": "0712",
          "code": 420922,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1778,
        },
        {
          "areaName": "云梦县",
          "shortName": "云梦",
          "areaCode": "0712",
          "code": 420923,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1779,
        },
        {
          "areaName": "应城市",
          "shortName": "应城",
          "areaCode": "0712",
          "code": 420981,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1780,
        },
        {
          "areaName": "安陆市",
          "shortName": "安陆",
          "areaCode": "0712",
          "code": 420982,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1781,
        },
        {
          "areaName": "汉川市",
          "shortName": "汉川",
          "areaCode": "0712",
          "code": 420984,
          "parentCode": 420900,
          "level": 4,
          "children": null,
          "id": 1782,
        },
        {
          "areaName": "荆州市",
          "shortName": "荆州",
          "areaCode": "0716",
          "code": 421000,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1783,
        },
        {
          "areaName": "沙市区",
          "shortName": "沙市",
          "areaCode": "0716",
          "code": 421002,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1784,
        },
        {
          "areaName": "荆州区",
          "shortName": "荆州",
          "areaCode": "0716",
          "code": 421003,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1785,
        },
        {
          "areaName": "公安县",
          "shortName": "公安",
          "areaCode": "0716",
          "code": 421022,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1786,
        },
        {
          "areaName": "监利县",
          "shortName": "监利",
          "areaCode": "0716",
          "code": 421023,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1787,
        },
        {
          "areaName": "江陵县",
          "shortName": "江陵",
          "areaCode": "0716",
          "code": 421024,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1788,
        },
        {
          "areaName": "石首市",
          "shortName": "石首",
          "areaCode": "0716",
          "code": 421081,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1789,
        },
        {
          "areaName": "洪湖市",
          "shortName": "洪湖",
          "areaCode": "0716",
          "code": 421083,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1790,
        },
        {
          "areaName": "松滋市",
          "shortName": "松滋",
          "areaCode": "0716",
          "code": 421087,
          "parentCode": 421000,
          "level": 4,
          "children": null,
          "id": 1791,
        },
        {
          "areaName": "黄冈市",
          "shortName": "黄冈",
          "areaCode": "0713",
          "code": 421100,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1792,
        },
        {
          "areaName": "黄州区",
          "shortName": "黄州",
          "areaCode": "0713",
          "code": 421102,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1793,
        },
        {
          "areaName": "团风县",
          "shortName": "团风",
          "areaCode": "0713",
          "code": 421121,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1794,
        },
        {
          "areaName": "红安县",
          "shortName": "红安",
          "areaCode": "0713",
          "code": 421122,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1795,
        },
        {
          "areaName": "罗田县",
          "shortName": "罗田",
          "areaCode": "0713",
          "code": 421123,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1796,
        },
        {
          "areaName": "英山县",
          "shortName": "英山",
          "areaCode": "0713",
          "code": 421124,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1797,
        },
        {
          "areaName": "浠水县",
          "shortName": "浠水",
          "areaCode": "0713",
          "code": 421125,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1798,
        },
        {
          "areaName": "蕲春县",
          "shortName": "蕲春",
          "areaCode": "0713",
          "code": 421126,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1799,
        },
        {
          "areaName": "黄梅县",
          "shortName": "黄梅",
          "areaCode": "0713",
          "code": 421127,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1800,
        },
        {
          "areaName": "麻城市",
          "shortName": "麻城",
          "areaCode": "0713",
          "code": 421181,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1801,
        },
        {
          "areaName": "武穴市",
          "shortName": "武穴",
          "areaCode": "0713",
          "code": 421182,
          "parentCode": 421100,
          "level": 4,
          "children": null,
          "id": 1802,
        },
        {
          "areaName": "咸宁市",
          "shortName": "咸宁",
          "areaCode": "0715",
          "code": 421200,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1803,
        },
        {
          "areaName": "咸安区",
          "shortName": "咸安",
          "areaCode": "0715",
          "code": 421202,
          "parentCode": 421200,
          "level": 4,
          "children": null,
          "id": 1804,
        },
        {
          "areaName": "嘉鱼县",
          "shortName": "嘉鱼",
          "areaCode": "0715",
          "code": 421221,
          "parentCode": 421200,
          "level": 4,
          "children": null,
          "id": 1805,
        },
        {
          "areaName": "通城县",
          "shortName": "通城",
          "areaCode": "0715",
          "code": 421222,
          "parentCode": 421200,
          "level": 4,
          "children": null,
          "id": 1806,
        },
        {
          "areaName": "崇阳县",
          "shortName": "崇阳",
          "areaCode": "0715",
          "code": 421223,
          "parentCode": 421200,
          "level": 4,
          "children": null,
          "id": 1807,
        },
        {
          "areaName": "通山县",
          "shortName": "通山",
          "areaCode": "0715",
          "code": 421224,
          "parentCode": 421200,
          "level": 4,
          "children": null,
          "id": 1808,
        },
        {
          "areaName": "赤壁市",
          "shortName": "赤壁",
          "areaCode": "0715",
          "code": 421281,
          "parentCode": 421200,
          "level": 4,
          "children": null,
          "id": 1809,
        },
        {
          "areaName": "随州市",
          "shortName": "随州",
          "areaCode": "0722",
          "code": 421300,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1810,
        },
        {
          "areaName": "曾都区",
          "shortName": "曾都",
          "areaCode": "0722",
          "code": 421303,
          "parentCode": 421300,
          "level": 4,
          "children": null,
          "id": 1811,
        },
        {
          "areaName": "随县",
          "shortName": "随县",
          "areaCode": "0722",
          "code": 421321,
          "parentCode": 421300,
          "level": 4,
          "children": null,
          "id": 1812,
        },
        {
          "areaName": "广水市",
          "shortName": "广水",
          "areaCode": "0722",
          "code": 421381,
          "parentCode": 421300,
          "level": 4,
          "children": null,
          "id": 1813,
        },
        {
          "areaName": "恩施土家族苗族自治州",
          "shortName": "恩施",
          "areaCode": "0718",
          "code": 422800,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1814,
        },
        {
          "areaName": "恩施市",
          "shortName": "恩施",
          "areaCode": "0718",
          "code": 422801,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1815,
        },
        {
          "areaName": "利川市",
          "shortName": "利川",
          "areaCode": "0718",
          "code": 422802,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1816,
        },
        {
          "areaName": "建始县",
          "shortName": "建始",
          "areaCode": "0718",
          "code": 422822,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1817,
        },
        {
          "areaName": "巴东县",
          "shortName": "巴东",
          "areaCode": "0718",
          "code": 422823,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1818,
        },
        {
          "areaName": "宣恩县",
          "shortName": "宣恩",
          "areaCode": "0718",
          "code": 422825,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1819,
        },
        {
          "areaName": "咸丰县",
          "shortName": "咸丰",
          "areaCode": "0718",
          "code": 422826,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1820,
        },
        {
          "areaName": "来凤县",
          "shortName": "来凤",
          "areaCode": "0718",
          "code": 422827,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1821,
        },
        {
          "areaName": "鹤峰县",
          "shortName": "鹤峰",
          "areaCode": "0718",
          "code": 422828,
          "parentCode": 422800,
          "level": 4,
          "children": null,
          "id": 1822,
        },
        {
          "areaName": "直辖县级",
          "shortName": "",
          "code": 429000,
          "parentCode": 420000,
          "level": 3,
          "children": null,
          "id": 1823,
        },
        {
          "areaName": "仙桃市",
          "shortName": "仙桃",
          "areaCode": "0728",
          "code": 429004,
          "parentCode": 429000,
          "level": 4,
          "children": null,
          "id": 1824,
        },
        {
          "areaName": "潜江市",
          "shortName": "潜江",
          "areaCode": "0728",
          "code": 429005,
          "parentCode": 429000,
          "level": 4,
          "children": null,
          "id": 1825,
        },
        {
          "areaName": "天门市",
          "shortName": "天门",
          "areaCode": "0728",
          "code": 429006,
          "parentCode": 429000,
          "level": 4,
          "children": null,
          "id": 1826,
        },
        {
          "areaName": "神农架林区",
          "shortName": "神农架",
          "areaCode": "0719",
          "code": 429021,
          "parentCode": 429000,
          "level": 4,
          "children": null,
          "id": 1827,
        }
      ],
      "id": 1710,
    },
    {
      "areaName": "湖南省",
      "shortName": "湖南",
      "code": 430000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "长沙市",
          "shortName": "长沙",
          "areaCode": "0731",
          "code": 430100,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1829,
        },
        {
          "areaName": "芙蓉区",
          "shortName": "芙蓉",
          "areaCode": "0731",
          "code": 430102,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1830,
        },
        {
          "areaName": "天心区",
          "shortName": "天心",
          "areaCode": "0731",
          "code": 430103,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1831,
        },
        {
          "areaName": "岳麓区",
          "shortName": "岳麓",
          "areaCode": "0731",
          "code": 430104,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1832,
        },
        {
          "areaName": "开福区",
          "shortName": "开福",
          "areaCode": "0731",
          "code": 430105,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1833,
        },
        {
          "areaName": "雨花区",
          "shortName": "雨花",
          "areaCode": "0731",
          "code": 430111,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1834,
        },
        {
          "areaName": "望城区",
          "shortName": "望城",
          "areaCode": "0731",
          "code": 430112,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1835,
        },
        {
          "areaName": "长沙县",
          "shortName": "长沙",
          "areaCode": "0731",
          "code": 430121,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1836,
        },
        {
          "areaName": "宁乡县",
          "shortName": "宁乡",
          "areaCode": "0731",
          "code": 430124,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1837,
        },
        {
          "areaName": "浏阳市",
          "shortName": "浏阳",
          "areaCode": "0731",
          "code": 430181,
          "parentCode": 430100,
          "level": 4,
          "children": null,
          "id": 1838,
        },
        {
          "areaName": "株洲市",
          "shortName": "株洲",
          "areaCode": "0731",
          "code": 430200,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1839,
        },
        {
          "areaName": "荷塘区",
          "shortName": "荷塘",
          "areaCode": "0731",
          "code": 430202,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1840,
        },
        {
          "areaName": "芦淞区",
          "shortName": "芦淞",
          "areaCode": "0731",
          "code": 430203,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1841,
        },
        {
          "areaName": "石峰区",
          "shortName": "石峰",
          "areaCode": "0731",
          "code": 430204,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1842,
        },
        {
          "areaName": "天元区",
          "shortName": "天元",
          "areaCode": "0731",
          "code": 430211,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1843,
        },
        {
          "areaName": "株洲县",
          "shortName": "株洲",
          "areaCode": "0731",
          "code": 430221,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1844,
        },
        {
          "areaName": "攸县",
          "shortName": "攸县",
          "areaCode": "0731",
          "code": 430223,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1845,
        },
        {
          "areaName": "茶陵县",
          "shortName": "茶陵",
          "areaCode": "0731",
          "code": 430224,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1846,
        },
        {
          "areaName": "炎陵县",
          "shortName": "炎陵",
          "areaCode": "0731",
          "code": 430225,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1847,
        },
        {
          "areaName": "醴陵市",
          "shortName": "醴陵",
          "areaCode": "0731",
          "code": 430281,
          "parentCode": 430200,
          "level": 4,
          "children": null,
          "id": 1848,
        },
        {
          "areaName": "湘潭市",
          "shortName": "湘潭",
          "areaCode": "0731",
          "code": 430300,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1849,
        },
        {
          "areaName": "雨湖区",
          "shortName": "雨湖",
          "areaCode": "0731",
          "code": 430302,
          "parentCode": 430300,
          "level": 4,
          "children": null,
          "id": 1850,
        },
        {
          "areaName": "岳塘区",
          "shortName": "岳塘",
          "areaCode": "0731",
          "code": 430304,
          "parentCode": 430300,
          "level": 4,
          "children": null,
          "id": 1851,
        },
        {
          "areaName": "湘潭县",
          "shortName": "湘潭",
          "areaCode": "0731",
          "code": 430321,
          "parentCode": 430300,
          "level": 4,
          "children": null,
          "id": 1852,
        },
        {
          "areaName": "湘乡市",
          "shortName": "湘乡",
          "areaCode": "0731",
          "code": 430381,
          "parentCode": 430300,
          "level": 4,
          "children": null,
          "id": 1853,
        },
        {
          "areaName": "韶山市",
          "shortName": "韶山",
          "areaCode": "0731",
          "code": 430382,
          "parentCode": 430300,
          "level": 4,
          "children": null,
          "id": 1854,
        },
        {
          "areaName": "衡阳市",
          "shortName": "衡阳",
          "areaCode": "0734",
          "code": 430400,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1855,
        },
        {
          "areaName": "珠晖区",
          "shortName": "珠晖",
          "areaCode": "0734",
          "code": 430405,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1856,
        },
        {
          "areaName": "雁峰区",
          "shortName": "雁峰",
          "areaCode": "0734",
          "code": 430406,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1857,
        },
        {
          "areaName": "石鼓区",
          "shortName": "石鼓",
          "areaCode": "0734",
          "code": 430407,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1858,
        },
        {
          "areaName": "蒸湘区",
          "shortName": "蒸湘",
          "areaCode": "0734",
          "code": 430408,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1859,
        },
        {
          "areaName": "南岳区",
          "shortName": "南岳",
          "areaCode": "0734",
          "code": 430412,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1860,
        },
        {
          "areaName": "衡阳县",
          "shortName": "衡阳",
          "areaCode": "0734",
          "code": 430421,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1861,
        },
        {
          "areaName": "衡南县",
          "shortName": "衡南",
          "areaCode": "0734",
          "code": 430422,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1862,
        },
        {
          "areaName": "衡山县",
          "shortName": "衡山",
          "areaCode": "0734",
          "code": 430423,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1863,
        },
        {
          "areaName": "衡东县",
          "shortName": "衡东",
          "areaCode": "0734",
          "code": 430424,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1864,
        },
        {
          "areaName": "祁东县",
          "shortName": "祁东",
          "areaCode": "0734",
          "code": 430426,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1865,
        },
        {
          "areaName": "耒阳市",
          "shortName": "耒阳",
          "areaCode": "0734",
          "code": 430481,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1866,
        },
        {
          "areaName": "常宁市",
          "shortName": "常宁",
          "areaCode": "0734",
          "code": 430482,
          "parentCode": 430400,
          "level": 4,
          "children": null,
          "id": 1867,
        },
        {
          "areaName": "邵阳市",
          "shortName": "邵阳",
          "areaCode": "0739",
          "code": 430500,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1868,
        },
        {
          "areaName": "双清区",
          "shortName": "双清",
          "areaCode": "0739",
          "code": 430502,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1869,
        },
        {
          "areaName": "大祥区",
          "shortName": "大祥",
          "areaCode": "0739",
          "code": 430503,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1870,
        },
        {
          "areaName": "北塔区",
          "shortName": "北塔",
          "areaCode": "0739",
          "code": 430511,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1871,
        },
        {
          "areaName": "邵东县",
          "shortName": "邵东",
          "areaCode": "0739",
          "code": 430521,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1872,
        },
        {
          "areaName": "新邵县",
          "shortName": "新邵",
          "areaCode": "0739",
          "code": 430522,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1873,
        },
        {
          "areaName": "邵阳县",
          "shortName": "邵阳",
          "areaCode": "0739",
          "code": 430523,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1874,
        },
        {
          "areaName": "隆回县",
          "shortName": "隆回",
          "areaCode": "0739",
          "code": 430524,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1875,
        },
        {
          "areaName": "洞口县",
          "shortName": "洞口",
          "areaCode": "0739",
          "code": 430525,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1876,
        },
        {
          "areaName": "绥宁县",
          "shortName": "绥宁",
          "areaCode": "0739",
          "code": 430527,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1877,
        },
        {
          "areaName": "新宁县",
          "shortName": "新宁",
          "areaCode": "0739",
          "code": 430528,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1878,
        },
        {
          "areaName": "城步苗族自治县",
          "shortName": "城步",
          "areaCode": "0739",
          "code": 430529,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1879,
        },
        {
          "areaName": "武冈市",
          "shortName": "武冈",
          "areaCode": "0739",
          "code": 430581,
          "parentCode": 430500,
          "level": 4,
          "children": null,
          "id": 1880,
        },
        {
          "areaName": "岳阳市",
          "shortName": "岳阳",
          "areaCode": "0730",
          "code": 430600,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1881,
        },
        {
          "areaName": "岳阳楼区",
          "shortName": "岳阳楼",
          "areaCode": "0730",
          "code": 430602,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1882,
        },
        {
          "areaName": "云溪区",
          "shortName": "云溪",
          "areaCode": "0730",
          "code": 430603,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1883,
        },
        {
          "areaName": "君山区",
          "shortName": "君山",
          "areaCode": "0730",
          "code": 430611,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1884,
        },
        {
          "areaName": "岳阳县",
          "shortName": "岳阳",
          "areaCode": "0730",
          "code": 430621,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1885,
        },
        {
          "areaName": "华容县",
          "shortName": "华容",
          "areaCode": "0730",
          "code": 430623,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1886,
        },
        {
          "areaName": "湘阴县",
          "shortName": "湘阴",
          "areaCode": "0730",
          "code": 430624,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1887,
        },
        {
          "areaName": "平江县",
          "shortName": "平江",
          "areaCode": "0730",
          "code": 430626,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1888,
        },
        {
          "areaName": "汨罗市",
          "shortName": "汨罗",
          "areaCode": "0730",
          "code": 430681,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1889,
        },
        {
          "areaName": "临湘市",
          "shortName": "临湘",
          "areaCode": "0730",
          "code": 430682,
          "parentCode": 430600,
          "level": 4,
          "children": null,
          "id": 1890,
        },
        {
          "areaName": "常德市",
          "shortName": "常德",
          "areaCode": "0736",
          "code": 430700,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1891,
        },
        {
          "areaName": "武陵区",
          "shortName": "武陵",
          "areaCode": "0736",
          "code": 430702,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1892,
        },
        {
          "areaName": "鼎城区",
          "shortName": "鼎城",
          "areaCode": "0736",
          "code": 430703,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1893,
        },
        {
          "areaName": "安乡县",
          "shortName": "安乡",
          "areaCode": "0736",
          "code": 430721,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1894,
        },
        {
          "areaName": "汉寿县",
          "shortName": "汉寿",
          "areaCode": "0736",
          "code": 430722,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1895,
        },
        {
          "areaName": "澧县",
          "shortName": "澧县",
          "areaCode": "0736",
          "code": 430723,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1896,
        },
        {
          "areaName": "临澧县",
          "shortName": "临澧",
          "areaCode": "0736",
          "code": 430724,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1897,
        },
        {
          "areaName": "桃源县",
          "shortName": "桃源",
          "areaCode": "0736",
          "code": 430725,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1898,
        },
        {
          "areaName": "石门县",
          "shortName": "石门",
          "areaCode": "0736",
          "code": 430726,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1899,
        },
        {
          "areaName": "津市市",
          "shortName": "津市",
          "areaCode": "0736",
          "code": 430781,
          "parentCode": 430700,
          "level": 4,
          "children": null,
          "id": 1900,
        },
        {
          "areaName": "张家界市",
          "shortName": "张家界",
          "areaCode": "0744",
          "code": 430800,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1901,
        },
        {
          "areaName": "永定区",
          "shortName": "永定",
          "areaCode": "0744",
          "code": 430802,
          "parentCode": 430800,
          "level": 4,
          "children": null,
          "id": 1902,
        },
        {
          "areaName": "武陵源区",
          "shortName": "武陵源",
          "areaCode": "0744",
          "code": 430811,
          "parentCode": 430800,
          "level": 4,
          "children": null,
          "id": 1903,
        },
        {
          "areaName": "慈利县",
          "shortName": "慈利",
          "areaCode": "0744",
          "code": 430821,
          "parentCode": 430800,
          "level": 4,
          "children": null,
          "id": 1904,
        },
        {
          "areaName": "桑植县",
          "shortName": "桑植",
          "areaCode": "0744",
          "code": 430822,
          "parentCode": 430800,
          "level": 4,
          "children": null,
          "id": 1905,
        },
        {
          "areaName": "益阳市",
          "shortName": "益阳",
          "areaCode": "0737",
          "code": 430900,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1906,
        },
        {
          "areaName": "资阳区",
          "shortName": "资阳",
          "areaCode": "0737",
          "code": 430902,
          "parentCode": 430900,
          "level": 4,
          "children": null,
          "id": 1907,
        },
        {
          "areaName": "赫山区",
          "shortName": "赫山",
          "areaCode": "0737",
          "code": 430903,
          "parentCode": 430900,
          "level": 4,
          "children": null,
          "id": 1908,
        },
        {
          "areaName": "南县",
          "shortName": "南县",
          "areaCode": "0737",
          "code": 430921,
          "parentCode": 430900,
          "level": 4,
          "children": null,
          "id": 1909,
        },
        {
          "areaName": "桃江县",
          "shortName": "桃江",
          "areaCode": "0737",
          "code": 430922,
          "parentCode": 430900,
          "level": 4,
          "children": null,
          "id": 1910,
        },
        {
          "areaName": "安化县",
          "shortName": "安化",
          "areaCode": "0737",
          "code": 430923,
          "parentCode": 430900,
          "level": 4,
          "children": null,
          "id": 1911,
        },
        {
          "areaName": "沅江市",
          "shortName": "沅江",
          "areaCode": "0737",
          "code": 430981,
          "parentCode": 430900,
          "level": 4,
          "children": null,
          "id": 1912,
        },
        {
          "areaName": "郴州市",
          "shortName": "郴州",
          "areaCode": "0735",
          "code": 431000,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1913,
        },
        {
          "areaName": "北湖区",
          "shortName": "北湖",
          "areaCode": "0735",
          "code": 431002,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1914,
        },
        {
          "areaName": "苏仙区",
          "shortName": "苏仙",
          "areaCode": "0735",
          "code": 431003,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1915,
        },
        {
          "areaName": "桂阳县",
          "shortName": "桂阳",
          "areaCode": "0735",
          "code": 431021,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1916,
        },
        {
          "areaName": "宜章县",
          "shortName": "宜章",
          "areaCode": "0735",
          "code": 431022,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1917,
        },
        {
          "areaName": "永兴县",
          "shortName": "永兴",
          "areaCode": "0735",
          "code": 431023,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1918,
        },
        {
          "areaName": "嘉禾县",
          "shortName": "嘉禾",
          "areaCode": "0735",
          "code": 431024,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1919,
        },
        {
          "areaName": "临武县",
          "shortName": "临武",
          "areaCode": "0735",
          "code": 431025,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1920,
        },
        {
          "areaName": "汝城县",
          "shortName": "汝城",
          "areaCode": "0735",
          "code": 431026,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1921,
        },
        {
          "areaName": "桂东县",
          "shortName": "桂东",
          "areaCode": "0735",
          "code": 431027,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1922,
        },
        {
          "areaName": "安仁县",
          "shortName": "安仁",
          "areaCode": "0735",
          "code": 431028,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1923,
        },
        {
          "areaName": "资兴市",
          "shortName": "资兴",
          "areaCode": "0735",
          "code": 431081,
          "parentCode": 431000,
          "level": 4,
          "children": null,
          "id": 1924,
        },
        {
          "areaName": "永州市",
          "shortName": "永州",
          "areaCode": "0746",
          "code": 431100,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1925,
        },
        {
          "areaName": "零陵区",
          "shortName": "零陵",
          "areaCode": "0746",
          "code": 431102,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1926,
        },
        {
          "areaName": "冷水滩区",
          "shortName": "冷水滩",
          "areaCode": "0746",
          "code": 431103,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1927,
        },
        {
          "areaName": "祁阳县",
          "shortName": "祁阳",
          "areaCode": "0746",
          "code": 431121,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1928,
        },
        {
          "areaName": "东安县",
          "shortName": "东安",
          "areaCode": "0746",
          "code": 431122,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1929,
        },
        {
          "areaName": "双牌县",
          "shortName": "双牌",
          "areaCode": "0746",
          "code": 431123,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1930,
        },
        {
          "areaName": "道县",
          "shortName": "道县",
          "areaCode": "0746",
          "code": 431124,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1931,
        },
        {
          "areaName": "江永县",
          "shortName": "江永",
          "areaCode": "0746",
          "code": 431125,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1932,
        },
        {
          "areaName": "宁远县",
          "shortName": "宁远",
          "areaCode": "0746",
          "code": 431126,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1933,
        },
        {
          "areaName": "蓝山县",
          "shortName": "蓝山",
          "areaCode": "0746",
          "code": 431127,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1934,
        },
        {
          "areaName": "新田县",
          "shortName": "新田",
          "areaCode": "0746",
          "code": 431128,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1935,
        },
        {
          "areaName": "江华瑶族自治县",
          "shortName": "江华",
          "areaCode": "0746",
          "code": 431129,
          "parentCode": 431100,
          "level": 4,
          "children": null,
          "id": 1936,
        },
        {
          "areaName": "怀化市",
          "shortName": "怀化",
          "areaCode": "0745",
          "code": 431200,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1937,
        },
        {
          "areaName": "鹤城区",
          "shortName": "鹤城",
          "areaCode": "0745",
          "code": 431202,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1938,
        },
        {
          "areaName": "中方县",
          "shortName": "中方",
          "areaCode": "0745",
          "code": 431221,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1939,
        },
        {
          "areaName": "沅陵县",
          "shortName": "沅陵",
          "areaCode": "0745",
          "code": 431222,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1940,
        },
        {
          "areaName": "辰溪县",
          "shortName": "辰溪",
          "areaCode": "0745",
          "code": 431223,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1941,
        },
        {
          "areaName": "溆浦县",
          "shortName": "溆浦",
          "areaCode": "0745",
          "code": 431224,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1942,
        },
        {
          "areaName": "会同县",
          "shortName": "会同",
          "areaCode": "0745",
          "code": 431225,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1943,
        },
        {
          "areaName": "麻阳苗族自治县",
          "shortName": "麻阳",
          "areaCode": "0745",
          "code": 431226,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1944,
        },
        {
          "areaName": "新晃侗族自治县",
          "shortName": "新晃",
          "areaCode": "0745",
          "code": 431227,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1945,
        },
        {
          "areaName": "芷江侗族自治县",
          "shortName": "芷江",
          "areaCode": "0745",
          "code": 431228,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1946,
        },
        {
          "areaName": "靖州苗族侗族自治县",
          "shortName": "靖州",
          "areaCode": "0745",
          "code": 431229,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1947,
        },
        {
          "areaName": "通道侗族自治县",
          "shortName": "通道",
          "areaCode": "0745",
          "code": 431230,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1948,
        },
        {
          "areaName": "洪江市",
          "shortName": "洪江",
          "areaCode": "0745",
          "code": 431281,
          "parentCode": 431200,
          "level": 4,
          "children": null,
          "id": 1949,
        },
        {
          "areaName": "娄底市",
          "shortName": "娄底",
          "areaCode": "0738",
          "code": 431300,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1950,
        },
        {
          "areaName": "娄星区",
          "shortName": "娄星",
          "areaCode": "0738",
          "code": 431302,
          "parentCode": 431300,
          "level": 4,
          "children": null,
          "id": 1951,
        },
        {
          "areaName": "双峰县",
          "shortName": "双峰",
          "areaCode": "0738",
          "code": 431321,
          "parentCode": 431300,
          "level": 4,
          "children": null,
          "id": 1952,
        },
        {
          "areaName": "新化县",
          "shortName": "新化",
          "areaCode": "0738",
          "code": 431322,
          "parentCode": 431300,
          "level": 4,
          "children": null,
          "id": 1953,
        },
        {
          "areaName": "冷水江市",
          "shortName": "冷水江",
          "areaCode": "0738",
          "code": 431381,
          "parentCode": 431300,
          "level": 4,
          "children": null,
          "id": 1954,
        },
        {
          "areaName": "涟源市",
          "shortName": "涟源",
          "areaCode": "0738",
          "code": 431382,
          "parentCode": 431300,
          "level": 4,
          "children": null,
          "id": 1955,
        },
        {
          "areaName": "湘西土家族苗族自治州",
          "shortName": "湘西",
          "areaCode": "0743",
          "code": 433100,
          "parentCode": 430000,
          "level": 3,
          "children": null,
          "id": 1956,
        },
        {
          "areaName": "吉首市",
          "shortName": "吉首",
          "areaCode": "0743",
          "code": 433101,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1957,
        },
        {
          "areaName": "泸溪县",
          "shortName": "泸溪",
          "areaCode": "0743",
          "code": 433122,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1958,
        },
        {
          "areaName": "凤凰县",
          "shortName": "凤凰",
          "areaCode": "0743",
          "code": 433123,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1959,
        },
        {
          "areaName": "花垣县",
          "shortName": "花垣",
          "areaCode": "0743",
          "code": 433124,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1960,
        },
        {
          "areaName": "保靖县",
          "shortName": "保靖",
          "areaCode": "0743",
          "code": 433125,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1961,
        },
        {
          "areaName": "古丈县",
          "shortName": "古丈",
          "areaCode": "0743",
          "code": 433126,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1962,
        },
        {
          "areaName": "永顺县",
          "shortName": "永顺",
          "areaCode": "0743",
          "code": 433127,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1963,
        },
        {
          "areaName": "龙山县",
          "shortName": "龙山",
          "areaCode": "0743",
          "code": 433130,
          "parentCode": 433100,
          "level": 4,
          "children": null,
          "id": 1964,
        }
      ],
      "id": 1828,
    },
    {
      "areaName": "广东省",
      "shortName": "广东",
      "code": 440000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "广州市",
          "shortName": "广州",
          "areaCode": "020",
          "code": 440100,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 1966,
        },
        {
          "areaName": "荔湾区",
          "shortName": "荔湾",
          "areaCode": "020",
          "code": 440103,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1967,
        },
        {
          "areaName": "越秀区",
          "shortName": "越秀",
          "areaCode": "020",
          "code": 440104,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1968,
        },
        {
          "areaName": "海珠区",
          "shortName": "海珠",
          "areaCode": "020",
          "code": 440105,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1969,
        },
        {
          "areaName": "天河区",
          "shortName": "天河",
          "areaCode": "020",
          "code": 440106,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1970,
        },
        {
          "areaName": "白云区",
          "shortName": "白云",
          "areaCode": "020",
          "code": 440111,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1971,
        },
        {
          "areaName": "黄埔区",
          "shortName": "黄埔",
          "areaCode": "020",
          "code": 440112,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1972,
        },
        {
          "areaName": "番禺区",
          "shortName": "番禺",
          "areaCode": "020",
          "code": 440113,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1973,
        },
        {
          "areaName": "花都区",
          "shortName": "花都",
          "areaCode": "020",
          "code": 440114,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1974,
        },
        {
          "areaName": "南沙区",
          "shortName": "南沙",
          "areaCode": "020",
          "code": 440115,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1975,
        },
        {
          "areaName": "从化区",
          "shortName": "从化",
          "areaCode": "020",
          "code": 440117,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1976,
        },
        {
          "areaName": "增城区",
          "shortName": "增城",
          "areaCode": "020",
          "code": 440118,
          "parentCode": 440100,
          "level": 4,
          "children": null,
          "id": 1977,
        },
        {
          "areaName": "韶关市",
          "shortName": "韶关",
          "areaCode": "0751",
          "code": 440200,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 1978,
        },
        {
          "areaName": "武江区",
          "shortName": "武江",
          "areaCode": "0751",
          "code": 440203,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1979,
        },
        {
          "areaName": "浈江区",
          "shortName": "浈江",
          "areaCode": "0751",
          "code": 440204,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1980,
        },
        {
          "areaName": "曲江区",
          "shortName": "曲江",
          "areaCode": "0751",
          "code": 440205,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1981,
        },
        {
          "areaName": "始兴县",
          "shortName": "始兴",
          "areaCode": "0751",
          "code": 440222,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1982,
        },
        {
          "areaName": "仁化县",
          "shortName": "仁化",
          "areaCode": "0751",
          "code": 440224,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1983,
        },
        {
          "areaName": "翁源县",
          "shortName": "翁源",
          "areaCode": "0751",
          "code": 440229,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1984,
        },
        {
          "areaName": "乳源瑶族自治县",
          "shortName": "乳源",
          "areaCode": "0751",
          "code": 440232,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1985,
        },
        {
          "areaName": "新丰县",
          "shortName": "新丰",
          "areaCode": "0751",
          "code": 440233,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1986,
        },
        {
          "areaName": "乐昌市",
          "shortName": "乐昌",
          "areaCode": "0751",
          "code": 440281,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1987,
        },
        {
          "areaName": "南雄市",
          "shortName": "南雄",
          "areaCode": "0751",
          "code": 440282,
          "parentCode": 440200,
          "level": 4,
          "children": null,
          "id": 1988,
        },
        {
          "areaName": "深圳市",
          "shortName": "深圳",
          "areaCode": "0755",
          "code": 440300,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 1989,
        },
        {
          "areaName": "罗湖区",
          "shortName": "罗湖",
          "areaCode": "0755",
          "code": 440303,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1990,
        },
        {
          "areaName": "福田区",
          "shortName": "福田",
          "areaCode": "0755",
          "code": 440304,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1991,
        },
        {
          "areaName": "南山区",
          "shortName": "南山",
          "areaCode": "0755",
          "code": 440305,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1992,
        },
        {
          "areaName": "宝安区",
          "shortName": "宝安",
          "areaCode": "0755",
          "code": 440306,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1993,
        },
        {
          "areaName": "龙岗区",
          "shortName": "龙岗",
          "areaCode": "0755",
          "code": 440307,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1994,
        },
        {
          "areaName": "盐田区",
          "shortName": "盐田",
          "areaCode": "0755",
          "code": 440308,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1995,
        },
        {
          "areaName": "光明新区",
          "shortName": "光明新区",
          "areaCode": "0755",
          "code": 440309,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1996,
        },
        {
          "areaName": "坪山新区",
          "shortName": "坪山新区",
          "areaCode": "0755",
          "code": 440310,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1997,
        },
        {
          "areaName": "大鹏新区",
          "shortName": "大鹏新区",
          "areaCode": "0755",
          "code": 440311,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1998,
        },
        {
          "areaName": "龙华新区",
          "shortName": "龙华新区",
          "areaCode": "0755",
          "code": 440312,
          "parentCode": 440300,
          "level": 4,
          "children": null,
          "id": 1999,
        },
        {
          "areaName": "珠海市",
          "shortName": "珠海",
          "areaCode": "0756",
          "code": 440400,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2000,
        },
        {
          "areaName": "香洲区",
          "shortName": "香洲",
          "areaCode": "0756",
          "code": 440402,
          "parentCode": 440400,
          "level": 4,
          "children": null,
          "id": 2001,
        },
        {
          "areaName": "斗门区",
          "shortName": "斗门",
          "areaCode": "0756",
          "code": 440403,
          "parentCode": 440400,
          "level": 4,
          "children": null,
          "id": 2002,
        },
        {
          "areaName": "金湾区",
          "shortName": "金湾",
          "areaCode": "0756",
          "code": 440404,
          "parentCode": 440400,
          "level": 4,
          "children": null,
          "id": 2003,
        },
        {
          "areaName": "汕头市",
          "shortName": "汕头",
          "areaCode": "0754",
          "code": 440500,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2004,
        },
        {
          "areaName": "龙湖区",
          "shortName": "龙湖",
          "areaCode": "0754",
          "code": 440507,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2005,
        },
        {
          "areaName": "金平区",
          "shortName": "金平",
          "areaCode": "0754",
          "code": 440511,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2006,
        },
        {
          "areaName": "濠江区",
          "shortName": "濠江",
          "areaCode": "0754",
          "code": 440512,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2007,
        },
        {
          "areaName": "潮阳区",
          "shortName": "潮阳",
          "areaCode": "0754",
          "code": 440513,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2008,
        },
        {
          "areaName": "潮南区",
          "shortName": "潮南",
          "areaCode": "0754",
          "code": 440514,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2009,
        },
        {
          "areaName": "澄海区",
          "shortName": "澄海",
          "areaCode": "0754",
          "code": 440515,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2010,
        },
        {
          "areaName": "南澳县",
          "shortName": "南澳",
          "areaCode": "0754",
          "code": 440523,
          "parentCode": 440500,
          "level": 4,
          "children": null,
          "id": 2011,
        },
        {
          "areaName": "佛山市",
          "shortName": "佛山",
          "areaCode": "0757",
          "code": 440600,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2012,
        },
        {
          "areaName": "禅城区",
          "shortName": "禅城",
          "areaCode": "0757",
          "code": 440604,
          "parentCode": 440600,
          "level": 4,
          "children": null,
          "id": 2013,
        },
        {
          "areaName": "南海区",
          "shortName": "南海",
          "areaCode": "0757",
          "code": 440605,
          "parentCode": 440600,
          "level": 4,
          "children": null,
          "id": 2014,
        },
        {
          "areaName": "顺德区",
          "shortName": "顺德",
          "areaCode": "0757",
          "code": 440606,
          "parentCode": 440600,
          "level": 4,
          "children": null,
          "id": 2015,
        },
        {
          "areaName": "三水区",
          "shortName": "三水",
          "areaCode": "0757",
          "code": 440607,
          "parentCode": 440600,
          "level": 4,
          "children": null,
          "id": 2016,
        },
        {
          "areaName": "高明区",
          "shortName": "高明",
          "areaCode": "0757",
          "code": 440608,
          "parentCode": 440600,
          "level": 4,
          "children": null,
          "id": 2017,
        },
        {
          "areaName": "江门市",
          "shortName": "江门",
          "areaCode": "0750",
          "code": 440700,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2018,
        },
        {
          "areaName": "蓬江区",
          "shortName": "蓬江",
          "areaCode": "0750",
          "code": 440703,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2019,
        },
        {
          "areaName": "江海区",
          "shortName": "江海",
          "areaCode": "0750",
          "code": 440704,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2020,
        },
        {
          "areaName": "新会区",
          "shortName": "新会",
          "areaCode": "0750",
          "code": 440705,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2021,
        },
        {
          "areaName": "台山市",
          "shortName": "台山",
          "areaCode": "0750",
          "code": 440781,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2022,
        },
        {
          "areaName": "开平市",
          "shortName": "开平",
          "areaCode": "0750",
          "code": 440783,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2023,
        },
        {
          "areaName": "鹤山市",
          "shortName": "鹤山",
          "areaCode": "0750",
          "code": 440784,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2024,
        },
        {
          "areaName": "恩平市",
          "shortName": "恩平",
          "areaCode": "0750",
          "code": 440785,
          "parentCode": 440700,
          "level": 4,
          "children": null,
          "id": 2025,
        },
        {
          "areaName": "湛江市",
          "shortName": "湛江",
          "areaCode": "0759",
          "code": 440800,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2026,
        },
        {
          "areaName": "赤坎区",
          "shortName": "赤坎",
          "areaCode": "0759",
          "code": 440802,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2027,
        },
        {
          "areaName": "霞山区",
          "shortName": "霞山",
          "areaCode": "0759",
          "code": 440803,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2028,
        },
        {
          "areaName": "坡头区",
          "shortName": "坡头",
          "areaCode": "0759",
          "code": 440804,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2029,
        },
        {
          "areaName": "麻章区",
          "shortName": "麻章",
          "areaCode": "0759",
          "code": 440811,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2030,
        },
        {
          "areaName": "遂溪县",
          "shortName": "遂溪",
          "areaCode": "0759",
          "code": 440823,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2031,
        },
        {
          "areaName": "徐闻县",
          "shortName": "徐闻",
          "areaCode": "0759",
          "code": 440825,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2032,
        },
        {
          "areaName": "廉江市",
          "shortName": "廉江",
          "areaCode": "0759",
          "code": 440881,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2033,
        },
        {
          "areaName": "雷州市",
          "shortName": "雷州",
          "areaCode": "0759",
          "code": 440882,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2034,
        },
        {
          "areaName": "吴川市",
          "shortName": "吴川",
          "areaCode": "0759",
          "code": 440883,
          "parentCode": 440800,
          "level": 4,
          "children": null,
          "id": 2035,
        },
        {
          "areaName": "茂名市",
          "shortName": "茂名",
          "areaCode": "0668",
          "code": 440900,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2036,
        },
        {
          "areaName": "茂南区",
          "shortName": "茂南",
          "areaCode": "0668",
          "code": 440902,
          "parentCode": 440900,
          "level": 4,
          "children": null,
          "id": 2037,
        },
        {
          "areaName": "电白区",
          "shortName": "电白",
          "areaCode": "0668",
          "code": 440904,
          "parentCode": 440900,
          "level": 4,
          "children": null,
          "id": 2038,
        },
        {
          "areaName": "高州市",
          "shortName": "高州",
          "areaCode": "0668",
          "code": 440981,
          "parentCode": 440900,
          "level": 4,
          "children": null,
          "id": 2039,
        },
        {
          "areaName": "化州市",
          "shortName": "化州",
          "areaCode": "0668",
          "code": 440982,
          "parentCode": 440900,
          "level": 4,
          "children": null,
          "id": 2040,
        },
        {
          "areaName": "信宜市",
          "shortName": "信宜",
          "areaCode": "0668",
          "code": 440983,
          "parentCode": 440900,
          "level": 4,
          "children": null,
          "id": 2041,
        },
        {
          "areaName": "肇庆市",
          "shortName": "肇庆",
          "areaCode": "0758",
          "code": 441200,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2042,
        },
        {
          "areaName": "端州区",
          "shortName": "端州",
          "areaCode": "0758",
          "code": 441202,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2043,
        },
        {
          "areaName": "鼎湖区",
          "shortName": "鼎湖",
          "areaCode": "0758",
          "code": 441203,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2044,
        },
        {
          "areaName": "广宁县",
          "shortName": "广宁",
          "areaCode": "0758",
          "code": 441223,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2045,
        },
        {
          "areaName": "怀集县",
          "shortName": "怀集",
          "areaCode": "0758",
          "code": 441224,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2046,
        },
        {
          "areaName": "封开县",
          "shortName": "封开",
          "areaCode": "0758",
          "code": 441225,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2047,
        },
        {
          "areaName": "德庆县",
          "shortName": "德庆",
          "areaCode": "0758",
          "code": 441226,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2048,
        },
        {
          "areaName": "高要市",
          "shortName": "高要",
          "areaCode": "0758",
          "code": 441283,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2049,
        },
        {
          "areaName": "四会市",
          "shortName": "四会",
          "areaCode": "0758",
          "code": 441284,
          "parentCode": 441200,
          "level": 4,
          "children": null,
          "id": 2050,
        },
        {
          "areaName": "惠州市",
          "shortName": "惠州",
          "areaCode": "0752",
          "code": 441300,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2051,
        },
        {
          "areaName": "惠城区",
          "shortName": "惠城",
          "areaCode": "0752",
          "code": 441302,
          "parentCode": 441300,
          "level": 4,
          "children": null,
          "id": 2052,
        },
        {
          "areaName": "惠阳区",
          "shortName": "惠阳",
          "areaCode": "0752",
          "code": 441303,
          "parentCode": 441300,
          "level": 4,
          "children": null,
          "id": 2053,
        },
        {
          "areaName": "博罗县",
          "shortName": "博罗",
          "areaCode": "0752",
          "code": 441322,
          "parentCode": 441300,
          "level": 4,
          "children": null,
          "id": 2054,
        },
        {
          "areaName": "惠东县",
          "shortName": "惠东",
          "areaCode": "0752",
          "code": 441323,
          "parentCode": 441300,
          "level": 4,
          "children": null,
          "id": 2055,
        },
        {
          "areaName": "龙门县",
          "shortName": "龙门",
          "areaCode": "0752",
          "code": 441324,
          "parentCode": 441300,
          "level": 4,
          "children": null,
          "id": 2056,
        },
        {
          "areaName": "梅州市",
          "shortName": "梅州",
          "areaCode": "0753",
          "code": 441400,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2057,
        },
        {
          "areaName": "梅江区",
          "shortName": "梅江",
          "areaCode": "0753",
          "code": 441402,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2058,
        },
        {
          "areaName": "梅县区",
          "shortName": "梅县",
          "areaCode": "0753",
          "code": 441403,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2059,
        },
        {
          "areaName": "大埔县",
          "shortName": "大埔",
          "areaCode": "0753",
          "code": 441422,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2060,
        },
        {
          "areaName": "丰顺县",
          "shortName": "丰顺",
          "areaCode": "0753",
          "code": 441423,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2061,
        },
        {
          "areaName": "五华县",
          "shortName": "五华",
          "areaCode": "0753",
          "code": 441424,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2062,
        },
        {
          "areaName": "平远县",
          "shortName": "平远",
          "areaCode": "0753",
          "code": 441426,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2063,
        },
        {
          "areaName": "蕉岭县",
          "shortName": "蕉岭",
          "areaCode": "0753",
          "code": 441427,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2064,
        },
        {
          "areaName": "兴宁市",
          "shortName": "兴宁",
          "areaCode": "0753",
          "code": 441481,
          "parentCode": 441400,
          "level": 4,
          "children": null,
          "id": 2065,
        },
        {
          "areaName": "汕尾市",
          "shortName": "汕尾",
          "areaCode": "0660",
          "code": 441500,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2066,
        },
        {
          "areaName": "城区",
          "shortName": "城区",
          "areaCode": "0660",
          "code": 441502,
          "parentCode": 441500,
          "level": 4,
          "children": null,
          "id": 2067,
        },
        {
          "areaName": "海丰县",
          "shortName": "海丰",
          "areaCode": "0660",
          "code": 441521,
          "parentCode": 441500,
          "level": 4,
          "children": null,
          "id": 2068,
        },
        {
          "areaName": "陆河县",
          "shortName": "陆河",
          "areaCode": "0660",
          "code": 441523,
          "parentCode": 441500,
          "level": 4,
          "children": null,
          "id": 2069,
        },
        {
          "areaName": "陆丰市",
          "shortName": "陆丰",
          "areaCode": "0660",
          "code": 441581,
          "parentCode": 441500,
          "level": 4,
          "children": null,
          "id": 2070,
        },
        {
          "areaName": "河源市",
          "shortName": "河源",
          "areaCode": "0762",
          "code": 441600,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2071,
        },
        {
          "areaName": "源城区",
          "shortName": "源城",
          "areaCode": "0762",
          "code": 441602,
          "parentCode": 441600,
          "level": 4,
          "children": null,
          "id": 2072,
        },
        {
          "areaName": "紫金县",
          "shortName": "紫金",
          "areaCode": "0762",
          "code": 441621,
          "parentCode": 441600,
          "level": 4,
          "children": null,
          "id": 2073,
        },
        {
          "areaName": "龙川县",
          "shortName": "龙川",
          "areaCode": "0762",
          "code": 441622,
          "parentCode": 441600,
          "level": 4,
          "children": null,
          "id": 2074,
        },
        {
          "areaName": "连平县",
          "shortName": "连平",
          "areaCode": "0762",
          "code": 441623,
          "parentCode": 441600,
          "level": 4,
          "children": null,
          "id": 2075,
        },
        {
          "areaName": "和平县",
          "shortName": "和平",
          "areaCode": "0762",
          "code": 441624,
          "parentCode": 441600,
          "level": 4,
          "children": null,
          "id": 2076,
        },
        {
          "areaName": "东源县",
          "shortName": "东源",
          "areaCode": "0762",
          "code": 441625,
          "parentCode": 441600,
          "level": 4,
          "children": null,
          "id": 2077,
        },
        {
          "areaName": "阳江市",
          "shortName": "阳江",
          "areaCode": "0662",
          "code": 441700,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2078,
        },
        {
          "areaName": "江城区",
          "shortName": "江城",
          "areaCode": "0662",
          "code": 441702,
          "parentCode": 441700,
          "level": 4,
          "children": null,
          "id": 2079,
        },
        {
          "areaName": "阳东区",
          "shortName": "阳东",
          "areaCode": "0662",
          "code": 441704,
          "parentCode": 441700,
          "level": 4,
          "children": null,
          "id": 2080,
        },
        {
          "areaName": "阳西县",
          "shortName": "阳西",
          "areaCode": "0662",
          "code": 441721,
          "parentCode": 441700,
          "level": 4,
          "children": null,
          "id": 2081,
        },
        {
          "areaName": "阳春市",
          "shortName": "阳春",
          "areaCode": "0662",
          "code": 441781,
          "parentCode": 441700,
          "level": 4,
          "children": null,
          "id": 2082,
        },
        {
          "areaName": "清远市",
          "shortName": "清远",
          "areaCode": "0763",
          "code": 441800,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2083,
        },
        {
          "areaName": "清城区",
          "shortName": "清城",
          "areaCode": "0763",
          "code": 441802,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2084,
        },
        {
          "areaName": "清新区",
          "shortName": "清新",
          "areaCode": "0763",
          "code": 441803,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2085,
        },
        {
          "areaName": "佛冈县",
          "shortName": "佛冈",
          "areaCode": "0763",
          "code": 441821,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2086,
        },
        {
          "areaName": "阳山县",
          "shortName": "阳山",
          "areaCode": "0763",
          "code": 441823,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2087,
        },
        {
          "areaName": "连山壮族瑶族自治县",
          "shortName": "连山",
          "areaCode": "0763",
          "code": 441825,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2088,
        },
        {
          "areaName": "连南瑶族自治县",
          "shortName": "连南",
          "areaCode": "0763",
          "code": 441826,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2089,
        },
        {
          "areaName": "英德市",
          "shortName": "英德",
          "areaCode": "0763",
          "code": 441881,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2090,
        },
        {
          "areaName": "连州市",
          "shortName": "连州",
          "areaCode": "0763",
          "code": 441882,
          "parentCode": 441800,
          "level": 4,
          "children": null,
          "id": 2091,
        },
        {
          "areaName": "东莞市",
          "shortName": "东莞",
          "areaCode": "0769",
          "code": 441900,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2092,
        },
        {
          "areaName": "莞城区",
          "shortName": "莞城",
          "areaCode": "0769",
          "code": 441901,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2093,
        },
        {
          "areaName": "南城区",
          "shortName": "南城",
          "areaCode": "0769",
          "code": 441902,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2094,
        },
        {
          "areaName": "万江区",
          "shortName": "万江",
          "areaCode": "0769",
          "code": 441904,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2095,
        },
        {
          "areaName": "石碣镇",
          "shortName": "石碣",
          "areaCode": "0769",
          "code": 441905,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2096,
        },
        {
          "areaName": "石龙镇",
          "shortName": "石龙",
          "areaCode": "0769",
          "code": 441906,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2097,
        },
        {
          "areaName": "茶山镇",
          "shortName": "茶山",
          "areaCode": "0769",
          "code": 441907,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2098,
        },
        {
          "areaName": "石排镇",
          "shortName": "石排",
          "areaCode": "0769",
          "code": 441908,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2099,
        },
        {
          "areaName": "企石镇",
          "shortName": "企石",
          "areaCode": "0769",
          "code": 441909,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2100,
        },
        {
          "areaName": "横沥镇",
          "shortName": "横沥",
          "areaCode": "0769",
          "code": 441910,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2101,
        },
        {
          "areaName": "桥头镇",
          "shortName": "桥头",
          "areaCode": "0769",
          "code": 441911,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2102,
        },
        {
          "areaName": "谢岗镇",
          "shortName": "谢岗",
          "areaCode": "0769",
          "code": 441912,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2103,
        },
        {
          "areaName": "东坑镇",
          "shortName": "东坑",
          "areaCode": "0769",
          "code": 441913,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2104,
        },
        {
          "areaName": "常平镇",
          "shortName": "常平",
          "areaCode": "0769",
          "code": 441914,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2105,
        },
        {
          "areaName": "寮步镇",
          "shortName": "寮步",
          "areaCode": "0769",
          "code": 441915,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2106,
        },
        {
          "areaName": "大朗镇",
          "shortName": "大朗",
          "areaCode": "0769",
          "code": 441916,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2107,
        },
        {
          "areaName": "麻涌镇",
          "shortName": "麻涌",
          "areaCode": "0769",
          "code": 441917,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2108,
        },
        {
          "areaName": "中堂镇",
          "shortName": "中堂",
          "areaCode": "0769",
          "code": 441918,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2109,
        },
        {
          "areaName": "高埗镇",
          "shortName": "高埗",
          "areaCode": "0769",
          "code": 441919,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2110,
        },
        {
          "areaName": "樟木头镇",
          "shortName": "樟木头",
          "areaCode": "0769",
          "code": 441920,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2111,
        },
        {
          "areaName": "大岭山镇",
          "shortName": "大岭山",
          "areaCode": "0769",
          "code": 441921,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2112,
        },
        {
          "areaName": "望牛墩镇",
          "shortName": "望牛墩",
          "areaCode": "0769",
          "code": 441922,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2113,
        },
        {
          "areaName": "黄江镇",
          "shortName": "黄江",
          "areaCode": "0769",
          "code": 441923,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2114,
        },
        {
          "areaName": "洪梅镇",
          "shortName": "洪梅",
          "areaCode": "0769",
          "code": 441924,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2115,
        },
        {
          "areaName": "清溪镇",
          "shortName": "清溪",
          "areaCode": "0769",
          "code": 441925,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2116,
        },
        {
          "areaName": "沙田镇",
          "shortName": "沙田",
          "areaCode": "0769",
          "code": 441926,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2117,
        },
        {
          "areaName": "道滘镇",
          "shortName": "道滘",
          "areaCode": "0769",
          "code": 441927,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2118,
        },
        {
          "areaName": "塘厦镇",
          "shortName": "塘厦",
          "areaCode": "0769",
          "code": 441928,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2119,
        },
        {
          "areaName": "虎门镇",
          "shortName": "虎门",
          "areaCode": "0769",
          "code": 441929,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2120,
        },
        {
          "areaName": "厚街镇",
          "shortName": "厚街",
          "areaCode": "0769",
          "code": 441930,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2121,
        },
        {
          "areaName": "凤岗镇",
          "shortName": "凤岗",
          "areaCode": "0769",
          "code": 441931,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2122,
        },
        {
          "areaName": "长安镇",
          "shortName": "长安",
          "areaCode": "0769",
          "code": 441932,
          "parentCode": 441900,
          "level": 4,
          "children": null,
          "id": 2123,
        },
        {
          "areaName": "中山市",
          "shortName": "中山",
          "areaCode": "0760",
          "code": 442000,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2124,
        },
        {
          "areaName": "石岐区",
          "shortName": "石岐",
          "areaCode": "0760",
          "code": 442001,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2125,
        },
        {
          "areaName": "南区",
          "shortName": "南区",
          "areaCode": "0760",
          "code": 442004,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2126,
        },
        {
          "areaName": "五桂山区",
          "shortName": "五桂山",
          "areaCode": "0760",
          "code": 442005,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2127,
        },
        {
          "areaName": "火炬开发区",
          "shortName": "火炬",
          "areaCode": "0760",
          "code": 442006,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2128,
        },
        {
          "areaName": "黄圃镇",
          "shortName": "黄圃",
          "areaCode": "0760",
          "code": 442007,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2129,
        },
        {
          "areaName": "南头镇",
          "shortName": "南头",
          "areaCode": "0760",
          "code": 442008,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2130,
        },
        {
          "areaName": "东凤镇",
          "shortName": "东凤",
          "areaCode": "0760",
          "code": 442009,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2131,
        },
        {
          "areaName": "阜沙镇",
          "shortName": "阜沙",
          "areaCode": "0760",
          "code": 442010,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2132,
        },
        {
          "areaName": "小榄镇",
          "shortName": "小榄",
          "areaCode": "0760",
          "code": 442011,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2133,
        },
        {
          "areaName": "东升镇",
          "shortName": "东升",
          "areaCode": "0760",
          "code": 442012,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2134,
        },
        {
          "areaName": "古镇镇",
          "shortName": "古镇",
          "areaCode": "0760",
          "code": 442013,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2135,
        },
        {
          "areaName": "横栏镇",
          "shortName": "横栏",
          "areaCode": "0760",
          "code": 442014,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2136,
        },
        {
          "areaName": "三角镇",
          "shortName": "三角",
          "areaCode": "0760",
          "code": 442015,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2137,
        },
        {
          "areaName": "民众镇",
          "shortName": "民众",
          "areaCode": "0760",
          "code": 442016,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2138,
        },
        {
          "areaName": "南朗镇",
          "shortName": "南朗",
          "areaCode": "0760",
          "code": 442017,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2139,
        },
        {
          "areaName": "港口镇",
          "shortName": "港口",
          "areaCode": "0760",
          "code": 442018,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2140,
        },
        {
          "areaName": "大涌镇",
          "shortName": "大涌",
          "areaCode": "0760",
          "code": 442019,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2141,
        },
        {
          "areaName": "沙溪镇",
          "shortName": "沙溪",
          "areaCode": "0760",
          "code": 442020,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2142,
        },
        {
          "areaName": "三乡镇",
          "shortName": "三乡",
          "areaCode": "0760",
          "code": 442021,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2143,
        },
        {
          "areaName": "板芙镇",
          "shortName": "板芙",
          "areaCode": "0760",
          "code": 442022,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2144,
        },
        {
          "areaName": "神湾镇",
          "shortName": "神湾",
          "areaCode": "0760",
          "code": 442023,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2145,
        },
        {
          "areaName": "坦洲镇",
          "shortName": "坦洲",
          "areaCode": "0760",
          "code": 442024,
          "parentCode": 442000,
          "level": 4,
          "children": null,
          "id": 2146,
        },
        {
          "areaName": "潮州市",
          "shortName": "潮州",
          "areaCode": "0768",
          "code": 445100,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2147,
        },
        {
          "areaName": "湘桥区",
          "shortName": "湘桥",
          "areaCode": "0768",
          "code": 445102,
          "parentCode": 445100,
          "level": 4,
          "children": null,
          "id": 2148,
        },
        {
          "areaName": "潮安区",
          "shortName": "潮安",
          "areaCode": "0768",
          "code": 445103,
          "parentCode": 445100,
          "level": 4,
          "children": null,
          "id": 2149,
        },
        {
          "areaName": "饶平县",
          "shortName": "饶平",
          "areaCode": "0768",
          "code": 445122,
          "parentCode": 445100,
          "level": 4,
          "children": null,
          "id": 2150,
        },
        {
          "areaName": "揭阳市",
          "shortName": "揭阳",
          "areaCode": "0633",
          "code": 445200,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2151,
        },
        {
          "areaName": "榕城区",
          "shortName": "榕城",
          "areaCode": "0633",
          "code": 445202,
          "parentCode": 445200,
          "level": 4,
          "children": null,
          "id": 2152,
        },
        {
          "areaName": "揭东区",
          "shortName": "揭东",
          "areaCode": "0633",
          "code": 445203,
          "parentCode": 445200,
          "level": 4,
          "children": null,
          "id": 2153,
        },
        {
          "areaName": "揭西县",
          "shortName": "揭西",
          "areaCode": "0633",
          "code": 445222,
          "parentCode": 445200,
          "level": 4,
          "children": null,
          "id": 2154,
        },
        {
          "areaName": "惠来县",
          "shortName": "惠来",
          "areaCode": "0633",
          "code": 445224,
          "parentCode": 445200,
          "level": 4,
          "children": null,
          "id": 2155,
        },
        {
          "areaName": "普宁市",
          "shortName": "普宁",
          "areaCode": "0633",
          "code": 445281,
          "parentCode": 445200,
          "level": 4,
          "children": null,
          "id": 2156,
        },
        {
          "areaName": "云浮市",
          "shortName": "云浮",
          "areaCode": "0766",
          "code": 445300,
          "parentCode": 440000,
          "level": 3,
          "children": null,
          "id": 2157,
        },
        {
          "areaName": "云城区",
          "shortName": "云城",
          "areaCode": "0766",
          "code": 445302,
          "parentCode": 445300,
          "level": 4,
          "children": null,
          "id": 2158,
        },
        {
          "areaName": "云安区",
          "shortName": "云安",
          "areaCode": "0766",
          "code": 445303,
          "parentCode": 445300,
          "level": 4,
          "children": null,
          "id": 2159,
        },
        {
          "areaName": "新兴县",
          "shortName": "新兴",
          "areaCode": "0766",
          "code": 445321,
          "parentCode": 445300,
          "level": 4,
          "children": null,
          "id": 2160,
        },
        {
          "areaName": "郁南县",
          "shortName": "郁南",
          "areaCode": "0766",
          "code": 445322,
          "parentCode": 445300,
          "level": 4,
          "children": null,
          "id": 2161,
        },
        {
          "areaName": "罗定市",
          "shortName": "罗定",
          "areaCode": "0766",
          "code": 445381,
          "parentCode": 445300,
          "level": 4,
          "children": null,
          "id": 2162,
        }
      ],
      "id": 1965,
    },
    {
      "areaName": "广西壮族自治区",
      "shortName": "广西",
      "code": 450000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "南宁市",
          "shortName": "南宁",
          "areaCode": "0771",
          "code": 450100,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2164,
        },
        {
          "areaName": "兴宁区",
          "shortName": "兴宁",
          "areaCode": "0771",
          "code": 450102,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2165,
        },
        {
          "areaName": "青秀区",
          "shortName": "青秀",
          "areaCode": "0771",
          "code": 450103,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2166,
        },
        {
          "areaName": "江南区",
          "shortName": "江南",
          "areaCode": "0771",
          "code": 450105,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2167,
        },
        {
          "areaName": "西乡塘区",
          "shortName": "西乡塘",
          "areaCode": "0771",
          "code": 450107,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2168,
        },
        {
          "areaName": "良庆区",
          "shortName": "良庆",
          "areaCode": "0771",
          "code": 450108,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2169,
        },
        {
          "areaName": "邕宁区",
          "shortName": "邕宁",
          "areaCode": "0771",
          "code": 450109,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2170,
        },
        {
          "areaName": "武鸣县",
          "shortName": "武鸣",
          "areaCode": "0771",
          "code": 450122,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2171,
        },
        {
          "areaName": "隆安县",
          "shortName": "隆安",
          "areaCode": "0771",
          "code": 450123,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2172,
        },
        {
          "areaName": "马山县",
          "shortName": "马山",
          "areaCode": "0771",
          "code": 450124,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2173,
        },
        {
          "areaName": "上林县",
          "shortName": "上林",
          "areaCode": "0771",
          "code": 450125,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2174,
        },
        {
          "areaName": "宾阳县",
          "shortName": "宾阳",
          "areaCode": "0771",
          "code": 450126,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2175,
        },
        {
          "areaName": "横县",
          "shortName": "横县",
          "areaCode": "0771",
          "code": 450127,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2176,
        },
        {
          "areaName": "埌东新区",
          "shortName": "埌东",
          "areaCode": "0771",
          "code": 450128,
          "parentCode": 450100,
          "level": 4,
          "children": null,
          "id": 2177,
        },
        {
          "areaName": "柳州市",
          "shortName": "柳州",
          "areaCode": "0772",
          "code": 450200,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2178,
        },
        {
          "areaName": "城中区",
          "shortName": "城中",
          "areaCode": "0772",
          "code": 450202,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2179,
        },
        {
          "areaName": "鱼峰区",
          "shortName": "鱼峰",
          "areaCode": "0772",
          "code": 450203,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2180,
        },
        {
          "areaName": "柳南区",
          "shortName": "柳南",
          "areaCode": "0772",
          "code": 450204,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2181,
        },
        {
          "areaName": "柳北区",
          "shortName": "柳北",
          "areaCode": "0772",
          "code": 450205,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2182,
        },
        {
          "areaName": "柳江县",
          "shortName": "柳江",
          "areaCode": "0772",
          "code": 450221,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2183,
        },
        {
          "areaName": "柳城县",
          "shortName": "柳城",
          "areaCode": "0772",
          "code": 450222,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2184,
        },
        {
          "areaName": "鹿寨县",
          "shortName": "鹿寨",
          "areaCode": "0772",
          "code": 450223,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2185,
        },
        {
          "areaName": "融安县",
          "shortName": "融安",
          "areaCode": "0772",
          "code": 450224,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2186,
        },
        {
          "areaName": "融水苗族自治县",
          "shortName": "融水",
          "areaCode": "0772",
          "code": 450225,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2187,
        },
        {
          "areaName": "三江侗族自治县",
          "shortName": "三江",
          "areaCode": "0772",
          "code": 450226,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2188,
        },
        {
          "areaName": "柳东新区",
          "shortName": "柳东",
          "areaCode": "0772",
          "code": 450227,
          "parentCode": 450200,
          "level": 4,
          "children": null,
          "id": 2189,
        },
        {
          "areaName": "桂林市",
          "shortName": "桂林",
          "areaCode": "0773",
          "code": 450300,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2190,
        },
        {
          "areaName": "秀峰区",
          "shortName": "秀峰",
          "areaCode": "0773",
          "code": 450302,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2191,
        },
        {
          "areaName": "叠彩区",
          "shortName": "叠彩",
          "areaCode": "0773",
          "code": 450303,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2192,
        },
        {
          "areaName": "象山区",
          "shortName": "象山",
          "areaCode": "0773",
          "code": 450304,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2193,
        },
        {
          "areaName": "七星区",
          "shortName": "七星",
          "areaCode": "0773",
          "code": 450305,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2194,
        },
        {
          "areaName": "雁山区",
          "shortName": "雁山",
          "areaCode": "0773",
          "code": 450311,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2195,
        },
        {
          "areaName": "临桂区",
          "shortName": "临桂",
          "areaCode": "0773",
          "code": 450312,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2196,
        },
        {
          "areaName": "阳朔县",
          "shortName": "阳朔",
          "areaCode": "0773",
          "code": 450321,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2197,
        },
        {
          "areaName": "灵川县",
          "shortName": "灵川",
          "areaCode": "0773",
          "code": 450323,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2198,
        },
        {
          "areaName": "全州县",
          "shortName": "全州",
          "areaCode": "0773",
          "code": 450324,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2199,
        },
        {
          "areaName": "兴安县",
          "shortName": "兴安",
          "areaCode": "0773",
          "code": 450325,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2200,
        },
        {
          "areaName": "永福县",
          "shortName": "永福",
          "areaCode": "0773",
          "code": 450326,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2201,
        },
        {
          "areaName": "灌阳县",
          "shortName": "灌阳",
          "areaCode": "0773",
          "code": 450327,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2202,
        },
        {
          "areaName": "龙胜各族自治县",
          "shortName": "龙胜",
          "areaCode": "0773",
          "code": 450328,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2203,
        },
        {
          "areaName": "资源县",
          "shortName": "资源",
          "areaCode": "0773",
          "code": 450329,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2204,
        },
        {
          "areaName": "平乐县",
          "shortName": "平乐",
          "areaCode": "0773",
          "code": 450330,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2205,
        },
        {
          "areaName": "荔浦县",
          "shortName": "荔浦",
          "areaCode": "0773",
          "code": 450331,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2206,
        },
        {
          "areaName": "恭城瑶族自治县",
          "shortName": "恭城",
          "areaCode": "0773",
          "code": 450332,
          "parentCode": 450300,
          "level": 4,
          "children": null,
          "id": 2207,
        },
        {
          "areaName": "梧州市",
          "shortName": "梧州",
          "areaCode": "0774",
          "code": 450400,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2208,
        },
        {
          "areaName": "万秀区",
          "shortName": "万秀",
          "areaCode": "0774",
          "code": 450403,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2209,
        },
        {
          "areaName": "长洲区",
          "shortName": "长洲",
          "areaCode": "0774",
          "code": 450405,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2210,
        },
        {
          "areaName": "龙圩区",
          "shortName": "龙圩",
          "areaCode": "0774",
          "code": 450406,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2211,
        },
        {
          "areaName": "苍梧县",
          "shortName": "苍梧",
          "areaCode": "0774",
          "code": 450421,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2212,
        },
        {
          "areaName": "藤县",
          "shortName": "藤县",
          "areaCode": "0774",
          "code": 450422,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2213,
        },
        {
          "areaName": "蒙山县",
          "shortName": "蒙山",
          "areaCode": "0774",
          "code": 450423,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2214,
        },
        {
          "areaName": "岑溪市",
          "shortName": "岑溪",
          "areaCode": "0774",
          "code": 450481,
          "parentCode": 450400,
          "level": 4,
          "children": null,
          "id": 2215,
        },
        {
          "areaName": "北海市",
          "shortName": "北海",
          "areaCode": "0779",
          "code": 450500,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2216,
        },
        {
          "areaName": "海城区",
          "shortName": "海城",
          "areaCode": "0779",
          "code": 450502,
          "parentCode": 450500,
          "level": 4,
          "children": null,
          "id": 2217,
        },
        {
          "areaName": "银海区",
          "shortName": "银海",
          "areaCode": "0779",
          "code": 450503,
          "parentCode": 450500,
          "level": 4,
          "children": null,
          "id": 2218,
        },
        {
          "areaName": "铁山港区",
          "shortName": "铁山港",
          "areaCode": "0779",
          "code": 450512,
          "parentCode": 450500,
          "level": 4,
          "children": null,
          "id": 2219,
        },
        {
          "areaName": "合浦县",
          "shortName": "合浦",
          "areaCode": "0779",
          "code": 450521,
          "parentCode": 450500,
          "level": 4,
          "children": null,
          "id": 2220,
        },
        {
          "areaName": "防城港市",
          "shortName": "防城港",
          "areaCode": "0770",
          "code": 450600,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2221,
        },
        {
          "areaName": "港口区",
          "shortName": "港口",
          "areaCode": "0770",
          "code": 450602,
          "parentCode": 450600,
          "level": 4,
          "children": null,
          "id": 2222,
        },
        {
          "areaName": "防城区",
          "shortName": "防城",
          "areaCode": "0770",
          "code": 450603,
          "parentCode": 450600,
          "level": 4,
          "children": null,
          "id": 2223,
        },
        {
          "areaName": "上思县",
          "shortName": "上思",
          "areaCode": "0770",
          "code": 450621,
          "parentCode": 450600,
          "level": 4,
          "children": null,
          "id": 2224,
        },
        {
          "areaName": "东兴市",
          "shortName": "东兴",
          "areaCode": "0770",
          "code": 450681,
          "parentCode": 450600,
          "level": 4,
          "children": null,
          "id": 2225,
        },
        {
          "areaName": "钦州市",
          "shortName": "钦州",
          "areaCode": "0777",
          "code": 450700,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2226,
        },
        {
          "areaName": "钦南区",
          "shortName": "钦南",
          "areaCode": "0777",
          "code": 450702,
          "parentCode": 450700,
          "level": 4,
          "children": null,
          "id": 2227,
        },
        {
          "areaName": "钦北区",
          "shortName": "钦北",
          "areaCode": "0777",
          "code": 450703,
          "parentCode": 450700,
          "level": 4,
          "children": null,
          "id": 2228,
        },
        {
          "areaName": "灵山县",
          "shortName": "灵山",
          "areaCode": "0777",
          "code": 450721,
          "parentCode": 450700,
          "level": 4,
          "children": null,
          "id": 2229,
        },
        {
          "areaName": "浦北县",
          "shortName": "浦北",
          "areaCode": "0777",
          "code": 450722,
          "parentCode": 450700,
          "level": 4,
          "children": null,
          "id": 2230,
        },
        {
          "areaName": "贵港市",
          "shortName": "贵港",
          "areaCode": "0775",
          "code": 450800,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2231,
        },
        {
          "areaName": "港北区",
          "shortName": "港北",
          "areaCode": "0775",
          "code": 450802,
          "parentCode": 450800,
          "level": 4,
          "children": null,
          "id": 2232,
        },
        {
          "areaName": "港南区",
          "shortName": "港南",
          "areaCode": "0775",
          "code": 450803,
          "parentCode": 450800,
          "level": 4,
          "children": null,
          "id": 2233,
        },
        {
          "areaName": "覃塘区",
          "shortName": "覃塘",
          "areaCode": "0775",
          "code": 450804,
          "parentCode": 450800,
          "level": 4,
          "children": null,
          "id": 2234,
        },
        {
          "areaName": "平南县",
          "shortName": "平南",
          "areaCode": "0775",
          "code": 450821,
          "parentCode": 450800,
          "level": 4,
          "children": null,
          "id": 2235,
        },
        {
          "areaName": "桂平市",
          "shortName": "桂平",
          "areaCode": "0775",
          "code": 450881,
          "parentCode": 450800,
          "level": 4,
          "children": null,
          "id": 2236,
        },
        {
          "areaName": "玉林市",
          "shortName": "玉林",
          "areaCode": "0775",
          "code": 450900,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2237,
        },
        {
          "areaName": "玉州区",
          "shortName": "玉州",
          "areaCode": "0775",
          "code": 450902,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2238,
        },
        {
          "areaName": "福绵区",
          "shortName": "福绵",
          "areaCode": "0775",
          "code": 450903,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2239,
        },
        {
          "areaName": "玉东新区",
          "shortName": "玉东",
          "areaCode": "0775",
          "code": 450904,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2240,
        },
        {
          "areaName": "容县",
          "shortName": "容县",
          "areaCode": "0775",
          "code": 450921,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2241,
        },
        {
          "areaName": "陆川县",
          "shortName": "陆川",
          "areaCode": "0775",
          "code": 450922,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2242,
        },
        {
          "areaName": "博白县",
          "shortName": "博白",
          "areaCode": "0775",
          "code": 450923,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2243,
        },
        {
          "areaName": "兴业县",
          "shortName": "兴业",
          "areaCode": "0775",
          "code": 450924,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2244,
        },
        {
          "areaName": "北流市",
          "shortName": "北流",
          "areaCode": "0775",
          "code": 450981,
          "parentCode": 450900,
          "level": 4,
          "children": null,
          "id": 2245,
        },
        {
          "areaName": "百色市",
          "shortName": "百色",
          "areaCode": "0776",
          "code": 451000,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2246,
        },
        {
          "areaName": "右江区",
          "shortName": "右江",
          "areaCode": "0776",
          "code": 451002,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2247,
        },
        {
          "areaName": "田阳县",
          "shortName": "田阳",
          "areaCode": "0776",
          "code": 451021,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2248,
        },
        {
          "areaName": "田东县",
          "shortName": "田东",
          "areaCode": "0776",
          "code": 451022,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2249,
        },
        {
          "areaName": "平果县",
          "shortName": "平果",
          "areaCode": "0776",
          "code": 451023,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2250,
        },
        {
          "areaName": "德保县",
          "shortName": "德保",
          "areaCode": "0776",
          "code": 451024,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2251,
        },
        {
          "areaName": "靖西县",
          "shortName": "靖西",
          "areaCode": "0776",
          "code": 451025,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2252,
        },
        {
          "areaName": "那坡县",
          "shortName": "那坡",
          "areaCode": "0776",
          "code": 451026,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2253,
        },
        {
          "areaName": "凌云县",
          "shortName": "凌云",
          "areaCode": "0776",
          "code": 451027,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2254,
        },
        {
          "areaName": "乐业县",
          "shortName": "乐业",
          "areaCode": "0776",
          "code": 451028,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2255,
        },
        {
          "areaName": "田林县",
          "shortName": "田林",
          "areaCode": "0776",
          "code": 451029,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2256,
        },
        {
          "areaName": "西林县",
          "shortName": "西林",
          "areaCode": "0776",
          "code": 451030,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2257,
        },
        {
          "areaName": "隆林各族自治县",
          "shortName": "隆林",
          "areaCode": "0776",
          "code": 451031,
          "parentCode": 451000,
          "level": 4,
          "children": null,
          "id": 2258,
        },
        {
          "areaName": "贺州市",
          "shortName": "贺州",
          "areaCode": "0774",
          "code": 451100,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2259,
        },
        {
          "areaName": "八步区",
          "shortName": "八步",
          "areaCode": "0774",
          "code": 451102,
          "parentCode": 451100,
          "level": 4,
          "children": null,
          "id": 2260,
        },
        {
          "areaName": "昭平县",
          "shortName": "昭平",
          "areaCode": "0774",
          "code": 451121,
          "parentCode": 451100,
          "level": 4,
          "children": null,
          "id": 2261,
        },
        {
          "areaName": "钟山县",
          "shortName": "钟山",
          "areaCode": "0774",
          "code": 451122,
          "parentCode": 451100,
          "level": 4,
          "children": null,
          "id": 2262,
        },
        {
          "areaName": "富川瑶族自治县",
          "shortName": "富川",
          "areaCode": "0774",
          "code": 451123,
          "parentCode": 451100,
          "level": 4,
          "children": null,
          "id": 2263,
        },
        {
          "areaName": "平桂管理区",
          "shortName": "平桂",
          "areaCode": "0774",
          "code": 451124,
          "parentCode": 451100,
          "level": 4,
          "children": null,
          "id": 2264,
        },
        {
          "areaName": "河池市",
          "shortName": "河池",
          "areaCode": "0778",
          "code": 451200,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2265,
        },
        {
          "areaName": "金城江区",
          "shortName": "金城江",
          "areaCode": "0779",
          "code": 451202,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2266,
        },
        {
          "areaName": "南丹县",
          "shortName": "南丹",
          "areaCode": "0781",
          "code": 451221,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2267,
        },
        {
          "areaName": "天峨县",
          "shortName": "天峨",
          "areaCode": "0782",
          "code": 451222,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2268,
        },
        {
          "areaName": "凤山县",
          "shortName": "凤山",
          "areaCode": "0783",
          "code": 451223,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2269,
        },
        {
          "areaName": "东兰县",
          "shortName": "东兰",
          "areaCode": "0784",
          "code": 451224,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2270,
        },
        {
          "areaName": "罗城仫佬族自治县",
          "shortName": "罗城",
          "areaCode": "0785",
          "code": 451225,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2271,
        },
        {
          "areaName": "环江毛南族自治县",
          "shortName": "环江",
          "areaCode": "0786",
          "code": 451226,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2272,
        },
        {
          "areaName": "巴马瑶族自治县",
          "shortName": "巴马",
          "areaCode": "0787",
          "code": 451227,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2273,
        },
        {
          "areaName": "都安瑶族自治县",
          "shortName": "都安",
          "areaCode": "0788",
          "code": 451228,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2274,
        },
        {
          "areaName": "大化瑶族自治县",
          "shortName": "大化",
          "areaCode": "0789",
          "code": 451229,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2275,
        },
        {
          "areaName": "宜州市",
          "shortName": "宜州",
          "areaCode": "0780",
          "code": 451281,
          "parentCode": 451200,
          "level": 4,
          "children": null,
          "id": 2276,
        },
        {
          "areaName": "来宾市",
          "shortName": "来宾",
          "areaCode": "0772",
          "code": 451300,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2277,
        },
        {
          "areaName": "兴宾区",
          "shortName": "兴宾",
          "areaCode": "0772",
          "code": 451302,
          "parentCode": 451300,
          "level": 4,
          "children": null,
          "id": 2278,
        },
        {
          "areaName": "忻城县",
          "shortName": "忻城",
          "areaCode": "0772",
          "code": 451321,
          "parentCode": 451300,
          "level": 4,
          "children": null,
          "id": 2279,
        },
        {
          "areaName": "象州县",
          "shortName": "象州",
          "areaCode": "0772",
          "code": 451322,
          "parentCode": 451300,
          "level": 4,
          "children": null,
          "id": 2280,
        },
        {
          "areaName": "武宣县",
          "shortName": "武宣",
          "areaCode": "0772",
          "code": 451323,
          "parentCode": 451300,
          "level": 4,
          "children": null,
          "id": 2281,
        },
        {
          "areaName": "金秀瑶族自治县",
          "shortName": "金秀",
          "areaCode": "0772",
          "code": 451324,
          "parentCode": 451300,
          "level": 4,
          "children": null,
          "id": 2282,
        },
        {
          "areaName": "合山市",
          "shortName": "合山",
          "areaCode": "0772",
          "code": 451381,
          "parentCode": 451300,
          "level": 4,
          "children": null,
          "id": 2283,
        },
        {
          "areaName": "崇左市",
          "shortName": "崇左",
          "areaCode": "0771",
          "code": 451400,
          "parentCode": 450000,
          "level": 3,
          "children": null,
          "id": 2284,
        },
        {
          "areaName": "江州区",
          "shortName": "江州",
          "areaCode": "0771",
          "code": 451402,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2285,
        },
        {
          "areaName": "扶绥县",
          "shortName": "扶绥",
          "areaCode": "0771",
          "code": 451421,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2286,
        },
        {
          "areaName": "宁明县",
          "shortName": "宁明",
          "areaCode": "0771",
          "code": 451422,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2287,
        },
        {
          "areaName": "龙州县",
          "shortName": "龙州",
          "areaCode": "0771",
          "code": 451423,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2288,
        },
        {
          "areaName": "大新县",
          "shortName": "大新",
          "areaCode": "0771",
          "code": 451424,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2289,
        },
        {
          "areaName": "天等县",
          "shortName": "天等",
          "areaCode": "0771",
          "code": 451425,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2290,
        },
        {
          "areaName": "凭祥市",
          "shortName": "凭祥",
          "areaCode": "0771",
          "code": 451481,
          "parentCode": 451400,
          "level": 4,
          "children": null,
          "id": 2291,
        }
      ],
      "id": 2163,
    },
    {
      "areaName": "海南省",
      "shortName": "海南",
      "code": 460000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "海口市",
          "shortName": "海口",
          "areaCode": "0898",
          "code": 460100,
          "parentCode": 460000,
          "level": 3,
          "children": null,
          "id": 2293,
        },
        {
          "areaName": "秀英区",
          "shortName": "秀英",
          "areaCode": "0898",
          "code": 460105,
          "parentCode": 460100,
          "level": 4,
          "children": null,
          "id": 2294,
        },
        {
          "areaName": "龙华区",
          "shortName": "龙华",
          "areaCode": "0898",
          "code": 460106,
          "parentCode": 460100,
          "level": 4,
          "children": null,
          "id": 2295,
        },
        {
          "areaName": "琼山区",
          "shortName": "琼山",
          "areaCode": "0898",
          "code": 460107,
          "parentCode": 460100,
          "level": 4,
          "children": null,
          "id": 2296,
        },
        {
          "areaName": "美兰区",
          "shortName": "美兰",
          "areaCode": "0898",
          "code": 460108,
          "parentCode": 460100,
          "level": 4,
          "children": null,
          "id": 2297,
        },
        {
          "areaName": "三亚市",
          "shortName": "三亚",
          "areaCode": "0898",
          "code": 460200,
          "parentCode": 460000,
          "level": 3,
          "children": null,
          "id": 2298,
        },
        {
          "areaName": "海棠区",
          "shortName": "海棠",
          "areaCode": "0898",
          "code": 460202,
          "parentCode": 460200,
          "level": 4,
          "children": null,
          "id": 2299,
        },
        {
          "areaName": "吉阳区",
          "shortName": "吉阳",
          "areaCode": "0898",
          "code": 460203,
          "parentCode": 460200,
          "level": 4,
          "children": null,
          "id": 2300,
        },
        {
          "areaName": "天涯区",
          "shortName": "天涯",
          "areaCode": "0898",
          "code": 460204,
          "parentCode": 460200,
          "level": 4,
          "children": null,
          "id": 2301,
        },
        {
          "areaName": "崖州区",
          "shortName": "崖州",
          "areaCode": "0898",
          "code": 460205,
          "parentCode": 460200,
          "level": 4,
          "children": null,
          "id": 2302,
        },
        {
          "areaName": "三沙市",
          "shortName": "三沙",
          "areaCode": "0898",
          "code": 460300,
          "parentCode": 460000,
          "level": 3,
          "children": null,
          "id": 2303,
        },
        {
          "areaName": "西沙群岛",
          "shortName": "西沙",
          "areaCode": "0898",
          "code": 460321,
          "parentCode": 460300,
          "level": 4,
          "children": null,
          "id": 2304,
        },
        {
          "areaName": "南沙群岛",
          "shortName": "南沙",
          "areaCode": "0898",
          "code": 460322,
          "parentCode": 460300,
          "level": 4,
          "children": null,
          "id": 2305,
        },
        {
          "areaName": "中沙群岛",
          "shortName": "中沙",
          "areaCode": "0898",
          "code": 460323,
          "parentCode": 460300,
          "level": 4,
          "children": null,
          "id": 2306,
        },
        {
          "areaName": "直辖县级",
          "shortName": "",
          "code": 469000,
          "parentCode": 460000,
          "level": 3,
          "children": null,
          "id": 2307,
        },
        {
          "areaName": "五指山市",
          "shortName": "五指山",
          "areaCode": "0898",
          "code": 469001,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2308,
        },
        {
          "areaName": "琼海市",
          "shortName": "琼海",
          "areaCode": "0898",
          "code": 469002,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2309,
        },
        {
          "areaName": "儋州市",
          "shortName": "儋州",
          "areaCode": "0898",
          "code": 469003,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2310,
        },
        {
          "areaName": "文昌市",
          "shortName": "文昌",
          "areaCode": "0898",
          "code": 469005,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2311,
        },
        {
          "areaName": "万宁市",
          "shortName": "万宁",
          "areaCode": "0898",
          "code": 469006,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2312,
        },
        {
          "areaName": "东方市",
          "shortName": "东方",
          "areaCode": "0898",
          "code": 469007,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2313,
        },
        {
          "areaName": "定安县",
          "shortName": "定安",
          "areaCode": "0898",
          "code": 469021,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2314,
        },
        {
          "areaName": "屯昌县",
          "shortName": "屯昌",
          "areaCode": "0898",
          "code": 469022,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2315,
        },
        {
          "areaName": "澄迈县",
          "shortName": "澄迈",
          "areaCode": "0898",
          "code": 469023,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2316,
        },
        {
          "areaName": "临高县",
          "shortName": "临高",
          "areaCode": "0898",
          "code": 469024,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2317,
        },
        {
          "areaName": "白沙黎族自治县",
          "shortName": "白沙",
          "areaCode": "0898",
          "code": 469025,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2318,
        },
        {
          "areaName": "昌江黎族自治县",
          "shortName": "昌江",
          "areaCode": "0898",
          "code": 469026,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2319,
        },
        {
          "areaName": "乐东黎族自治县",
          "shortName": "乐东",
          "areaCode": "0898",
          "code": 469027,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2320,
        },
        {
          "areaName": "陵水黎族自治县",
          "shortName": "陵水",
          "areaCode": "0898",
          "code": 469028,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2321,
        },
        {
          "areaName": "保亭黎族苗族自治县",
          "shortName": "保亭",
          "areaCode": "0898",
          "code": 469029,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2322,
        },
        {
          "areaName": "琼中黎族苗族自治县",
          "shortName": "琼中",
          "areaCode": "0898",
          "code": 469030,
          "parentCode": 469000,
          "level": 4,
          "children": null,
          "id": 2323,
        }
      ],
      "id": 2292,
    },
    {
      "areaName": "重庆",
      "shortName": "重庆",
      "code": 500000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "重庆市",
          "shortName": "重庆",
          "areaCode": "023",
          "code": 500100,
          "parentCode": 500000,
          "level": 3,
          "children": null,
          "id": 2325,
        },
        {
          "areaName": "万州区",
          "shortName": "万州",
          "areaCode": "023",
          "code": 500101,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2326,
        },
        {
          "areaName": "涪陵区",
          "shortName": "涪陵",
          "areaCode": "023",
          "code": 500102,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2327,
        },
        {
          "areaName": "渝中区",
          "shortName": "渝中",
          "areaCode": "023",
          "code": 500103,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2328,
        },
        {
          "areaName": "大渡口区",
          "shortName": "大渡口",
          "areaCode": "023",
          "code": 500104,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2329,
        },
        {
          "areaName": "江北区",
          "shortName": "江北",
          "areaCode": "023",
          "code": 500105,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2330,
        },
        {
          "areaName": "沙坪坝区",
          "shortName": "沙坪坝",
          "areaCode": "023",
          "code": 500106,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2331,
        },
        {
          "areaName": "九龙坡区",
          "shortName": "九龙坡",
          "areaCode": "023",
          "code": 500107,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2332,
        },
        {
          "areaName": "南岸区",
          "shortName": "南岸",
          "areaCode": "023",
          "code": 500108,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2333,
        },
        {
          "areaName": "北碚区",
          "shortName": "北碚",
          "areaCode": "023",
          "code": 500109,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2334,
        },
        {
          "areaName": "綦江区",
          "shortName": "綦江",
          "areaCode": "023",
          "code": 500110,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2335,
        },
        {
          "areaName": "大足区",
          "shortName": "大足",
          "areaCode": "023",
          "code": 500111,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2336,
        },
        {
          "areaName": "渝北区",
          "shortName": "渝北",
          "areaCode": "023",
          "code": 500112,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2337,
        },
        {
          "areaName": "巴南区",
          "shortName": "巴南",
          "areaCode": "023",
          "code": 500113,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2338,
        },
        {
          "areaName": "黔江区",
          "shortName": "黔江",
          "areaCode": "023",
          "code": 500114,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2339,
        },
        {
          "areaName": "长寿区",
          "shortName": "长寿",
          "areaCode": "023",
          "code": 500115,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2340,
        },
        {
          "areaName": "江津区",
          "shortName": "江津",
          "areaCode": "023",
          "code": 500116,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2341,
        },
        {
          "areaName": "合川区",
          "shortName": "合川",
          "areaCode": "023",
          "code": 500117,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2342,
        },
        {
          "areaName": "永川区",
          "shortName": "永川",
          "areaCode": "023",
          "code": 500118,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2343,
        },
        {
          "areaName": "南川区",
          "shortName": "南川",
          "areaCode": "023",
          "code": 500119,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2344,
        },
        {
          "areaName": "璧山区",
          "shortName": "璧山",
          "areaCode": "023",
          "code": 500120,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2345,
        },
        {
          "areaName": "铜梁区",
          "shortName": "铜梁",
          "areaCode": "023",
          "code": 500151,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2346,
        },
        {
          "areaName": "潼南县",
          "shortName": "潼南",
          "areaCode": "023",
          "code": 500223,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2347,
        },
        {
          "areaName": "荣昌县",
          "shortName": "荣昌",
          "areaCode": "023",
          "code": 500226,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2348,
        },
        {
          "areaName": "梁平县",
          "shortName": "梁平",
          "areaCode": "023",
          "code": 500228,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2349,
        },
        {
          "areaName": "城口县",
          "shortName": "城口",
          "areaCode": "023",
          "code": 500229,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2350,
        },
        {
          "areaName": "丰都县",
          "shortName": "丰都",
          "areaCode": "023",
          "code": 500230,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2351,
        },
        {
          "areaName": "垫江县",
          "shortName": "垫江",
          "areaCode": "023",
          "code": 500231,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2352,
        },
        {
          "areaName": "武隆县",
          "shortName": "武隆",
          "areaCode": "023",
          "code": 500232,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2353,
        },
        {
          "areaName": "忠县",
          "shortName": "忠县",
          "areaCode": "023",
          "code": 500233,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2354,
        },
        {
          "areaName": "开县",
          "shortName": "开县",
          "areaCode": "023",
          "code": 500234,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2355,
        },
        {
          "areaName": "云阳县",
          "shortName": "云阳",
          "areaCode": "023",
          "code": 500235,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2356,
        },
        {
          "areaName": "奉节县",
          "shortName": "奉节",
          "areaCode": "023",
          "code": 500236,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2357,
        },
        {
          "areaName": "巫山县",
          "shortName": "巫山",
          "areaCode": "023",
          "code": 500237,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2358,
        },
        {
          "areaName": "巫溪县",
          "shortName": "巫溪",
          "areaCode": "023",
          "code": 500238,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2359,
        },
        {
          "areaName": "石柱土家族自治县",
          "shortName": "石柱",
          "areaCode": "023",
          "code": 500240,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2360,
        },
        {
          "areaName": "秀山土家族苗族自治县",
          "shortName": "秀山",
          "areaCode": "023",
          "code": 500241,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2361,
        },
        {
          "areaName": "酉阳土家族苗族自治县",
          "shortName": "酉阳",
          "areaCode": "023",
          "code": 500242,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2362,
        },
        {
          "areaName": "彭水苗族土家族自治县",
          "shortName": "彭水",
          "areaCode": "023",
          "code": 500243,
          "parentCode": 500100,
          "level": 4,
          "children": null,
          "id": 2363,
        },
        {
          "areaName": "两江新区",
          "shortName": "两江新区",
          "areaCode": "023",
          "code": 500300,
          "parentCode": 500000,
          "level": 3,
          "children": null,
          "id": 2364,
        },
        {
          "areaName": "北部新区",
          "shortName": "北部新区",
          "areaCode": "023",
          "code": 500301,
          "parentCode": 500300,
          "level": 4,
          "children": null,
          "id": 2365,
        },
        {
          "areaName": "保税港区",
          "shortName": "保税港区",
          "areaCode": "023",
          "code": 500302,
          "parentCode": 500300,
          "level": 4,
          "children": null,
          "id": 2366,
        },
        {
          "areaName": "工业园区",
          "shortName": "工业园区",
          "areaCode": "023",
          "code": 500303,
          "parentCode": 500300,
          "level": 4,
          "children": null,
          "id": 2367,
        }
      ],
      "id": 2324,
    },
    {
      "areaName": "四川省",
      "shortName": "四川",
      "code": 510000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "成都市",
          "shortName": "成都",
          "areaCode": "028",
          "code": 510100,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2369,
        },
        {
          "areaName": "锦江区",
          "shortName": "锦江",
          "areaCode": "028",
          "code": 510104,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2370,
        },
        {
          "areaName": "青羊区",
          "shortName": "青羊",
          "areaCode": "028",
          "code": 510105,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2371,
        },
        {
          "areaName": "金牛区",
          "shortName": "金牛",
          "areaCode": "028",
          "code": 510106,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2372,
        },
        {
          "areaName": "武侯区",
          "shortName": "武侯",
          "areaCode": "028",
          "code": 510107,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2373,
        },
        {
          "areaName": "成华区",
          "shortName": "成华",
          "areaCode": "028",
          "code": 510108,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2374,
        },
        {
          "areaName": "龙泉驿区",
          "shortName": "龙泉驿",
          "areaCode": "028",
          "code": 510112,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2375,
        },
        {
          "areaName": "青白江区",
          "shortName": "青白江",
          "areaCode": "028",
          "code": 510113,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2376,
        },
        {
          "areaName": "新都区",
          "shortName": "新都",
          "areaCode": "028",
          "code": 510114,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2377,
        },
        {
          "areaName": "温江区",
          "shortName": "温江",
          "areaCode": "028",
          "code": 510115,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2378,
        },
        {
          "areaName": "金堂县",
          "shortName": "金堂",
          "areaCode": "028",
          "code": 510121,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2379,
        },
        {
          "areaName": "双流县",
          "shortName": "双流",
          "areaCode": "028",
          "code": 510122,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2380,
        },
        {
          "areaName": "郫县",
          "shortName": "郫县",
          "areaCode": "028",
          "code": 510124,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2381,
        },
        {
          "areaName": "大邑县",
          "shortName": "大邑",
          "areaCode": "028",
          "code": 510129,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2382,
        },
        {
          "areaName": "蒲江县",
          "shortName": "蒲江",
          "areaCode": "028",
          "code": 510131,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2383,
        },
        {
          "areaName": "新津县",
          "shortName": "新津",
          "areaCode": "028",
          "code": 510132,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2384,
        },
        {
          "areaName": "都江堰市",
          "shortName": "都江堰",
          "areaCode": "028",
          "code": 510181,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2385,
        },
        {
          "areaName": "彭州市",
          "shortName": "彭州",
          "areaCode": "028",
          "code": 510182,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2386,
        },
        {
          "areaName": "邛崃市",
          "shortName": "邛崃",
          "areaCode": "028",
          "code": 510183,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2387,
        },
        {
          "areaName": "崇州市",
          "shortName": "崇州",
          "areaCode": "028",
          "code": 510184,
          "parentCode": 510100,
          "level": 4,
          "children": null,
          "id": 2388,
        },
        {
          "areaName": "自贡市",
          "shortName": "自贡",
          "areaCode": "0813",
          "code": 510300,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2389,
        },
        {
          "areaName": "自流井区",
          "shortName": "自流井",
          "areaCode": "0813",
          "code": 510302,
          "parentCode": 510300,
          "level": 4,
          "children": null,
          "id": 2390,
        },
        {
          "areaName": "贡井区",
          "shortName": "贡井",
          "areaCode": "0813",
          "code": 510303,
          "parentCode": 510300,
          "level": 4,
          "children": null,
          "id": 2391,
        },
        {
          "areaName": "大安区",
          "shortName": "大安",
          "areaCode": "0813",
          "code": 510304,
          "parentCode": 510300,
          "level": 4,
          "children": null,
          "id": 2392,
        },
        {
          "areaName": "沿滩区",
          "shortName": "沿滩",
          "areaCode": "0813",
          "code": 510311,
          "parentCode": 510300,
          "level": 4,
          "children": null,
          "id": 2393,
        },
        {
          "areaName": "荣县",
          "shortName": "荣县",
          "areaCode": "0813",
          "code": 510321,
          "parentCode": 510300,
          "level": 4,
          "children": null,
          "id": 2394,
        },
        {
          "areaName": "富顺县",
          "shortName": "富顺",
          "areaCode": "0813",
          "code": 510322,
          "parentCode": 510300,
          "level": 4,
          "children": null,
          "id": 2395,
        },
        {
          "areaName": "攀枝花市",
          "shortName": "攀枝花",
          "areaCode": "0812",
          "code": 510400,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2396,
        },
        {
          "areaName": "东区",
          "shortName": "东区",
          "areaCode": "0812",
          "code": 510402,
          "parentCode": 510400,
          "level": 4,
          "children": null,
          "id": 2397,
        },
        {
          "areaName": "西区",
          "shortName": "西区",
          "areaCode": "0812",
          "code": 510403,
          "parentCode": 510400,
          "level": 4,
          "children": null,
          "id": 2398,
        },
        {
          "areaName": "仁和区",
          "shortName": "仁和",
          "areaCode": "0812",
          "code": 510411,
          "parentCode": 510400,
          "level": 4,
          "children": null,
          "id": 2399,
        },
        {
          "areaName": "米易县",
          "shortName": "米易",
          "areaCode": "0812",
          "code": 510421,
          "parentCode": 510400,
          "level": 4,
          "children": null,
          "id": 2400,
        },
        {
          "areaName": "盐边县",
          "shortName": "盐边",
          "areaCode": "0812",
          "code": 510422,
          "parentCode": 510400,
          "level": 4,
          "children": null,
          "id": 2401,
        },
        {
          "areaName": "泸州市",
          "shortName": "泸州",
          "areaCode": "0830",
          "code": 510500,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2402,
        },
        {
          "areaName": "江阳区",
          "shortName": "江阳",
          "areaCode": "0830",
          "code": 510502,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2403,
        },
        {
          "areaName": "纳溪区",
          "shortName": "纳溪",
          "areaCode": "0830",
          "code": 510503,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2404,
        },
        {
          "areaName": "龙马潭区",
          "shortName": "龙马潭",
          "areaCode": "0830",
          "code": 510504,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2405,
        },
        {
          "areaName": "泸县",
          "shortName": "泸县",
          "areaCode": "0830",
          "code": 510521,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2406,
        },
        {
          "areaName": "合江县",
          "shortName": "合江",
          "areaCode": "0830",
          "code": 510522,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2407,
        },
        {
          "areaName": "叙永县",
          "shortName": "叙永",
          "areaCode": "0830",
          "code": 510524,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2408,
        },
        {
          "areaName": "古蔺县",
          "shortName": "古蔺",
          "areaCode": "0830",
          "code": 510525,
          "parentCode": 510500,
          "level": 4,
          "children": null,
          "id": 2409,
        },
        {
          "areaName": "德阳市",
          "shortName": "德阳",
          "areaCode": "0838",
          "code": 510600,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2410,
        },
        {
          "areaName": "旌阳区",
          "shortName": "旌阳",
          "areaCode": "0838",
          "code": 510603,
          "parentCode": 510600,
          "level": 4,
          "children": null,
          "id": 2411,
        },
        {
          "areaName": "中江县",
          "shortName": "中江",
          "areaCode": "0838",
          "code": 510623,
          "parentCode": 510600,
          "level": 4,
          "children": null,
          "id": 2412,
        },
        {
          "areaName": "罗江县",
          "shortName": "罗江",
          "areaCode": "0838",
          "code": 510626,
          "parentCode": 510600,
          "level": 4,
          "children": null,
          "id": 2413,
        },
        {
          "areaName": "广汉市",
          "shortName": "广汉",
          "areaCode": "0838",
          "code": 510681,
          "parentCode": 510600,
          "level": 4,
          "children": null,
          "id": 2414,
        },
        {
          "areaName": "什邡市",
          "shortName": "什邡",
          "areaCode": "0838",
          "code": 510682,
          "parentCode": 510600,
          "level": 4,
          "children": null,
          "id": 2415,
        },
        {
          "areaName": "绵竹市",
          "shortName": "绵竹",
          "areaCode": "0838",
          "code": 510683,
          "parentCode": 510600,
          "level": 4,
          "children": null,
          "id": 2416,
        },
        {
          "areaName": "绵阳市",
          "shortName": "绵阳",
          "areaCode": "0816",
          "code": 510700,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2417,
        },
        {
          "areaName": "涪城区",
          "shortName": "涪城",
          "areaCode": "0816",
          "code": 510703,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2418,
        },
        {
          "areaName": "游仙区",
          "shortName": "游仙",
          "areaCode": "0816",
          "code": 510704,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2419,
        },
        {
          "areaName": "三台县",
          "shortName": "三台",
          "areaCode": "0816",
          "code": 510722,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2420,
        },
        {
          "areaName": "盐亭县",
          "shortName": "盐亭",
          "areaCode": "0816",
          "code": 510723,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2421,
        },
        {
          "areaName": "安县",
          "shortName": "安县",
          "areaCode": "0816",
          "code": 510724,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2422,
        },
        {
          "areaName": "梓潼县",
          "shortName": "梓潼",
          "areaCode": "0816",
          "code": 510725,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2423,
        },
        {
          "areaName": "北川羌族自治县",
          "shortName": "北川",
          "areaCode": "0816",
          "code": 510726,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2424,
        },
        {
          "areaName": "平武县",
          "shortName": "平武",
          "areaCode": "0816",
          "code": 510727,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2425,
        },
        {
          "areaName": "江油市",
          "shortName": "江油",
          "areaCode": "0816",
          "code": 510781,
          "parentCode": 510700,
          "level": 4,
          "children": null,
          "id": 2426,
        },
        {
          "areaName": "广元市",
          "shortName": "广元",
          "areaCode": "0839",
          "code": 510800,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2427,
        },
        {
          "areaName": "利州区",
          "shortName": "利州",
          "areaCode": "0839",
          "code": 510802,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2428,
        },
        {
          "areaName": "昭化区",
          "shortName": "昭化",
          "areaCode": "0839",
          "code": 510811,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2429,
        },
        {
          "areaName": "朝天区",
          "shortName": "朝天",
          "areaCode": "0839",
          "code": 510812,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2430,
        },
        {
          "areaName": "旺苍县",
          "shortName": "旺苍",
          "areaCode": "0839",
          "code": 510821,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2431,
        },
        {
          "areaName": "青川县",
          "shortName": "青川",
          "areaCode": "0839",
          "code": 510822,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2432,
        },
        {
          "areaName": "剑阁县",
          "shortName": "剑阁",
          "areaCode": "0839",
          "code": 510823,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2433,
        },
        {
          "areaName": "苍溪县",
          "shortName": "苍溪",
          "areaCode": "0839",
          "code": 510824,
          "parentCode": 510800,
          "level": 4,
          "children": null,
          "id": 2434,
        },
        {
          "areaName": "遂宁市",
          "shortName": "遂宁",
          "areaCode": "0825",
          "code": 510900,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2435,
        },
        {
          "areaName": "船山区",
          "shortName": "船山",
          "areaCode": "0825",
          "code": 510903,
          "parentCode": 510900,
          "level": 4,
          "children": null,
          "id": 2436,
        },
        {
          "areaName": "安居区",
          "shortName": "安居",
          "areaCode": "0825",
          "code": 510904,
          "parentCode": 510900,
          "level": 4,
          "children": null,
          "id": 2437,
        },
        {
          "areaName": "蓬溪县",
          "shortName": "蓬溪",
          "areaCode": "0825",
          "code": 510921,
          "parentCode": 510900,
          "level": 4,
          "children": null,
          "id": 2438,
        },
        {
          "areaName": "射洪县",
          "shortName": "射洪",
          "areaCode": "0825",
          "code": 510922,
          "parentCode": 510900,
          "level": 4,
          "children": null,
          "id": 2439,
        },
        {
          "areaName": "大英县",
          "shortName": "大英",
          "areaCode": "0825",
          "code": 510923,
          "parentCode": 510900,
          "level": 4,
          "children": null,
          "id": 2440,
        },
        {
          "areaName": "内江市",
          "shortName": "内江",
          "areaCode": "0832",
          "code": 511000,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2441,
        },
        {
          "areaName": "市中区",
          "shortName": "市中区",
          "areaCode": "0832",
          "code": 511002,
          "parentCode": 511000,
          "level": 4,
          "children": null,
          "id": 2442,
        },
        {
          "areaName": "东兴区",
          "shortName": "东兴",
          "areaCode": "0832",
          "code": 511011,
          "parentCode": 511000,
          "level": 4,
          "children": null,
          "id": 2443,
        },
        {
          "areaName": "威远县",
          "shortName": "威远",
          "areaCode": "0832",
          "code": 511024,
          "parentCode": 511000,
          "level": 4,
          "children": null,
          "id": 2444,
        },
        {
          "areaName": "资中县",
          "shortName": "资中",
          "areaCode": "0832",
          "code": 511025,
          "parentCode": 511000,
          "level": 4,
          "children": null,
          "id": 2445,
        },
        {
          "areaName": "隆昌县",
          "shortName": "隆昌",
          "areaCode": "0832",
          "code": 511028,
          "parentCode": 511000,
          "level": 4,
          "children": null,
          "id": 2446,
        },
        {
          "areaName": "乐山市",
          "shortName": "乐山",
          "areaCode": "0833",
          "code": 511100,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2447,
        },
        {
          "areaName": "市中区",
          "shortName": "市中区",
          "areaCode": "0833",
          "code": 511102,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2448,
        },
        {
          "areaName": "沙湾区",
          "shortName": "沙湾",
          "areaCode": "0833",
          "code": 511111,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2449,
        },
        {
          "areaName": "五通桥区",
          "shortName": "五通桥",
          "areaCode": "0833",
          "code": 511112,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2450,
        },
        {
          "areaName": "金口河区",
          "shortName": "金口河",
          "areaCode": "0833",
          "code": 511113,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2451,
        },
        {
          "areaName": "犍为县",
          "shortName": "犍为",
          "areaCode": "0833",
          "code": 511123,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2452,
        },
        {
          "areaName": "井研县",
          "shortName": "井研",
          "areaCode": "0833",
          "code": 511124,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2453,
        },
        {
          "areaName": "夹江县",
          "shortName": "夹江",
          "areaCode": "0833",
          "code": 511126,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2454,
        },
        {
          "areaName": "沐川县",
          "shortName": "沐川",
          "areaCode": "0833",
          "code": 511129,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2455,
        },
        {
          "areaName": "峨边彝族自治县",
          "shortName": "峨边",
          "areaCode": "0833",
          "code": 511132,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2456,
        },
        {
          "areaName": "马边彝族自治县",
          "shortName": "马边",
          "areaCode": "0833",
          "code": 511133,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2457,
        },
        {
          "areaName": "峨眉山市",
          "shortName": "峨眉山",
          "areaCode": "0833",
          "code": 511181,
          "parentCode": 511100,
          "level": 4,
          "children": null,
          "id": 2458,
        },
        {
          "areaName": "南充市",
          "shortName": "南充",
          "areaCode": "0817",
          "code": 511300,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2459,
        },
        {
          "areaName": "顺庆区",
          "shortName": "顺庆",
          "areaCode": "0817",
          "code": 511302,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2460,
        },
        {
          "areaName": "高坪区",
          "shortName": "高坪",
          "areaCode": "0817",
          "code": 511303,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2461,
        },
        {
          "areaName": "嘉陵区",
          "shortName": "嘉陵",
          "areaCode": "0817",
          "code": 511304,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2462,
        },
        {
          "areaName": "南部县",
          "shortName": "南部",
          "areaCode": "0817",
          "code": 511321,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2463,
        },
        {
          "areaName": "营山县",
          "shortName": "营山",
          "areaCode": "0817",
          "code": 511322,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2464,
        },
        {
          "areaName": "蓬安县",
          "shortName": "蓬安",
          "areaCode": "0817",
          "code": 511323,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2465,
        },
        {
          "areaName": "仪陇县",
          "shortName": "仪陇",
          "areaCode": "0817",
          "code": 511324,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2466,
        },
        {
          "areaName": "西充县",
          "shortName": "西充",
          "areaCode": "0817",
          "code": 511325,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2467,
        },
        {
          "areaName": "阆中市",
          "shortName": "阆中",
          "areaCode": "0817",
          "code": 511381,
          "parentCode": 511300,
          "level": 4,
          "children": null,
          "id": 2468,
        },
        {
          "areaName": "眉山市",
          "shortName": "眉山",
          "areaCode": "028",
          "code": 511400,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2469,
        },
        {
          "areaName": "东坡区",
          "shortName": "东坡",
          "areaCode": "028",
          "code": 511402,
          "parentCode": 511400,
          "level": 4,
          "children": null,
          "id": 2470,
        },
        {
          "areaName": "彭山区",
          "shortName": "彭山",
          "areaCode": "028",
          "code": 511403,
          "parentCode": 511400,
          "level": 4,
          "children": null,
          "id": 2471,
        },
        {
          "areaName": "仁寿县",
          "shortName": "仁寿",
          "areaCode": "028",
          "code": 511421,
          "parentCode": 511400,
          "level": 4,
          "children": null,
          "id": 2472,
        },
        {
          "areaName": "洪雅县",
          "shortName": "洪雅",
          "areaCode": "028",
          "code": 511423,
          "parentCode": 511400,
          "level": 4,
          "children": null,
          "id": 2473,
        },
        {
          "areaName": "丹棱县",
          "shortName": "丹棱",
          "areaCode": "028",
          "code": 511424,
          "parentCode": 511400,
          "level": 4,
          "children": null,
          "id": 2474,
        },
        {
          "areaName": "青神县",
          "shortName": "青神",
          "areaCode": "028",
          "code": 511425,
          "parentCode": 511400,
          "level": 4,
          "children": null,
          "id": 2475,
        },
        {
          "areaName": "宜宾市",
          "shortName": "宜宾",
          "areaCode": "0831",
          "code": 511500,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2476,
        },
        {
          "areaName": "翠屏区",
          "shortName": "翠屏",
          "areaCode": "0831",
          "code": 511502,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2477,
        },
        {
          "areaName": "南溪区",
          "shortName": "南溪",
          "areaCode": "0831",
          "code": 511503,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2478,
        },
        {
          "areaName": "宜宾县",
          "shortName": "宜宾",
          "areaCode": "0831",
          "code": 511521,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2479,
        },
        {
          "areaName": "江安县",
          "shortName": "江安",
          "areaCode": "0831",
          "code": 511523,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2480,
        },
        {
          "areaName": "长宁县",
          "shortName": "长宁",
          "areaCode": "0831",
          "code": 511524,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2481,
        },
        {
          "areaName": "高县",
          "shortName": "高县",
          "areaCode": "0831",
          "code": 511525,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2482,
        },
        {
          "areaName": "珙县",
          "shortName": "珙县",
          "areaCode": "0831",
          "code": 511526,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2483,
        },
        {
          "areaName": "筠连县",
          "shortName": "筠连",
          "areaCode": "0831",
          "code": 511527,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2484,
        },
        {
          "areaName": "兴文县",
          "shortName": "兴文",
          "areaCode": "0831",
          "code": 511528,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2485,
        },
        {
          "areaName": "屏山县",
          "shortName": "屏山",
          "areaCode": "0831",
          "code": 511529,
          "parentCode": 511500,
          "level": 4,
          "children": null,
          "id": 2486,
        },
        {
          "areaName": "广安市",
          "shortName": "广安",
          "areaCode": "0826",
          "code": 511600,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2487,
        },
        {
          "areaName": "广安区",
          "shortName": "广安",
          "areaCode": "0826",
          "code": 511602,
          "parentCode": 511600,
          "level": 4,
          "children": null,
          "id": 2488,
        },
        {
          "areaName": "前锋区",
          "shortName": "前锋",
          "areaCode": "0826",
          "code": 511603,
          "parentCode": 511600,
          "level": 4,
          "children": null,
          "id": 2489,
        },
        {
          "areaName": "岳池县",
          "shortName": "岳池",
          "areaCode": "0826",
          "code": 511621,
          "parentCode": 511600,
          "level": 4,
          "children": null,
          "id": 2490,
        },
        {
          "areaName": "武胜县",
          "shortName": "武胜",
          "areaCode": "0826",
          "code": 511622,
          "parentCode": 511600,
          "level": 4,
          "children": null,
          "id": 2491,
        },
        {
          "areaName": "邻水县",
          "shortName": "邻水",
          "areaCode": "0826",
          "code": 511623,
          "parentCode": 511600,
          "level": 4,
          "children": null,
          "id": 2492,
        },
        {
          "areaName": "华蓥市",
          "shortName": "华蓥",
          "areaCode": "0826",
          "code": 511681,
          "parentCode": 511600,
          "level": 4,
          "children": null,
          "id": 2493,
        },
        {
          "areaName": "达州市",
          "shortName": "达州",
          "areaCode": "0818",
          "code": 511700,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2494,
        },
        {
          "areaName": "通川区",
          "shortName": "通川",
          "areaCode": "0818",
          "code": 511702,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2495,
        },
        {
          "areaName": "达川区",
          "shortName": "达川",
          "areaCode": "0818",
          "code": 511703,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2496,
        },
        {
          "areaName": "宣汉县",
          "shortName": "宣汉",
          "areaCode": "0818",
          "code": 511722,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2497,
        },
        {
          "areaName": "开江县",
          "shortName": "开江",
          "areaCode": "0818",
          "code": 511723,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2498,
        },
        {
          "areaName": "大竹县",
          "shortName": "大竹",
          "areaCode": "0818",
          "code": 511724,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2499,
        },
        {
          "areaName": "渠县",
          "shortName": "渠县",
          "areaCode": "0818",
          "code": 511725,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2500,
        },
        {
          "areaName": "万源市",
          "shortName": "万源",
          "areaCode": "0818",
          "code": 511781,
          "parentCode": 511700,
          "level": 4,
          "children": null,
          "id": 2501,
        },
        {
          "areaName": "雅安市",
          "shortName": "雅安",
          "areaCode": "0835",
          "code": 511800,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2502,
        },
        {
          "areaName": "雨城区",
          "shortName": "雨城",
          "areaCode": "0835",
          "code": 511802,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2503,
        },
        {
          "areaName": "名山区",
          "shortName": "名山",
          "areaCode": "0835",
          "code": 511803,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2504,
        },
        {
          "areaName": "荥经县",
          "shortName": "荥经",
          "areaCode": "0835",
          "code": 511822,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2505,
        },
        {
          "areaName": "汉源县",
          "shortName": "汉源",
          "areaCode": "0835",
          "code": 511823,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2506,
        },
        {
          "areaName": "石棉县",
          "shortName": "石棉",
          "areaCode": "0835",
          "code": 511824,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2507,
        },
        {
          "areaName": "天全县",
          "shortName": "天全",
          "areaCode": "0835",
          "code": 511825,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2508,
        },
        {
          "areaName": "芦山县",
          "shortName": "芦山",
          "areaCode": "0835",
          "code": 511826,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2509,
        },
        {
          "areaName": "宝兴县",
          "shortName": "宝兴",
          "areaCode": "0835",
          "code": 511827,
          "parentCode": 511800,
          "level": 4,
          "children": null,
          "id": 2510,
        },
        {
          "areaName": "巴中市",
          "shortName": "巴中",
          "areaCode": "0827",
          "code": 511900,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2511,
        },
        {
          "areaName": "巴州区",
          "shortName": "巴州",
          "areaCode": "0827",
          "code": 511902,
          "parentCode": 511900,
          "level": 4,
          "children": null,
          "id": 2512,
        },
        {
          "areaName": "恩阳区",
          "shortName": "恩阳",
          "areaCode": "0827",
          "code": 511903,
          "parentCode": 511900,
          "level": 4,
          "children": null,
          "id": 2513,
        },
        {
          "areaName": "通江县",
          "shortName": "通江",
          "areaCode": "0827",
          "code": 511921,
          "parentCode": 511900,
          "level": 4,
          "children": null,
          "id": 2514,
        },
        {
          "areaName": "南江县",
          "shortName": "南江",
          "areaCode": "0827",
          "code": 511922,
          "parentCode": 511900,
          "level": 4,
          "children": null,
          "id": 2515,
        },
        {
          "areaName": "平昌县",
          "shortName": "平昌",
          "areaCode": "0827",
          "code": 511923,
          "parentCode": 511900,
          "level": 4,
          "children": null,
          "id": 2516,
        },
        {
          "areaName": "资阳市",
          "shortName": "资阳",
          "areaCode": "028",
          "code": 512000,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2517,
        },
        {
          "areaName": "雁江区",
          "shortName": "雁江",
          "areaCode": "028",
          "code": 512002,
          "parentCode": 512000,
          "level": 4,
          "children": null,
          "id": 2518,
        },
        {
          "areaName": "安岳县",
          "shortName": "安岳",
          "areaCode": "028",
          "code": 512021,
          "parentCode": 512000,
          "level": 4,
          "children": null,
          "id": 2519,
        },
        {
          "areaName": "乐至县",
          "shortName": "乐至",
          "areaCode": "028",
          "code": 512022,
          "parentCode": 512000,
          "level": 4,
          "children": null,
          "id": 2520,
        },
        {
          "areaName": "简阳市",
          "shortName": "简阳",
          "areaCode": "028",
          "code": 512081,
          "parentCode": 512000,
          "level": 4,
          "children": null,
          "id": 2521,
        },
        {
          "areaName": "阿坝藏族羌族自治州",
          "shortName": "阿坝",
          "areaCode": "0837",
          "code": 513200,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2522,
        },
        {
          "areaName": "汶川县",
          "shortName": "汶川",
          "areaCode": "0837",
          "code": 513221,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2523,
        },
        {
          "areaName": "理县",
          "shortName": "理县",
          "areaCode": "0837",
          "code": 513222,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2524,
        },
        {
          "areaName": "茂县",
          "shortName": "茂县",
          "areaCode": "0837",
          "code": 513223,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2525,
        },
        {
          "areaName": "松潘县",
          "shortName": "松潘",
          "areaCode": "0837",
          "code": 513224,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2526,
        },
        {
          "areaName": "九寨沟县",
          "shortName": "九寨沟",
          "areaCode": "0837",
          "code": 513225,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2527,
        },
        {
          "areaName": "金川县",
          "shortName": "金川",
          "areaCode": "0837",
          "code": 513226,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2528,
        },
        {
          "areaName": "小金县",
          "shortName": "小金",
          "areaCode": "0837",
          "code": 513227,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2529,
        },
        {
          "areaName": "黑水县",
          "shortName": "黑水",
          "areaCode": "0837",
          "code": 513228,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2530,
        },
        {
          "areaName": "马尔康县",
          "shortName": "马尔康",
          "areaCode": "0837",
          "code": 513229,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2531,
        },
        {
          "areaName": "壤塘县",
          "shortName": "壤塘",
          "areaCode": "0837",
          "code": 513230,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2532,
        },
        {
          "areaName": "阿坝县",
          "shortName": "阿坝",
          "areaCode": "0837",
          "code": 513231,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2533,
        },
        {
          "areaName": "若尔盖县",
          "shortName": "若尔盖",
          "areaCode": "0837",
          "code": 513232,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2534,
        },
        {
          "areaName": "红原县",
          "shortName": "红原",
          "areaCode": "0837",
          "code": 513233,
          "parentCode": 513200,
          "level": 4,
          "children": null,
          "id": 2535,
        },
        {
          "areaName": "甘孜藏族自治州",
          "shortName": "甘孜",
          "areaCode": "0836",
          "code": 513300,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2536,
        },
        {
          "areaName": "康定县",
          "shortName": "康定",
          "areaCode": "0836",
          "code": 513321,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2537,
        },
        {
          "areaName": "泸定县",
          "shortName": "泸定",
          "areaCode": "0836",
          "code": 513322,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2538,
        },
        {
          "areaName": "丹巴县",
          "shortName": "丹巴",
          "areaCode": "0836",
          "code": 513323,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2539,
        },
        {
          "areaName": "九龙县",
          "shortName": "九龙",
          "areaCode": "0836",
          "code": 513324,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2540,
        },
        {
          "areaName": "雅江县",
          "shortName": "雅江",
          "areaCode": "0836",
          "code": 513325,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2541,
        },
        {
          "areaName": "道孚县",
          "shortName": "道孚",
          "areaCode": "0836",
          "code": 513326,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2542,
        },
        {
          "areaName": "炉霍县",
          "shortName": "炉霍",
          "areaCode": "0836",
          "code": 513327,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2543,
        },
        {
          "areaName": "甘孜县",
          "shortName": "甘孜",
          "areaCode": "0836",
          "code": 513328,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2544,
        },
        {
          "areaName": "新龙县",
          "shortName": "新龙",
          "areaCode": "0836",
          "code": 513329,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2545,
        },
        {
          "areaName": "德格县",
          "shortName": "德格",
          "areaCode": "0836",
          "code": 513330,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2546,
        },
        {
          "areaName": "白玉县",
          "shortName": "白玉",
          "areaCode": "0836",
          "code": 513331,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2547,
        },
        {
          "areaName": "石渠县",
          "shortName": "石渠",
          "areaCode": "0836",
          "code": 513332,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2548,
        },
        {
          "areaName": "色达县",
          "shortName": "色达",
          "areaCode": "0836",
          "code": 513333,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2549,
        },
        {
          "areaName": "理塘县",
          "shortName": "理塘",
          "areaCode": "0836",
          "code": 513334,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2550,
        },
        {
          "areaName": "巴塘县",
          "shortName": "巴塘",
          "areaCode": "0836",
          "code": 513335,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2551,
        },
        {
          "areaName": "乡城县",
          "shortName": "乡城",
          "areaCode": "0836",
          "code": 513336,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2552,
        },
        {
          "areaName": "稻城县",
          "shortName": "稻城",
          "areaCode": "0836",
          "code": 513337,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2553,
        },
        {
          "areaName": "得荣县",
          "shortName": "得荣",
          "areaCode": "0836",
          "code": 513338,
          "parentCode": 513300,
          "level": 4,
          "children": null,
          "id": 2554,
        },
        {
          "areaName": "凉山彝族自治州",
          "shortName": "凉山",
          "areaCode": "0834",
          "code": 513400,
          "parentCode": 510000,
          "level": 3,
          "children": null,
          "id": 2555,
        },
        {
          "areaName": "西昌市",
          "shortName": "西昌",
          "areaCode": "0835",
          "code": 513401,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2556,
        },
        {
          "areaName": "木里藏族自治县",
          "shortName": "木里",
          "areaCode": "0851",
          "code": 513422,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2557,
        },
        {
          "areaName": "盐源县",
          "shortName": "盐源",
          "areaCode": "0836",
          "code": 513423,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2558,
        },
        {
          "areaName": "德昌县",
          "shortName": "德昌",
          "areaCode": "0837",
          "code": 513424,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2559,
        },
        {
          "areaName": "会理县",
          "shortName": "会理",
          "areaCode": "0838",
          "code": 513425,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2560,
        },
        {
          "areaName": "会东县",
          "shortName": "会东",
          "areaCode": "0839",
          "code": 513426,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2561,
        },
        {
          "areaName": "宁南县",
          "shortName": "宁南",
          "areaCode": "0840",
          "code": 513427,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2562,
        },
        {
          "areaName": "普格县",
          "shortName": "普格",
          "areaCode": "0841",
          "code": 513428,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2563,
        },
        {
          "areaName": "布拖县",
          "shortName": "布拖",
          "areaCode": "0842",
          "code": 513429,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2564,
        },
        {
          "areaName": "金阳县",
          "shortName": "金阳",
          "areaCode": "0843",
          "code": 513430,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2565,
        },
        {
          "areaName": "昭觉县",
          "shortName": "昭觉",
          "areaCode": "0844",
          "code": 513431,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2566,
        },
        {
          "areaName": "喜德县",
          "shortName": "喜德",
          "areaCode": "0845",
          "code": 513432,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2567,
        },
        {
          "areaName": "冕宁县",
          "shortName": "冕宁",
          "areaCode": "0846",
          "code": 513433,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2568,
        },
        {
          "areaName": "越西县",
          "shortName": "越西",
          "areaCode": "0847",
          "code": 513434,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2569,
        },
        {
          "areaName": "甘洛县",
          "shortName": "甘洛",
          "areaCode": "0848",
          "code": 513435,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2570,
        },
        {
          "areaName": "美姑县",
          "shortName": "美姑",
          "areaCode": "0849",
          "code": 513436,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2571,
        },
        {
          "areaName": "雷波县",
          "shortName": "雷波",
          "areaCode": "0850",
          "code": 513437,
          "parentCode": 513400,
          "level": 4,
          "children": null,
          "id": 2572,
        }
      ],
      "id": 2368,
    },
    {
      "areaName": "贵州省",
      "shortName": "贵州",
      "code": 520000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "贵阳市",
          "shortName": "贵阳",
          "areaCode": "0851",
          "code": 520100,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2574,
        },
        {
          "areaName": "南明区",
          "shortName": "南明",
          "areaCode": "0851",
          "code": 520102,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2575,
        },
        {
          "areaName": "云岩区",
          "shortName": "云岩",
          "areaCode": "0851",
          "code": 520103,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2576,
        },
        {
          "areaName": "花溪区",
          "shortName": "花溪",
          "areaCode": "0851",
          "code": 520111,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2577,
        },
        {
          "areaName": "乌当区",
          "shortName": "乌当",
          "areaCode": "0851",
          "code": 520112,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2578,
        },
        {
          "areaName": "白云区",
          "shortName": "白云",
          "areaCode": "0851",
          "code": 520113,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2579,
        },
        {
          "areaName": "观山湖区",
          "shortName": "观山湖",
          "areaCode": "0851",
          "code": 520115,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2580,
        },
        {
          "areaName": "开阳县",
          "shortName": "开阳",
          "areaCode": "0851",
          "code": 520121,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2581,
        },
        {
          "areaName": "息烽县",
          "shortName": "息烽",
          "areaCode": "0851",
          "code": 520122,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2582,
        },
        {
          "areaName": "修文县",
          "shortName": "修文",
          "areaCode": "0851",
          "code": 520123,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2583,
        },
        {
          "areaName": "清镇市",
          "shortName": "清镇",
          "areaCode": "0851",
          "code": 520181,
          "parentCode": 520100,
          "level": 4,
          "children": null,
          "id": 2584,
        },
        {
          "areaName": "六盘水市",
          "shortName": "六盘水",
          "areaCode": "0858",
          "code": 520200,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2585,
        },
        {
          "areaName": "钟山区",
          "shortName": "钟山",
          "areaCode": "0858",
          "code": 520201,
          "parentCode": 520200,
          "level": 4,
          "children": null,
          "id": 2586,
        },
        {
          "areaName": "六枝特区",
          "shortName": "六枝",
          "areaCode": "0858",
          "code": 520203,
          "parentCode": 520200,
          "level": 4,
          "children": null,
          "id": 2587,
        },
        {
          "areaName": "水城县",
          "shortName": "水城",
          "areaCode": "0858",
          "code": 520221,
          "parentCode": 520200,
          "level": 4,
          "children": null,
          "id": 2588,
        },
        {
          "areaName": "盘县",
          "shortName": "盘县",
          "areaCode": "0858",
          "code": 520222,
          "parentCode": 520200,
          "level": 4,
          "children": null,
          "id": 2589,
        },
        {
          "areaName": "遵义市",
          "shortName": "遵义",
          "areaCode": "0852",
          "code": 520300,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2590,
        },
        {
          "areaName": "红花岗区",
          "shortName": "红花岗",
          "areaCode": "0852",
          "code": 520302,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2591,
        },
        {
          "areaName": "汇川区",
          "shortName": "汇川",
          "areaCode": "0852",
          "code": 520303,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2592,
        },
        {
          "areaName": "遵义县",
          "shortName": "遵义",
          "areaCode": "0852",
          "code": 520321,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2593,
        },
        {
          "areaName": "桐梓县",
          "shortName": "桐梓",
          "areaCode": "0852",
          "code": 520322,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2594,
        },
        {
          "areaName": "绥阳县",
          "shortName": "绥阳",
          "areaCode": "0852",
          "code": 520323,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2595,
        },
        {
          "areaName": "正安县",
          "shortName": "正安",
          "areaCode": "0852",
          "code": 520324,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2596,
        },
        {
          "areaName": "道真仡佬族苗族自治县",
          "shortName": "道真",
          "areaCode": "0852",
          "code": 520325,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2597,
        },
        {
          "areaName": "务川仡佬族苗族自治县",
          "shortName": "务川",
          "areaCode": "0852",
          "code": 520326,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2598,
        },
        {
          "areaName": "凤冈县",
          "shortName": "凤冈",
          "areaCode": "0852",
          "code": 520327,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2599,
        },
        {
          "areaName": "湄潭县",
          "shortName": "湄潭",
          "areaCode": "0852",
          "code": 520328,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2600,
        },
        {
          "areaName": "余庆县",
          "shortName": "余庆",
          "areaCode": "0852",
          "code": 520329,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2601,
        },
        {
          "areaName": "习水县",
          "shortName": "习水",
          "areaCode": "0852",
          "code": 520330,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2602,
        },
        {
          "areaName": "赤水市",
          "shortName": "赤水",
          "areaCode": "0852",
          "code": 520381,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2603,
        },
        {
          "areaName": "仁怀市",
          "shortName": "仁怀",
          "areaCode": "0852",
          "code": 520382,
          "parentCode": 520300,
          "level": 4,
          "children": null,
          "id": 2604,
        },
        {
          "areaName": "安顺市",
          "shortName": "安顺",
          "areaCode": "0853",
          "code": 520400,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2605,
        },
        {
          "areaName": "西秀区",
          "shortName": "西秀",
          "areaCode": "0853",
          "code": 520402,
          "parentCode": 520400,
          "level": 4,
          "children": null,
          "id": 2606,
        },
        {
          "areaName": "平坝区",
          "shortName": "平坝",
          "areaCode": "0853",
          "code": 520421,
          "parentCode": 520400,
          "level": 4,
          "children": null,
          "id": 2607,
        },
        {
          "areaName": "普定县",
          "shortName": "普定",
          "areaCode": "0853",
          "code": 520422,
          "parentCode": 520400,
          "level": 4,
          "children": null,
          "id": 2608,
        },
        {
          "areaName": "镇宁布依族苗族自治县",
          "shortName": "镇宁",
          "areaCode": "0853",
          "code": 520423,
          "parentCode": 520400,
          "level": 4,
          "children": null,
          "id": 2609,
        },
        {
          "areaName": "关岭布依族苗族自治县",
          "shortName": "关岭",
          "areaCode": "0853",
          "code": 520424,
          "parentCode": 520400,
          "level": 4,
          "children": null,
          "id": 2610,
        },
        {
          "areaName": "紫云苗族布依族自治县",
          "shortName": "紫云",
          "areaCode": "0853",
          "code": 520425,
          "parentCode": 520400,
          "level": 4,
          "children": null,
          "id": 2611,
        },
        {
          "areaName": "毕节市",
          "shortName": "毕节",
          "areaCode": "0857",
          "code": 520500,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2612,
        },
        {
          "areaName": "七星关区",
          "shortName": "七星关",
          "areaCode": "0857",
          "code": 520502,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2613,
        },
        {
          "areaName": "大方县",
          "shortName": "大方",
          "areaCode": "0857",
          "code": 520521,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2614,
        },
        {
          "areaName": "黔西县",
          "shortName": "黔西",
          "areaCode": "0857",
          "code": 520522,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2615,
        },
        {
          "areaName": "金沙县",
          "shortName": "金沙",
          "areaCode": "0857",
          "code": 520523,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2616,
        },
        {
          "areaName": "织金县",
          "shortName": "织金",
          "areaCode": "0857",
          "code": 520524,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2617,
        },
        {
          "areaName": "纳雍县",
          "shortName": "纳雍",
          "areaCode": "0857",
          "code": 520525,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2618,
        },
        {
          "areaName": "威宁彝族回族苗族自治县",
          "shortName": "威宁",
          "areaCode": "0857",
          "code": 520526,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2619,
        },
        {
          "areaName": "赫章县",
          "shortName": "赫章",
          "areaCode": "0857",
          "code": 520527,
          "parentCode": 520500,
          "level": 4,
          "children": null,
          "id": 2620,
        },
        {
          "areaName": "铜仁市",
          "shortName": "铜仁",
          "areaCode": "0856",
          "code": 520600,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2621,
        },
        {
          "areaName": "碧江区",
          "shortName": "碧江",
          "areaCode": "0856",
          "code": 520602,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2622,
        },
        {
          "areaName": "万山区",
          "shortName": "万山",
          "areaCode": "0856",
          "code": 520603,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2623,
        },
        {
          "areaName": "江口县",
          "shortName": "江口",
          "areaCode": "0856",
          "code": 520621,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2624,
        },
        {
          "areaName": "玉屏侗族自治县",
          "shortName": "玉屏",
          "areaCode": "0856",
          "code": 520622,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2625,
        },
        {
          "areaName": "石阡县",
          "shortName": "石阡",
          "areaCode": "0856",
          "code": 520623,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2626,
        },
        {
          "areaName": "思南县",
          "shortName": "思南",
          "areaCode": "0856",
          "code": 520624,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2627,
        },
        {
          "areaName": "印江土家族苗族自治县",
          "shortName": "印江",
          "areaCode": "0856",
          "code": 520625,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2628,
        },
        {
          "areaName": "德江县",
          "shortName": "德江",
          "areaCode": "0856",
          "code": 520626,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2629,
        },
        {
          "areaName": "沿河土家族自治县",
          "shortName": "沿河",
          "areaCode": "0856",
          "code": 520627,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2630,
        },
        {
          "areaName": "松桃苗族自治县",
          "shortName": "松桃",
          "areaCode": "0856",
          "code": 520628,
          "parentCode": 520600,
          "level": 4,
          "children": null,
          "id": 2631,
        },
        {
          "areaName": "黔西南布依族苗族自治州",
          "shortName": "黔西南",
          "areaCode": "0859",
          "code": 522300,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2632,
        },
        {
          "areaName": "兴义市",
          "shortName": "兴义",
          "areaCode": "0859",
          "code": 522301,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2633,
        },
        {
          "areaName": "兴仁县",
          "shortName": "兴仁",
          "areaCode": "0859",
          "code": 522322,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2634,
        },
        {
          "areaName": "普安县",
          "shortName": "普安",
          "areaCode": "0859",
          "code": 522323,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2635,
        },
        {
          "areaName": "晴隆县",
          "shortName": "晴隆",
          "areaCode": "0859",
          "code": 522324,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2636,
        },
        {
          "areaName": "贞丰县",
          "shortName": "贞丰",
          "areaCode": "0859",
          "code": 522325,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2637,
        },
        {
          "areaName": "望谟县",
          "shortName": "望谟",
          "areaCode": "0859",
          "code": 522326,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2638,
        },
        {
          "areaName": "册亨县",
          "shortName": "册亨",
          "areaCode": "0859",
          "code": 522327,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2639,
        },
        {
          "areaName": "安龙县",
          "shortName": "安龙",
          "areaCode": "0859",
          "code": 522328,
          "parentCode": 522300,
          "level": 4,
          "children": null,
          "id": 2640,
        },
        {
          "areaName": "黔东南苗族侗族自治州",
          "shortName": "黔东南",
          "areaCode": "0855",
          "code": 522600,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2641,
        },
        {
          "areaName": "凯里市",
          "shortName": "凯里",
          "areaCode": "0855",
          "code": 522601,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2642,
        },
        {
          "areaName": "黄平县",
          "shortName": "黄平",
          "areaCode": "0855",
          "code": 522622,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2643,
        },
        {
          "areaName": "施秉县",
          "shortName": "施秉",
          "areaCode": "0855",
          "code": 522623,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2644,
        },
        {
          "areaName": "三穗县",
          "shortName": "三穗",
          "areaCode": "0855",
          "code": 522624,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2645,
        },
        {
          "areaName": "镇远县",
          "shortName": "镇远",
          "areaCode": "0855",
          "code": 522625,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2646,
        },
        {
          "areaName": "岑巩县",
          "shortName": "岑巩",
          "areaCode": "0855",
          "code": 522626,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2647,
        },
        {
          "areaName": "天柱县",
          "shortName": "天柱",
          "areaCode": "0855",
          "code": 522627,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2648,
        },
        {
          "areaName": "锦屏县",
          "shortName": "锦屏",
          "areaCode": "0855",
          "code": 522628,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2649,
        },
        {
          "areaName": "剑河县",
          "shortName": "剑河",
          "areaCode": "0855",
          "code": 522629,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2650,
        },
        {
          "areaName": "台江县",
          "shortName": "台江",
          "areaCode": "0855",
          "code": 522630,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2651,
        },
        {
          "areaName": "黎平县",
          "shortName": "黎平",
          "areaCode": "0855",
          "code": 522631,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2652,
        },
        {
          "areaName": "榕江县",
          "shortName": "榕江",
          "areaCode": "0855",
          "code": 522632,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2653,
        },
        {
          "areaName": "从江县",
          "shortName": "从江",
          "areaCode": "0855",
          "code": 522633,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2654,
        },
        {
          "areaName": "雷山县",
          "shortName": "雷山",
          "areaCode": "0855",
          "code": 522634,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2655,
        },
        {
          "areaName": "麻江县",
          "shortName": "麻江",
          "areaCode": "0855",
          "code": 522635,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2656,
        },
        {
          "areaName": "丹寨县",
          "shortName": "丹寨",
          "areaCode": "0855",
          "code": 522636,
          "parentCode": 522600,
          "level": 4,
          "children": null,
          "id": 2657,
        },
        {
          "areaName": "黔南布依族苗族自治州",
          "shortName": "黔南",
          "areaCode": "0854",
          "code": 522700,
          "parentCode": 520000,
          "level": 3,
          "children": null,
          "id": 2658,
        },
        {
          "areaName": "都匀市",
          "shortName": "都匀",
          "areaCode": "0854",
          "code": 522701,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2659,
        },
        {
          "areaName": "福泉市",
          "shortName": "福泉",
          "areaCode": "0854",
          "code": 522702,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2660,
        },
        {
          "areaName": "荔波县",
          "shortName": "荔波",
          "areaCode": "0854",
          "code": 522722,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2661,
        },
        {
          "areaName": "贵定县",
          "shortName": "贵定",
          "areaCode": "0854",
          "code": 522723,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2662,
        },
        {
          "areaName": "瓮安县",
          "shortName": "瓮安",
          "areaCode": "0854",
          "code": 522725,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2663,
        },
        {
          "areaName": "独山县",
          "shortName": "独山",
          "areaCode": "0854",
          "code": 522726,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2664,
        },
        {
          "areaName": "平塘县",
          "shortName": "平塘",
          "areaCode": "0854",
          "code": 522727,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2665,
        },
        {
          "areaName": "罗甸县",
          "shortName": "罗甸",
          "areaCode": "0854",
          "code": 522728,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2666,
        },
        {
          "areaName": "长顺县",
          "shortName": "长顺",
          "areaCode": "0854",
          "code": 522729,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2667,
        },
        {
          "areaName": "龙里县",
          "shortName": "龙里",
          "areaCode": "0854",
          "code": 522730,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2668,
        },
        {
          "areaName": "惠水县",
          "shortName": "惠水",
          "areaCode": "0854",
          "code": 522731,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2669,
        },
        {
          "areaName": "三都水族自治县",
          "shortName": "三都",
          "areaCode": "0854",
          "code": 522732,
          "parentCode": 522700,
          "level": 4,
          "children": null,
          "id": 2670,
        }
      ],
      "id": 2573,
    },
    {
      "areaName": "云南省",
      "shortName": "云南",
      "code": 530000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "昆明市",
          "shortName": "昆明",
          "areaCode": "0871",
          "code": 530100,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2672,
        },
        {
          "areaName": "五华区",
          "shortName": "五华",
          "areaCode": "0871",
          "code": 530102,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2673,
        },
        {
          "areaName": "盘龙区",
          "shortName": "盘龙",
          "areaCode": "0871",
          "code": 530103,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2674,
        },
        {
          "areaName": "官渡区",
          "shortName": "官渡",
          "areaCode": "0871",
          "code": 530111,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2675,
        },
        {
          "areaName": "西山区",
          "shortName": "西山",
          "areaCode": "0871",
          "code": 530112,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2676,
        },
        {
          "areaName": "东川区",
          "shortName": "东川",
          "areaCode": "0871",
          "code": 530113,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2677,
        },
        {
          "areaName": "呈贡区",
          "shortName": "呈贡",
          "areaCode": "0871",
          "code": 530114,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2678,
        },
        {
          "areaName": "晋宁县",
          "shortName": "晋宁",
          "areaCode": "0871",
          "code": 530122,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2679,
        },
        {
          "areaName": "富民县",
          "shortName": "富民",
          "areaCode": "0871",
          "code": 530124,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2680,
        },
        {
          "areaName": "宜良县",
          "shortName": "宜良",
          "areaCode": "0871",
          "code": 530125,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2681,
        },
        {
          "areaName": "石林彝族自治县",
          "shortName": "石林",
          "areaCode": "0871",
          "code": 530126,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2682,
        },
        {
          "areaName": "嵩明县",
          "shortName": "嵩明",
          "areaCode": "0871",
          "code": 530127,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2683,
        },
        {
          "areaName": "禄劝彝族苗族自治县",
          "shortName": "禄劝",
          "areaCode": "0871",
          "code": 530128,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2684,
        },
        {
          "areaName": "寻甸回族彝族自治县",
          "shortName": "寻甸",
          "areaCode": "0871",
          "code": 530129,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2685,
        },
        {
          "areaName": "安宁市",
          "shortName": "安宁",
          "areaCode": "0871",
          "code": 530181,
          "parentCode": 530100,
          "level": 4,
          "children": null,
          "id": 2686,
        },
        {
          "areaName": "曲靖市",
          "shortName": "曲靖",
          "areaCode": "0874",
          "code": 530300,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2687,
        },
        {
          "areaName": "麒麟区",
          "shortName": "麒麟",
          "areaCode": "0874",
          "code": 530302,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2688,
        },
        {
          "areaName": "马龙县",
          "shortName": "马龙",
          "areaCode": "0874",
          "code": 530321,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2689,
        },
        {
          "areaName": "陆良县",
          "shortName": "陆良",
          "areaCode": "0874",
          "code": 530322,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2690,
        },
        {
          "areaName": "师宗县",
          "shortName": "师宗",
          "areaCode": "0874",
          "code": 530323,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2691,
        },
        {
          "areaName": "罗平县",
          "shortName": "罗平",
          "areaCode": "0874",
          "code": 530324,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2692,
        },
        {
          "areaName": "富源县",
          "shortName": "富源",
          "areaCode": "0874",
          "code": 530325,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2693,
        },
        {
          "areaName": "会泽县",
          "shortName": "会泽",
          "areaCode": "0874",
          "code": 530326,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2694,
        },
        {
          "areaName": "沾益县",
          "shortName": "沾益",
          "areaCode": "0874",
          "code": 530328,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2695,
        },
        {
          "areaName": "宣威市",
          "shortName": "宣威",
          "areaCode": "0874",
          "code": 530381,
          "parentCode": 530300,
          "level": 4,
          "children": null,
          "id": 2696,
        },
        {
          "areaName": "玉溪市",
          "shortName": "玉溪",
          "areaCode": "0877",
          "code": 530400,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2697,
        },
        {
          "areaName": "红塔区",
          "shortName": "红塔",
          "areaCode": "0877",
          "code": 530402,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2698,
        },
        {
          "areaName": "江川县",
          "shortName": "江川",
          "areaCode": "0877",
          "code": 530421,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2699,
        },
        {
          "areaName": "澄江县",
          "shortName": "澄江",
          "areaCode": "0877",
          "code": 530422,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2700,
        },
        {
          "areaName": "通海县",
          "shortName": "通海",
          "areaCode": "0877",
          "code": 530423,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2701,
        },
        {
          "areaName": "华宁县",
          "shortName": "华宁",
          "areaCode": "0877",
          "code": 530424,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2702,
        },
        {
          "areaName": "易门县",
          "shortName": "易门",
          "areaCode": "0877",
          "code": 530425,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2703,
        },
        {
          "areaName": "峨山彝族自治县",
          "shortName": "峨山",
          "areaCode": "0877",
          "code": 530426,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2704,
        },
        {
          "areaName": "新平彝族傣族自治县",
          "shortName": "新平",
          "areaCode": "0877",
          "code": 530427,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2705,
        },
        {
          "areaName": "元江哈尼族彝族傣族自治县",
          "shortName": "元江",
          "areaCode": "0877",
          "code": 530428,
          "parentCode": 530400,
          "level": 4,
          "children": null,
          "id": 2706,
        },
        {
          "areaName": "保山市",
          "shortName": "保山",
          "areaCode": "0875",
          "code": 530500,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2707,
        },
        {
          "areaName": "隆阳区",
          "shortName": "隆阳",
          "areaCode": "0875",
          "code": 530502,
          "parentCode": 530500,
          "level": 4,
          "children": null,
          "id": 2708,
        },
        {
          "areaName": "施甸县",
          "shortName": "施甸",
          "areaCode": "0875",
          "code": 530521,
          "parentCode": 530500,
          "level": 4,
          "children": null,
          "id": 2709,
        },
        {
          "areaName": "腾冲县",
          "shortName": "腾冲",
          "areaCode": "0875",
          "code": 530522,
          "parentCode": 530500,
          "level": 4,
          "children": null,
          "id": 2710,
        },
        {
          "areaName": "龙陵县",
          "shortName": "龙陵",
          "areaCode": "0875",
          "code": 530523,
          "parentCode": 530500,
          "level": 4,
          "children": null,
          "id": 2711,
        },
        {
          "areaName": "昌宁县",
          "shortName": "昌宁",
          "areaCode": "0875",
          "code": 530524,
          "parentCode": 530500,
          "level": 4,
          "children": null,
          "id": 2712,
        },
        {
          "areaName": "昭通市",
          "shortName": "昭通",
          "areaCode": "0870",
          "code": 530600,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2713,
        },
        {
          "areaName": "昭阳区",
          "shortName": "昭阳",
          "areaCode": "0870",
          "code": 530602,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2714,
        },
        {
          "areaName": "鲁甸县",
          "shortName": "鲁甸",
          "areaCode": "0870",
          "code": 530621,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2715,
        },
        {
          "areaName": "巧家县",
          "shortName": "巧家",
          "areaCode": "0870",
          "code": 530622,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2716,
        },
        {
          "areaName": "盐津县",
          "shortName": "盐津",
          "areaCode": "0870",
          "code": 530623,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2717,
        },
        {
          "areaName": "大关县",
          "shortName": "大关",
          "areaCode": "0870",
          "code": 530624,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2718,
        },
        {
          "areaName": "永善县",
          "shortName": "永善",
          "areaCode": "0870",
          "code": 530625,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2719,
        },
        {
          "areaName": "绥江县",
          "shortName": "绥江",
          "areaCode": "0870",
          "code": 530626,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2720,
        },
        {
          "areaName": "镇雄县",
          "shortName": "镇雄",
          "areaCode": "0870",
          "code": 530627,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2721,
        },
        {
          "areaName": "彝良县",
          "shortName": "彝良",
          "areaCode": "0870",
          "code": 530628,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2722,
        },
        {
          "areaName": "威信县",
          "shortName": "威信",
          "areaCode": "0870",
          "code": 530629,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2723,
        },
        {
          "areaName": "水富县",
          "shortName": "水富",
          "areaCode": "0870",
          "code": 530630,
          "parentCode": 530600,
          "level": 4,
          "children": null,
          "id": 2724,
        },
        {
          "areaName": "丽江市",
          "shortName": "丽江",
          "areaCode": "0888",
          "code": 530700,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2725,
        },
        {
          "areaName": "古城区",
          "shortName": "古城",
          "areaCode": "0888",
          "code": 530702,
          "parentCode": 530700,
          "level": 4,
          "children": null,
          "id": 2726,
        },
        {
          "areaName": "玉龙纳西族自治县",
          "shortName": "玉龙",
          "areaCode": "0888",
          "code": 530721,
          "parentCode": 530700,
          "level": 4,
          "children": null,
          "id": 2727,
        },
        {
          "areaName": "永胜县",
          "shortName": "永胜",
          "areaCode": "0888",
          "code": 530722,
          "parentCode": 530700,
          "level": 4,
          "children": null,
          "id": 2728,
        },
        {
          "areaName": "华坪县",
          "shortName": "华坪",
          "areaCode": "0888",
          "code": 530723,
          "parentCode": 530700,
          "level": 4,
          "children": null,
          "id": 2729,
        },
        {
          "areaName": "宁蒗彝族自治县",
          "shortName": "宁蒗",
          "areaCode": "0888",
          "code": 530724,
          "parentCode": 530700,
          "level": 4,
          "children": null,
          "id": 2730,
        },
        {
          "areaName": "普洱市",
          "shortName": "普洱",
          "areaCode": "0879",
          "code": 530800,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2731,
        },
        {
          "areaName": "思茅区",
          "shortName": "思茅",
          "areaCode": "0879",
          "code": 530802,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2732,
        },
        {
          "areaName": "宁洱哈尼族彝族自治县",
          "shortName": "宁洱",
          "areaCode": "0879",
          "code": 530821,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2733,
        },
        {
          "areaName": "墨江哈尼族自治县",
          "shortName": "墨江",
          "areaCode": "0879",
          "code": 530822,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2734,
        },
        {
          "areaName": "景东彝族自治县",
          "shortName": "景东",
          "areaCode": "0879",
          "code": 530823,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2735,
        },
        {
          "areaName": "景谷傣族彝族自治县",
          "shortName": "景谷",
          "areaCode": "0879",
          "code": 530824,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2736,
        },
        {
          "areaName": "镇沅彝族哈尼族拉祜族自治县",
          "shortName": "镇沅",
          "areaCode": "0879",
          "code": 530825,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2737,
        },
        {
          "areaName": "江城哈尼族彝族自治县",
          "shortName": "江城",
          "areaCode": "0879",
          "code": 530826,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2738,
        },
        {
          "areaName": "孟连傣族拉祜族佤族自治县",
          "shortName": "孟连",
          "areaCode": "0879",
          "code": 530827,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2739,
        },
        {
          "areaName": "澜沧拉祜族自治县",
          "shortName": "澜沧",
          "areaCode": "0879",
          "code": 530828,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2740,
        },
        {
          "areaName": "西盟佤族自治县",
          "shortName": "西盟",
          "areaCode": "0879",
          "code": 530829,
          "parentCode": 530800,
          "level": 4,
          "children": null,
          "id": 2741,
        },
        {
          "areaName": "临沧市",
          "shortName": "临沧",
          "areaCode": "0883",
          "code": 530900,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2742,
        },
        {
          "areaName": "临翔区",
          "shortName": "临翔",
          "areaCode": "0883",
          "code": 530902,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2743,
        },
        {
          "areaName": "凤庆县",
          "shortName": "凤庆",
          "areaCode": "0883",
          "code": 530921,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2744,
        },
        {
          "areaName": "云县",
          "shortName": "云县",
          "areaCode": "0883",
          "code": 530922,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2745,
        },
        {
          "areaName": "永德县",
          "shortName": "永德",
          "areaCode": "0883",
          "code": 530923,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2746,
        },
        {
          "areaName": "镇康县",
          "shortName": "镇康",
          "areaCode": "0883",
          "code": 530924,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2747,
        },
        {
          "areaName": "双江拉祜族佤族布朗族傣族自治县",
          "shortName": "双江",
          "areaCode": "0883",
          "code": 530925,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2748,
        },
        {
          "areaName": "耿马傣族佤族自治县",
          "shortName": "耿马",
          "areaCode": "0883",
          "code": 530926,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2749,
        },
        {
          "areaName": "沧源佤族自治县",
          "shortName": "沧源",
          "areaCode": "0883",
          "code": 530927,
          "parentCode": 530900,
          "level": 4,
          "children": null,
          "id": 2750,
        },
        {
          "areaName": "楚雄彝族自治州",
          "shortName": "楚雄",
          "areaCode": "0878",
          "code": 532300,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2751,
        },
        {
          "areaName": "楚雄市",
          "shortName": "楚雄",
          "areaCode": "0878",
          "code": 532301,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2752,
        },
        {
          "areaName": "双柏县",
          "shortName": "双柏",
          "areaCode": "0878",
          "code": 532322,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2753,
        },
        {
          "areaName": "牟定县",
          "shortName": "牟定",
          "areaCode": "0878",
          "code": 532323,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2754,
        },
        {
          "areaName": "南华县",
          "shortName": "南华",
          "areaCode": "0878",
          "code": 532324,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2755,
        },
        {
          "areaName": "姚安县",
          "shortName": "姚安",
          "areaCode": "0878",
          "code": 532325,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2756,
        },
        {
          "areaName": "大姚县",
          "shortName": "大姚",
          "areaCode": "0878",
          "code": 532326,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2757,
        },
        {
          "areaName": "永仁县",
          "shortName": "永仁",
          "areaCode": "0878",
          "code": 532327,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2758,
        },
        {
          "areaName": "元谋县",
          "shortName": "元谋",
          "areaCode": "0878",
          "code": 532328,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2759,
        },
        {
          "areaName": "武定县",
          "shortName": "武定",
          "areaCode": "0878",
          "code": 532329,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2760,
        },
        {
          "areaName": "禄丰县",
          "shortName": "禄丰",
          "areaCode": "0878",
          "code": 532331,
          "parentCode": 532300,
          "level": 4,
          "children": null,
          "id": 2761,
        },
        {
          "areaName": "红河哈尼族彝族自治州",
          "shortName": "红河",
          "areaCode": "0873",
          "code": 532500,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2762,
        },
        {
          "areaName": "个旧市",
          "shortName": "个旧",
          "areaCode": "0873",
          "code": 532501,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2763,
        },
        {
          "areaName": "开远市",
          "shortName": "开远",
          "areaCode": "0873",
          "code": 532502,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2764,
        },
        {
          "areaName": "蒙自市",
          "shortName": "蒙自",
          "areaCode": "0873",
          "code": 532503,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2765,
        },
        {
          "areaName": "弥勒市",
          "shortName": "弥勒",
          "areaCode": "0873",
          "code": 532504,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2766,
        },
        {
          "areaName": "屏边苗族自治县",
          "shortName": "屏边",
          "areaCode": "0873",
          "code": 532523,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2767,
        },
        {
          "areaName": "建水县",
          "shortName": "建水",
          "areaCode": "0873",
          "code": 532524,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2768,
        },
        {
          "areaName": "石屏县",
          "shortName": "石屏",
          "areaCode": "0873",
          "code": 532525,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2769,
        },
        {
          "areaName": "泸西县",
          "shortName": "泸西",
          "areaCode": "0873",
          "code": 532527,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2770,
        },
        {
          "areaName": "元阳县",
          "shortName": "元阳",
          "areaCode": "0873",
          "code": 532528,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2771,
        },
        {
          "areaName": "红河县",
          "shortName": "红河县",
          "areaCode": "0873",
          "code": 532529,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2772,
        },
        {
          "areaName": "金平苗族瑶族傣族自治县",
          "shortName": "金平",
          "areaCode": "0873",
          "code": 532530,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2773,
        },
        {
          "areaName": "绿春县",
          "shortName": "绿春",
          "areaCode": "0873",
          "code": 532531,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2774,
        },
        {
          "areaName": "河口瑶族自治县",
          "shortName": "河口",
          "areaCode": "0873",
          "code": 532532,
          "parentCode": 532500,
          "level": 4,
          "children": null,
          "id": 2775,
        },
        {
          "areaName": "文山壮族苗族自治州",
          "shortName": "文山",
          "areaCode": "0876",
          "code": 532600,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2776,
        },
        {
          "areaName": "文山市",
          "shortName": "文山",
          "areaCode": "0876",
          "code": 532601,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2777,
        },
        {
          "areaName": "砚山县",
          "shortName": "砚山",
          "areaCode": "0876",
          "code": 532622,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2778,
        },
        {
          "areaName": "西畴县",
          "shortName": "西畴",
          "areaCode": "0876",
          "code": 532623,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2779,
        },
        {
          "areaName": "麻栗坡县",
          "shortName": "麻栗坡",
          "areaCode": "0876",
          "code": 532624,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2780,
        },
        {
          "areaName": "马关县",
          "shortName": "马关",
          "areaCode": "0876",
          "code": 532625,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2781,
        },
        {
          "areaName": "丘北县",
          "shortName": "丘北",
          "areaCode": "0876",
          "code": 532626,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2782,
        },
        {
          "areaName": "广南县",
          "shortName": "广南",
          "areaCode": "0876",
          "code": 532627,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2783,
        },
        {
          "areaName": "富宁县",
          "shortName": "富宁",
          "areaCode": "0876",
          "code": 532628,
          "parentCode": 532600,
          "level": 4,
          "children": null,
          "id": 2784,
        },
        {
          "areaName": "西双版纳傣族自治州",
          "shortName": "西双版纳",
          "areaCode": "0691",
          "code": 532800,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2785,
        },
        {
          "areaName": "景洪市",
          "shortName": "景洪",
          "areaCode": "0691",
          "code": 532801,
          "parentCode": 532800,
          "level": 4,
          "children": null,
          "id": 2786,
        },
        {
          "areaName": "勐海县",
          "shortName": "勐海",
          "areaCode": "0691",
          "code": 532822,
          "parentCode": 532800,
          "level": 4,
          "children": null,
          "id": 2787,
        },
        {
          "areaName": "勐腊县",
          "shortName": "勐腊",
          "areaCode": "0691",
          "code": 532823,
          "parentCode": 532800,
          "level": 4,
          "children": null,
          "id": 2788,
        },
        {
          "areaName": "大理白族自治州",
          "shortName": "大理",
          "areaCode": "0872",
          "code": 532900,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2789,
        },
        {
          "areaName": "大理市",
          "shortName": "大理",
          "areaCode": "0872",
          "code": 532901,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2790,
        },
        {
          "areaName": "漾濞彝族自治县",
          "shortName": "漾濞",
          "areaCode": "0872",
          "code": 532922,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2791,
        },
        {
          "areaName": "祥云县",
          "shortName": "祥云",
          "areaCode": "0872",
          "code": 532923,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2792,
        },
        {
          "areaName": "宾川县",
          "shortName": "宾川",
          "areaCode": "0872",
          "code": 532924,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2793,
        },
        {
          "areaName": "弥渡县",
          "shortName": "弥渡",
          "areaCode": "0872",
          "code": 532925,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2794,
        },
        {
          "areaName": "南涧彝族自治县",
          "shortName": "南涧",
          "areaCode": "0872",
          "code": 532926,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2795,
        },
        {
          "areaName": "巍山彝族回族自治县",
          "shortName": "巍山",
          "areaCode": "0872",
          "code": 532927,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2796,
        },
        {
          "areaName": "永平县",
          "shortName": "永平",
          "areaCode": "0872",
          "code": 532928,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2797,
        },
        {
          "areaName": "云龙县",
          "shortName": "云龙",
          "areaCode": "0872",
          "code": 532929,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2798,
        },
        {
          "areaName": "洱源县",
          "shortName": "洱源",
          "areaCode": "0872",
          "code": 532930,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2799,
        },
        {
          "areaName": "剑川县",
          "shortName": "剑川",
          "areaCode": "0872",
          "code": 532931,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2800,
        },
        {
          "areaName": "鹤庆县",
          "shortName": "鹤庆",
          "areaCode": "0872",
          "code": 532932,
          "parentCode": 532900,
          "level": 4,
          "children": null,
          "id": 2801,
        },
        {
          "areaName": "德宏傣族景颇族自治州",
          "shortName": "德宏",
          "areaCode": "0692",
          "code": 533100,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2802,
        },
        {
          "areaName": "瑞丽市",
          "shortName": "瑞丽",
          "areaCode": "0692",
          "code": 533102,
          "parentCode": 533100,
          "level": 4,
          "children": null,
          "id": 2803,
        },
        {
          "areaName": "芒市",
          "shortName": "芒市",
          "areaCode": "0692",
          "code": 533103,
          "parentCode": 533100,
          "level": 4,
          "children": null,
          "id": 2804,
        },
        {
          "areaName": "梁河县",
          "shortName": "梁河",
          "areaCode": "0692",
          "code": 533122,
          "parentCode": 533100,
          "level": 4,
          "children": null,
          "id": 2805,
        },
        {
          "areaName": "盈江县",
          "shortName": "盈江",
          "areaCode": "0692",
          "code": 533123,
          "parentCode": 533100,
          "level": 4,
          "children": null,
          "id": 2806,
        },
        {
          "areaName": "陇川县",
          "shortName": "陇川",
          "areaCode": "0692",
          "code": 533124,
          "parentCode": 533100,
          "level": 4,
          "children": null,
          "id": 2807,
        },
        {
          "areaName": "怒江傈僳族自治州",
          "shortName": "怒江",
          "areaCode": "0886",
          "code": 533300,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2808,
        },
        {
          "areaName": "泸水县",
          "shortName": "泸水",
          "areaCode": "0886",
          "code": 533321,
          "parentCode": 533300,
          "level": 4,
          "children": null,
          "id": 2809,
        },
        {
          "areaName": "福贡县",
          "shortName": "福贡",
          "areaCode": "0886",
          "code": 533323,
          "parentCode": 533300,
          "level": 4,
          "children": null,
          "id": 2810,
        },
        {
          "areaName": "贡山独龙族怒族自治县",
          "shortName": "贡山",
          "areaCode": "0886",
          "code": 533324,
          "parentCode": 533300,
          "level": 4,
          "children": null,
          "id": 2811,
        },
        {
          "areaName": "兰坪白族普米族自治县",
          "shortName": "兰坪",
          "areaCode": "0886",
          "code": 533325,
          "parentCode": 533300,
          "level": 4,
          "children": null,
          "id": 2812,
        },
        {
          "areaName": "迪庆藏族自治州",
          "shortName": "迪庆",
          "areaCode": "0887",
          "code": 533400,
          "parentCode": 530000,
          "level": 3,
          "children": null,
          "id": 2813,
        },
        {
          "areaName": "香格里拉市",
          "shortName": "香格里拉",
          "areaCode": "0887",
          "code": 533421,
          "parentCode": 533400,
          "level": 4,
          "children": null,
          "id": 2814,
        },
        {
          "areaName": "德钦县",
          "shortName": "德钦",
          "areaCode": "0887",
          "code": 533422,
          "parentCode": 533400,
          "level": 4,
          "children": null,
          "id": 2815,
        },
        {
          "areaName": "维西傈僳族自治县",
          "shortName": "维西",
          "areaCode": "0887",
          "code": 533423,
          "parentCode": 533400,
          "level": 4,
          "children": null,
          "id": 2816,
        }
      ],
      "id": 2671,
    },
    {
      "areaName": "西藏自治区",
      "shortName": "西藏",
      "code": 540000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "拉萨市",
          "shortName": "拉萨",
          "areaCode": "0891",
          "code": 540100,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2818,
        },
        {
          "areaName": "城关区",
          "shortName": "城关",
          "areaCode": "0891",
          "code": 540102,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2819,
        },
        {
          "areaName": "林周县",
          "shortName": "林周",
          "areaCode": "0891",
          "code": 540121,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2820,
        },
        {
          "areaName": "当雄县",
          "shortName": "当雄",
          "areaCode": "0891",
          "code": 540122,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2821,
        },
        {
          "areaName": "尼木县",
          "shortName": "尼木",
          "areaCode": "0891",
          "code": 540123,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2822,
        },
        {
          "areaName": "曲水县",
          "shortName": "曲水",
          "areaCode": "0891",
          "code": 540124,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2823,
        },
        {
          "areaName": "堆龙德庆县",
          "shortName": "堆龙德庆",
          "areaCode": "0891",
          "code": 540125,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2824,
        },
        {
          "areaName": "达孜县",
          "shortName": "达孜",
          "areaCode": "0891",
          "code": 540126,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2825,
        },
        {
          "areaName": "墨竹工卡县",
          "shortName": "墨竹工卡",
          "areaCode": "0891",
          "code": 540127,
          "parentCode": 540100,
          "level": 4,
          "children": null,
          "id": 2826,
        },
        {
          "areaName": "日喀则市",
          "shortName": "日喀则",
          "areaCode": "0892",
          "code": 540200,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2827,
        },
        {
          "areaName": "桑珠孜区",
          "shortName": "桑珠孜",
          "areaCode": "0892",
          "code": 540202,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2828,
        },
        {
          "areaName": "南木林县",
          "shortName": "南木林",
          "areaCode": "0892",
          "code": 540221,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2829,
        },
        {
          "areaName": "江孜县",
          "shortName": "江孜",
          "areaCode": "0892",
          "code": 540222,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2830,
        },
        {
          "areaName": "定日县",
          "shortName": "定日",
          "areaCode": "0892",
          "code": 540223,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2831,
        },
        {
          "areaName": "萨迦县",
          "shortName": "萨迦",
          "areaCode": "0892",
          "code": 540224,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2832,
        },
        {
          "areaName": "拉孜县",
          "shortName": "拉孜",
          "areaCode": "0892",
          "code": 540225,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2833,
        },
        {
          "areaName": "昂仁县",
          "shortName": "昂仁",
          "areaCode": "0892",
          "code": 540226,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2834,
        },
        {
          "areaName": "谢通门县",
          "shortName": "谢通门",
          "areaCode": "0892",
          "code": 540227,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2835,
        },
        {
          "areaName": "白朗县",
          "shortName": "白朗",
          "areaCode": "0892",
          "code": 540228,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2836,
        },
        {
          "areaName": "仁布县",
          "shortName": "仁布",
          "areaCode": "0892",
          "code": 540229,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2837,
        },
        {
          "areaName": "康马县",
          "shortName": "康马",
          "areaCode": "0892",
          "code": 540230,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2838,
        },
        {
          "areaName": "定结县",
          "shortName": "定结",
          "areaCode": "0892",
          "code": 540231,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2839,
        },
        {
          "areaName": "仲巴县",
          "shortName": "仲巴",
          "areaCode": "0892",
          "code": 540232,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2840,
        },
        {
          "areaName": "亚东县",
          "shortName": "亚东",
          "areaCode": "0892",
          "code": 540233,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2841,
        },
        {
          "areaName": "吉隆县",
          "shortName": "吉隆",
          "areaCode": "0892",
          "code": 540234,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2842,
        },
        {
          "areaName": "聂拉木县",
          "shortName": "聂拉木",
          "areaCode": "0892",
          "code": 540235,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2843,
        },
        {
          "areaName": "萨嘎县",
          "shortName": "萨嘎",
          "areaCode": "0892",
          "code": 540236,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2844,
        },
        {
          "areaName": "岗巴县",
          "shortName": "岗巴",
          "areaCode": "0892",
          "code": 540237,
          "parentCode": 540200,
          "level": 4,
          "children": null,
          "id": 2845,
        },
        {
          "areaName": "昌都市",
          "shortName": "昌都",
          "areaCode": "0895",
          "code": 540300,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2846,
        },
        {
          "areaName": "卡若区",
          "shortName": "昌都",
          "areaCode": "0895",
          "code": 540302,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2847,
        },
        {
          "areaName": "江达县",
          "shortName": "江达",
          "areaCode": "0895",
          "code": 540321,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2848,
        },
        {
          "areaName": "贡觉县",
          "shortName": "贡觉",
          "areaCode": "0895",
          "code": 540322,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2849,
        },
        {
          "areaName": "类乌齐县",
          "shortName": "类乌齐",
          "areaCode": "0895",
          "code": 540323,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2850,
        },
        {
          "areaName": "丁青县",
          "shortName": "丁青",
          "areaCode": "0895",
          "code": 540324,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2851,
        },
        {
          "areaName": "察雅县",
          "shortName": "察雅",
          "areaCode": "0895",
          "code": 540325,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2852,
        },
        {
          "areaName": "八宿县",
          "shortName": "八宿",
          "areaCode": "0895",
          "code": 540326,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2853,
        },
        {
          "areaName": "左贡县",
          "shortName": "左贡",
          "areaCode": "0895",
          "code": 540327,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2854,
        },
        {
          "areaName": "芒康县",
          "shortName": "芒康",
          "areaCode": "0895",
          "code": 540328,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2855,
        },
        {
          "areaName": "洛隆县",
          "shortName": "洛隆",
          "areaCode": "0895",
          "code": 540329,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2856,
        },
        {
          "areaName": "边坝县",
          "shortName": "边坝",
          "areaCode": "0895",
          "code": 540330,
          "parentCode": 540300,
          "level": 4,
          "children": null,
          "id": 2857,
        },
        {
          "areaName": "山南地区",
          "shortName": "山南",
          "areaCode": "0893",
          "code": 542200,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2858,
        },
        {
          "areaName": "乃东县",
          "shortName": "乃东",
          "areaCode": "0893",
          "code": 542221,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2859,
        },
        {
          "areaName": "扎囊县",
          "shortName": "扎囊",
          "areaCode": "0893",
          "code": 542222,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2860,
        },
        {
          "areaName": "贡嘎县",
          "shortName": "贡嘎",
          "areaCode": "0893",
          "code": 542223,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2861,
        },
        {
          "areaName": "桑日县",
          "shortName": "桑日",
          "areaCode": "0893",
          "code": 542224,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2862,
        },
        {
          "areaName": "琼结县",
          "shortName": "琼结",
          "areaCode": "0893",
          "code": 542225,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2863,
        },
        {
          "areaName": "曲松县",
          "shortName": "曲松",
          "areaCode": "0893",
          "code": 542226,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2864,
        },
        {
          "areaName": "措美县",
          "shortName": "措美",
          "areaCode": "0893",
          "code": 542227,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2865,
        },
        {
          "areaName": "洛扎县",
          "shortName": "洛扎",
          "areaCode": "0893",
          "code": 542228,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2866,
        },
        {
          "areaName": "加查县",
          "shortName": "加查",
          "areaCode": "0893",
          "code": 542229,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2867,
        },
        {
          "areaName": "隆子县",
          "shortName": "隆子",
          "areaCode": "0893",
          "code": 542231,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2868,
        },
        {
          "areaName": "错那县",
          "shortName": "错那",
          "areaCode": "0893",
          "code": 542232,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2869,
        },
        {
          "areaName": "浪卡子县",
          "shortName": "浪卡子",
          "areaCode": "0893",
          "code": 542233,
          "parentCode": 542200,
          "level": 4,
          "children": null,
          "id": 2870,
        },
        {
          "areaName": "那曲地区",
          "shortName": "那曲",
          "areaCode": "0896",
          "code": 542400,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2871,
        },
        {
          "areaName": "那曲县",
          "shortName": "那曲",
          "areaCode": "0896",
          "code": 542421,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2872,
        },
        {
          "areaName": "嘉黎县",
          "shortName": "嘉黎",
          "areaCode": "0896",
          "code": 542422,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2873,
        },
        {
          "areaName": "比如县",
          "shortName": "比如",
          "areaCode": "0896",
          "code": 542423,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2874,
        },
        {
          "areaName": "聂荣县",
          "shortName": "聂荣",
          "areaCode": "0896",
          "code": 542424,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2875,
        },
        {
          "areaName": "安多县",
          "shortName": "安多",
          "areaCode": "0896",
          "code": 542425,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2876,
        },
        {
          "areaName": "申扎县",
          "shortName": "申扎",
          "areaCode": "0896",
          "code": 542426,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2877,
        },
        {
          "areaName": "索县",
          "shortName": "索县",
          "areaCode": "0896",
          "code": 542427,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2878,
        },
        {
          "areaName": "班戈县",
          "shortName": "班戈",
          "areaCode": "0896",
          "code": 542428,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2879,
        },
        {
          "areaName": "巴青县",
          "shortName": "巴青",
          "areaCode": "0896",
          "code": 542429,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2880,
        },
        {
          "areaName": "尼玛县",
          "shortName": "尼玛",
          "areaCode": "0896",
          "code": 542430,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2881,
        },
        {
          "areaName": "双湖县",
          "shortName": "双湖",
          "areaCode": "0896",
          "code": 542431,
          "parentCode": 542400,
          "level": 4,
          "children": null,
          "id": 2882,
        },
        {
          "areaName": "阿里地区",
          "shortName": "阿里",
          "areaCode": "0897",
          "code": 542500,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2883,
        },
        {
          "areaName": "普兰县",
          "shortName": "普兰",
          "areaCode": "0897",
          "code": 542521,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2884,
        },
        {
          "areaName": "札达县",
          "shortName": "札达",
          "areaCode": "0897",
          "code": 542522,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2885,
        },
        {
          "areaName": "噶尔县",
          "shortName": "噶尔",
          "areaCode": "0897",
          "code": 542523,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2886,
        },
        {
          "areaName": "日土县",
          "shortName": "日土",
          "areaCode": "0897",
          "code": 542524,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2887,
        },
        {
          "areaName": "革吉县",
          "shortName": "革吉",
          "areaCode": "0897",
          "code": 542525,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2888,
        },
        {
          "areaName": "改则县",
          "shortName": "改则",
          "areaCode": "0897",
          "code": 542526,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2889,
        },
        {
          "areaName": "措勤县",
          "shortName": "措勤",
          "areaCode": "0897",
          "code": 542527,
          "parentCode": 542500,
          "level": 4,
          "children": null,
          "id": 2890,
        },
        {
          "areaName": "林芝地区",
          "shortName": "林芝",
          "areaCode": "0894",
          "code": 542600,
          "parentCode": 540000,
          "level": 3,
          "children": null,
          "id": 2891,
        },
        {
          "areaName": "林芝县",
          "shortName": "林芝",
          "areaCode": "0894",
          "code": 542621,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2892,
        },
        {
          "areaName": "工布江达县",
          "shortName": "工布江达",
          "areaCode": "0894",
          "code": 542622,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2893,
        },
        {
          "areaName": "米林县",
          "shortName": "米林",
          "areaCode": "0894",
          "code": 542623,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2894,
        },
        {
          "areaName": "墨脱县",
          "shortName": "墨脱",
          "areaCode": "0894",
          "code": 542624,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2895,
        },
        {
          "areaName": "波密县",
          "shortName": "波密",
          "areaCode": "0894",
          "code": 542625,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2896,
        },
        {
          "areaName": "察隅县",
          "shortName": "察隅",
          "areaCode": "0894",
          "code": 542626,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2897,
        },
        {
          "areaName": "朗县",
          "shortName": "朗县",
          "areaCode": "0894",
          "code": 542627,
          "parentCode": 542600,
          "level": 4,
          "children": null,
          "id": 2898,
        }
      ],
      "id": 2817,
    },
    {
      "areaName": "陕西省",
      "shortName": "陕西",
      "code": 610000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "西安市",
          "shortName": "西安",
          "areaCode": "029",
          "code": 610100,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2900,
        },
        {
          "areaName": "新城区",
          "shortName": "新城",
          "areaCode": "029",
          "code": 610102,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2901,
        },
        {
          "areaName": "碑林区",
          "shortName": "碑林",
          "areaCode": "029",
          "code": 610103,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2902,
        },
        {
          "areaName": "莲湖区",
          "shortName": "莲湖",
          "areaCode": "029",
          "code": 610104,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2903,
        },
        {
          "areaName": "灞桥区",
          "shortName": "灞桥",
          "areaCode": "029",
          "code": 610111,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2904,
        },
        {
          "areaName": "未央区",
          "shortName": "未央",
          "areaCode": "029",
          "code": 610112,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2905,
        },
        {
          "areaName": "雁塔区",
          "shortName": "雁塔",
          "areaCode": "029",
          "code": 610113,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2906,
        },
        {
          "areaName": "阎良区",
          "shortName": "阎良",
          "areaCode": "029",
          "code": 610114,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2907,
        },
        {
          "areaName": "临潼区",
          "shortName": "临潼",
          "areaCode": "029",
          "code": 610115,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2908,
        },
        {
          "areaName": "长安区",
          "shortName": "长安",
          "areaCode": "029",
          "code": 610116,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2909,
        },
        {
          "areaName": "蓝田县",
          "shortName": "蓝田",
          "areaCode": "029",
          "code": 610122,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2910,
        },
        {
          "areaName": "周至县",
          "shortName": "周至",
          "areaCode": "029",
          "code": 610124,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2911,
        },
        {
          "areaName": "户县",
          "shortName": "户县",
          "areaCode": "029",
          "code": 610125,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2912,
        },
        {
          "areaName": "高陵区",
          "shortName": "高陵",
          "areaCode": "029",
          "code": 610126,
          "parentCode": 610100,
          "level": 4,
          "children": null,
          "id": 2913,
        },
        {
          "areaName": "铜川市",
          "shortName": "铜川",
          "areaCode": "0919",
          "code": 610200,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2914,
        },
        {
          "areaName": "王益区",
          "shortName": "王益",
          "areaCode": "0919",
          "code": 610202,
          "parentCode": 610200,
          "level": 4,
          "children": null,
          "id": 2915,
        },
        {
          "areaName": "印台区",
          "shortName": "印台",
          "areaCode": "0919",
          "code": 610203,
          "parentCode": 610200,
          "level": 4,
          "children": null,
          "id": 2916,
        },
        {
          "areaName": "耀州区",
          "shortName": "耀州",
          "areaCode": "0919",
          "code": 610204,
          "parentCode": 610200,
          "level": 4,
          "children": null,
          "id": 2917,
        },
        {
          "areaName": "宜君县",
          "shortName": "宜君",
          "areaCode": "0919",
          "code": 610222,
          "parentCode": 610200,
          "level": 4,
          "children": null,
          "id": 2918,
        },
        {
          "areaName": "宝鸡市",
          "shortName": "宝鸡",
          "areaCode": "0917",
          "code": 610300,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2919,
        },
        {
          "areaName": "渭滨区",
          "shortName": "渭滨",
          "areaCode": "0917",
          "code": 610302,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2920,
        },
        {
          "areaName": "金台区",
          "shortName": "金台",
          "areaCode": "0917",
          "code": 610303,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2921,
        },
        {
          "areaName": "陈仓区",
          "shortName": "陈仓",
          "areaCode": "0917",
          "code": 610304,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2922,
        },
        {
          "areaName": "凤翔县",
          "shortName": "凤翔",
          "areaCode": "0917",
          "code": 610322,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2923,
        },
        {
          "areaName": "岐山县",
          "shortName": "岐山",
          "areaCode": "0917",
          "code": 610323,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2924,
        },
        {
          "areaName": "扶风县",
          "shortName": "扶风",
          "areaCode": "0917",
          "code": 610324,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2925,
        },
        {
          "areaName": "眉县",
          "shortName": "眉县",
          "areaCode": "0917",
          "code": 610326,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2926,
        },
        {
          "areaName": "陇县",
          "shortName": "陇县",
          "areaCode": "0917",
          "code": 610327,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2927,
        },
        {
          "areaName": "千阳县",
          "shortName": "千阳",
          "areaCode": "0917",
          "code": 610328,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2928,
        },
        {
          "areaName": "麟游县",
          "shortName": "麟游",
          "areaCode": "0917",
          "code": 610329,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2929,
        },
        {
          "areaName": "凤县",
          "shortName": "凤县",
          "areaCode": "0917",
          "code": 610330,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2930,
        },
        {
          "areaName": "太白县",
          "shortName": "太白",
          "areaCode": "0917",
          "code": 610331,
          "parentCode": 610300,
          "level": 4,
          "children": null,
          "id": 2931,
        },
        {
          "areaName": "咸阳市",
          "shortName": "咸阳",
          "areaCode": "029",
          "code": 610400,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2932,
        },
        {
          "areaName": "秦都区",
          "shortName": "秦都",
          "areaCode": "029",
          "code": 610402,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2933,
        },
        {
          "areaName": "杨陵区",
          "shortName": "杨陵",
          "areaCode": "029",
          "code": 610403,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2934,
        },
        {
          "areaName": "渭城区",
          "shortName": "渭城",
          "areaCode": "029",
          "code": 610404,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2935,
        },
        {
          "areaName": "三原县",
          "shortName": "三原",
          "areaCode": "029",
          "code": 610422,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2936,
        },
        {
          "areaName": "泾阳县",
          "shortName": "泾阳",
          "areaCode": "029",
          "code": 610423,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2937,
        },
        {
          "areaName": "乾县",
          "shortName": "乾县",
          "areaCode": "029",
          "code": 610424,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2938,
        },
        {
          "areaName": "礼泉县",
          "shortName": "礼泉",
          "areaCode": "029",
          "code": 610425,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2939,
        },
        {
          "areaName": "永寿县",
          "shortName": "永寿",
          "areaCode": "029",
          "code": 610426,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2940,
        },
        {
          "areaName": "彬县",
          "shortName": "彬县",
          "areaCode": "029",
          "code": 610427,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2941,
        },
        {
          "areaName": "长武县",
          "shortName": "长武",
          "areaCode": "029",
          "code": 610428,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2942,
        },
        {
          "areaName": "旬邑县",
          "shortName": "旬邑",
          "areaCode": "029",
          "code": 610429,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2943,
        },
        {
          "areaName": "淳化县",
          "shortName": "淳化",
          "areaCode": "029",
          "code": 610430,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2944,
        },
        {
          "areaName": "武功县",
          "shortName": "武功",
          "areaCode": "029",
          "code": 610431,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2945,
        },
        {
          "areaName": "兴平市",
          "shortName": "兴平",
          "areaCode": "029",
          "code": 610481,
          "parentCode": 610400,
          "level": 4,
          "children": null,
          "id": 2946,
        },
        {
          "areaName": "渭南市",
          "shortName": "渭南",
          "areaCode": "0913",
          "code": 610500,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2947,
        },
        {
          "areaName": "临渭区",
          "shortName": "临渭",
          "areaCode": "0913",
          "code": 610502,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2948,
        },
        {
          "areaName": "华县",
          "shortName": "华县",
          "areaCode": "0913",
          "code": 610521,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2949,
        },
        {
          "areaName": "潼关县",
          "shortName": "潼关",
          "areaCode": "0913",
          "code": 610522,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2950,
        },
        {
          "areaName": "大荔县",
          "shortName": "大荔",
          "areaCode": "0913",
          "code": 610523,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2951,
        },
        {
          "areaName": "合阳县",
          "shortName": "合阳",
          "areaCode": "0913",
          "code": 610524,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2952,
        },
        {
          "areaName": "澄城县",
          "shortName": "澄城",
          "areaCode": "0913",
          "code": 610525,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2953,
        },
        {
          "areaName": "蒲城县",
          "shortName": "蒲城",
          "areaCode": "0913",
          "code": 610526,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2954,
        },
        {
          "areaName": "白水县",
          "shortName": "白水",
          "areaCode": "0913",
          "code": 610527,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2955,
        },
        {
          "areaName": "富平县",
          "shortName": "富平",
          "areaCode": "0913",
          "code": 610528,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2956,
        },
        {
          "areaName": "韩城市",
          "shortName": "韩城",
          "areaCode": "0913",
          "code": 610581,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2957,
        },
        {
          "areaName": "华阴市",
          "shortName": "华阴",
          "areaCode": "0913",
          "code": 610582,
          "parentCode": 610500,
          "level": 4,
          "children": null,
          "id": 2958,
        },
        {
          "areaName": "延安市",
          "shortName": "延安",
          "areaCode": "0911",
          "code": 610600,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2959,
        },
        {
          "areaName": "宝塔区",
          "shortName": "宝塔",
          "areaCode": "0911",
          "code": 610602,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2960,
        },
        {
          "areaName": "延长县",
          "shortName": "延长",
          "areaCode": "0911",
          "code": 610621,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2961,
        },
        {
          "areaName": "延川县",
          "shortName": "延川",
          "areaCode": "0911",
          "code": 610622,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2962,
        },
        {
          "areaName": "子长县",
          "shortName": "子长",
          "areaCode": "0911",
          "code": 610623,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2963,
        },
        {
          "areaName": "安塞县",
          "shortName": "安塞",
          "areaCode": "0911",
          "code": 610624,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2964,
        },
        {
          "areaName": "志丹县",
          "shortName": "志丹",
          "areaCode": "0911",
          "code": 610625,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2965,
        },
        {
          "areaName": "吴起县",
          "shortName": "吴起",
          "areaCode": "0911",
          "code": 610626,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2966,
        },
        {
          "areaName": "甘泉县",
          "shortName": "甘泉",
          "areaCode": "0911",
          "code": 610627,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2967,
        },
        {
          "areaName": "富县",
          "shortName": "富县",
          "areaCode": "0911",
          "code": 610628,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2968,
        },
        {
          "areaName": "洛川县",
          "shortName": "洛川",
          "areaCode": "0911",
          "code": 610629,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2969,
        },
        {
          "areaName": "宜川县",
          "shortName": "宜川",
          "areaCode": "0911",
          "code": 610630,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2970,
        },
        {
          "areaName": "黄龙县",
          "shortName": "黄龙",
          "areaCode": "0911",
          "code": 610631,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2971,
        },
        {
          "areaName": "黄陵县",
          "shortName": "黄陵",
          "areaCode": "0911",
          "code": 610632,
          "parentCode": 610600,
          "level": 4,
          "children": null,
          "id": 2972,
        },
        {
          "areaName": "汉中市",
          "shortName": "汉中",
          "areaCode": "0916",
          "code": 610700,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2973,
        },
        {
          "areaName": "汉台区",
          "shortName": "汉台",
          "areaCode": "0916",
          "code": 610702,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2974,
        },
        {
          "areaName": "南郑县",
          "shortName": "南郑",
          "areaCode": "0916",
          "code": 610721,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2975,
        },
        {
          "areaName": "城固县",
          "shortName": "城固",
          "areaCode": "0916",
          "code": 610722,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2976,
        },
        {
          "areaName": "洋县",
          "shortName": "洋县",
          "areaCode": "0916",
          "code": 610723,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2977,
        },
        {
          "areaName": "西乡县",
          "shortName": "西乡",
          "areaCode": "0916",
          "code": 610724,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2978,
        },
        {
          "areaName": "勉县",
          "shortName": "勉县",
          "areaCode": "0916",
          "code": 610725,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2979,
        },
        {
          "areaName": "宁强县",
          "shortName": "宁强",
          "areaCode": "0916",
          "code": 610726,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2980,
        },
        {
          "areaName": "略阳县",
          "shortName": "略阳",
          "areaCode": "0916",
          "code": 610727,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2981,
        },
        {
          "areaName": "镇巴县",
          "shortName": "镇巴",
          "areaCode": "0916",
          "code": 610728,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2982,
        },
        {
          "areaName": "留坝县",
          "shortName": "留坝",
          "areaCode": "0916",
          "code": 610729,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2983,
        },
        {
          "areaName": "佛坪县",
          "shortName": "佛坪",
          "areaCode": "0916",
          "code": 610730,
          "parentCode": 610700,
          "level": 4,
          "children": null,
          "id": 2984,
        },
        {
          "areaName": "榆林市",
          "shortName": "榆林",
          "areaCode": "0912",
          "code": 610800,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2985,
        },
        {
          "areaName": "榆阳区",
          "shortName": "榆阳",
          "areaCode": "0912",
          "code": 610802,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2986,
        },
        {
          "areaName": "神木县",
          "shortName": "神木",
          "areaCode": "0912",
          "code": 610821,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2987,
        },
        {
          "areaName": "府谷县",
          "shortName": "府谷",
          "areaCode": "0912",
          "code": 610822,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2988,
        },
        {
          "areaName": "横山县",
          "shortName": "横山",
          "areaCode": "0912",
          "code": 610823,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2989,
        },
        {
          "areaName": "靖边县",
          "shortName": "靖边",
          "areaCode": "0912",
          "code": 610824,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2990,
        },
        {
          "areaName": "定边县",
          "shortName": "定边",
          "areaCode": "0912",
          "code": 610825,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2991,
        },
        {
          "areaName": "绥德县",
          "shortName": "绥德",
          "areaCode": "0912",
          "code": 610826,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2992,
        },
        {
          "areaName": "米脂县",
          "shortName": "米脂",
          "areaCode": "0912",
          "code": 610827,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2993,
        },
        {
          "areaName": "佳县",
          "shortName": "佳县",
          "areaCode": "0912",
          "code": 610828,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2994,
        },
        {
          "areaName": "吴堡县",
          "shortName": "吴堡",
          "areaCode": "0912",
          "code": 610829,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2995,
        },
        {
          "areaName": "清涧县",
          "shortName": "清涧",
          "areaCode": "0912",
          "code": 610830,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2996,
        },
        {
          "areaName": "子洲县",
          "shortName": "子洲",
          "areaCode": "0912",
          "code": 610831,
          "parentCode": 610800,
          "level": 4,
          "children": null,
          "id": 2997,
        },
        {
          "areaName": "安康市",
          "shortName": "安康",
          "areaCode": "0915",
          "code": 610900,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 2998,
        },
        {
          "areaName": "汉滨区",
          "shortName": "汉滨",
          "areaCode": "0915",
          "code": 610902,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 2999,
        },
        {
          "areaName": "汉阴县",
          "shortName": "汉阴",
          "areaCode": "0915",
          "code": 610921,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3000,
        },
        {
          "areaName": "石泉县",
          "shortName": "石泉",
          "areaCode": "0915",
          "code": 610922,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3001,
        },
        {
          "areaName": "宁陕县",
          "shortName": "宁陕",
          "areaCode": "0915",
          "code": 610923,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3002,
        },
        {
          "areaName": "紫阳县",
          "shortName": "紫阳",
          "areaCode": "0915",
          "code": 610924,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3003,
        },
        {
          "areaName": "岚皋县",
          "shortName": "岚皋",
          "areaCode": "0915",
          "code": 610925,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3004,
        },
        {
          "areaName": "平利县",
          "shortName": "平利",
          "areaCode": "0915",
          "code": 610926,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3005,
        },
        {
          "areaName": "镇坪县",
          "shortName": "镇坪",
          "areaCode": "0915",
          "code": 610927,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3006,
        },
        {
          "areaName": "旬阳县",
          "shortName": "旬阳",
          "areaCode": "0915",
          "code": 610928,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3007,
        },
        {
          "areaName": "白河县",
          "shortName": "白河",
          "areaCode": "0915",
          "code": 610929,
          "parentCode": 610900,
          "level": 4,
          "children": null,
          "id": 3008,
        },
        {
          "areaName": "商洛市",
          "shortName": "商洛",
          "areaCode": "0914",
          "code": 611000,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 3009,
        },
        {
          "areaName": "商州区",
          "shortName": "商州",
          "areaCode": "0914",
          "code": 611002,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3010,
        },
        {
          "areaName": "洛南县",
          "shortName": "洛南",
          "areaCode": "0914",
          "code": 611021,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3011,
        },
        {
          "areaName": "丹凤县",
          "shortName": "丹凤",
          "areaCode": "0914",
          "code": 611022,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3012,
        },
        {
          "areaName": "商南县",
          "shortName": "商南",
          "areaCode": "0914",
          "code": 611023,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3013,
        },
        {
          "areaName": "山阳县",
          "shortName": "山阳",
          "areaCode": "0914",
          "code": 611024,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3014,
        },
        {
          "areaName": "镇安县",
          "shortName": "镇安",
          "areaCode": "0914",
          "code": 611025,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3015,
        },
        {
          "areaName": "柞水县",
          "shortName": "柞水",
          "areaCode": "0914",
          "code": 611026,
          "parentCode": 611000,
          "level": 4,
          "children": null,
          "id": 3016,
        },
        {
          "areaName": "西咸新区",
          "shortName": "西咸",
          "areaCode": "029",
          "code": 611100,
          "parentCode": 610000,
          "level": 3,
          "children": null,
          "id": 3017,
        },
        {
          "areaName": "空港新城",
          "shortName": "空港",
          "areaCode": "0374",
          "code": 611101,
          "parentCode": 611100,
          "level": 4,
          "children": null,
          "id": 3018,
        },
        {
          "areaName": "沣东新城",
          "shortName": "沣东",
          "areaCode": "029",
          "code": 611102,
          "parentCode": 611100,
          "level": 4,
          "children": null,
          "id": 3019,
        },
        {
          "areaName": "秦汉新城",
          "shortName": "秦汉",
          "areaCode": "029",
          "code": 611103,
          "parentCode": 611100,
          "level": 4,
          "children": null,
          "id": 3020,
        },
        {
          "areaName": "沣西新城",
          "shortName": "沣西",
          "areaCode": "029",
          "code": 611104,
          "parentCode": 611100,
          "level": 4,
          "children": null,
          "id": 3021,
        },
        {
          "areaName": "泾河新城",
          "shortName": "泾河",
          "areaCode": "029",
          "code": 611105,
          "parentCode": 611100,
          "level": 4,
          "children": null,
          "id": 3022,
        }
      ],
      "id": 2899,
    },
    {
      "areaName": "甘肃省",
      "shortName": "甘肃",
      "code": 620000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "兰州市",
          "shortName": "兰州",
          "areaCode": "0931",
          "code": 620100,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3024,
        },
        {
          "areaName": "城关区",
          "shortName": "城关",
          "areaCode": "0931",
          "code": 620102,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3025,
        },
        {
          "areaName": "七里河区",
          "shortName": "七里河",
          "areaCode": "0931",
          "code": 620103,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3026,
        },
        {
          "areaName": "西固区",
          "shortName": "西固",
          "areaCode": "0931",
          "code": 620104,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3027,
        },
        {
          "areaName": "安宁区",
          "shortName": "安宁",
          "areaCode": "0931",
          "code": 620105,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3028,
        },
        {
          "areaName": "红古区",
          "shortName": "红古",
          "areaCode": "0931",
          "code": 620111,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3029,
        },
        {
          "areaName": "永登县",
          "shortName": "永登",
          "areaCode": "0931",
          "code": 620121,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3030,
        },
        {
          "areaName": "皋兰县",
          "shortName": "皋兰",
          "areaCode": "0931",
          "code": 620122,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3031,
        },
        {
          "areaName": "榆中县",
          "shortName": "榆中",
          "areaCode": "0931",
          "code": 620123,
          "parentCode": 620100,
          "level": 4,
          "children": null,
          "id": 3032,
        },
        {
          "areaName": "嘉峪关市",
          "shortName": "嘉峪关",
          "areaCode": "0937",
          "code": 620200,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3033,
        },
        {
          "areaName": "雄关区",
          "shortName": "雄关",
          "areaCode": "0937",
          "code": 620201,
          "parentCode": 620200,
          "level": 4,
          "children": null,
          "id": 3034,
        },
        {
          "areaName": "长城区",
          "shortName": "长城",
          "areaCode": "0937",
          "code": 620202,
          "parentCode": 620200,
          "level": 4,
          "children": null,
          "id": 3035,
        },
        {
          "areaName": "镜铁区",
          "shortName": "镜铁",
          "areaCode": "0937",
          "code": 620203,
          "parentCode": 620200,
          "level": 4,
          "children": null,
          "id": 3036,
        },
        {
          "areaName": "金昌市",
          "shortName": "金昌",
          "areaCode": "0935",
          "code": 620300,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3037,
        },
        {
          "areaName": "金川区",
          "shortName": "金川",
          "areaCode": "0935",
          "code": 620302,
          "parentCode": 620300,
          "level": 4,
          "children": null,
          "id": 3038,
        },
        {
          "areaName": "永昌县",
          "shortName": "永昌",
          "areaCode": "0935",
          "code": 620321,
          "parentCode": 620300,
          "level": 4,
          "children": null,
          "id": 3039,
        },
        {
          "areaName": "白银市",
          "shortName": "白银",
          "areaCode": "0943",
          "code": 620400,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3040,
        },
        {
          "areaName": "白银区",
          "shortName": "白银",
          "areaCode": "0943",
          "code": 620402,
          "parentCode": 620400,
          "level": 4,
          "children": null,
          "id": 3041,
        },
        {
          "areaName": "平川区",
          "shortName": "平川",
          "areaCode": "0943",
          "code": 620403,
          "parentCode": 620400,
          "level": 4,
          "children": null,
          "id": 3042,
        },
        {
          "areaName": "靖远县",
          "shortName": "靖远",
          "areaCode": "0943",
          "code": 620421,
          "parentCode": 620400,
          "level": 4,
          "children": null,
          "id": 3043,
        },
        {
          "areaName": "会宁县",
          "shortName": "会宁",
          "areaCode": "0943",
          "code": 620422,
          "parentCode": 620400,
          "level": 4,
          "children": null,
          "id": 3044,
        },
        {
          "areaName": "景泰县",
          "shortName": "景泰",
          "areaCode": "0943",
          "code": 620423,
          "parentCode": 620400,
          "level": 4,
          "children": null,
          "id": 3045,
        },
        {
          "areaName": "天水市",
          "shortName": "天水",
          "areaCode": "0938",
          "code": 620500,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3046,
        },
        {
          "areaName": "秦州区",
          "shortName": "秦州",
          "areaCode": "0938",
          "code": 620502,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3047,
        },
        {
          "areaName": "麦积区",
          "shortName": "麦积",
          "areaCode": "0938",
          "code": 620503,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3048,
        },
        {
          "areaName": "清水县",
          "shortName": "清水",
          "areaCode": "0938",
          "code": 620521,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3049,
        },
        {
          "areaName": "秦安县",
          "shortName": "秦安",
          "areaCode": "0938",
          "code": 620522,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3050,
        },
        {
          "areaName": "甘谷县",
          "shortName": "甘谷",
          "areaCode": "0938",
          "code": 620523,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3051,
        },
        {
          "areaName": "武山县",
          "shortName": "武山",
          "areaCode": "0938",
          "code": 620524,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3052,
        },
        {
          "areaName": "张家川回族自治县",
          "shortName": "张家川",
          "areaCode": "0938",
          "code": 620525,
          "parentCode": 620500,
          "level": 4,
          "children": null,
          "id": 3053,
        },
        {
          "areaName": "武威市",
          "shortName": "武威",
          "areaCode": "0935",
          "code": 620600,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3054,
        },
        {
          "areaName": "凉州区",
          "shortName": "凉州",
          "areaCode": "0935",
          "code": 620602,
          "parentCode": 620600,
          "level": 4,
          "children": null,
          "id": 3055,
        },
        {
          "areaName": "民勤县",
          "shortName": "民勤",
          "areaCode": "0935",
          "code": 620621,
          "parentCode": 620600,
          "level": 4,
          "children": null,
          "id": 3056,
        },
        {
          "areaName": "古浪县",
          "shortName": "古浪",
          "areaCode": "0935",
          "code": 620622,
          "parentCode": 620600,
          "level": 4,
          "children": null,
          "id": 3057,
        },
        {
          "areaName": "天祝藏族自治县",
          "shortName": "天祝",
          "areaCode": "0935",
          "code": 620623,
          "parentCode": 620600,
          "level": 4,
          "children": null,
          "id": 3058,
        },
        {
          "areaName": "张掖市",
          "shortName": "张掖",
          "areaCode": "0936",
          "code": 620700,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3059,
        },
        {
          "areaName": "甘州区",
          "shortName": "甘州",
          "areaCode": "0936",
          "code": 620702,
          "parentCode": 620700,
          "level": 4,
          "children": null,
          "id": 3060,
        },
        {
          "areaName": "肃南裕固族自治县",
          "shortName": "肃南",
          "areaCode": "0936",
          "code": 620721,
          "parentCode": 620700,
          "level": 4,
          "children": null,
          "id": 3061,
        },
        {
          "areaName": "民乐县",
          "shortName": "民乐",
          "areaCode": "0936",
          "code": 620722,
          "parentCode": 620700,
          "level": 4,
          "children": null,
          "id": 3062,
        },
        {
          "areaName": "临泽县",
          "shortName": "临泽",
          "areaCode": "0936",
          "code": 620723,
          "parentCode": 620700,
          "level": 4,
          "children": null,
          "id": 3063,
        },
        {
          "areaName": "高台县",
          "shortName": "高台",
          "areaCode": "0936",
          "code": 620724,
          "parentCode": 620700,
          "level": 4,
          "children": null,
          "id": 3064,
        },
        {
          "areaName": "山丹县",
          "shortName": "山丹",
          "areaCode": "0936",
          "code": 620725,
          "parentCode": 620700,
          "level": 4,
          "children": null,
          "id": 3065,
        },
        {
          "areaName": "平凉市",
          "shortName": "平凉",
          "areaCode": "0933",
          "code": 620800,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3066,
        },
        {
          "areaName": "崆峒区",
          "shortName": "崆峒",
          "areaCode": "0933",
          "code": 620802,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3067,
        },
        {
          "areaName": "泾川县",
          "shortName": "泾川",
          "areaCode": "0933",
          "code": 620821,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3068,
        },
        {
          "areaName": "灵台县",
          "shortName": "灵台",
          "areaCode": "0933",
          "code": 620822,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3069,
        },
        {
          "areaName": "崇信县",
          "shortName": "崇信",
          "areaCode": "0933",
          "code": 620823,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3070,
        },
        {
          "areaName": "华亭县",
          "shortName": "华亭",
          "areaCode": "0933",
          "code": 620824,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3071,
        },
        {
          "areaName": "庄浪县",
          "shortName": "庄浪",
          "areaCode": "0933",
          "code": 620825,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3072,
        },
        {
          "areaName": "静宁县",
          "shortName": "静宁",
          "areaCode": "0933",
          "code": 620826,
          "parentCode": 620800,
          "level": 4,
          "children": null,
          "id": 3073,
        },
        {
          "areaName": "酒泉市",
          "shortName": "酒泉",
          "areaCode": "0937",
          "code": 620900,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3074,
        },
        {
          "areaName": "肃州区",
          "shortName": "肃州",
          "areaCode": "0937",
          "code": 620902,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3075,
        },
        {
          "areaName": "金塔县",
          "shortName": "金塔",
          "areaCode": "0937",
          "code": 620921,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3076,
        },
        {
          "areaName": "瓜州县",
          "shortName": "瓜州",
          "areaCode": "0937",
          "code": 620922,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3077,
        },
        {
          "areaName": "肃北蒙古族自治县",
          "shortName": "肃北",
          "areaCode": "0937",
          "code": 620923,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3078,
        },
        {
          "areaName": "阿克塞哈萨克族自治县",
          "shortName": "阿克塞",
          "areaCode": "0937",
          "code": 620924,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3079,
        },
        {
          "areaName": "玉门市",
          "shortName": "玉门",
          "areaCode": "0937",
          "code": 620981,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3080,
        },
        {
          "areaName": "敦煌市",
          "shortName": "敦煌",
          "areaCode": "0937",
          "code": 620982,
          "parentCode": 620900,
          "level": 4,
          "children": null,
          "id": 3081,
        },
        {
          "areaName": "庆阳市",
          "shortName": "庆阳",
          "areaCode": "0934",
          "code": 621000,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3082,
        },
        {
          "areaName": "西峰区",
          "shortName": "西峰",
          "areaCode": "0934",
          "code": 621002,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3083,
        },
        {
          "areaName": "庆城县",
          "shortName": "庆城",
          "areaCode": "0934",
          "code": 621021,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3084,
        },
        {
          "areaName": "环县",
          "shortName": "环县",
          "areaCode": "0934",
          "code": 621022,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3085,
        },
        {
          "areaName": "华池县",
          "shortName": "华池",
          "areaCode": "0934",
          "code": 621023,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3086,
        },
        {
          "areaName": "合水县",
          "shortName": "合水",
          "areaCode": "0934",
          "code": 621024,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3087,
        },
        {
          "areaName": "正宁县",
          "shortName": "正宁",
          "areaCode": "0934",
          "code": 621025,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3088,
        },
        {
          "areaName": "宁县",
          "shortName": "宁县",
          "areaCode": "0934",
          "code": 621026,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3089,
        },
        {
          "areaName": "镇原县",
          "shortName": "镇原",
          "areaCode": "0934",
          "code": 621027,
          "parentCode": 621000,
          "level": 4,
          "children": null,
          "id": 3090,
        },
        {
          "areaName": "定西市",
          "shortName": "定西",
          "areaCode": "0932",
          "code": 621100,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3091,
        },
        {
          "areaName": "安定区",
          "shortName": "安定",
          "areaCode": "0932",
          "code": 621102,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3092,
        },
        {
          "areaName": "通渭县",
          "shortName": "通渭",
          "areaCode": "0932",
          "code": 621121,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3093,
        },
        {
          "areaName": "陇西县",
          "shortName": "陇西",
          "areaCode": "0932",
          "code": 621122,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3094,
        },
        {
          "areaName": "渭源县",
          "shortName": "渭源",
          "areaCode": "0932",
          "code": 621123,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3095,
        },
        {
          "areaName": "临洮县",
          "shortName": "临洮",
          "areaCode": "0932",
          "code": 621124,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3096,
        },
        {
          "areaName": "漳县",
          "shortName": "漳县",
          "areaCode": "0932",
          "code": 621125,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3097,
        },
        {
          "areaName": "岷县",
          "shortName": "岷县",
          "areaCode": "0932",
          "code": 621126,
          "parentCode": 621100,
          "level": 4,
          "children": null,
          "id": 3098,
        },
        {
          "areaName": "陇南市",
          "shortName": "陇南",
          "areaCode": "0939",
          "code": 621200,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3099,
        },
        {
          "areaName": "武都区",
          "shortName": "武都",
          "areaCode": "0939",
          "code": 621202,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3100,
        },
        {
          "areaName": "成县",
          "shortName": "成县",
          "areaCode": "0939",
          "code": 621221,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3101,
        },
        {
          "areaName": "文县",
          "shortName": "文县",
          "areaCode": "0939",
          "code": 621222,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3102,
        },
        {
          "areaName": "宕昌县",
          "shortName": "宕昌",
          "areaCode": "0939",
          "code": 621223,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3103,
        },
        {
          "areaName": "康县",
          "shortName": "康县",
          "areaCode": "0939",
          "code": 621224,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3104,
        },
        {
          "areaName": "西和县",
          "shortName": "西和",
          "areaCode": "0939",
          "code": 621225,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3105,
        },
        {
          "areaName": "礼县",
          "shortName": "礼县",
          "areaCode": "0939",
          "code": 621226,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3106,
        },
        {
          "areaName": "徽县",
          "shortName": "徽县",
          "areaCode": "0939",
          "code": 621227,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3107,
        },
        {
          "areaName": "两当县",
          "shortName": "两当",
          "areaCode": "0939",
          "code": 621228,
          "parentCode": 621200,
          "level": 4,
          "children": null,
          "id": 3108,
        },
        {
          "areaName": "临夏回族自治州",
          "shortName": "临夏",
          "areaCode": "0930",
          "code": 622900,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3109,
        },
        {
          "areaName": "临夏市",
          "shortName": "临夏",
          "areaCode": "0930",
          "code": 622901,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3110,
        },
        {
          "areaName": "临夏县",
          "shortName": "临夏",
          "areaCode": "0930",
          "code": 622921,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3111,
        },
        {
          "areaName": "康乐县",
          "shortName": "康乐",
          "areaCode": "0930",
          "code": 622922,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3112,
        },
        {
          "areaName": "永靖县",
          "shortName": "永靖",
          "areaCode": "0930",
          "code": 622923,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3113,
        },
        {
          "areaName": "广河县",
          "shortName": "广河",
          "areaCode": "0930",
          "code": 622924,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3114,
        },
        {
          "areaName": "和政县",
          "shortName": "和政",
          "areaCode": "0930",
          "code": 622925,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3115,
        },
        {
          "areaName": "东乡族自治县",
          "shortName": "东乡族",
          "areaCode": "0930",
          "code": 622926,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3116,
        },
        {
          "areaName": "积石山保安族东乡族撒拉族自治县",
          "shortName": "积石山",
          "areaCode": "0930",
          "code": 622927,
          "parentCode": 622900,
          "level": 4,
          "children": null,
          "id": 3117,
        },
        {
          "areaName": "甘南藏族自治州",
          "shortName": "甘南",
          "areaCode": "0941",
          "code": 623000,
          "parentCode": 620000,
          "level": 3,
          "children": null,
          "id": 3118,
        },
        {
          "areaName": "合作市",
          "shortName": "合作",
          "areaCode": "0941",
          "code": 623001,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3119,
        },
        {
          "areaName": "临潭县",
          "shortName": "临潭",
          "areaCode": "0941",
          "code": 623021,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3120,
        },
        {
          "areaName": "卓尼县",
          "shortName": "卓尼",
          "areaCode": "0941",
          "code": 623022,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3121,
        },
        {
          "areaName": "舟曲县",
          "shortName": "舟曲",
          "areaCode": "0941",
          "code": 623023,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3122,
        },
        {
          "areaName": "迭部县",
          "shortName": "迭部",
          "areaCode": "0941",
          "code": 623024,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3123,
        },
        {
          "areaName": "玛曲县",
          "shortName": "玛曲",
          "areaCode": "0941",
          "code": 623025,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3124,
        },
        {
          "areaName": "碌曲县",
          "shortName": "碌曲",
          "areaCode": "0941",
          "code": 623026,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3125,
        },
        {
          "areaName": "夏河县",
          "shortName": "夏河",
          "areaCode": "0941",
          "code": 623027,
          "parentCode": 623000,
          "level": 4,
          "children": null,
          "id": 3126,
        }
      ],
      "id": 3023,
    },
    {
      "areaName": "青海省",
      "shortName": "青海",
      "code": 630000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "西宁市",
          "shortName": "西宁",
          "areaCode": "0971",
          "code": 630100,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3128,
        },
        {
          "areaName": "城东区",
          "shortName": "城东",
          "areaCode": "0971",
          "code": 630102,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3129,
        },
        {
          "areaName": "城中区",
          "shortName": "城中",
          "areaCode": "0971",
          "code": 630103,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3130,
        },
        {
          "areaName": "城西区",
          "shortName": "城西",
          "areaCode": "0971",
          "code": 630104,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3131,
        },
        {
          "areaName": "城北区",
          "shortName": "城北",
          "areaCode": "0971",
          "code": 630105,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3132,
        },
        {
          "areaName": "大通回族土族自治县",
          "shortName": "大通",
          "areaCode": "0971",
          "code": 630121,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3133,
        },
        {
          "areaName": "湟中县",
          "shortName": "湟中",
          "areaCode": "0971",
          "code": 630122,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3134,
        },
        {
          "areaName": "湟源县",
          "shortName": "湟源",
          "areaCode": "0971",
          "code": 630123,
          "parentCode": 630100,
          "level": 4,
          "children": null,
          "id": 3135,
        },
        {
          "areaName": "海东市",
          "shortName": "海东",
          "areaCode": "0972",
          "code": 630200,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3136,
        },
        {
          "areaName": "乐都区",
          "shortName": "乐都",
          "areaCode": "0972",
          "code": 630202,
          "parentCode": 630200,
          "level": 4,
          "children": null,
          "id": 3137,
        },
        {
          "areaName": "平安县",
          "shortName": "平安",
          "areaCode": "0972",
          "code": 630221,
          "parentCode": 630200,
          "level": 4,
          "children": null,
          "id": 3138,
        },
        {
          "areaName": "民和回族土族自治县",
          "shortName": "民和",
          "areaCode": "0972",
          "code": 630222,
          "parentCode": 630200,
          "level": 4,
          "children": null,
          "id": 3139,
        },
        {
          "areaName": "互助土族自治县",
          "shortName": "互助",
          "areaCode": "0972",
          "code": 630223,
          "parentCode": 630200,
          "level": 4,
          "children": null,
          "id": 3140,
        },
        {
          "areaName": "化隆回族自治县",
          "shortName": "化隆",
          "areaCode": "0972",
          "code": 630224,
          "parentCode": 630200,
          "level": 4,
          "children": null,
          "id": 3141,
        },
        {
          "areaName": "循化撒拉族自治县",
          "shortName": "循化",
          "areaCode": "0972",
          "code": 630225,
          "parentCode": 630200,
          "level": 4,
          "children": null,
          "id": 3142,
        },
        {
          "areaName": "海北藏族自治州",
          "shortName": "海北",
          "areaCode": "0970",
          "code": 632200,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3143,
        },
        {
          "areaName": "门源回族自治县",
          "shortName": "门源",
          "areaCode": "0970",
          "code": 632221,
          "parentCode": 632200,
          "level": 4,
          "children": null,
          "id": 3144,
        },
        {
          "areaName": "祁连县",
          "shortName": "祁连",
          "areaCode": "0970",
          "code": 632222,
          "parentCode": 632200,
          "level": 4,
          "children": null,
          "id": 3145,
        },
        {
          "areaName": "海晏县",
          "shortName": "海晏",
          "areaCode": "0970",
          "code": 632223,
          "parentCode": 632200,
          "level": 4,
          "children": null,
          "id": 3146,
        },
        {
          "areaName": "刚察县",
          "shortName": "刚察",
          "areaCode": "0970",
          "code": 632224,
          "parentCode": 632200,
          "level": 4,
          "children": null,
          "id": 3147,
        },
        {
          "areaName": "黄南藏族自治州",
          "shortName": "黄南",
          "areaCode": "0973",
          "code": 632300,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3148,
        },
        {
          "areaName": "同仁县",
          "shortName": "同仁",
          "areaCode": "0973",
          "code": 632321,
          "parentCode": 632300,
          "level": 4,
          "children": null,
          "id": 3149,
        },
        {
          "areaName": "尖扎县",
          "shortName": "尖扎",
          "areaCode": "0973",
          "code": 632322,
          "parentCode": 632300,
          "level": 4,
          "children": null,
          "id": 3150,
        },
        {
          "areaName": "泽库县",
          "shortName": "泽库",
          "areaCode": "0973",
          "code": 632323,
          "parentCode": 632300,
          "level": 4,
          "children": null,
          "id": 3151,
        },
        {
          "areaName": "河南蒙古族自治县",
          "shortName": "河南",
          "areaCode": "0973",
          "code": 632324,
          "parentCode": 632300,
          "level": 4,
          "children": null,
          "id": 3152,
        },
        {
          "areaName": "海南藏族自治州",
          "shortName": "海南",
          "areaCode": "0974",
          "code": 632500,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3153,
        },
        {
          "areaName": "共和县",
          "shortName": "共和",
          "areaCode": "0974",
          "code": 632521,
          "parentCode": 632500,
          "level": 4,
          "children": null,
          "id": 3154,
        },
        {
          "areaName": "同德县",
          "shortName": "同德",
          "areaCode": "0974",
          "code": 632522,
          "parentCode": 632500,
          "level": 4,
          "children": null,
          "id": 3155,
        },
        {
          "areaName": "贵德县",
          "shortName": "贵德",
          "areaCode": "0974",
          "code": 632523,
          "parentCode": 632500,
          "level": 4,
          "children": null,
          "id": 3156,
        },
        {
          "areaName": "兴海县",
          "shortName": "兴海",
          "areaCode": "0974",
          "code": 632524,
          "parentCode": 632500,
          "level": 4,
          "children": null,
          "id": 3157,
        },
        {
          "areaName": "贵南县",
          "shortName": "贵南",
          "areaCode": "0974",
          "code": 632525,
          "parentCode": 632500,
          "level": 4,
          "children": null,
          "id": 3158,
        },
        {
          "areaName": "果洛藏族自治州",
          "shortName": "果洛",
          "areaCode": "0975",
          "code": 632600,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3159,
        },
        {
          "areaName": "玛沁县",
          "shortName": "玛沁",
          "areaCode": "0975",
          "code": 632621,
          "parentCode": 632600,
          "level": 4,
          "children": null,
          "id": 3160,
        },
        {
          "areaName": "班玛县",
          "shortName": "班玛",
          "areaCode": "0975",
          "code": 632622,
          "parentCode": 632600,
          "level": 4,
          "children": null,
          "id": 3161,
        },
        {
          "areaName": "甘德县",
          "shortName": "甘德",
          "areaCode": "0975",
          "code": 632623,
          "parentCode": 632600,
          "level": 4,
          "children": null,
          "id": 3162,
        },
        {
          "areaName": "达日县",
          "shortName": "达日",
          "areaCode": "0975",
          "code": 632624,
          "parentCode": 632600,
          "level": 4,
          "children": null,
          "id": 3163,
        },
        {
          "areaName": "久治县",
          "shortName": "久治",
          "areaCode": "0975",
          "code": 632625,
          "parentCode": 632600,
          "level": 4,
          "children": null,
          "id": 3164,
        },
        {
          "areaName": "玛多县",
          "shortName": "玛多",
          "areaCode": "0975",
          "code": 632626,
          "parentCode": 632600,
          "level": 4,
          "children": null,
          "id": 3165,
        },
        {
          "areaName": "玉树藏族自治州",
          "shortName": "玉树",
          "areaCode": "0976",
          "code": 632700,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3166,
        },
        {
          "areaName": "玉树市",
          "shortName": "玉树",
          "areaCode": "0976",
          "code": 632701,
          "parentCode": 632700,
          "level": 4,
          "children": null,
          "id": 3167,
        },
        {
          "areaName": "杂多县",
          "shortName": "杂多",
          "areaCode": "0976",
          "code": 632722,
          "parentCode": 632700,
          "level": 4,
          "children": null,
          "id": 3168,
        },
        {
          "areaName": "称多县",
          "shortName": "称多",
          "areaCode": "0976",
          "code": 632723,
          "parentCode": 632700,
          "level": 4,
          "children": null,
          "id": 3169,
        },
        {
          "areaName": "治多县",
          "shortName": "治多",
          "areaCode": "0976",
          "code": 632724,
          "parentCode": 632700,
          "level": 4,
          "children": null,
          "id": 3170,
        },
        {
          "areaName": "囊谦县",
          "shortName": "囊谦",
          "areaCode": "0976",
          "code": 632725,
          "parentCode": 632700,
          "level": 4,
          "children": null,
          "id": 3171,
        },
        {
          "areaName": "曲麻莱县",
          "shortName": "曲麻莱",
          "areaCode": "0976",
          "code": 632726,
          "parentCode": 632700,
          "level": 4,
          "children": null,
          "id": 3172,
        },
        {
          "areaName": "海西蒙古族藏族自治州",
          "shortName": "海西",
          "areaCode": "0977",
          "code": 632800,
          "parentCode": 630000,
          "level": 3,
          "children": null,
          "id": 3173,
        },
        {
          "areaName": "格尔木市",
          "shortName": "格尔木",
          "areaCode": "0977",
          "code": 632801,
          "parentCode": 632800,
          "level": 4,
          "children": null,
          "id": 3174,
        },
        {
          "areaName": "德令哈市",
          "shortName": "德令哈",
          "areaCode": "0977",
          "code": 632802,
          "parentCode": 632800,
          "level": 4,
          "children": null,
          "id": 3175,
        },
        {
          "areaName": "乌兰县",
          "shortName": "乌兰",
          "areaCode": "0977",
          "code": 632821,
          "parentCode": 632800,
          "level": 4,
          "children": null,
          "id": 3176,
        },
        {
          "areaName": "都兰县",
          "shortName": "都兰",
          "areaCode": "0977",
          "code": 632822,
          "parentCode": 632800,
          "level": 4,
          "children": null,
          "id": 3177,
        },
        {
          "areaName": "天峻县",
          "shortName": "天峻",
          "areaCode": "0977",
          "code": 632823,
          "parentCode": 632800,
          "level": 4,
          "children": null,
          "id": 3178,
        }
      ],
      "id": 3127,
    },
    {
      "areaName": "宁夏回族自治区",
      "shortName": "宁夏",
      "code": 640000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "银川市",
          "shortName": "银川",
          "areaCode": "0951",
          "code": 640100,
          "parentCode": 640000,
          "level": 3,
          "children": null,
          "id": 3180,
        },
        {
          "areaName": "兴庆区",
          "shortName": "兴庆",
          "areaCode": "0951",
          "code": 640104,
          "parentCode": 640100,
          "level": 4,
          "children": null,
          "id": 3181,
        },
        {
          "areaName": "西夏区",
          "shortName": "西夏",
          "areaCode": "0951",
          "code": 640105,
          "parentCode": 640100,
          "level": 4,
          "children": null,
          "id": 3182,
        },
        {
          "areaName": "金凤区",
          "shortName": "金凤",
          "areaCode": "0951",
          "code": 640106,
          "parentCode": 640100,
          "level": 4,
          "children": null,
          "id": 3183,
        },
        {
          "areaName": "永宁县",
          "shortName": "永宁",
          "areaCode": "0951",
          "code": 640121,
          "parentCode": 640100,
          "level": 4,
          "children": null,
          "id": 3184,
        },
        {
          "areaName": "贺兰县",
          "shortName": "贺兰",
          "areaCode": "0951",
          "code": 640122,
          "parentCode": 640100,
          "level": 4,
          "children": null,
          "id": 3185,
        },
        {
          "areaName": "灵武市",
          "shortName": "灵武",
          "areaCode": "0951",
          "code": 640181,
          "parentCode": 640100,
          "level": 4,
          "children": null,
          "id": 3186,
        },
        {
          "areaName": "石嘴山市",
          "shortName": "石嘴山",
          "areaCode": "0952",
          "code": 640200,
          "parentCode": 640000,
          "level": 3,
          "children": null,
          "id": 3187,
        },
        {
          "areaName": "大武口区",
          "shortName": "大武口",
          "areaCode": "0952",
          "code": 640202,
          "parentCode": 640200,
          "level": 4,
          "children": null,
          "id": 3188,
        },
        {
          "areaName": "惠农区",
          "shortName": "惠农",
          "areaCode": "0952",
          "code": 640205,
          "parentCode": 640200,
          "level": 4,
          "children": null,
          "id": 3189,
        },
        {
          "areaName": "平罗县",
          "shortName": "平罗",
          "areaCode": "0952",
          "code": 640221,
          "parentCode": 640200,
          "level": 4,
          "children": null,
          "id": 3190,
        },
        {
          "areaName": "吴忠市",
          "shortName": "吴忠",
          "areaCode": "0953",
          "code": 640300,
          "parentCode": 640000,
          "level": 3,
          "children": null,
          "id": 3191,
        },
        {
          "areaName": "利通区",
          "shortName": "利通",
          "areaCode": "0953",
          "code": 640302,
          "parentCode": 640300,
          "level": 4,
          "children": null,
          "id": 3192,
        },
        {
          "areaName": "红寺堡区",
          "shortName": "红寺堡",
          "areaCode": "0953",
          "code": 640303,
          "parentCode": 640300,
          "level": 4,
          "children": null,
          "id": 3193,
        },
        {
          "areaName": "盐池县",
          "shortName": "盐池",
          "areaCode": "0953",
          "code": 640323,
          "parentCode": 640300,
          "level": 4,
          "children": null,
          "id": 3194,
        },
        {
          "areaName": "同心县",
          "shortName": "同心",
          "areaCode": "0953",
          "code": 640324,
          "parentCode": 640300,
          "level": 4,
          "children": null,
          "id": 3195,
        },
        {
          "areaName": "青铜峡市",
          "shortName": "青铜峡",
          "areaCode": "0953",
          "code": 640381,
          "parentCode": 640300,
          "level": 4,
          "children": null,
          "id": 3196,
        },
        {
          "areaName": "固原市",
          "shortName": "固原",
          "areaCode": "0954",
          "code": 640400,
          "parentCode": 640000,
          "level": 3,
          "children": null,
          "id": 3197,
        },
        {
          "areaName": "原州区",
          "shortName": "原州",
          "areaCode": "0954",
          "code": 640402,
          "parentCode": 640400,
          "level": 4,
          "children": null,
          "id": 3198,
        },
        {
          "areaName": "西吉县",
          "shortName": "西吉",
          "areaCode": "0954",
          "code": 640422,
          "parentCode": 640400,
          "level": 4,
          "children": null,
          "id": 3199,
        },
        {
          "areaName": "隆德县",
          "shortName": "隆德",
          "areaCode": "0954",
          "code": 640423,
          "parentCode": 640400,
          "level": 4,
          "children": null,
          "id": 3200,
        },
        {
          "areaName": "泾源县",
          "shortName": "泾源",
          "areaCode": "0954",
          "code": 640424,
          "parentCode": 640400,
          "level": 4,
          "children": null,
          "id": 3201,
        },
        {
          "areaName": "彭阳县",
          "shortName": "彭阳",
          "areaCode": "0954",
          "code": 640425,
          "parentCode": 640400,
          "level": 4,
          "children": null,
          "id": 3202,
        },
        {
          "areaName": "中卫市",
          "shortName": "中卫",
          "areaCode": "0955",
          "code": 640500,
          "parentCode": 640000,
          "level": 3,
          "children": null,
          "id": 3203,
        },
        {
          "areaName": "沙坡头区",
          "shortName": "沙坡头",
          "areaCode": "0955",
          "code": 640502,
          "parentCode": 640500,
          "level": 4,
          "children": null,
          "id": 3204,
        },
        {
          "areaName": "中宁县",
          "shortName": "中宁",
          "areaCode": "0955",
          "code": 640521,
          "parentCode": 640500,
          "level": 4,
          "children": null,
          "id": 3205,
        },
        {
          "areaName": "海原县",
          "shortName": "海原",
          "areaCode": "0955",
          "code": 640522,
          "parentCode": 640500,
          "level": 4,
          "children": null,
          "id": 3206,
        }
      ],
      "id": 3179,
    },
    {
      "areaName": "新疆维吾尔自治区",
      "shortName": "新疆",
      "code": 650000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "乌鲁木齐市",
          "shortName": "乌鲁木齐",
          "areaCode": "0991",
          "code": 650100,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3208,
        },
        {
          "areaName": "天山区",
          "shortName": "天山",
          "areaCode": "0991",
          "code": 650102,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3209,
        },
        {
          "areaName": "沙依巴克区",
          "shortName": "沙依巴克",
          "areaCode": "0991",
          "code": 650103,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3210,
        },
        {
          "areaName": "新市区",
          "shortName": "新市",
          "areaCode": "0991",
          "code": 650104,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3211,
        },
        {
          "areaName": "水磨沟区",
          "shortName": "水磨沟",
          "areaCode": "0991",
          "code": 650105,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3212,
        },
        {
          "areaName": "头屯河区",
          "shortName": "头屯河",
          "areaCode": "0991",
          "code": 650106,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3213,
        },
        {
          "areaName": "达坂城区",
          "shortName": "达坂城",
          "areaCode": "0991",
          "code": 650107,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3214,
        },
        {
          "areaName": "米东区",
          "shortName": "米东",
          "areaCode": "0991",
          "code": 650109,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3215,
        },
        {
          "areaName": "乌鲁木齐县",
          "shortName": "乌鲁木齐",
          "areaCode": "0991",
          "code": 650121,
          "parentCode": 650100,
          "level": 4,
          "children": null,
          "id": 3216,
        },
        {
          "areaName": "克拉玛依市",
          "shortName": "克拉玛依",
          "areaCode": "0990",
          "code": 650200,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3217,
        },
        {
          "areaName": "独山子区",
          "shortName": "独山子",
          "areaCode": "0992",
          "code": 650202,
          "parentCode": 650200,
          "level": 4,
          "children": null,
          "id": 3218,
        },
        {
          "areaName": "克拉玛依区",
          "shortName": "克拉玛依",
          "areaCode": "0990",
          "code": 650203,
          "parentCode": 650200,
          "level": 4,
          "children": null,
          "id": 3219,
        },
        {
          "areaName": "白碱滩区",
          "shortName": "白碱滩",
          "areaCode": "0990",
          "code": 650204,
          "parentCode": 650200,
          "level": 4,
          "children": null,
          "id": 3220,
        },
        {
          "areaName": "乌尔禾区",
          "shortName": "乌尔禾",
          "areaCode": "0990",
          "code": 650205,
          "parentCode": 650200,
          "level": 4,
          "children": null,
          "id": 3221,
        },
        {
          "areaName": "吐鲁番地区",
          "shortName": "吐鲁番",
          "areaCode": "0995",
          "code": 652100,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3222,
        },
        {
          "areaName": "吐鲁番市",
          "shortName": "吐鲁番",
          "areaCode": "0995",
          "code": 652101,
          "parentCode": 652100,
          "level": 4,
          "children": null,
          "id": 3223,
        },
        {
          "areaName": "鄯善县",
          "shortName": "鄯善",
          "areaCode": "0995",
          "code": 652122,
          "parentCode": 652100,
          "level": 4,
          "children": null,
          "id": 3224,
        },
        {
          "areaName": "托克逊县",
          "shortName": "托克逊",
          "areaCode": "0995",
          "code": 652123,
          "parentCode": 652100,
          "level": 4,
          "children": null,
          "id": 3225,
        },
        {
          "areaName": "哈密地区",
          "shortName": "哈密",
          "areaCode": "0902",
          "code": 652200,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3226,
        },
        {
          "areaName": "哈密市",
          "shortName": "哈密",
          "areaCode": "0902",
          "code": 652201,
          "parentCode": 652200,
          "level": 4,
          "children": null,
          "id": 3227,
        },
        {
          "areaName": "巴里坤哈萨克自治县",
          "shortName": "巴里坤",
          "areaCode": "0902",
          "code": 652222,
          "parentCode": 652200,
          "level": 4,
          "children": null,
          "id": 3228,
        },
        {
          "areaName": "伊吾县",
          "shortName": "伊吾",
          "areaCode": "0902",
          "code": 652223,
          "parentCode": 652200,
          "level": 4,
          "children": null,
          "id": 3229,
        },
        {
          "areaName": "昌吉回族自治州",
          "shortName": "昌吉",
          "areaCode": "0994",
          "code": 652300,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3230,
        },
        {
          "areaName": "昌吉市",
          "shortName": "昌吉",
          "areaCode": "0994",
          "code": 652301,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3231,
        },
        {
          "areaName": "阜康市",
          "shortName": "阜康",
          "areaCode": "0994",
          "code": 652302,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3232,
        },
        {
          "areaName": "呼图壁县",
          "shortName": "呼图壁",
          "areaCode": "0994",
          "code": 652323,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3233,
        },
        {
          "areaName": "玛纳斯县",
          "shortName": "玛纳斯",
          "areaCode": "0994",
          "code": 652324,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3234,
        },
        {
          "areaName": "奇台县",
          "shortName": "奇台",
          "areaCode": "0994",
          "code": 652325,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3235,
        },
        {
          "areaName": "吉木萨尔县",
          "shortName": "吉木萨尔",
          "areaCode": "0994",
          "code": 652327,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3236,
        },
        {
          "areaName": "木垒哈萨克自治县",
          "shortName": "木垒",
          "areaCode": "0994",
          "code": 652328,
          "parentCode": 652300,
          "level": 4,
          "children": null,
          "id": 3237,
        },
        {
          "areaName": "博尔塔拉蒙古自治州",
          "shortName": "博尔塔拉",
          "areaCode": "0909",
          "code": 652700,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3238,
        },
        {
          "areaName": "博乐市",
          "shortName": "博乐",
          "areaCode": "0909",
          "code": 652701,
          "parentCode": 652700,
          "level": 4,
          "children": null,
          "id": 3239,
        },
        {
          "areaName": "阿拉山口市",
          "shortName": "阿拉山口",
          "areaCode": "0909",
          "code": 652702,
          "parentCode": 652700,
          "level": 4,
          "children": null,
          "id": 3240,
        },
        {
          "areaName": "精河县",
          "shortName": "精河",
          "areaCode": "0909",
          "code": 652722,
          "parentCode": 652700,
          "level": 4,
          "children": null,
          "id": 3241,
        },
        {
          "areaName": "温泉县",
          "shortName": "温泉",
          "areaCode": "0909",
          "code": 652723,
          "parentCode": 652700,
          "level": 4,
          "children": null,
          "id": 3242,
        },
        {
          "areaName": "巴音郭楞蒙古自治州",
          "shortName": "巴音郭楞",
          "areaCode": "0996",
          "code": 652800,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3243,
        },
        {
          "areaName": "库尔勒市",
          "shortName": "库尔勒",
          "areaCode": "0996",
          "code": 652801,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3244,
        },
        {
          "areaName": "轮台县",
          "shortName": "轮台",
          "areaCode": "0996",
          "code": 652822,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3245,
        },
        {
          "areaName": "尉犁县",
          "shortName": "尉犁",
          "areaCode": "0996",
          "code": 652823,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3246,
        },
        {
          "areaName": "若羌县",
          "shortName": "若羌",
          "areaCode": "0996",
          "code": 652824,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3247,
        },
        {
          "areaName": "且末县",
          "shortName": "且末",
          "areaCode": "0996",
          "code": 652825,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3248,
        },
        {
          "areaName": "焉耆回族自治县",
          "shortName": "焉耆",
          "areaCode": "0996",
          "code": 652826,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3249,
        },
        {
          "areaName": "和静县",
          "shortName": "和静",
          "areaCode": "0996",
          "code": 652827,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3250,
        },
        {
          "areaName": "和硕县",
          "shortName": "和硕",
          "areaCode": "0996",
          "code": 652828,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3251,
        },
        {
          "areaName": "博湖县",
          "shortName": "博湖",
          "areaCode": "0996",
          "code": 652829,
          "parentCode": 652800,
          "level": 4,
          "children": null,
          "id": 3252,
        },
        {
          "areaName": "阿克苏地区",
          "shortName": "阿克苏",
          "areaCode": "0997",
          "code": 652900,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3253,
        },
        {
          "areaName": "阿克苏市",
          "shortName": "阿克苏",
          "areaCode": "0997",
          "code": 652901,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3254,
        },
        {
          "areaName": "温宿县",
          "shortName": "温宿",
          "areaCode": "0997",
          "code": 652922,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3255,
        },
        {
          "areaName": "库车县",
          "shortName": "库车",
          "areaCode": "0997",
          "code": 652923,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3256,
        },
        {
          "areaName": "沙雅县",
          "shortName": "沙雅",
          "areaCode": "0997",
          "code": 652924,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3257,
        },
        {
          "areaName": "新和县",
          "shortName": "新和",
          "areaCode": "0997",
          "code": 652925,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3258,
        },
        {
          "areaName": "拜城县",
          "shortName": "拜城",
          "areaCode": "0997",
          "code": 652926,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3259,
        },
        {
          "areaName": "乌什县",
          "shortName": "乌什",
          "areaCode": "0997",
          "code": 652927,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3260,
        },
        {
          "areaName": "阿瓦提县",
          "shortName": "阿瓦提",
          "areaCode": "0997",
          "code": 652928,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3261,
        },
        {
          "areaName": "柯坪县",
          "shortName": "柯坪",
          "areaCode": "0997",
          "code": 652929,
          "parentCode": 652900,
          "level": 4,
          "children": null,
          "id": 3262,
        },
        {
          "areaName": "克孜勒苏柯尔克孜自治州",
          "shortName": "克孜勒苏",
          "areaCode": "0908",
          "code": 653000,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3263,
        },
        {
          "areaName": "阿图什市",
          "shortName": "阿图什",
          "areaCode": "0908",
          "code": 653001,
          "parentCode": 653000,
          "level": 4,
          "children": null,
          "id": 3264,
        },
        {
          "areaName": "阿克陶县",
          "shortName": "阿克陶",
          "areaCode": "0908",
          "code": 653022,
          "parentCode": 653000,
          "level": 4,
          "children": null,
          "id": 3265,
        },
        {
          "areaName": "阿合奇县",
          "shortName": "阿合奇",
          "areaCode": "0997",
          "code": 653023,
          "parentCode": 653000,
          "level": 4,
          "children": null,
          "id": 3266,
        },
        {
          "areaName": "乌恰县",
          "shortName": "乌恰",
          "areaCode": "0908",
          "code": 653024,
          "parentCode": 653000,
          "level": 4,
          "children": null,
          "id": 3267,
        },
        {
          "areaName": "喀什地区",
          "shortName": "喀什",
          "areaCode": "0998",
          "code": 653100,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3268,
        },
        {
          "areaName": "喀什市",
          "shortName": "喀什",
          "areaCode": "0998",
          "code": 653101,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3269,
        },
        {
          "areaName": "疏附县",
          "shortName": "疏附",
          "areaCode": "0998",
          "code": 653121,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3270,
        },
        {
          "areaName": "疏勒县",
          "shortName": "疏勒",
          "areaCode": "0998",
          "code": 653122,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3271,
        },
        {
          "areaName": "英吉沙县",
          "shortName": "英吉沙",
          "areaCode": "0998",
          "code": 653123,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3272,
        },
        {
          "areaName": "泽普县",
          "shortName": "泽普",
          "areaCode": "0998",
          "code": 653124,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3273,
        },
        {
          "areaName": "莎车县",
          "shortName": "莎车",
          "areaCode": "0998",
          "code": 653125,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3274,
        },
        {
          "areaName": "叶城县",
          "shortName": "叶城",
          "areaCode": "0998",
          "code": 653126,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3275,
        },
        {
          "areaName": "麦盖提县",
          "shortName": "麦盖提",
          "areaCode": "0998",
          "code": 653127,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3276,
        },
        {
          "areaName": "岳普湖县",
          "shortName": "岳普湖",
          "areaCode": "0998",
          "code": 653128,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3277,
        },
        {
          "areaName": "伽师县",
          "shortName": "伽师",
          "areaCode": "0998",
          "code": 653129,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3278,
        },
        {
          "areaName": "巴楚县",
          "shortName": "巴楚",
          "areaCode": "0998",
          "code": 653130,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3279,
        },
        {
          "areaName": "塔什库尔干塔吉克自治县",
          "shortName": "塔什库尔干塔吉克",
          "areaCode": "0998",
          "code": 653131,
          "parentCode": 653100,
          "level": 4,
          "children": null,
          "id": 3280,
        },
        {
          "areaName": "和田地区",
          "shortName": "和田",
          "areaCode": "0903",
          "code": 653200,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3281,
        },
        {
          "areaName": "和田市",
          "shortName": "和田市",
          "areaCode": "0903",
          "code": 653201,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3282,
        },
        {
          "areaName": "和田县",
          "shortName": "和田县",
          "areaCode": "0903",
          "code": 653221,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3283,
        },
        {
          "areaName": "墨玉县",
          "shortName": "墨玉",
          "areaCode": "0903",
          "code": 653222,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3284,
        },
        {
          "areaName": "皮山县",
          "shortName": "皮山",
          "areaCode": "0903",
          "code": 653223,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3285,
        },
        {
          "areaName": "洛浦县",
          "shortName": "洛浦",
          "areaCode": "0903",
          "code": 653224,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3286,
        },
        {
          "areaName": "策勒县",
          "shortName": "策勒",
          "areaCode": "0903",
          "code": 653225,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3287,
        },
        {
          "areaName": "于田县",
          "shortName": "于田",
          "areaCode": "0903",
          "code": 653226,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3288,
        },
        {
          "areaName": "民丰县",
          "shortName": "民丰",
          "areaCode": "0903",
          "code": 653227,
          "parentCode": 653200,
          "level": 4,
          "children": null,
          "id": 3289,
        },
        {
          "areaName": "伊犁哈萨克自治州",
          "shortName": "伊犁",
          "areaCode": "0999",
          "code": 654000,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3290,
        },
        {
          "areaName": "伊宁市",
          "shortName": "伊宁",
          "areaCode": "0999",
          "code": 654002,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3291,
        },
        {
          "areaName": "奎屯市",
          "shortName": "奎屯",
          "areaCode": "0992",
          "code": 654003,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3292,
        },
        {
          "areaName": "霍尔果斯市",
          "shortName": "霍尔果斯",
          "areaCode": "0999",
          "code": 654004,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3293,
        },
        {
          "areaName": "伊宁县",
          "shortName": "伊宁",
          "areaCode": "0999",
          "code": 654021,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3294,
        },
        {
          "areaName": "察布查尔锡伯自治县",
          "shortName": "察布查尔锡伯",
          "areaCode": "0999",
          "code": 654022,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3295,
        },
        {
          "areaName": "霍城县",
          "shortName": "霍城",
          "areaCode": "0999",
          "code": 654023,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3296,
        },
        {
          "areaName": "巩留县",
          "shortName": "巩留",
          "areaCode": "0999",
          "code": 654024,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3297,
        },
        {
          "areaName": "新源县",
          "shortName": "新源",
          "areaCode": "0999",
          "code": 654025,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3298,
        },
        {
          "areaName": "昭苏县",
          "shortName": "昭苏",
          "areaCode": "0999",
          "code": 654026,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3299,
        },
        {
          "areaName": "特克斯县",
          "shortName": "特克斯",
          "areaCode": "0999",
          "code": 654027,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3300,
        },
        {
          "areaName": "尼勒克县",
          "shortName": "尼勒克",
          "areaCode": "0999",
          "code": 654028,
          "parentCode": 654000,
          "level": 4,
          "children": null,
          "id": 3301,
        },
        {
          "areaName": "塔城地区",
          "shortName": "塔城",
          "areaCode": "0901",
          "code": 654200,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3302,
        },
        {
          "areaName": "塔城市",
          "shortName": "塔城",
          "areaCode": "0901",
          "code": 654201,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3303,
        },
        {
          "areaName": "乌苏市",
          "shortName": "乌苏",
          "areaCode": "0992",
          "code": 654202,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3304,
        },
        {
          "areaName": "额敏县",
          "shortName": "额敏",
          "areaCode": "0901",
          "code": 654221,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3305,
        },
        {
          "areaName": "沙湾县",
          "shortName": "沙湾",
          "areaCode": "0993",
          "code": 654223,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3306,
        },
        {
          "areaName": "托里县",
          "shortName": "托里",
          "areaCode": "0901",
          "code": 654224,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3307,
        },
        {
          "areaName": "裕民县",
          "shortName": "裕民",
          "areaCode": "0901",
          "code": 654225,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3308,
        },
        {
          "areaName": "和布克赛尔蒙古自治县",
          "shortName": "和布克赛尔",
          "areaCode": "0990",
          "code": 654226,
          "parentCode": 654200,
          "level": 4,
          "children": null,
          "id": 3309,
        },
        {
          "areaName": "阿勒泰地区",
          "shortName": "阿勒泰",
          "areaCode": "0906",
          "code": 654300,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3310,
        },
        {
          "areaName": "阿勒泰市",
          "shortName": "阿勒泰",
          "areaCode": "0906",
          "code": 654301,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3311,
        },
        {
          "areaName": "布尔津县",
          "shortName": "布尔津",
          "areaCode": "0906",
          "code": 654321,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3312,
        },
        {
          "areaName": "富蕴县",
          "shortName": "富蕴",
          "areaCode": "0906",
          "code": 654322,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3313,
        },
        {
          "areaName": "福海县",
          "shortName": "福海",
          "areaCode": "0906",
          "code": 654323,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3314,
        },
        {
          "areaName": "哈巴河县",
          "shortName": "哈巴河",
          "areaCode": "0906",
          "code": 654324,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3315,
        },
        {
          "areaName": "青河县",
          "shortName": "青河",
          "areaCode": "0906",
          "code": 654325,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3316,
        },
        {
          "areaName": "吉木乃县",
          "shortName": "吉木乃",
          "areaCode": "0906",
          "code": 654326,
          "parentCode": 654300,
          "level": 4,
          "children": null,
          "id": 3317,
        },
        {
          "areaName": "直辖县级",
          "shortName": "",
          "code": 659000,
          "parentCode": 650000,
          "level": 3,
          "children": null,
          "id": 3318,
        },
        {
          "areaName": "石河子市",
          "shortName": "石河子",
          "areaCode": "0993",
          "code": 659001,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3319,
        },
        {
          "areaName": "阿拉尔市",
          "shortName": "阿拉尔",
          "areaCode": "0997",
          "code": 659002,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3320,
        },
        {
          "areaName": "图木舒克市",
          "shortName": "图木舒克",
          "areaCode": "0998",
          "code": 659003,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3321,
        },
        {
          "areaName": "五家渠市",
          "shortName": "五家渠",
          "areaCode": "0994",
          "code": 659004,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3322,
        },
        {
          "areaName": "北屯市",
          "shortName": "北屯",
          "areaCode": "0906",
          "code": 659005,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3323,
        },
        {
          "areaName": "铁门关市",
          "shortName": "铁门关",
          "areaCode": "0906",
          "code": 659006,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3324,
        },
        {
          "areaName": "双河市",
          "shortName": "双河",
          "areaCode": "0909",
          "code": 659007,
          "parentCode": 659000,
          "level": 4,
          "children": null,
          "id": 3325,
        }
      ],
      "id": 3207,
    },
    {
      "areaName": "台湾",
      "shortName": "台湾",
      "code": 710000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "台北市",
          "shortName": "台北",
          "areaCode": "02",
          "code": 710100,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3327,
        },
        {
          "areaName": "松山区",
          "shortName": "松山",
          "areaCode": "02",
          "code": 710101,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3328,
        },
        {
          "areaName": "信义区",
          "shortName": "信义",
          "areaCode": "02",
          "code": 710102,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3329,
        },
        {
          "areaName": "大安区",
          "shortName": "大安",
          "areaCode": "02",
          "code": 710103,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3330,
        },
        {
          "areaName": "中山区",
          "shortName": "中山",
          "areaCode": "02",
          "code": 710104,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3331,
        },
        {
          "areaName": "中正区",
          "shortName": "中正",
          "areaCode": "02",
          "code": 710105,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3332,
        },
        {
          "areaName": "大同区",
          "shortName": "大同",
          "areaCode": "02",
          "code": 710106,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3333,
        },
        {
          "areaName": "万华区",
          "shortName": "万华",
          "areaCode": "02",
          "code": 710107,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3334,
        },
        {
          "areaName": "文山区",
          "shortName": "文山",
          "areaCode": "02",
          "code": 710108,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3335,
        },
        {
          "areaName": "南港区",
          "shortName": "南港",
          "areaCode": "02",
          "code": 710109,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3336,
        },
        {
          "areaName": "内湖区",
          "shortName": "内湖",
          "areaCode": "02",
          "code": 710110,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3337,
        },
        {
          "areaName": "士林区",
          "shortName": "士林",
          "areaCode": "02",
          "code": 710111,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3338,
        },
        {
          "areaName": "北投区",
          "shortName": "北投",
          "areaCode": "02",
          "code": 710112,
          "parentCode": 710100,
          "level": 4,
          "children": null,
          "id": 3339,
        },
        {
          "areaName": "高雄市",
          "shortName": "高雄",
          "areaCode": "07",
          "code": 710200,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3340,
        },
        {
          "areaName": "盐埕区",
          "shortName": "盐埕",
          "areaCode": "07",
          "code": 710201,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3341,
        },
        {
          "areaName": "鼓山区",
          "shortName": "鼓山",
          "areaCode": "07",
          "code": 710202,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3342,
        },
        {
          "areaName": "左营区",
          "shortName": "左营",
          "areaCode": "07",
          "code": 710203,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3343,
        },
        {
          "areaName": "楠梓区",
          "shortName": "楠梓",
          "areaCode": "07",
          "code": 710204,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3344,
        },
        {
          "areaName": "三民区",
          "shortName": "三民",
          "areaCode": "07",
          "code": 710205,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3345,
        },
        {
          "areaName": "新兴区",
          "shortName": "新兴",
          "areaCode": "07",
          "code": 710206,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3346,
        },
        {
          "areaName": "前金区",
          "shortName": "前金",
          "areaCode": "07",
          "code": 710207,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3347,
        },
        {
          "areaName": "苓雅区",
          "shortName": "苓雅",
          "areaCode": "07",
          "code": 710208,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3348,
        },
        {
          "areaName": "前镇区",
          "shortName": "前镇",
          "areaCode": "07",
          "code": 710209,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3349,
        },
        {
          "areaName": "旗津区",
          "shortName": "旗津",
          "areaCode": "07",
          "code": 710210,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3350,
        },
        {
          "areaName": "小港区",
          "shortName": "小港",
          "areaCode": "07",
          "code": 710211,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3351,
        },
        {
          "areaName": "凤山区",
          "shortName": "凤山",
          "areaCode": "07",
          "code": 710212,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3352,
        },
        {
          "areaName": "林园区",
          "shortName": "林园",
          "areaCode": "07",
          "code": 710213,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3353,
        },
        {
          "areaName": "大寮区",
          "shortName": "大寮",
          "areaCode": "07",
          "code": 710214,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3354,
        },
        {
          "areaName": "大树区",
          "shortName": "大树",
          "areaCode": "07",
          "code": 710215,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3355,
        },
        {
          "areaName": "大社区",
          "shortName": "大社",
          "areaCode": "07",
          "code": 710216,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3356,
        },
        {
          "areaName": "仁武区",
          "shortName": "仁武",
          "areaCode": "07",
          "code": 710217,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3357,
        },
        {
          "areaName": "鸟松区",
          "shortName": "鸟松",
          "areaCode": "07",
          "code": 710218,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3358,
        },
        {
          "areaName": "冈山区",
          "shortName": "冈山",
          "areaCode": "07",
          "code": 710219,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3359,
        },
        {
          "areaName": "桥头区",
          "shortName": "桥头",
          "areaCode": "07",
          "code": 710220,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3360,
        },
        {
          "areaName": "燕巢区",
          "shortName": "燕巢",
          "areaCode": "07",
          "code": 710221,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3361,
        },
        {
          "areaName": "田寮区",
          "shortName": "田寮",
          "areaCode": "07",
          "code": 710222,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3362,
        },
        {
          "areaName": "阿莲区",
          "shortName": "阿莲",
          "areaCode": "07",
          "code": 710223,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3363,
        },
        {
          "areaName": "路竹区",
          "shortName": "路竹",
          "areaCode": "07",
          "code": 710224,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3364,
        },
        {
          "areaName": "湖内区",
          "shortName": "湖内",
          "areaCode": "07",
          "code": 710225,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3365,
        },
        {
          "areaName": "茄萣区",
          "shortName": "茄萣",
          "areaCode": "07",
          "code": 710226,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3366,
        },
        {
          "areaName": "永安区",
          "shortName": "永安",
          "areaCode": "07",
          "code": 710227,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3367,
        },
        {
          "areaName": "弥陀区",
          "shortName": "弥陀",
          "areaCode": "07",
          "code": 710228,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3368,
        },
        {
          "areaName": "梓官区",
          "shortName": "梓官",
          "areaCode": "07",
          "code": 710229,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3369,
        },
        {
          "areaName": "旗山区",
          "shortName": "旗山",
          "areaCode": "07",
          "code": 710230,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3370,
        },
        {
          "areaName": "美浓区",
          "shortName": "美浓",
          "areaCode": "07",
          "code": 710231,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3371,
        },
        {
          "areaName": "六龟区",
          "shortName": "六龟",
          "areaCode": "07",
          "code": 710232,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3372,
        },
        {
          "areaName": "甲仙区",
          "shortName": "甲仙",
          "areaCode": "07",
          "code": 710233,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3373,
        },
        {
          "areaName": "杉林区",
          "shortName": "杉林",
          "areaCode": "07",
          "code": 710234,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3374,
        },
        {
          "areaName": "内门区",
          "shortName": "内门",
          "areaCode": "07",
          "code": 710235,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3375,
        },
        {
          "areaName": "茂林区",
          "shortName": "茂林",
          "areaCode": "07",
          "code": 710236,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3376,
        },
        {
          "areaName": "桃源区",
          "shortName": "桃源",
          "areaCode": "07",
          "code": 710237,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3377,
        },
        {
          "areaName": "那玛夏区",
          "shortName": "那玛夏",
          "areaCode": "07",
          "code": 710238,
          "parentCode": 710200,
          "level": 4,
          "children": null,
          "id": 3378,
        },
        {
          "areaName": "基隆市",
          "shortName": "基隆",
          "areaCode": "02",
          "code": 710300,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3379,
        },
        {
          "areaName": "中正区",
          "shortName": "中正",
          "areaCode": "02",
          "code": 710301,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3380,
        },
        {
          "areaName": "七堵区",
          "shortName": "七堵",
          "areaCode": "02",
          "code": 710302,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3381,
        },
        {
          "areaName": "暖暖区",
          "shortName": "暖暖",
          "areaCode": "02",
          "code": 710303,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3382,
        },
        {
          "areaName": "仁爱区",
          "shortName": "仁爱",
          "areaCode": "02",
          "code": 710304,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3383,
        },
        {
          "areaName": "中山区",
          "shortName": "中山",
          "areaCode": "02",
          "code": 710305,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3384,
        },
        {
          "areaName": "安乐区",
          "shortName": "安乐",
          "areaCode": "02",
          "code": 710306,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3385,
        },
        {
          "areaName": "信义区",
          "shortName": "信义",
          "areaCode": "02",
          "code": 710307,
          "parentCode": 710300,
          "level": 4,
          "children": null,
          "id": 3386,
        },
        {
          "areaName": "台中市",
          "shortName": "台中",
          "areaCode": "04",
          "code": 710400,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3387,
        },
        {
          "areaName": "中区",
          "shortName": "中区",
          "areaCode": "04",
          "code": 710401,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3388,
        },
        {
          "areaName": "东区",
          "shortName": "东区",
          "areaCode": "04",
          "code": 710402,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3389,
        },
        {
          "areaName": "南区",
          "shortName": "南区",
          "areaCode": "04",
          "code": 710403,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3390,
        },
        {
          "areaName": "西区",
          "shortName": "西区",
          "areaCode": "04",
          "code": 710404,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3391,
        },
        {
          "areaName": "北区",
          "shortName": "北区",
          "areaCode": "04",
          "code": 710405,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3392,
        },
        {
          "areaName": "西屯区",
          "shortName": "西屯",
          "areaCode": "04",
          "code": 710406,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3393,
        },
        {
          "areaName": "南屯区",
          "shortName": "南屯",
          "areaCode": "04",
          "code": 710407,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3394,
        },
        {
          "areaName": "北屯区",
          "shortName": "北屯",
          "areaCode": "04",
          "code": 710408,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3395,
        },
        {
          "areaName": "丰原区",
          "shortName": "丰原",
          "areaCode": "04",
          "code": 710409,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3396,
        },
        {
          "areaName": "东势区",
          "shortName": "东势",
          "areaCode": "04",
          "code": 710410,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3397,
        },
        {
          "areaName": "大甲区",
          "shortName": "大甲",
          "areaCode": "04",
          "code": 710411,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3398,
        },
        {
          "areaName": "清水区",
          "shortName": "清水",
          "areaCode": "04",
          "code": 710412,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3399,
        },
        {
          "areaName": "沙鹿区",
          "shortName": "沙鹿",
          "areaCode": "04",
          "code": 710413,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3400,
        },
        {
          "areaName": "梧栖区",
          "shortName": "梧栖",
          "areaCode": "04",
          "code": 710414,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3401,
        },
        {
          "areaName": "后里区",
          "shortName": "后里",
          "areaCode": "04",
          "code": 710415,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3402,
        },
        {
          "areaName": "神冈区",
          "shortName": "神冈",
          "areaCode": "04",
          "code": 710416,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3403,
        },
        {
          "areaName": "潭子区",
          "shortName": "潭子",
          "areaCode": "04",
          "code": 710417,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3404,
        },
        {
          "areaName": "大雅区",
          "shortName": "大雅",
          "areaCode": "04",
          "code": 710418,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3405,
        },
        {
          "areaName": "新社区",
          "shortName": "新社",
          "areaCode": "04",
          "code": 710419,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3406,
        },
        {
          "areaName": "石冈区",
          "shortName": "石冈",
          "areaCode": "04",
          "code": 710420,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3407,
        },
        {
          "areaName": "外埔区",
          "shortName": "外埔",
          "areaCode": "04",
          "code": 710421,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3408,
        },
        {
          "areaName": "大安区",
          "shortName": "大安",
          "areaCode": "04",
          "code": 710422,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3409,
        },
        {
          "areaName": "乌日区",
          "shortName": "乌日",
          "areaCode": "04",
          "code": 710423,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3410,
        },
        {
          "areaName": "大肚区",
          "shortName": "大肚",
          "areaCode": "04",
          "code": 710424,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3411,
        },
        {
          "areaName": "龙井区",
          "shortName": "龙井",
          "areaCode": "04",
          "code": 710425,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3412,
        },
        {
          "areaName": "雾峰区",
          "shortName": "雾峰",
          "areaCode": "04",
          "code": 710426,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3413,
        },
        {
          "areaName": "太平区",
          "shortName": "太平",
          "areaCode": "04",
          "code": 710427,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3414,
        },
        {
          "areaName": "大里区",
          "shortName": "大里",
          "areaCode": "04",
          "code": 710428,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3415,
        },
        {
          "areaName": "和平区",
          "shortName": "和平",
          "areaCode": "04",
          "code": 710429,
          "parentCode": 710400,
          "level": 4,
          "children": null,
          "id": 3416,
        },
        {
          "areaName": "台南市",
          "shortName": "台南",
          "areaCode": "06",
          "code": 710500,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3417,
        },
        {
          "areaName": "东区",
          "shortName": "东区",
          "areaCode": "06",
          "code": 710501,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3418,
        },
        {
          "areaName": "南区",
          "shortName": "南区",
          "areaCode": "06",
          "code": 710502,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3419,
        },
        {
          "areaName": "北区",
          "shortName": "北区",
          "areaCode": "06",
          "code": 710504,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3420,
        },
        {
          "areaName": "安南区",
          "shortName": "安南",
          "areaCode": "06",
          "code": 710506,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3421,
        },
        {
          "areaName": "安平区",
          "shortName": "安平",
          "areaCode": "06",
          "code": 710507,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3422,
        },
        {
          "areaName": "中西区",
          "shortName": "中西",
          "areaCode": "06",
          "code": 710508,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3423,
        },
        {
          "areaName": "新营区",
          "shortName": "新营",
          "areaCode": "06",
          "code": 710509,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3424,
        },
        {
          "areaName": "盐水区",
          "shortName": "盐水",
          "areaCode": "06",
          "code": 710510,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3425,
        },
        {
          "areaName": "白河区",
          "shortName": "白河",
          "areaCode": "06",
          "code": 710511,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3426,
        },
        {
          "areaName": "柳营区",
          "shortName": "柳营",
          "areaCode": "06",
          "code": 710512,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3427,
        },
        {
          "areaName": "后壁区",
          "shortName": "后壁",
          "areaCode": "06",
          "code": 710513,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3428,
        },
        {
          "areaName": "东山区",
          "shortName": "东山",
          "areaCode": "06",
          "code": 710514,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3429,
        },
        {
          "areaName": "麻豆区",
          "shortName": "麻豆",
          "areaCode": "06",
          "code": 710515,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3430,
        },
        {
          "areaName": "下营区",
          "shortName": "下营",
          "areaCode": "06",
          "code": 710516,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3431,
        },
        {
          "areaName": "六甲区",
          "shortName": "六甲",
          "areaCode": "06",
          "code": 710517,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3432,
        },
        {
          "areaName": "官田区",
          "shortName": "官田",
          "areaCode": "06",
          "code": 710518,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3433,
        },
        {
          "areaName": "大内区",
          "shortName": "大内",
          "areaCode": "06",
          "code": 710519,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3434,
        },
        {
          "areaName": "佳里区",
          "shortName": "佳里",
          "areaCode": "06",
          "code": 710520,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3435,
        },
        {
          "areaName": "学甲区",
          "shortName": "学甲",
          "areaCode": "06",
          "code": 710521,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3436,
        },
        {
          "areaName": "西港区",
          "shortName": "西港",
          "areaCode": "06",
          "code": 710522,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3437,
        },
        {
          "areaName": "七股区",
          "shortName": "七股",
          "areaCode": "06",
          "code": 710523,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3438,
        },
        {
          "areaName": "将军区",
          "shortName": "将军",
          "areaCode": "06",
          "code": 710524,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3439,
        },
        {
          "areaName": "北门区",
          "shortName": "北门",
          "areaCode": "06",
          "code": 710525,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3440,
        },
        {
          "areaName": "新化区",
          "shortName": "新化",
          "areaCode": "06",
          "code": 710526,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3441,
        },
        {
          "areaName": "善化区",
          "shortName": "善化",
          "areaCode": "06",
          "code": 710527,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3442,
        },
        {
          "areaName": "新市区",
          "shortName": "新市",
          "areaCode": "06",
          "code": 710528,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3443,
        },
        {
          "areaName": "安定区",
          "shortName": "安定",
          "areaCode": "06",
          "code": 710529,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3444,
        },
        {
          "areaName": "山上区",
          "shortName": "山上",
          "areaCode": "06",
          "code": 710530,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3445,
        },
        {
          "areaName": "玉井区",
          "shortName": "玉井",
          "areaCode": "06",
          "code": 710531,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3446,
        },
        {
          "areaName": "楠西区",
          "shortName": "楠西",
          "areaCode": "06",
          "code": 710532,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3447,
        },
        {
          "areaName": "南化区",
          "shortName": "南化",
          "areaCode": "06",
          "code": 710533,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3448,
        },
        {
          "areaName": "左镇区",
          "shortName": "左镇",
          "areaCode": "06",
          "code": 710534,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3449,
        },
        {
          "areaName": "仁德区",
          "shortName": "仁德",
          "areaCode": "06",
          "code": 710535,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3450,
        },
        {
          "areaName": "归仁区",
          "shortName": "归仁",
          "areaCode": "06",
          "code": 710536,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3451,
        },
        {
          "areaName": "关庙区",
          "shortName": "关庙",
          "areaCode": "06",
          "code": 710537,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3452,
        },
        {
          "areaName": "龙崎区",
          "shortName": "龙崎",
          "areaCode": "06",
          "code": 710538,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3453,
        },
        {
          "areaName": "永康区",
          "shortName": "永康",
          "areaCode": "06",
          "code": 710539,
          "parentCode": 710500,
          "level": 4,
          "children": null,
          "id": 3454,
        },
        {
          "areaName": "新竹市",
          "shortName": "新竹",
          "areaCode": "03",
          "code": 710600,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3455,
        },
        {
          "areaName": "东区",
          "shortName": "东区",
          "areaCode": "03",
          "code": 710601,
          "parentCode": 710600,
          "level": 4,
          "children": null,
          "id": 3456,
        },
        {
          "areaName": "北区",
          "shortName": "北区",
          "areaCode": "03",
          "code": 710602,
          "parentCode": 710600,
          "level": 4,
          "children": null,
          "id": 3457,
        },
        {
          "areaName": "香山区",
          "shortName": "香山",
          "areaCode": "03",
          "code": 710603,
          "parentCode": 710600,
          "level": 4,
          "children": null,
          "id": 3458,
        },
        {
          "areaName": "嘉义市",
          "shortName": "嘉义",
          "areaCode": "05",
          "code": 710700,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3459,
        },
        {
          "areaName": "东区",
          "shortName": "东区",
          "areaCode": "05",
          "code": 710701,
          "parentCode": 710700,
          "level": 4,
          "children": null,
          "id": 3460,
        },
        {
          "areaName": "西区",
          "shortName": "西区",
          "areaCode": "05",
          "code": 710702,
          "parentCode": 710700,
          "level": 4,
          "children": null,
          "id": 3461,
        },
        {
          "areaName": "新北市",
          "shortName": "新北",
          "areaCode": "02",
          "code": 710800,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3462,
        },
        {
          "areaName": "板桥区",
          "shortName": "板桥",
          "areaCode": "02",
          "code": 710801,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3463,
        },
        {
          "areaName": "三重区",
          "shortName": "三重",
          "areaCode": "02",
          "code": 710802,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3464,
        },
        {
          "areaName": "中和区",
          "shortName": "中和",
          "areaCode": "02",
          "code": 710803,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3465,
        },
        {
          "areaName": "永和区",
          "shortName": "永和",
          "areaCode": "02",
          "code": 710804,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3466,
        },
        {
          "areaName": "新庄区",
          "shortName": "新庄",
          "areaCode": "02",
          "code": 710805,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3467,
        },
        {
          "areaName": "新店区",
          "shortName": "新店",
          "areaCode": "02",
          "code": 710806,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3468,
        },
        {
          "areaName": "树林区",
          "shortName": "树林",
          "areaCode": "02",
          "code": 710807,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3469,
        },
        {
          "areaName": "莺歌区",
          "shortName": "莺歌",
          "areaCode": "02",
          "code": 710808,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3470,
        },
        {
          "areaName": "三峡区",
          "shortName": "三峡",
          "areaCode": "02",
          "code": 710809,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3471,
        },
        {
          "areaName": "淡水区",
          "shortName": "淡水",
          "areaCode": "02",
          "code": 710810,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3472,
        },
        {
          "areaName": "汐止区",
          "shortName": "汐止",
          "areaCode": "02",
          "code": 710811,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3473,
        },
        {
          "areaName": "瑞芳区",
          "shortName": "瑞芳",
          "areaCode": "02",
          "code": 710812,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3474,
        },
        {
          "areaName": "土城区",
          "shortName": "土城",
          "areaCode": "02",
          "code": 710813,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3475,
        },
        {
          "areaName": "芦洲区",
          "shortName": "芦洲",
          "areaCode": "02",
          "code": 710814,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3476,
        },
        {
          "areaName": "五股区",
          "shortName": "五股",
          "areaCode": "02",
          "code": 710815,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3477,
        },
        {
          "areaName": "泰山区",
          "shortName": "泰山",
          "areaCode": "02",
          "code": 710816,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3478,
        },
        {
          "areaName": "林口区",
          "shortName": "林口",
          "areaCode": "02",
          "code": 710817,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3479,
        },
        {
          "areaName": "深坑区",
          "shortName": "深坑",
          "areaCode": "02",
          "code": 710818,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3480,
        },
        {
          "areaName": "石碇区",
          "shortName": "石碇",
          "areaCode": "02",
          "code": 710819,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3481,
        },
        {
          "areaName": "坪林区",
          "shortName": "坪林",
          "areaCode": "02",
          "code": 710820,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3482,
        },
        {
          "areaName": "三芝区",
          "shortName": "三芝",
          "areaCode": "02",
          "code": 710821,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3483,
        },
        {
          "areaName": "石门区",
          "shortName": "石门",
          "areaCode": "02",
          "code": 710822,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3484,
        },
        {
          "areaName": "八里区",
          "shortName": "八里",
          "areaCode": "02",
          "code": 710823,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3485,
        },
        {
          "areaName": "平溪区",
          "shortName": "平溪",
          "areaCode": "02",
          "code": 710824,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3486,
        },
        {
          "areaName": "双溪区",
          "shortName": "双溪",
          "areaCode": "02",
          "code": 710825,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3487,
        },
        {
          "areaName": "贡寮区",
          "shortName": "贡寮",
          "areaCode": "02",
          "code": 710826,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3488,
        },
        {
          "areaName": "金山区",
          "shortName": "金山",
          "areaCode": "02",
          "code": 710827,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3489,
        },
        {
          "areaName": "万里区",
          "shortName": "万里",
          "areaCode": "02",
          "code": 710828,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3490,
        },
        {
          "areaName": "乌来区",
          "shortName": "乌来",
          "areaCode": "02",
          "code": 710829,
          "parentCode": 710800,
          "level": 4,
          "children": null,
          "id": 3491,
        },
        {
          "areaName": "宜兰县",
          "shortName": "宜兰",
          "areaCode": "03",
          "code": 712200,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3492,
        },
        {
          "areaName": "宜兰市",
          "shortName": "宜兰",
          "areaCode": "03",
          "code": 712201,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3493,
        },
        {
          "areaName": "罗东镇",
          "shortName": "罗东",
          "areaCode": "03",
          "code": 712221,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3494,
        },
        {
          "areaName": "苏澳镇",
          "shortName": "苏澳",
          "areaCode": "03",
          "code": 712222,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3495,
        },
        {
          "areaName": "头城镇",
          "shortName": "头城",
          "areaCode": "03",
          "code": 712223,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3496,
        },
        {
          "areaName": "礁溪乡",
          "shortName": "礁溪",
          "areaCode": "03",
          "code": 712224,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3497,
        },
        {
          "areaName": "壮围乡",
          "shortName": "壮围",
          "areaCode": "03",
          "code": 712225,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3498,
        },
        {
          "areaName": "员山乡",
          "shortName": "员山",
          "areaCode": "03",
          "code": 712226,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3499,
        },
        {
          "areaName": "冬山乡",
          "shortName": "冬山",
          "areaCode": "03",
          "code": 712227,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3500,
        },
        {
          "areaName": "五结乡",
          "shortName": "五结",
          "areaCode": "03",
          "code": 712228,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3501,
        },
        {
          "areaName": "三星乡",
          "shortName": "三星",
          "areaCode": "03",
          "code": 712229,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3502,
        },
        {
          "areaName": "大同乡",
          "shortName": "大同",
          "areaCode": "03",
          "code": 712230,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3503,
        },
        {
          "areaName": "南澳乡",
          "shortName": "南澳",
          "areaCode": "03",
          "code": 712231,
          "parentCode": 712200,
          "level": 4,
          "children": null,
          "id": 3504,
        },
        {
          "areaName": "桃园县",
          "shortName": "桃园",
          "areaCode": "03",
          "code": 712300,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3505,
        },
        {
          "areaName": "桃园市",
          "shortName": "桃园",
          "areaCode": "03",
          "code": 712301,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3506,
        },
        {
          "areaName": "中坜市",
          "shortName": "中坜",
          "areaCode": "03",
          "code": 712302,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3507,
        },
        {
          "areaName": "平镇市",
          "shortName": "平镇",
          "areaCode": "03",
          "code": 712303,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3508,
        },
        {
          "areaName": "八德市",
          "shortName": "八德",
          "areaCode": "03",
          "code": 712304,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3509,
        },
        {
          "areaName": "杨梅市",
          "shortName": "杨梅",
          "areaCode": "03",
          "code": 712305,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3510,
        },
        {
          "areaName": "芦竹市",
          "shortName": "芦竹",
          "areaCode": "03",
          "code": 712306,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3511,
        },
        {
          "areaName": "大溪镇",
          "shortName": "大溪",
          "areaCode": "03",
          "code": 712321,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3512,
        },
        {
          "areaName": "大园乡",
          "shortName": "大园",
          "areaCode": "03",
          "code": 712324,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3513,
        },
        {
          "areaName": "龟山乡",
          "shortName": "龟山",
          "areaCode": "03",
          "code": 712325,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3514,
        },
        {
          "areaName": "龙潭乡",
          "shortName": "龙潭",
          "areaCode": "03",
          "code": 712327,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3515,
        },
        {
          "areaName": "新屋乡",
          "shortName": "新屋",
          "areaCode": "03",
          "code": 712329,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3516,
        },
        {
          "areaName": "观音乡",
          "shortName": "观音",
          "areaCode": "03",
          "code": 712330,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3517,
        },
        {
          "areaName": "复兴乡",
          "shortName": "复兴",
          "areaCode": "03",
          "code": 712331,
          "parentCode": 712300,
          "level": 4,
          "children": null,
          "id": 3518,
        },
        {
          "areaName": "新竹县",
          "shortName": "新竹",
          "areaCode": "03",
          "code": 712400,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3519,
        },
        {
          "areaName": "竹北市",
          "shortName": "竹北",
          "areaCode": "03",
          "code": 712401,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3520,
        },
        {
          "areaName": "竹东镇",
          "shortName": "竹东",
          "areaCode": "03",
          "code": 712421,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3521,
        },
        {
          "areaName": "新埔镇",
          "shortName": "新埔",
          "areaCode": "03",
          "code": 712422,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3522,
        },
        {
          "areaName": "关西镇",
          "shortName": "关西",
          "areaCode": "03",
          "code": 712423,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3523,
        },
        {
          "areaName": "湖口乡",
          "shortName": "湖口",
          "areaCode": "03",
          "code": 712424,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3524,
        },
        {
          "areaName": "新丰乡",
          "shortName": "新丰",
          "areaCode": "03",
          "code": 712425,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3525,
        },
        {
          "areaName": "芎林乡",
          "shortName": "芎林",
          "areaCode": "03",
          "code": 712426,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3526,
        },
        {
          "areaName": "横山乡",
          "shortName": "横山",
          "areaCode": "03",
          "code": 712427,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3527,
        },
        {
          "areaName": "北埔乡",
          "shortName": "北埔",
          "areaCode": "03",
          "code": 712428,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3528,
        },
        {
          "areaName": "宝山乡",
          "shortName": "宝山",
          "areaCode": "03",
          "code": 712429,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3529,
        },
        {
          "areaName": "峨眉乡",
          "shortName": "峨眉",
          "areaCode": "03",
          "code": 712430,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3530,
        },
        {
          "areaName": "尖石乡",
          "shortName": "尖石",
          "areaCode": "03",
          "code": 712431,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3531,
        },
        {
          "areaName": "五峰乡",
          "shortName": "五峰",
          "areaCode": "03",
          "code": 712432,
          "parentCode": 712400,
          "level": 4,
          "children": null,
          "id": 3532,
        },
        {
          "areaName": "苗栗县",
          "shortName": "苗栗",
          "areaCode": "037",
          "code": 712500,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3533,
        },
        {
          "areaName": "苗栗市",
          "shortName": "苗栗",
          "areaCode": "037",
          "code": 712501,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3534,
        },
        {
          "areaName": "苑里镇",
          "shortName": "苑里",
          "areaCode": "037",
          "code": 712521,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3535,
        },
        {
          "areaName": "通霄镇",
          "shortName": "通霄",
          "areaCode": "037",
          "code": 712522,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3536,
        },
        {
          "areaName": "竹南镇",
          "shortName": "竹南",
          "areaCode": "037",
          "code": 712523,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3537,
        },
        {
          "areaName": "头份镇",
          "shortName": "头份",
          "areaCode": "037",
          "code": 712524,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3538,
        },
        {
          "areaName": "后龙镇",
          "shortName": "后龙",
          "areaCode": "037",
          "code": 712525,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3539,
        },
        {
          "areaName": "卓兰镇",
          "shortName": "卓兰",
          "areaCode": "037",
          "code": 712526,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3540,
        },
        {
          "areaName": "大湖乡",
          "shortName": "大湖",
          "areaCode": "037",
          "code": 712527,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3541,
        },
        {
          "areaName": "公馆乡",
          "shortName": "公馆",
          "areaCode": "037",
          "code": 712528,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3542,
        },
        {
          "areaName": "铜锣乡",
          "shortName": "铜锣",
          "areaCode": "037",
          "code": 712529,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3543,
        },
        {
          "areaName": "南庄乡",
          "shortName": "南庄",
          "areaCode": "037",
          "code": 712530,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3544,
        },
        {
          "areaName": "头屋乡",
          "shortName": "头屋",
          "areaCode": "037",
          "code": 712531,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3545,
        },
        {
          "areaName": "三义乡",
          "shortName": "三义",
          "areaCode": "037",
          "code": 712532,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3546,
        },
        {
          "areaName": "西湖乡",
          "shortName": "西湖",
          "areaCode": "037",
          "code": 712533,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3547,
        },
        {
          "areaName": "造桥乡",
          "shortName": "造桥",
          "areaCode": "037",
          "code": 712534,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3548,
        },
        {
          "areaName": "三湾乡",
          "shortName": "三湾",
          "areaCode": "037",
          "code": 712535,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3549,
        },
        {
          "areaName": "狮潭乡",
          "shortName": "狮潭",
          "areaCode": "037",
          "code": 712536,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3550,
        },
        {
          "areaName": "泰安乡",
          "shortName": "泰安",
          "areaCode": "037",
          "code": 712537,
          "parentCode": 712500,
          "level": 4,
          "children": null,
          "id": 3551,
        },
        {
          "areaName": "彰化县",
          "shortName": "彰化",
          "areaCode": "04",
          "code": 712700,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3552,
        },
        {
          "areaName": "彰化市",
          "shortName": "彰化市",
          "areaCode": "04",
          "code": 712701,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3553,
        },
        {
          "areaName": "鹿港镇",
          "shortName": "鹿港",
          "areaCode": "04",
          "code": 712721,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3554,
        },
        {
          "areaName": "和美镇",
          "shortName": "和美",
          "areaCode": "04",
          "code": 712722,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3555,
        },
        {
          "areaName": "线西乡",
          "shortName": "线西",
          "areaCode": "04",
          "code": 712723,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3556,
        },
        {
          "areaName": "伸港乡",
          "shortName": "伸港",
          "areaCode": "04",
          "code": 712724,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3557,
        },
        {
          "areaName": "福兴乡",
          "shortName": "福兴",
          "areaCode": "04",
          "code": 712725,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3558,
        },
        {
          "areaName": "秀水乡",
          "shortName": "秀水",
          "areaCode": "04",
          "code": 712726,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3559,
        },
        {
          "areaName": "花坛乡",
          "shortName": "花坛",
          "areaCode": "04",
          "code": 712727,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3560,
        },
        {
          "areaName": "芬园乡",
          "shortName": "芬园",
          "areaCode": "04",
          "code": 712728,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3561,
        },
        {
          "areaName": "员林镇",
          "shortName": "员林",
          "areaCode": "04",
          "code": 712729,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3562,
        },
        {
          "areaName": "溪湖镇",
          "shortName": "溪湖",
          "areaCode": "04",
          "code": 712730,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3563,
        },
        {
          "areaName": "田中镇",
          "shortName": "田中",
          "areaCode": "04",
          "code": 712731,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3564,
        },
        {
          "areaName": "大村乡",
          "shortName": "大村",
          "areaCode": "04",
          "code": 712732,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3565,
        },
        {
          "areaName": "埔盐乡",
          "shortName": "埔盐",
          "areaCode": "04",
          "code": 712733,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3566,
        },
        {
          "areaName": "埔心乡",
          "shortName": "埔心",
          "areaCode": "04",
          "code": 712734,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3567,
        },
        {
          "areaName": "永靖乡",
          "shortName": "永靖",
          "areaCode": "04",
          "code": 712735,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3568,
        },
        {
          "areaName": "社头乡",
          "shortName": "社头",
          "areaCode": "04",
          "code": 712736,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3569,
        },
        {
          "areaName": "二水乡",
          "shortName": "二水",
          "areaCode": "04",
          "code": 712737,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3570,
        },
        {
          "areaName": "北斗镇",
          "shortName": "北斗",
          "areaCode": "04",
          "code": 712738,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3571,
        },
        {
          "areaName": "二林镇",
          "shortName": "二林",
          "areaCode": "04",
          "code": 712739,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3572,
        },
        {
          "areaName": "田尾乡",
          "shortName": "田尾",
          "areaCode": "04",
          "code": 712740,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3573,
        },
        {
          "areaName": "埤头乡",
          "shortName": "埤头",
          "areaCode": "04",
          "code": 712741,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3574,
        },
        {
          "areaName": "芳苑乡",
          "shortName": "芳苑",
          "areaCode": "04",
          "code": 712742,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3575,
        },
        {
          "areaName": "大城乡",
          "shortName": "大城",
          "areaCode": "04",
          "code": 712743,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3576,
        },
        {
          "areaName": "竹塘乡",
          "shortName": "竹塘",
          "areaCode": "04",
          "code": 712744,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3577,
        },
        {
          "areaName": "溪州乡",
          "shortName": "溪州",
          "areaCode": "04",
          "code": 712745,
          "parentCode": 712700,
          "level": 4,
          "children": null,
          "id": 3578,
        },
        {
          "areaName": "南投县",
          "shortName": "南投",
          "areaCode": "049",
          "code": 712800,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3579,
        },
        {
          "areaName": "南投市",
          "shortName": "南投市",
          "areaCode": "049",
          "code": 712801,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3580,
        },
        {
          "areaName": "埔里镇",
          "shortName": "埔里",
          "areaCode": "049",
          "code": 712821,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3581,
        },
        {
          "areaName": "草屯镇",
          "shortName": "草屯",
          "areaCode": "049",
          "code": 712822,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3582,
        },
        {
          "areaName": "竹山镇",
          "shortName": "竹山",
          "areaCode": "049",
          "code": 712823,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3583,
        },
        {
          "areaName": "集集镇",
          "shortName": "集集",
          "areaCode": "049",
          "code": 712824,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3584,
        },
        {
          "areaName": "名间乡",
          "shortName": "名间",
          "areaCode": "049",
          "code": 712825,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3585,
        },
        {
          "areaName": "鹿谷乡",
          "shortName": "鹿谷",
          "areaCode": "049",
          "code": 712826,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3586,
        },
        {
          "areaName": "中寮乡",
          "shortName": "中寮",
          "areaCode": "049",
          "code": 712827,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3587,
        },
        {
          "areaName": "鱼池乡",
          "shortName": "鱼池",
          "areaCode": "049",
          "code": 712828,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3588,
        },
        {
          "areaName": "国姓乡",
          "shortName": "国姓",
          "areaCode": "049",
          "code": 712829,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3589,
        },
        {
          "areaName": "水里乡",
          "shortName": "水里",
          "areaCode": "049",
          "code": 712830,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3590,
        },
        {
          "areaName": "信义乡",
          "shortName": "信义",
          "areaCode": "049",
          "code": 712831,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3591,
        },
        {
          "areaName": "仁爱乡",
          "shortName": "仁爱",
          "areaCode": "049",
          "code": 712832,
          "parentCode": 712800,
          "level": 4,
          "children": null,
          "id": 3592,
        },
        {
          "areaName": "云林县",
          "shortName": "云林",
          "areaCode": "05",
          "code": 712900,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3593,
        },
        {
          "areaName": "斗六市",
          "shortName": "斗六",
          "areaCode": "05",
          "code": 712901,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3594,
        },
        {
          "areaName": "斗南镇",
          "shortName": "斗南",
          "areaCode": "05",
          "code": 712921,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3595,
        },
        {
          "areaName": "虎尾镇",
          "shortName": "虎尾",
          "areaCode": "05",
          "code": 712922,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3596,
        },
        {
          "areaName": "西螺镇",
          "shortName": "西螺",
          "areaCode": "05",
          "code": 712923,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3597,
        },
        {
          "areaName": "土库镇",
          "shortName": "土库",
          "areaCode": "05",
          "code": 712924,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3598,
        },
        {
          "areaName": "北港镇",
          "shortName": "北港",
          "areaCode": "05",
          "code": 712925,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3599,
        },
        {
          "areaName": "古坑乡",
          "shortName": "古坑",
          "areaCode": "05",
          "code": 712926,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3600,
        },
        {
          "areaName": "大埤乡",
          "shortName": "大埤",
          "areaCode": "05",
          "code": 712927,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3601,
        },
        {
          "areaName": "莿桐乡",
          "shortName": "莿桐",
          "areaCode": "05",
          "code": 712928,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3602,
        },
        {
          "areaName": "林内乡",
          "shortName": "林内",
          "areaCode": "05",
          "code": 712929,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3603,
        },
        {
          "areaName": "二仑乡",
          "shortName": "二仑",
          "areaCode": "05",
          "code": 712930,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3604,
        },
        {
          "areaName": "仑背乡",
          "shortName": "仑背",
          "areaCode": "05",
          "code": 712931,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3605,
        },
        {
          "areaName": "麦寮乡",
          "shortName": "麦寮",
          "areaCode": "05",
          "code": 712932,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3606,
        },
        {
          "areaName": "东势乡",
          "shortName": "东势",
          "areaCode": "05",
          "code": 712933,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3607,
        },
        {
          "areaName": "褒忠乡",
          "shortName": "褒忠",
          "areaCode": "05",
          "code": 712934,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3608,
        },
        {
          "areaName": "台西乡",
          "shortName": "台西",
          "areaCode": "05",
          "code": 712935,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3609,
        },
        {
          "areaName": "元长乡",
          "shortName": "元长",
          "areaCode": "05",
          "code": 712936,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3610,
        },
        {
          "areaName": "四湖乡",
          "shortName": "四湖",
          "areaCode": "05",
          "code": 712937,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3611,
        },
        {
          "areaName": "口湖乡",
          "shortName": "口湖",
          "areaCode": "05",
          "code": 712938,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3612,
        },
        {
          "areaName": "水林乡",
          "shortName": "水林",
          "areaCode": "05",
          "code": 712939,
          "parentCode": 712900,
          "level": 4,
          "children": null,
          "id": 3613,
        },
        {
          "areaName": "嘉义县",
          "shortName": "嘉义",
          "areaCode": "05",
          "code": 713000,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3614,
        },
        {
          "areaName": "太保市",
          "shortName": "太保",
          "areaCode": "05",
          "code": 713001,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3615,
        },
        {
          "areaName": "朴子市",
          "shortName": "朴子",
          "areaCode": "05",
          "code": 713002,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3616,
        },
        {
          "areaName": "布袋镇",
          "shortName": "布袋",
          "areaCode": "05",
          "code": 713023,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3617,
        },
        {
          "areaName": "大林镇",
          "shortName": "大林",
          "areaCode": "05",
          "code": 713024,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3618,
        },
        {
          "areaName": "民雄乡",
          "shortName": "民雄",
          "areaCode": "05",
          "code": 713025,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3619,
        },
        {
          "areaName": "溪口乡",
          "shortName": "溪口",
          "areaCode": "05",
          "code": 713026,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3620,
        },
        {
          "areaName": "新港乡",
          "shortName": "新港",
          "areaCode": "05",
          "code": 713027,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3621,
        },
        {
          "areaName": "六脚乡",
          "shortName": "六脚",
          "areaCode": "05",
          "code": 713028,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3622,
        },
        {
          "areaName": "东石乡",
          "shortName": "东石",
          "areaCode": "05",
          "code": 713029,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3623,
        },
        {
          "areaName": "义竹乡",
          "shortName": "义竹",
          "areaCode": "05",
          "code": 713030,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3624,
        },
        {
          "areaName": "鹿草乡",
          "shortName": "鹿草",
          "areaCode": "05",
          "code": 713031,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3625,
        },
        {
          "areaName": "水上乡",
          "shortName": "水上",
          "areaCode": "05",
          "code": 713032,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3626,
        },
        {
          "areaName": "中埔乡",
          "shortName": "中埔",
          "areaCode": "05",
          "code": 713033,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3627,
        },
        {
          "areaName": "竹崎乡",
          "shortName": "竹崎",
          "areaCode": "05",
          "code": 713034,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3628,
        },
        {
          "areaName": "梅山乡",
          "shortName": "梅山",
          "areaCode": "05",
          "code": 713035,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3629,
        },
        {
          "areaName": "番路乡",
          "shortName": "番路",
          "areaCode": "05",
          "code": 713036,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3630,
        },
        {
          "areaName": "大埔乡",
          "shortName": "大埔",
          "areaCode": "05",
          "code": 713037,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3631,
        },
        {
          "areaName": "阿里山乡",
          "shortName": "阿里山",
          "areaCode": "05",
          "code": 713038,
          "parentCode": 713000,
          "level": 4,
          "children": null,
          "id": 3632,
        },
        {
          "areaName": "屏东县",
          "shortName": "屏东",
          "areaCode": "08",
          "code": 713300,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3633,
        },
        {
          "areaName": "屏东市",
          "shortName": "屏东",
          "areaCode": "08",
          "code": 713301,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3634,
        },
        {
          "areaName": "潮州镇",
          "shortName": "潮州",
          "areaCode": "08",
          "code": 713321,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3635,
        },
        {
          "areaName": "东港镇",
          "shortName": "东港",
          "areaCode": "08",
          "code": 713322,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3636,
        },
        {
          "areaName": "恒春镇",
          "shortName": "恒春",
          "areaCode": "08",
          "code": 713323,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3637,
        },
        {
          "areaName": "万丹乡",
          "shortName": "万丹",
          "areaCode": "08",
          "code": 713324,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3638,
        },
        {
          "areaName": "长治乡",
          "shortName": "长治",
          "areaCode": "08",
          "code": 713325,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3639,
        },
        {
          "areaName": "麟洛乡",
          "shortName": "麟洛",
          "areaCode": "08",
          "code": 713326,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3640,
        },
        {
          "areaName": "九如乡",
          "shortName": "九如",
          "areaCode": "08",
          "code": 713327,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3641,
        },
        {
          "areaName": "里港乡",
          "shortName": "里港",
          "areaCode": "08",
          "code": 713328,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3642,
        },
        {
          "areaName": "盐埔乡",
          "shortName": "盐埔",
          "areaCode": "08",
          "code": 713329,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3643,
        },
        {
          "areaName": "高树乡",
          "shortName": "高树",
          "areaCode": "08",
          "code": 713330,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3644,
        },
        {
          "areaName": "万峦乡",
          "shortName": "万峦",
          "areaCode": "08",
          "code": 713331,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3645,
        },
        {
          "areaName": "内埔乡",
          "shortName": "内埔",
          "areaCode": "08",
          "code": 713332,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3646,
        },
        {
          "areaName": "竹田乡",
          "shortName": "竹田",
          "areaCode": "08",
          "code": 713333,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3647,
        },
        {
          "areaName": "新埤乡",
          "shortName": "新埤",
          "areaCode": "08",
          "code": 713334,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3648,
        },
        {
          "areaName": "枋寮乡",
          "shortName": "枋寮",
          "areaCode": "08",
          "code": 713335,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3649,
        },
        {
          "areaName": "新园乡",
          "shortName": "新园",
          "areaCode": "08",
          "code": 713336,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3650,
        },
        {
          "areaName": "崁顶乡",
          "shortName": "崁顶",
          "areaCode": "08",
          "code": 713337,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3651,
        },
        {
          "areaName": "林边乡",
          "shortName": "林边",
          "areaCode": "08",
          "code": 713338,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3652,
        },
        {
          "areaName": "南州乡",
          "shortName": "南州",
          "areaCode": "08",
          "code": 713339,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3653,
        },
        {
          "areaName": "佳冬乡",
          "shortName": "佳冬",
          "areaCode": "08",
          "code": 713340,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3654,
        },
        {
          "areaName": "琉球乡",
          "shortName": "琉球",
          "areaCode": "08",
          "code": 713341,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3655,
        },
        {
          "areaName": "车城乡",
          "shortName": "车城",
          "areaCode": "08",
          "code": 713342,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3656,
        },
        {
          "areaName": "满州乡",
          "shortName": "满州",
          "areaCode": "08",
          "code": 713343,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3657,
        },
        {
          "areaName": "枋山乡",
          "shortName": "枋山",
          "areaCode": "08",
          "code": 713344,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3658,
        },
        {
          "areaName": "三地门乡",
          "shortName": "三地门",
          "areaCode": "08",
          "code": 713345,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3659,
        },
        {
          "areaName": "雾台乡",
          "shortName": "雾台",
          "areaCode": "08",
          "code": 713346,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3660,
        },
        {
          "areaName": "玛家乡",
          "shortName": "玛家",
          "areaCode": "08",
          "code": 713347,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3661,
        },
        {
          "areaName": "泰武乡",
          "shortName": "泰武",
          "areaCode": "08",
          "code": 713348,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3662,
        },
        {
          "areaName": "来义乡",
          "shortName": "来义",
          "areaCode": "08",
          "code": 713349,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3663,
        },
        {
          "areaName": "春日乡",
          "shortName": "春日",
          "areaCode": "08",
          "code": 713350,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3664,
        },
        {
          "areaName": "狮子乡",
          "shortName": "狮子",
          "areaCode": "08",
          "code": 713351,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3665,
        },
        {
          "areaName": "牡丹乡",
          "shortName": "牡丹",
          "areaCode": "08",
          "code": 713352,
          "parentCode": 713300,
          "level": 4,
          "children": null,
          "id": 3666,
        },
        {
          "areaName": "台东县",
          "shortName": "台东",
          "areaCode": "089",
          "code": 713400,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3667,
        },
        {
          "areaName": "台东市",
          "shortName": "台东",
          "areaCode": "089",
          "code": 713401,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3668,
        },
        {
          "areaName": "成功镇",
          "shortName": "成功",
          "areaCode": "089",
          "code": 713421,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3669,
        },
        {
          "areaName": "关山镇",
          "shortName": "关山",
          "areaCode": "089",
          "code": 713422,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3670,
        },
        {
          "areaName": "卑南乡",
          "shortName": "卑南",
          "areaCode": "089",
          "code": 713423,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3671,
        },
        {
          "areaName": "鹿野乡",
          "shortName": "鹿野",
          "areaCode": "089",
          "code": 713424,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3672,
        },
        {
          "areaName": "池上乡",
          "shortName": "池上",
          "areaCode": "089",
          "code": 713425,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3673,
        },
        {
          "areaName": "东河乡",
          "shortName": "东河",
          "areaCode": "089",
          "code": 713426,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3674,
        },
        {
          "areaName": "长滨乡",
          "shortName": "长滨",
          "areaCode": "089",
          "code": 713427,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3675,
        },
        {
          "areaName": "太麻里乡",
          "shortName": "太麻里",
          "areaCode": "089",
          "code": 713428,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3676,
        },
        {
          "areaName": "大武乡",
          "shortName": "大武",
          "areaCode": "089",
          "code": 713429,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3677,
        },
        {
          "areaName": "绿岛乡",
          "shortName": "绿岛",
          "areaCode": "089",
          "code": 713430,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3678,
        },
        {
          "areaName": "海端乡",
          "shortName": "海端",
          "areaCode": "089",
          "code": 713431,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3679,
        },
        {
          "areaName": "延平乡",
          "shortName": "延平",
          "areaCode": "089",
          "code": 713432,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3680,
        },
        {
          "areaName": "金峰乡",
          "shortName": "金峰",
          "areaCode": "089",
          "code": 713433,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3681,
        },
        {
          "areaName": "达仁乡",
          "shortName": "达仁",
          "areaCode": "089",
          "code": 713434,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3682,
        },
        {
          "areaName": "兰屿乡",
          "shortName": "兰屿",
          "areaCode": "089",
          "code": 713435,
          "parentCode": 713400,
          "level": 4,
          "children": null,
          "id": 3683,
        },
        {
          "areaName": "花莲县",
          "shortName": "花莲",
          "areaCode": "03",
          "code": 713500,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3684,
        },
        {
          "areaName": "花莲市",
          "shortName": "花莲",
          "areaCode": "03",
          "code": 713501,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3685,
        },
        {
          "areaName": "凤林镇",
          "shortName": "凤林",
          "areaCode": "03",
          "code": 713521,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3686,
        },
        {
          "areaName": "玉里镇",
          "shortName": "玉里",
          "areaCode": "03",
          "code": 713522,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3687,
        },
        {
          "areaName": "新城乡",
          "shortName": "新城",
          "areaCode": "03",
          "code": 713523,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3688,
        },
        {
          "areaName": "吉安乡",
          "shortName": "吉安",
          "areaCode": "03",
          "code": 713524,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3689,
        },
        {
          "areaName": "寿丰乡",
          "shortName": "寿丰",
          "areaCode": "03",
          "code": 713525,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3690,
        },
        {
          "areaName": "光复乡",
          "shortName": "光复",
          "areaCode": "03",
          "code": 713526,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3691,
        },
        {
          "areaName": "丰滨乡",
          "shortName": "丰滨",
          "areaCode": "03",
          "code": 713527,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3692,
        },
        {
          "areaName": "瑞穗乡",
          "shortName": "瑞穗",
          "areaCode": "03",
          "code": 713528,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3693,
        },
        {
          "areaName": "富里乡",
          "shortName": "富里",
          "areaCode": "03",
          "code": 713529,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3694,
        },
        {
          "areaName": "秀林乡",
          "shortName": "秀林",
          "areaCode": "03",
          "code": 713530,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3695,
        },
        {
          "areaName": "万荣乡",
          "shortName": "万荣",
          "areaCode": "03",
          "code": 713531,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3696,
        },
        {
          "areaName": "卓溪乡",
          "shortName": "卓溪",
          "areaCode": "03",
          "code": 713532,
          "parentCode": 713500,
          "level": 4,
          "children": null,
          "id": 3697,
        },
        {
          "areaName": "澎湖县",
          "shortName": "澎湖",
          "areaCode": "06",
          "code": 713600,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3698,
        },
        {
          "areaName": "马公市",
          "shortName": "马公",
          "areaCode": "06",
          "code": 713601,
          "parentCode": 713600,
          "level": 4,
          "children": null,
          "id": 3699,
        },
        {
          "areaName": "湖西乡",
          "shortName": "湖西",
          "areaCode": "06",
          "code": 713621,
          "parentCode": 713600,
          "level": 4,
          "children": null,
          "id": 3700,
        },
        {
          "areaName": "白沙乡",
          "shortName": "白沙",
          "areaCode": "06",
          "code": 713622,
          "parentCode": 713600,
          "level": 4,
          "children": null,
          "id": 3701,
        },
        {
          "areaName": "西屿乡",
          "shortName": "西屿",
          "areaCode": "06",
          "code": 713623,
          "parentCode": 713600,
          "level": 4,
          "children": null,
          "id": 3702,
        },
        {
          "areaName": "望安乡",
          "shortName": "望安",
          "areaCode": "06",
          "code": 713624,
          "parentCode": 713600,
          "level": 4,
          "children": null,
          "id": 3703,
        },
        {
          "areaName": "七美乡",
          "shortName": "七美",
          "areaCode": "06",
          "code": 713625,
          "parentCode": 713600,
          "level": 4,
          "children": null,
          "id": 3704,
        },
        {
          "areaName": "金门县",
          "shortName": "金门",
          "areaCode": "082",
          "code": 713700,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3705,
        },
        {
          "areaName": "金城镇",
          "shortName": "金城",
          "areaCode": "082",
          "code": 713701,
          "parentCode": 713700,
          "level": 4,
          "children": null,
          "id": 3706,
        },
        {
          "areaName": "金湖镇",
          "shortName": "金湖",
          "areaCode": "082",
          "code": 713702,
          "parentCode": 713700,
          "level": 4,
          "children": null,
          "id": 3707,
        },
        {
          "areaName": "金沙镇",
          "shortName": "金沙",
          "areaCode": "082",
          "code": 713703,
          "parentCode": 713700,
          "level": 4,
          "children": null,
          "id": 3708,
        },
        {
          "areaName": "金宁乡",
          "shortName": "金宁",
          "areaCode": "082",
          "code": 713704,
          "parentCode": 713700,
          "level": 4,
          "children": null,
          "id": 3709,
        },
        {
          "areaName": "烈屿乡",
          "shortName": "烈屿",
          "areaCode": "082",
          "code": 713705,
          "parentCode": 713700,
          "level": 4,
          "children": null,
          "id": 3710,
        },
        {
          "areaName": "乌丘乡",
          "shortName": "乌丘",
          "areaCode": "082",
          "code": 713706,
          "parentCode": 713700,
          "level": 4,
          "children": null,
          "id": 3711,
        },
        {
          "areaName": "连江县",
          "shortName": "连江",
          "areaCode": "0836",
          "code": 713800,
          "parentCode": 710000,
          "level": 3,
          "children": null,
          "id": 3712,
        },
        {
          "areaName": "南竿乡",
          "shortName": "南竿",
          "areaCode": "0836",
          "code": 713801,
          "parentCode": 713800,
          "level": 4,
          "children": null,
          "id": 3713,
        },
        {
          "areaName": "北竿乡",
          "shortName": "北竿",
          "areaCode": "0836",
          "code": 713802,
          "parentCode": 713800,
          "level": 4,
          "children": null,
          "id": 3714,
        },
        {
          "areaName": "莒光乡",
          "shortName": "莒光",
          "areaCode": "0836",
          "code": 713803,
          "parentCode": 713800,
          "level": 4,
          "children": null,
          "id": 3715,
        },
        {
          "areaName": "东引乡",
          "shortName": "东引",
          "areaCode": "0836",
          "code": 713804,
          "parentCode": 713800,
          "level": 4,
          "children": null,
          "id": 3716,
        }
      ],
      "id": 3326,
    },
    {
      "areaName": "香港特别行政区",
      "shortName": "香港",
      "code": 810000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "香港岛",
          "shortName": "香港岛",
          "areaCode": "00852",
          "code": 810100,
          "parentCode": 810000,
          "level": 3,
          "children": null,
          "id": 3718,
        },
        {
          "areaName": "中西区",
          "shortName": "中西区",
          "areaCode": "00852",
          "code": 810101,
          "parentCode": 810100,
          "level": 4,
          "children": null,
          "id": 3719,
        },
        {
          "areaName": "湾仔区",
          "shortName": "湾仔区",
          "areaCode": "00852",
          "code": 810102,
          "parentCode": 810100,
          "level": 4,
          "children": null,
          "id": 3720,
        },
        {
          "areaName": "东区",
          "shortName": "东区",
          "areaCode": "00852",
          "code": 810103,
          "parentCode": 810100,
          "level": 4,
          "children": null,
          "id": 3721,
        },
        {
          "areaName": "南区",
          "shortName": "南区",
          "areaCode": "00852",
          "code": 810104,
          "parentCode": 810100,
          "level": 4,
          "children": null,
          "id": 3722,
        },
        {
          "areaName": "九龙",
          "shortName": "九龙",
          "areaCode": "00852",
          "code": 810200,
          "parentCode": 810000,
          "level": 3,
          "children": null,
          "id": 3723,
        },
        {
          "areaName": "油尖旺区",
          "shortName": "油尖旺",
          "areaCode": "00852",
          "code": 810201,
          "parentCode": 810200,
          "level": 4,
          "children": null,
          "id": 3724,
        },
        {
          "areaName": "深水埗区",
          "shortName": "深水埗",
          "areaCode": "00852",
          "code": 810202,
          "parentCode": 810200,
          "level": 4,
          "children": null,
          "id": 3725,
        },
        {
          "areaName": "九龙城区",
          "shortName": "九龙城",
          "areaCode": "00852",
          "code": 810203,
          "parentCode": 810200,
          "level": 4,
          "children": null,
          "id": 3726,
        },
        {
          "areaName": "黄大仙区",
          "shortName": "黄大仙",
          "areaCode": "00852",
          "code": 810204,
          "parentCode": 810200,
          "level": 4,
          "children": null,
          "id": 3727,
        },
        {
          "areaName": "观塘区",
          "shortName": "观塘",
          "areaCode": "00852",
          "code": 810205,
          "parentCode": 810200,
          "level": 4,
          "children": null,
          "id": 3728,
        },
        {
          "areaName": "新界",
          "shortName": "新界",
          "areaCode": "00852",
          "code": 810300,
          "parentCode": 810000,
          "level": 3,
          "children": null,
          "id": 3729,
        },
        {
          "areaName": "荃湾区",
          "shortName": "荃湾",
          "areaCode": "00852",
          "code": 810301,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3730,
        },
        {
          "areaName": "屯门区",
          "shortName": "屯门",
          "areaCode": "00852",
          "code": 810302,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3731,
        },
        {
          "areaName": "元朗区",
          "shortName": "元朗",
          "areaCode": "00852",
          "code": 810303,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3732,
        },
        {
          "areaName": "北区",
          "shortName": "北区",
          "areaCode": "00852",
          "code": 810304,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3733,
        },
        {
          "areaName": "大埔区",
          "shortName": "大埔",
          "areaCode": "00852",
          "code": 810305,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3734,
        },
        {
          "areaName": "西贡区",
          "shortName": "西贡",
          "areaCode": "00852",
          "code": 810306,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3735,
        },
        {
          "areaName": "沙田区",
          "shortName": "沙田",
          "areaCode": "00852",
          "code": 810307,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3736,
        },
        {
          "areaName": "葵青区",
          "shortName": "葵青",
          "areaCode": "00852",
          "code": 810308,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3737,
        },
        {
          "areaName": "离岛区",
          "shortName": "离岛",
          "areaCode": "00852",
          "code": 810309,
          "parentCode": 810300,
          "level": 4,
          "children": null,
          "id": 3738,
        }
      ],
      "id": 3717,
    },
    {
      "areaName": "澳门特别行政区",
      "shortName": "澳门",
      "code": 820000,
      "parentCode": 100000,
      "level": 2,
      "children": [
        {
          "areaName": "澳门半岛",
          "shortName": "澳门半岛",
          "areaCode": "00853",
          "code": 820100,
          "parentCode": 820000,
          "level": 3,
          "children": null,
          "id": 3740,
        },
        {
          "areaName": "花地玛堂区",
          "shortName": "花地玛堂区",
          "areaCode": "00853",
          "code": 820101,
          "parentCode": 820100,
          "level": 4,
          "children": null,
          "id": 3741,
        },
        {
          "areaName": "圣安多尼堂区",
          "shortName": "圣安多尼堂区",
          "areaCode": "00853",
          "code": 820102,
          "parentCode": 820100,
          "level": 4,
          "children": null,
          "id": 3742,
        },
        {
          "areaName": "大堂区",
          "shortName": "大堂",
          "areaCode": "00853",
          "code": 820103,
          "parentCode": 820100,
          "level": 4,
          "children": null,
          "id": 3743,
        },
        {
          "areaName": "望德堂区",
          "shortName": "望德堂区",
          "areaCode": "00853",
          "code": 820104,
          "parentCode": 820100,
          "level": 4,
          "children": null,
          "id": 3744,
        },
        {
          "areaName": "风顺堂区",
          "shortName": "风顺堂区",
          "areaCode": "00853",
          "code": 820105,
          "parentCode": 820100,
          "level": 4,
          "children": null,
          "id": 3745,
        },
        {
          "areaName": "氹仔岛",
          "shortName": "氹仔岛",
          "areaCode": "00853",
          "code": 820200,
          "parentCode": 820000,
          "level": 3,
          "children": null,
          "id": 3746,
        },
        {
          "areaName": "嘉模堂区",
          "shortName": "嘉模堂区",
          "areaCode": "00853",
          "code": 820201,
          "parentCode": 820200,
          "level": 4,
          "children": null,
          "id": 3747,
        },
        {
          "areaName": "路环岛",
          "shortName": "路环岛",
          "areaCode": "00853",
          "code": 820300,
          "parentCode": 820000,
          "level": 3,
          "children": null,
          "id": 3748,
        },
        {
          "areaName": "圣方济各堂区",
          "shortName": "圣方济各堂区",
          "areaCode": "00853",
          "code": 820301,
          "parentCode": 820300,
          "level": 4,
          "children": null,
          "id": 3749,
        }
      ],
      "id": 3739,
    },
    {
      "areaName": "钓鱼岛",
      "shortName": "钓鱼岛",
      "code": 900000,
      "parentCode": 100000,
      "level": 2,
      "children": [],
      "id": 3750,
    }
  ],
  "totalCount": 35
}